export const bateuLevouMock = [[
{
    "isSuccess": true,
    "data": [
        [
            {
                "id": 1195,
                "codigoVendedor": "264689",
                "nomeVendedor": "RODRIGO MARQUES NARCISO",
                "basesBateuLevou": [
                    {
                        "id": 532001,
                        "codigo": "1712601",
                        "razaoSocial": "CONSTRU MIX MATERIAIS PARA",
                        "aceite": true,
                        "volume": 100.02,
                        "meta": 80.6,
                        "atingimento": 1.2409429280397022,
                        "descontoRs": 1056,
                        "verMais": [
                            {
                                "id": 1,
                                "codigo": "1712601",
                                "razaoSocial": "CONSTRU MIX MATERIAIS PARA",
                                "produto": "Cimentos",
                                "volume": 100,
                                "meta": 80,
                                "atingimento": 1.25,
                                "descontoRs": 1056
                            },
                            {
                                "id": 3,
                                "codigo": "1712601",
                                "razaoSocial": "CONSTRU MIX MATERIAIS PARA",
                                "produto": "Rejuntes",
                                "volume": 0.02,
                                "meta": 0.6,
                                "atingimento": 0.03333333333333333,
                                "descontoRs": 0
                            }
                        ],
                        "clienteId": 53200,
                        "inicioMes": "2026-07-01T00:00:00"
                    },
                    {
                        "id": 532001,
                        "codigo": "1712601",
                        "razaoSocial": "CONSTRU MIX MATERIAIS PARA",
                        "aceite": true,
                        "volume": 63.2,
                        "meta": 87.2,
                        "atingimento": 0.7247706422018348,
                        "descontoRs": 102.4,
                        "verMais": [
                            {
                                "id": 4,
                                "codigo": "1712601",
                                "razaoSocial": "CONSTRU MIX MATERIAIS PARA",
                                "produto": "Colantes",
                                "volume": 3.2,
                                "meta": 3,
                                "atingimento": 1.0666666666666667,
                                "descontoRs": 102.4
                            },
                            {
                                "id": 2,
                                "codigo": "1712601",
                                "razaoSocial": "CONSTRU MIX MATERIAIS PARA",
                                "produto": "Impermeabilizantes",
                                "volume": 0,
                                "meta": 0.2,
                                "atingimento": 0,
                                "descontoRs": 0
                            },
                            {
                                "id": 1,
                                "codigo": "1712601",
                                "razaoSocial": "CONSTRU MIX MATERIAIS PARA",
                                "produto": "Cimentos",
                                "volume": 60,
                                "meta": 84,
                                "atingimento": 0.7142857142857143,
                                "descontoRs": 0
                            }
                        ],
                        "clienteId": 53200,
                        "inicioMes": "2026-06-01T00:00:00"
                    },
                    {
                        "id": 532001,
                        "codigo": "1712601",
                        "razaoSocial": "CONSTRU MIX MATERIAIS PARA",
                        "aceite": true,
                        "volume": 2,
                        "meta": 4.2,
                        "atingimento": 0.47619047619047616,
                        "descontoRs": 0,
                        "verMais": [
                            {
                                "id": 4,
                                "codigo": "1712601",
                                "razaoSocial": "CONSTRU MIX MATERIAIS PARA",
                                "produto": "Colantes",
                                "volume": 2,
                                "meta": 4,
                                "atingimento": 0.5,
                                "descontoRs": 0
                            },
                            {
                                "id": 2,
                                "codigo": "1712601",
                                "razaoSocial": "CONSTRU MIX MATERIAIS PARA",
                                "produto": "Impermeabilizantes",
                                "volume": 0,
                                "meta": 0.2,
                                "atingimento": 0,
                                "descontoRs": 0
                            }
                        ],
                        "clienteId": 53200,
                        "inicioMes": "2026-05-01T00:00:00"
                    },
                    {
                        "id": 532001,
                        "codigo": "1712601",
                        "razaoSocial": "CONSTRU MIX MATERIAIS PARA",
                        "aceite": true,
                        "volume": 76.8,
                        "meta": 64.2,
                        "atingimento": 1.1962616822429906,
                        "descontoRs": 792,
                        "verMais": [
                            {
                                "id": 4,
                                "codigo": "1712601",
                                "razaoSocial": "CONSTRU MIX MATERIAIS PARA",
                                "produto": "Colantes",
                                "volume": 2.8,
                                "meta": 4,
                                "atingimento": 0.7,
                                "descontoRs": 0
                            },
                            {
                                "id": 2,
                                "codigo": "1712601",
                                "razaoSocial": "CONSTRU MIX MATERIAIS PARA",
                                "produto": "Impermeabilizantes",
                                "volume": 0,
                                "meta": 0.2,
                                "atingimento": 0,
                                "descontoRs": 0
                            },
                            {
                                "id": 1,
                                "codigo": "1712601",
                                "razaoSocial": "CONSTRU MIX MATERIAIS PARA",
                                "produto": "Cimentos",
                                "volume": 74,
                                "meta": 60,
                                "atingimento": 1.2333333333333334,
                                "descontoRs": 792
                            }
                        ],
                        "clienteId": 53200,
                        "inicioMes": "2026-04-01T00:00:00"
                    },
                    {
                        "id": 532061,
                        "codigo": "1714523",
                        "razaoSocial": "QUEIROZ MATERIAIS PARA CONSTRUCAO",
                        "aceite": true,
                        "volume": 48.046,
                        "meta": 72.12,
                        "atingimento": 0.6661952301719356,
                        "descontoRs": 0,
                        "verMais": [
                            {
                                "id": 4,
                                "codigo": "1714523",
                                "razaoSocial": "QUEIROZ MATERIAIS PARA CONSTRUCAO",
                                "produto": "Colantes",
                                "volume": 4.8,
                                "meta": 7.4,
                                "atingimento": 0.6486486486486486,
                                "descontoRs": 0
                            },
                            {
                                "id": 1,
                                "codigo": "1714523",
                                "razaoSocial": "QUEIROZ MATERIAIS PARA CONSTRUCAO",
                                "produto": "Cimentos",
                                "volume": 43,
                                "meta": 64,
                                "atingimento": 0.671875,
                                "descontoRs": 0
                            },
                            {
                                "id": 3,
                                "codigo": "1714523",
                                "razaoSocial": "QUEIROZ MATERIAIS PARA CONSTRUCAO",
                                "produto": "Rejuntes",
                                "volume": 0.14,
                                "meta": 0.32,
                                "atingimento": 0.43750000000000006,
                                "descontoRs": 0
                            },
                            {
                                "id": 2,
                                "codigo": "1714523",
                                "razaoSocial": "QUEIROZ MATERIAIS PARA CONSTRUCAO",
                                "produto": "Impermeabilizantes",
                                "volume": 0.106,
                                "meta": 0.4,
                                "atingimento": 0.26499999999999996,
                                "descontoRs": 0
                            }
                        ],
                        "clienteId": 53206,
                        "inicioMes": "2026-06-01T00:00:00"
                    },
                    {
                        "id": 532060,
                        "codigo": "1714523",
                        "razaoSocial": "QUEIROZ MATERIAIS PARA CONSTRUCAO",
                        "aceite": false,
                        "volume": 12.037,
                        "meta": 75.73,
                        "atingimento": 0.1589462564373432,
                        "descontoRs": 0,
                        "verMais": [
                            {
                                "id": 1,
                                "codigo": "1714523",
                                "razaoSocial": "QUEIROZ MATERIAIS PARA CONSTRUCAO",
                                "produto": "Cimentos",
                                "volume": 10,
                                "meta": 64,
                                "atingimento": 0.15625,
                                "descontoRs": 0
                            },
                            {
                                "id": 2,
                                "codigo": "1714523",
                                "razaoSocial": "QUEIROZ MATERIAIS PARA CONSTRUCAO",
                                "produto": "Impermeabilizantes",
                                "volume": 0.037,
                                "meta": 0.23,
                                "atingimento": 0.1608695652173913,
                                "descontoRs": 0
                            },
                            {
                                "id": 4,
                                "codigo": "1714523",
                                "razaoSocial": "QUEIROZ MATERIAIS PARA CONSTRUCAO",
                                "produto": "Colantes",
                                "volume": 2,
                                "meta": 11.5,
                                "atingimento": 0.17391304347826086,
                                "descontoRs": 0
                            }
                        ],
                        "clienteId": 53206,
                        "inicioMes": "2026-08-01T00:00:00"
                    },
                    {
                        "id": 533750,
                        "codigo": "1630142",
                        "razaoSocial": "GUIOMAR RIOS DE MATOS",
                        "aceite": false,
                        "volume": 0,
                        "meta": 22,
                        "atingimento": 0,
                        "descontoRs": 0,
                        "verMais": [
                            {
                                "id": 1,
                                "codigo": "1630142",
                                "razaoSocial": "GUIOMAR RIOS DE MATOS",
                                "produto": "Cimentos",
                                "volume": 0,
                                "meta": 22,
                                "atingimento": 0,
                                "descontoRs": 0
                            }
                        ],
                        "clienteId": 53375,
                        "inicioMes": "2026-08-01T00:00:00"
                    },
                    {
                        "id": 533751,
                        "codigo": "1630142",
                        "razaoSocial": "GUIOMAR RIOS DE MATOS",
                        "aceite": true,
                        "volume": 20,
                        "meta": 16.2,
                        "atingimento": 1.234567901234568,
                        "descontoRs": 211.2,
                        "verMais": [
                            {
                                "id": 1,
                                "codigo": "1630142",
                                "razaoSocial": "GUIOMAR RIOS DE MATOS",
                                "produto": "Cimentos",
                                "volume": 20,
                                "meta": 16,
                                "atingimento": 1.25,
                                "descontoRs": 211.2
                            },
                            {
                                "id": 3,
                                "codigo": "1630142",
                                "razaoSocial": "GUIOMAR RIOS DE MATOS",
                                "produto": "Rejuntes",
                                "volume": 0,
                                "meta": 0.2,
                                "atingimento": 0,
                                "descontoRs": 0
                            }
                        ],
                        "clienteId": 53375,
                        "inicioMes": "2026-04-01T00:00:00"
                    },
                    {
                        "id": 534061,
                        "codigo": "1650357",
                        "razaoSocial": "ANDERSON RIBEIRO NASCIMENTO",
                        "aceite": true,
                        "volume": 11,
                        "meta": 10,
                        "atingimento": 1.1,
                        "descontoRs": 132,
                        "verMais": [
                            {
                                "id": 1,
                                "codigo": "1650357",
                                "razaoSocial": "ANDERSON RIBEIRO NASCIMENTO",
                                "produto": "Cimentos",
                                "volume": 11,
                                "meta": 10,
                                "atingimento": 1.1,
                                "descontoRs": 132
                            }
                        ],
                        "clienteId": 53406,
                        "inicioMes": "2026-04-01T00:00:00"
                    },
                    {
                        "id": 535600,
                        "codigo": "1547404",
                        "razaoSocial": "RODRIGO RODRIGUES CASA E FERRAGEM",
                        "aceite": false,
                        "volume": 0,
                        "meta": 32.6,
                        "atingimento": 0,
                        "descontoRs": 0,
                        "verMais": [
                            {
                                "id": 4,
                                "codigo": "1547404",
                                "razaoSocial": "RODRIGO RODRIGUES CASA E FERRAGEM",
                                "produto": "Colantes",
                                "volume": 0,
                                "meta": 4.6,
                                "atingimento": 0,
                                "descontoRs": 0
                            },
                            {
                                "id": 1,
                                "codigo": "1547404",
                                "razaoSocial": "RODRIGO RODRIGUES CASA E FERRAGEM",
                                "produto": "Cimentos",
                                "volume": 0,
                                "meta": 28,
                                "atingimento": 0,
                                "descontoRs": 0
                            }
                        ],
                        "clienteId": 53560,
                        "inicioMes": "2026-08-01T00:00:00"
                    },
                    {
                        "id": 538551,
                        "codigo": "1424685",
                        "razaoSocial": "ESS MATERIAIS P  CONSTRUCAO LTDA",
                        "aceite": true,
                        "volume": 43.02,
                        "meta": 46.400000000000006,
                        "atingimento": 0.9271551724137931,
                        "descontoRs": 452.8,
                        "verMais": [
                            {
                                "id": 1,
                                "codigo": "1424685",
                                "razaoSocial": "ESS MATERIAIS P  CONSTRUCAO LTDA",
                                "produto": "Cimentos",
                                "volume": 38,
                                "meta": 42,
                                "atingimento": 0.9047619047619048,
                                "descontoRs": 364.8
                            },
                            {
                                "id": 2,
                                "codigo": "1424685",
                                "razaoSocial": "ESS MATERIAIS P  CONSTRUCAO LTDA",
                                "produto": "Impermeabilizantes",
                                "volume": 0,
                                "meta": 0.2,
                                "atingimento": 0,
                                "descontoRs": 0
                            },
                            {
                                "id": 4,
                                "codigo": "1424685",
                                "razaoSocial": "ESS MATERIAIS P  CONSTRUCAO LTDA",
                                "produto": "Colantes",
                                "volume": 5,
                                "meta": 4,
                                "atingimento": 1.25,
                                "descontoRs": 88
                            },
                            {
                                "id": 3,
                                "codigo": "1424685",
                                "razaoSocial": "ESS MATERIAIS P  CONSTRUCAO LTDA",
                                "produto": "Rejuntes",
                                "volume": 0.02,
                                "meta": 0.2,
                                "atingimento": 0.09999999999999999,
                                "descontoRs": 0
                            }
                        ],
                        "clienteId": 53855,
                        "inicioMes": "2026-05-01T00:00:00"
                    },
                    {
                        "id": 538551,
                        "codigo": "1424685",
                        "razaoSocial": "ESS MATERIAIS P  CONSTRUCAO LTDA",
                        "aceite": true,
                        "volume": 42.966,
                        "meta": 44.800000000000004,
                        "atingimento": 0.9590624999999999,
                        "descontoRs": 456,
                        "verMais": [
                            {
                                "id": 3,
                                "codigo": "1424685",
                                "razaoSocial": "ESS MATERIAIS P  CONSTRUCAO LTDA",
                                "produto": "Rejuntes",
                                "volume": 0.04,
                                "meta": 0.6,
                                "atingimento": 0.06666666666666667,
                                "descontoRs": 0
                            },
                            {
                                "id": 4,
                                "codigo": "1424685",
                                "razaoSocial": "ESS MATERIAIS P  CONSTRUCAO LTDA",
                                "produto": "Colantes",
                                "volume": 4.8,
                                "meta": 8,
                                "atingimento": 0.6,
                                "descontoRs": 0
                            },
                            {
                                "id": 1,
                                "codigo": "1424685",
                                "razaoSocial": "ESS MATERIAIS P  CONSTRUCAO LTDA",
                                "produto": "Cimentos",
                                "volume": 38,
                                "meta": 36,
                                "atingimento": 1.0555555555555556,
                                "descontoRs": 456
                            },
                            {
                                "id": 2,
                                "codigo": "1424685",
                                "razaoSocial": "ESS MATERIAIS P  CONSTRUCAO LTDA",
                                "produto": "Impermeabilizantes",
                                "volume": 0.126,
                                "meta": 0.2,
                                "atingimento": 0.63,
                                "descontoRs": 0
                            }
                        ],
                        "clienteId": 53855,
                        "inicioMes": "2026-07-01T00:00:00"
                    },
                    {
                        "id": 538551,
                        "codigo": "1424685",
                        "razaoSocial": "ESS MATERIAIS P  CONSTRUCAO LTDA",
                        "aceite": true,
                        "volume": 41.348,
                        "meta": 26.8,
                        "atingimento": 1.5428358208955224,
                        "descontoRs": 532.4,
                        "verMais": [
                            {
                                "id": 3,
                                "codigo": "1424685",
                                "razaoSocial": "ESS MATERIAIS P  CONSTRUCAO LTDA",
                                "produto": "Rejuntes",
                                "volume": 0.04,
                                "meta": 0.2,
                                "atingimento": 0.19999999999999998,
                                "descontoRs": 0
                            },
                            {
                                "id": 4,
                                "codigo": "1424685",
                                "razaoSocial": "ESS MATERIAIS P  CONSTRUCAO LTDA",
                                "produto": "Colantes",
                                "volume": 5.2,
                                "meta": 4.4,
                                "atingimento": 1.1818181818181817,
                                "descontoRs": 193.6
                            },
                            {
                                "id": 2,
                                "codigo": "1424685",
                                "razaoSocial": "ESS MATERIAIS P  CONSTRUCAO LTDA",
                                "produto": "Impermeabilizantes",
                                "volume": 0.108,
                                "meta": 0.2,
                                "atingimento": 0.5399999999999999,
                                "descontoRs": 0
                            },
                            {
                                "id": 1,
                                "codigo": "1424685",
                                "razaoSocial": "ESS MATERIAIS P  CONSTRUCAO LTDA",
                                "produto": "Cimentos",
                                "volume": 36,
                                "meta": 22,
                                "atingimento": 1.6363636363636365,
                                "descontoRs": 338.8
                            }
                        ],
                        "clienteId": 53855,
                        "inicioMes": "2026-04-01T00:00:00"
                    },
                    {
                        "id": 538550,
                        "codigo": "1424685",
                        "razaoSocial": "ESS MATERIAIS P  CONSTRUCAO LTDA",
                        "aceite": false,
                        "volume": 14,
                        "meta": 57.129999999999995,
                        "atingimento": 0.24505513740591636,
                        "descontoRs": 0,
                        "verMais": [
                            {
                                "id": 4,
                                "codigo": "1424685",
                                "razaoSocial": "ESS MATERIAIS P  CONSTRUCAO LTDA",
                                "produto": "Colantes",
                                "volume": 0,
                                "meta": 6.9,
                                "atingimento": 0,
                                "descontoRs": 0
                            },
                            {
                                "id": 1,
                                "codigo": "1424685",
                                "razaoSocial": "ESS MATERIAIS P  CONSTRUCAO LTDA",
                                "produto": "Cimentos",
                                "volume": 14,
                                "meta": 50,
                                "atingimento": 0.28,
                                "descontoRs": 0
                            },
                            {
                                "id": 2,
                                "codigo": "1424685",
                                "razaoSocial": "ESS MATERIAIS P  CONSTRUCAO LTDA",
                                "produto": "Impermeabilizantes",
                                "volume": 0,
                                "meta": 0.23,
                                "atingimento": 0,
                                "descontoRs": 0
                            }
                        ],
                        "clienteId": 53855,
                        "inicioMes": "2026-08-01T00:00:00"
                    },
                    {
                        "id": 539591,
                        "codigo": "1367732",
                        "razaoSocial": "NOVA CARMELA III COMERCIO DE",
                        "aceite": true,
                        "volume": 49.84,
                        "meta": 20.8,
                        "atingimento": 2.396153846153846,
                        "descontoRs": 473.2,
                        "verMais": [
                            {
                                "id": 3,
                                "codigo": "1367732",
                                "razaoSocial": "NOVA CARMELA III COMERCIO DE",
                                "produto": "Rejuntes",
                                "volume": 0.06,
                                "meta": 0.6,
                                "atingimento": 0.1,
                                "descontoRs": 0
                            },
                            {
                                "id": 2,
                                "codigo": "1367732",
                                "razaoSocial": "NOVA CARMELA III COMERCIO DE",
                                "produto": "Impermeabilizantes",
                                "volume": 0.18,
                                "meta": 0.2,
                                "atingimento": 0.8999999999999999,
                                "descontoRs": 108
                            },
                            {
                                "id": 1,
                                "codigo": "1367732",
                                "razaoSocial": "NOVA CARMELA III COMERCIO DE",
                                "produto": "Cimentos",
                                "volume": 44,
                                "meta": 16,
                                "atingimento": 2.75,
                                "descontoRs": 211.2
                            },
                            {
                                "id": 4,
                                "codigo": "1367732",
                                "razaoSocial": "NOVA CARMELA III COMERCIO DE",
                                "produto": "Colantes",
                                "volume": 5.6,
                                "meta": 4,
                                "atingimento": 1.4,
                                "descontoRs": 154
                            }
                        ],
                        "clienteId": 53959,
                        "inicioMes": "2026-07-01T00:00:00"
                    },
                    {
                        "id": 539590,
                        "codigo": "1367732",
                        "razaoSocial": "NOVA CARMELA III COMERCIO DE",
                        "aceite": false,
                        "volume": 0,
                        "meta": 40.209999999999994,
                        "atingimento": 0,
                        "descontoRs": 0,
                        "verMais": [
                            {
                                "id": 1,
                                "codigo": "1367732",
                                "razaoSocial": "NOVA CARMELA III COMERCIO DE",
                                "produto": "Cimentos",
                                "volume": 0,
                                "meta": 34,
                                "atingimento": 0,
                                "descontoRs": 0
                            },
                            {
                                "id": 4,
                                "codigo": "1367732",
                                "razaoSocial": "NOVA CARMELA III COMERCIO DE",
                                "produto": "Colantes",
                                "volume": 0,
                                "meta": 5.75,
                                "atingimento": 0,
                                "descontoRs": 0
                            },
                            {
                                "id": 2,
                                "codigo": "1367732",
                                "razaoSocial": "NOVA CARMELA III COMERCIO DE",
                                "produto": "Impermeabilizantes",
                                "volume": 0,
                                "meta": 0.23,
                                "atingimento": 0,
                                "descontoRs": 0
                            },
                            {
                                "id": 3,
                                "codigo": "1367732",
                                "razaoSocial": "NOVA CARMELA III COMERCIO DE",
                                "produto": "Rejuntes",
                                "volume": 0,
                                "meta": 0.23,
                                "atingimento": 0,
                                "descontoRs": 0
                            }
                        ],
                        "clienteId": 53959,
                        "inicioMes": "2026-08-01T00:00:00"
                    },
                    {
                        "id": 540901,
                        "codigo": "1320574",
                        "razaoSocial": "COMERCIO DE FERRAGENS CORREIA LTDA",
                        "aceite": true,
                        "volume": 17.6,
                        "meta": 26.3,
                        "atingimento": 0.6692015209125476,
                        "descontoRs": 0,
                        "verMais": [
                            {
                                "id": 1,
                                "codigo": "1320574",
                                "razaoSocial": "COMERCIO DE FERRAGENS CORREIA LTDA",
                                "produto": "Cimentos",
                                "volume": 16,
                                "meta": 24,
                                "atingimento": 0.6666666666666666,
                                "descontoRs": 0
                            },
                            {
                                "id": 4,
                                "codigo": "1320574",
                                "razaoSocial": "COMERCIO DE FERRAGENS CORREIA LTDA",
                                "produto": "Colantes",
                                "volume": 1.6,
                                "meta": 2,
                                "atingimento": 0.8,
                                "descontoRs": 0
                            },
                            {
                                "id": 3,
                                "codigo": "1320574",
                                "razaoSocial": "COMERCIO DE FERRAGENS CORREIA LTDA",
                                "produto": "Rejuntes",
                                "volume": 0,
                                "meta": 0.3,
                                "atingimento": 0,
                                "descontoRs": 0
                            }
                        ],
                        "clienteId": 54090,
                        "inicioMes": "2026-06-01T00:00:00"
                    },
                    {
                        "id": 540901,
                        "codigo": "1320574",
                        "razaoSocial": "COMERCIO DE FERRAGENS CORREIA LTDA",
                        "aceite": true,
                        "volume": 14.4,
                        "meta": 20.7,
                        "atingimento": 0.6956521739130436,
                        "descontoRs": 0,
                        "verMais": [
                            {
                                "id": 1,
                                "codigo": "1320574",
                                "razaoSocial": "COMERCIO DE FERRAGENS CORREIA LTDA",
                                "produto": "Cimentos",
                                "volume": 14,
                                "meta": 16.5,
                                "atingimento": 0.8484848484848485,
                                "descontoRs": 0
                            },
                            {
                                "id": 4,
                                "codigo": "1320574",
                                "razaoSocial": "COMERCIO DE FERRAGENS CORREIA LTDA",
                                "produto": "Colantes",
                                "volume": 0.4,
                                "meta": 4,
                                "atingimento": 0.1,
                                "descontoRs": 0
                            },
                            {
                                "id": 2,
                                "codigo": "1320574",
                                "razaoSocial": "COMERCIO DE FERRAGENS CORREIA LTDA",
                                "produto": "Impermeabilizantes",
                                "volume": 0,
                                "meta": 0.2,
                                "atingimento": 0,
                                "descontoRs": 0
                            }
                        ],
                        "clienteId": 54090,
                        "inicioMes": "2026-04-01T00:00:00"
                    },
                    {
                        "id": 540901,
                        "codigo": "1320574",
                        "razaoSocial": "COMERCIO DE FERRAGENS CORREIA LTDA",
                        "aceite": true,
                        "volume": 18.44,
                        "meta": 32.800000000000004,
                        "atingimento": 0.5621951219512195,
                        "descontoRs": 0,
                        "verMais": [
                            {
                                "id": 4,
                                "codigo": "1320574",
                                "razaoSocial": "COMERCIO DE FERRAGENS CORREIA LTDA",
                                "produto": "Colantes",
                                "volume": 0.4,
                                "meta": 4,
                                "atingimento": 0.1,
                                "descontoRs": 0
                            },
                            {
                                "id": 3,
                                "codigo": "1320574",
                                "razaoSocial": "COMERCIO DE FERRAGENS CORREIA LTDA",
                                "produto": "Rejuntes",
                                "volume": 0.04,
                                "meta": 0.6,
                                "atingimento": 0.06666666666666667,
                                "descontoRs": 0
                            },
                            {
                                "id": 1,
                                "codigo": "1320574",
                                "razaoSocial": "COMERCIO DE FERRAGENS CORREIA LTDA",
                                "produto": "Cimentos",
                                "volume": 18,
                                "meta": 28,
                                "atingimento": 0.6428571428571429,
                                "descontoRs": 0
                            },
                            {
                                "id": 2,
                                "codigo": "1320574",
                                "razaoSocial": "COMERCIO DE FERRAGENS CORREIA LTDA",
                                "produto": "Impermeabilizantes",
                                "volume": 0,
                                "meta": 0.2,
                                "atingimento": 0,
                                "descontoRs": 0
                            }
                        ],
                        "clienteId": 54090,
                        "inicioMes": "2026-07-01T00:00:00"
                    },
                    {
                        "id": 542001,
                        "codigo": "1173049",
                        "razaoSocial": "GUARUTELHA MATERIAIS PARA",
                        "aceite": true,
                        "volume": 26,
                        "meta": 40,
                        "atingimento": 0.65,
                        "descontoRs": 0,
                        "verMais": [
                            {
                                "id": 1,
                                "codigo": "1173049",
                                "razaoSocial": "GUARUTELHA MATERIAIS PARA",
                                "produto": "Cimentos",
                                "volume": 26,
                                "meta": 40,
                                "atingimento": 0.65,
                                "descontoRs": 0
                            }
                        ],
                        "clienteId": 54200,
                        "inicioMes": "2026-04-01T00:00:00"
                    },
                    {
                        "id": 1733121,
                        "codigo": "1597012",
                        "razaoSocial": "LAILA VIANA DE SOUZA",
                        "aceite": true,
                        "volume": 115.608,
                        "meta": 210.24,
                        "atingimento": 0.5498858447488585,
                        "descontoRs": 0,
                        "verMais": [
                            {
                                "id": 1,
                                "codigo": "1597012",
                                "razaoSocial": "LAILA VIANA DE SOUZA",
                                "produto": "Cimentos",
                                "volume": 115.5,
                                "meta": 210,
                                "atingimento": 0.55,
                                "descontoRs": 0
                            },
                            {
                                "id": 2,
                                "codigo": "1597012",
                                "razaoSocial": "LAILA VIANA DE SOUZA",
                                "produto": "Impermeabilizantes",
                                "volume": 0.108,
                                "meta": 0.24,
                                "atingimento": 0.45,
                                "descontoRs": 0
                            }
                        ],
                        "clienteId": 173312,
                        "inicioMes": "2026-05-01T00:00:00"
                    },
                    {
                        "id": 1733121,
                        "codigo": "1597012",
                        "razaoSocial": "LAILA VIANA DE SOUZA",
                        "aceite": true,
                        "volume": 14,
                        "meta": 138.2,
                        "atingimento": 0.10130246020260493,
                        "descontoRs": 0,
                        "verMais": [
                            {
                                "id": 4,
                                "codigo": "1597012",
                                "razaoSocial": "LAILA VIANA DE SOUZA",
                                "produto": "Colantes",
                                "volume": 2,
                                "meta": 12,
                                "atingimento": 0.16666666666666666,
                                "descontoRs": 0
                            },
                            {
                                "id": 2,
                                "codigo": "1597012",
                                "razaoSocial": "LAILA VIANA DE SOUZA",
                                "produto": "Impermeabilizantes",
                                "volume": 0,
                                "meta": 0.2,
                                "atingimento": 0,
                                "descontoRs": 0
                            },
                            {
                                "id": 1,
                                "codigo": "1597012",
                                "razaoSocial": "LAILA VIANA DE SOUZA",
                                "produto": "Cimentos",
                                "volume": 12,
                                "meta": 126,
                                "atingimento": 0.09523809523809523,
                                "descontoRs": 0
                            }
                        ],
                        "clienteId": 173312,
                        "inicioMes": "2026-08-01T00:00:00"
                    },
                    {
                        "id": 1733121,
                        "codigo": "1597012",
                        "razaoSocial": "LAILA VIANA DE SOUZA",
                        "aceite": true,
                        "volume": 80.92399999999999,
                        "meta": 194.9,
                        "atingimento": 0.41520779887121595,
                        "descontoRs": 162,
                        "verMais": [
                            {
                                "id": 1,
                                "codigo": "1597012",
                                "razaoSocial": "LAILA VIANA DE SOUZA",
                                "produto": "Cimentos",
                                "volume": 73,
                                "meta": 180,
                                "atingimento": 0.40555555555555556,
                                "descontoRs": 0
                            },
                            {
                                "id": 3,
                                "codigo": "1597012",
                                "razaoSocial": "LAILA VIANA DE SOUZA",
                                "produto": "Rejuntes",
                                "volume": 0,
                                "meta": 0.6,
                                "atingimento": 0,
                                "descontoRs": 0
                            },
                            {
                                "id": 4,
                                "codigo": "1597012",
                                "razaoSocial": "LAILA VIANA DE SOUZA",
                                "produto": "Colantes",
                                "volume": 7.6,
                                "meta": 14,
                                "atingimento": 0.5428571428571428,
                                "descontoRs": 0
                            },
                            {
                                "id": 2,
                                "codigo": "1597012",
                                "razaoSocial": "LAILA VIANA DE SOUZA",
                                "produto": "Impermeabilizantes",
                                "volume": 0.324,
                                "meta": 0.3,
                                "atingimento": 1.08,
                                "descontoRs": 162
                            }
                        ],
                        "clienteId": 173312,
                        "inicioMes": "2026-07-01T00:00:00"
                    },
                    {
                        "id": 1733121,
                        "codigo": "1597012",
                        "razaoSocial": "LAILA VIANA DE SOUZA",
                        "aceite": true,
                        "volume": 232.274,
                        "meta": 165.39999999999998,
                        "atingimento": 1.4043168077388153,
                        "descontoRs": 2103.2,
                        "verMais": [
                            {
                                "id": 1,
                                "codigo": "1597012",
                                "razaoSocial": "LAILA VIANA DE SOUZA",
                                "produto": "Cimentos",
                                "volume": 226.75,
                                "meta": 151,
                                "atingimento": 1.5016556291390728,
                                "descontoRs": 1993.2
                            },
                            {
                                "id": 5,
                                "codigo": "1597012",
                                "razaoSocial": "LAILA VIANA DE SOUZA",
                                "produto": "Cales",
                                "volume": 0,
                                "meta": 4,
                                "atingimento": 0,
                                "descontoRs": 0
                            },
                            {
                                "id": 4,
                                "codigo": "1597012",
                                "razaoSocial": "LAILA VIANA DE SOUZA",
                                "produto": "Colantes",
                                "volume": 5.2,
                                "meta": 10,
                                "atingimento": 0.52,
                                "descontoRs": 0
                            },
                            {
                                "id": 2,
                                "codigo": "1597012",
                                "razaoSocial": "LAILA VIANA DE SOUZA",
                                "produto": "Impermeabilizantes",
                                "volume": 0.324,
                                "meta": 0.2,
                                "atingimento": 1.6199999999999999,
                                "descontoRs": 110
                            },
                            {
                                "id": 3,
                                "codigo": "1597012",
                                "razaoSocial": "LAILA VIANA DE SOUZA",
                                "produto": "Rejuntes",
                                "volume": 0,
                                "meta": 0.2,
                                "atingimento": 0,
                                "descontoRs": 0
                            }
                        ],
                        "clienteId": 173312,
                        "inicioMes": "2026-04-01T00:00:00"
                    },
                    {
                        "id": 1733141,
                        "codigo": "1153600",
                        "razaoSocial": "DEPOSITO CABUCU LTDA",
                        "aceite": true,
                        "volume": 147.46599999999998,
                        "meta": 124.83000000000001,
                        "atingimento": 1.1813346150765038,
                        "descontoRs": 1203.84,
                        "verMais": [
                            {
                                "id": 2,
                                "codigo": "1153600",
                                "razaoSocial": "DEPOSITO CABUCU LTDA",
                                "produto": "Impermeabilizantes",
                                "volume": 0.126,
                                "meta": 0.2,
                                "atingimento": 0.63,
                                "descontoRs": 0
                            },
                            {
                                "id": 1,
                                "codigo": "1153600",
                                "razaoSocial": "DEPOSITO CABUCU LTDA",
                                "produto": "Cimentos",
                                "volume": 144,
                                "meta": 114,
                                "atingimento": 1.263157894736842,
                                "descontoRs": 1203.84
                            },
                            {
                                "id": 3,
                                "codigo": "1153600",
                                "razaoSocial": "DEPOSITO CABUCU LTDA",
                                "produto": "Rejuntes",
                                "volume": 0.14,
                                "meta": 0.23,
                                "atingimento": 0.6086956521739131,
                                "descontoRs": 0
                            },
                            {
                                "id": 4,
                                "codigo": "1153600",
                                "razaoSocial": "DEPOSITO CABUCU LTDA",
                                "produto": "Colantes",
                                "volume": 3.2,
                                "meta": 10.4,
                                "atingimento": 0.3076923076923077,
                                "descontoRs": 0
                            }
                        ],
                        "clienteId": 173314,
                        "inicioMes": "2026-05-01T00:00:00"
                    },
                    {
                        "id": 1733141,
                        "codigo": "1153600",
                        "razaoSocial": "DEPOSITO CABUCU LTDA",
                        "aceite": true,
                        "volume": 156.09,
                        "meta": 84.2,
                        "atingimento": 1.8538004750593824,
                        "descontoRs": 1056,
                        "verMais": [
                            {
                                "id": 1,
                                "codigo": "1153600",
                                "razaoSocial": "DEPOSITO CABUCU LTDA",
                                "produto": "Cimentos",
                                "volume": 154,
                                "meta": 80,
                                "atingimento": 1.925,
                                "descontoRs": 1056
                            },
                            {
                                "id": 2,
                                "codigo": "1153600",
                                "razaoSocial": "DEPOSITO CABUCU LTDA",
                                "produto": "Impermeabilizantes",
                                "volume": 0.09,
                                "meta": 0.2,
                                "atingimento": 0.44999999999999996,
                                "descontoRs": 0
                            },
                            {
                                "id": 4,
                                "codigo": "1153600",
                                "razaoSocial": "DEPOSITO CABUCU LTDA",
                                "produto": "Colantes",
                                "volume": 2,
                                "meta": 4,
                                "atingimento": 0.5,
                                "descontoRs": 0
                            }
                        ],
                        "clienteId": 173314,
                        "inicioMes": "2026-04-01T00:00:00"
                    },
                    {
                        "id": 1733141,
                        "codigo": "1153600",
                        "razaoSocial": "DEPOSITO CABUCU LTDA",
                        "aceite": true,
                        "volume": 174.844,
                        "meta": 166.8,
                        "atingimento": 1.0482254196642684,
                        "descontoRs": 2450.8,
                        "verMais": [
                            {
                                "id": 4,
                                "codigo": "1153600",
                                "razaoSocial": "DEPOSITO CABUCU LTDA",
                                "produto": "Colantes",
                                "volume": 0.4,
                                "meta": 14,
                                "atingimento": 0.028571428571428574,
                                "descontoRs": 0
                            },
                            {
                                "id": 3,
                                "codigo": "1153600",
                                "razaoSocial": "DEPOSITO CABUCU LTDA",
                                "produto": "Rejuntes",
                                "volume": 0.12,
                                "meta": 0.6,
                                "atingimento": 0.2,
                                "descontoRs": 0
                            },
                            {
                                "id": 2,
                                "codigo": "1153600",
                                "razaoSocial": "DEPOSITO CABUCU LTDA",
                                "produto": "Impermeabilizantes",
                                "volume": 0.324,
                                "meta": 0.2,
                                "atingimento": 1.6199999999999999,
                                "descontoRs": 110
                            },
                            {
                                "id": 1,
                                "codigo": "1153600",
                                "razaoSocial": "DEPOSITO CABUCU LTDA",
                                "produto": "Cimentos",
                                "volume": 174,
                                "meta": 152,
                                "atingimento": 1.144736842105263,
                                "descontoRs": 2340.8
                            }
                        ],
                        "clienteId": 173314,
                        "inicioMes": "2026-07-01T00:00:00"
                    },
                    {
                        "id": 1733140,
                        "codigo": "1153600",
                        "razaoSocial": "DEPOSITO CABUCU LTDA",
                        "aceite": false,
                        "volume": 0,
                        "meta": 187.66,
                        "atingimento": 0,
                        "descontoRs": 0,
                        "verMais": [
                            {
                                "id": 2,
                                "codigo": "1153600",
                                "razaoSocial": "DEPOSITO CABUCU LTDA",
                                "produto": "Impermeabilizantes",
                                "volume": 0,
                                "meta": 0.23,
                                "atingimento": 0,
                                "descontoRs": 0
                            },
                            {
                                "id": 3,
                                "codigo": "1153600",
                                "razaoSocial": "DEPOSITO CABUCU LTDA",
                                "produto": "Rejuntes",
                                "volume": 0,
                                "meta": 0.23,
                                "atingimento": 0,
                                "descontoRs": 0
                            },
                            {
                                "id": 4,
                                "codigo": "1153600",
                                "razaoSocial": "DEPOSITO CABUCU LTDA",
                                "produto": "Colantes",
                                "volume": 0,
                                "meta": 9.2,
                                "atingimento": 0,
                                "descontoRs": 0
                            },
                            {
                                "id": 1,
                                "codigo": "1153600",
                                "razaoSocial": "DEPOSITO CABUCU LTDA",
                                "produto": "Cimentos",
                                "volume": 0,
                                "meta": 178,
                                "atingimento": 0,
                                "descontoRs": 0
                            }
                        ],
                        "clienteId": 173314,
                        "inicioMes": "2026-08-01T00:00:00"
                    },
                    {
                        "id": 543971,
                        "codigo": "1059853",
                        "razaoSocial": "L  E F  MATERIAIS PARA CONSTRUCAO",
                        "aceite": true,
                        "volume": 115.1,
                        "meta": 146.5,
                        "atingimento": 0.7856655290102389,
                        "descontoRs": 0,
                        "verMais": [
                            {
                                "id": 4,
                                "codigo": "1059853",
                                "razaoSocial": "L  E F  MATERIAIS PARA CONSTRUCAO",
                                "produto": "Colantes",
                                "volume": 12.8,
                                "meta": 16,
                                "atingimento": 0.8,
                                "descontoRs": 0
                            },
                            {
                                "id": 6,
                                "codigo": "1059853",
                                "razaoSocial": "L  E F  MATERIAIS PARA CONSTRUCAO",
                                "produto": "Basicas",
                                "volume": 0.8,
                                "meta": 8,
                                "atingimento": 0.1,
                                "descontoRs": 0
                            },
                            {
                                "id": 3,
                                "codigo": "1059853",
                                "razaoSocial": "L  E F  MATERIAIS PARA CONSTRUCAO",
                                "produto": "Rejuntes",
                                "volume": 0,
                                "meta": 0.5,
                                "atingimento": 0,
                                "descontoRs": 0
                            },
                            {
                                "id": 1,
                                "codigo": "1059853",
                                "razaoSocial": "L  E F  MATERIAIS PARA CONSTRUCAO",
                                "produto": "Cimentos",
                                "volume": 101.5,
                                "meta": 122,
                                "atingimento": 0.8319672131147541,
                                "descontoRs": 0
                            }
                        ],
                        "clienteId": 54397,
                        "inicioMes": "2026-06-01T00:00:00"
                    },
                    {
                        "id": 543971,
                        "codigo": "1059853",
                        "razaoSocial": "L  E F  MATERIAIS PARA CONSTRUCAO",
                        "aceite": true,
                        "volume": 140.094,
                        "meta": 148.87499999999997,
                        "atingimento": 0.9410176322418138,
                        "descontoRs": 1727.2,
                        "verMais": [
                            {
                                "id": 1,
                                "codigo": "1059853",
                                "razaoSocial": "L  E F  MATERIAIS PARA CONSTRUCAO",
                                "produto": "Cimentos",
                                "volume": 124.5,
                                "meta": 132,
                                "atingimento": 0.9431818181818182,
                                "descontoRs": 1195.2
                            },
                            {
                                "id": 3,
                                "codigo": "1059853",
                                "razaoSocial": "L  E F  MATERIAIS PARA CONSTRUCAO",
                                "produto": "Rejuntes",
                                "volume": 0.02,
                                "meta": 0.2,
                                "atingimento": 0.09999999999999999,
                                "descontoRs": 0
                            },
                            {
                                "id": 4,
                                "codigo": "1059853",
                                "razaoSocial": "L  E F  MATERIAIS PARA CONSTRUCAO",
                                "produto": "Colantes",
                                "volume": 15.2,
                                "meta": 16.1,
                                "atingimento": 0.9440993788819875,
                                "descontoRs": 532
                            },
                            {
                                "id": 2,
                                "codigo": "1059853",
                                "razaoSocial": "L  E F  MATERIAIS PARA CONSTRUCAO",
                                "produto": "Impermeabilizantes",
                                "volume": 0.374,
                                "meta": 0.575,
                                "atingimento": 0.6504347826086957,
                                "descontoRs": 0
                            }
                        ],
                        "clienteId": 54397,
                        "inicioMes": "2026-05-01T00:00:00"
                    },
                    {
                        "id": 543971,
                        "codigo": "1059853",
                        "razaoSocial": "L  E F  MATERIAIS PARA CONSTRUCAO",
                        "aceite": true,
                        "volume": 14.5,
                        "meta": 140.4,
                        "atingimento": 0.10327635327635327,
                        "descontoRs": 0,
                        "verMais": [
                            {
                                "id": 1,
                                "codigo": "1059853",
                                "razaoSocial": "L  E F  MATERIAIS PARA CONSTRUCAO",
                                "produto": "Cimentos",
                                "volume": 12.5,
                                "meta": 126,
                                "atingimento": 0.0992063492063492,
                                "descontoRs": 0
                            },
                            {
                                "id": 4,
                                "codigo": "1059853",
                                "razaoSocial": "L  E F  MATERIAIS PARA CONSTRUCAO",
                                "produto": "Colantes",
                                "volume": 2,
                                "meta": 14,
                                "atingimento": 0.14285714285714285,
                                "descontoRs": 0
                            },
                            {
                                "id": 2,
                                "codigo": "1059853",
                                "razaoSocial": "L  E F  MATERIAIS PARA CONSTRUCAO",
                                "produto": "Impermeabilizantes",
                                "volume": 0,
                                "meta": 0.4,
                                "atingimento": 0,
                                "descontoRs": 0
                            }
                        ],
                        "clienteId": 54397,
                        "inicioMes": "2026-08-01T00:00:00"
                    },
                    {
                        "id": 545481,
                        "codigo": "1055957",
                        "razaoSocial": "ITO BEL MATERIAIS PARA CONSTRUCAO",
                        "aceite": true,
                        "volume": 22,
                        "meta": 40.2,
                        "atingimento": 0.5472636815920398,
                        "descontoRs": 0,
                        "verMais": [
                            {
                                "id": 2,
                                "codigo": "1055957",
                                "razaoSocial": "ITO BEL MATERIAIS PARA CONSTRUCAO",
                                "produto": "Impermeabilizantes",
                                "volume": 0,
                                "meta": 0.2,
                                "atingimento": 0,
                                "descontoRs": 0
                            },
                            {
                                "id": 1,
                                "codigo": "1055957",
                                "razaoSocial": "ITO BEL MATERIAIS PARA CONSTRUCAO",
                                "produto": "Cimentos",
                                "volume": 22,
                                "meta": 40,
                                "atingimento": 0.55,
                                "descontoRs": 0
                            }
                        ],
                        "clienteId": 54548,
                        "inicioMes": "2026-05-01T00:00:00"
                    },
                    {
                        "id": 545480,
                        "codigo": "1055957",
                        "razaoSocial": "ITO BEL MATERIAIS PARA CONSTRUCAO",
                        "aceite": false,
                        "volume": 14,
                        "meta": 48.83,
                        "atingimento": 0.2867089903747696,
                        "descontoRs": 0,
                        "verMais": [
                            {
                                "id": 4,
                                "codigo": "1055957",
                                "razaoSocial": "ITO BEL MATERIAIS PARA CONSTRUCAO",
                                "produto": "Colantes",
                                "volume": 0,
                                "meta": 4.6,
                                "atingimento": 0,
                                "descontoRs": 0
                            },
                            {
                                "id": 1,
                                "codigo": "1055957",
                                "razaoSocial": "ITO BEL MATERIAIS PARA CONSTRUCAO",
                                "produto": "Cimentos",
                                "volume": 14,
                                "meta": 44,
                                "atingimento": 0.3181818181818182,
                                "descontoRs": 0
                            },
                            {
                                "id": 2,
                                "codigo": "1055957",
                                "razaoSocial": "ITO BEL MATERIAIS PARA CONSTRUCAO",
                                "produto": "Impermeabilizantes",
                                "volume": 0,
                                "meta": 0.23,
                                "atingimento": 0,
                                "descontoRs": 0
                            }
                        ],
                        "clienteId": 54548,
                        "inicioMes": "2026-08-01T00:00:00"
                    },
                    {
                        "id": 545481,
                        "codigo": "1055957",
                        "razaoSocial": "ITO BEL MATERIAIS PARA CONSTRUCAO",
                        "aceite": true,
                        "volume": 30.8,
                        "meta": 29.2,
                        "atingimento": 1.0547945205479452,
                        "descontoRs": 330,
                        "verMais": [
                            {
                                "id": 2,
                                "codigo": "1055957",
                                "razaoSocial": "ITO BEL MATERIAIS PARA CONSTRUCAO",
                                "produto": "Impermeabilizantes",
                                "volume": 0,
                                "meta": 0.2,
                                "atingimento": 0,
                                "descontoRs": 0
                            },
                            {
                                "id": 1,
                                "codigo": "1055957",
                                "razaoSocial": "ITO BEL MATERIAIS PARA CONSTRUCAO",
                                "produto": "Cimentos",
                                "volume": 28,
                                "meta": 25,
                                "atingimento": 1.12,
                                "descontoRs": 330
                            },
                            {
                                "id": 4,
                                "codigo": "1055957",
                                "razaoSocial": "ITO BEL MATERIAIS PARA CONSTRUCAO",
                                "produto": "Colantes",
                                "volume": 2.8,
                                "meta": 4,
                                "atingimento": 0.7,
                                "descontoRs": 0
                            }
                        ],
                        "clienteId": 54548,
                        "inicioMes": "2026-04-01T00:00:00"
                    },
                    {
                        "id": 545481,
                        "codigo": "1055957",
                        "razaoSocial": "ITO BEL MATERIAIS PARA CONSTRUCAO",
                        "aceite": true,
                        "volume": 38.4,
                        "meta": 38.2,
                        "atingimento": 1.0052356020942408,
                        "descontoRs": 432,
                        "verMais": [
                            {
                                "id": 2,
                                "codigo": "1055957",
                                "razaoSocial": "ITO BEL MATERIAIS PARA CONSTRUCAO",
                                "produto": "Impermeabilizantes",
                                "volume": 0,
                                "meta": 0.2,
                                "atingimento": 0,
                                "descontoRs": 0
                            },
                            {
                                "id": 4,
                                "codigo": "1055957",
                                "razaoSocial": "ITO BEL MATERIAIS PARA CONSTRUCAO",
                                "produto": "Colantes",
                                "volume": 2.4,
                                "meta": 4,
                                "atingimento": 0.6,
                                "descontoRs": 0
                            },
                            {
                                "id": 1,
                                "codigo": "1055957",
                                "razaoSocial": "ITO BEL MATERIAIS PARA CONSTRUCAO",
                                "produto": "Cimentos",
                                "volume": 36,
                                "meta": 34,
                                "atingimento": 1.0588235294117647,
                                "descontoRs": 432
                            }
                        ],
                        "clienteId": 54548,
                        "inicioMes": "2026-07-01T00:00:00"
                    },
                    {
                        "id": 571331,
                        "codigo": "1054953",
                        "razaoSocial": "DEPOSITO DE MATERIAIS PARA",
                        "aceite": true,
                        "volume": 30,
                        "meta": 32,
                        "atingimento": 0.9375,
                        "descontoRs": 360,
                        "verMais": [
                            {
                                "id": 1,
                                "codigo": "1054953",
                                "razaoSocial": "DEPOSITO DE MATERIAIS PARA",
                                "produto": "Cimentos",
                                "volume": 30,
                                "meta": 32,
                                "atingimento": 0.9375,
                                "descontoRs": 360
                            }
                        ],
                        "clienteId": 57133,
                        "inicioMes": "2026-04-01T00:00:00"
                    },
                    {
                        "id": 1967831,
                        "codigo": "1549482",
                        "razaoSocial": "S.C. CIMENTO E TRANSPORTE LTDA",
                        "aceite": true,
                        "volume": 530,
                        "meta": 466.2,
                        "atingimento": 1.136851136851137,
                        "descontoRs": 8162,
                        "verMais": [
                            {
                                "id": 4,
                                "codigo": "1549482",
                                "razaoSocial": "S.C. CIMENTO E TRANSPORTE LTDA",
                                "produto": "Colantes",
                                "volume": 10.4,
                                "meta": 5.5,
                                "atingimento": 1.8909090909090909,
                                "descontoRs": 242
                            },
                            {
                                "id": 2,
                                "codigo": "1549482",
                                "razaoSocial": "S.C. CIMENTO E TRANSPORTE LTDA",
                                "produto": "Impermeabilizantes",
                                "volume": 0,
                                "meta": 0.2,
                                "atingimento": 0,
                                "descontoRs": 0
                            },
                            {
                                "id": 6,
                                "codigo": "1549482",
                                "razaoSocial": "S.C. CIMENTO E TRANSPORTE LTDA",
                                "produto": "Basicas",
                                "volume": 0,
                                "meta": 10,
                                "atingimento": 0,
                                "descontoRs": 0
                            },
                            {
                                "id": 3,
                                "codigo": "1549482",
                                "razaoSocial": "S.C. CIMENTO E TRANSPORTE LTDA",
                                "produto": "Rejuntes",
                                "volume": 0.1,
                                "meta": 0.5,
                                "atingimento": 0.2,
                                "descontoRs": 0
                            },
                            {
                                "id": 1,
                                "codigo": "1549482",
                                "razaoSocial": "S.C. CIMENTO E TRANSPORTE LTDA",
                                "produto": "Cimentos",
                                "volume": 519.5,
                                "meta": 450,
                                "atingimento": 1.1544444444444444,
                                "descontoRs": 7920
                            }
                        ],
                        "clienteId": 196783,
                        "inicioMes": "2026-04-01T00:00:00"
                    },
                    {
                        "id": 1967831,
                        "codigo": "1549482",
                        "razaoSocial": "S.C. CIMENTO E TRANSPORTE LTDA",
                        "aceite": true,
                        "volume": 0,
                        "meta": 0.23,
                        "atingimento": 0,
                        "descontoRs": 0,
                        "verMais": [
                            {
                                "id": 2,
                                "codigo": "1549482",
                                "razaoSocial": "S.C. CIMENTO E TRANSPORTE LTDA",
                                "produto": "Impermeabilizantes",
                                "volume": 0,
                                "meta": 0.23,
                                "atingimento": 0,
                                "descontoRs": 0
                            }
                        ],
                        "clienteId": 196783,
                        "inicioMes": "2026-05-01T00:00:00"
                    },
                    {
                        "id": 1967831,
                        "codigo": "1549482",
                        "razaoSocial": "S.C. CIMENTO E TRANSPORTE LTDA",
                        "aceite": true,
                        "volume": 362.94,
                        "meta": 630.5200000000001,
                        "atingimento": 0.575620123073019,
                        "descontoRs": 0,
                        "verMais": [
                            {
                                "id": 1,
                                "codigo": "1549482",
                                "razaoSocial": "S.C. CIMENTO E TRANSPORTE LTDA",
                                "produto": "Cimentos",
                                "volume": 354,
                                "meta": 598,
                                "atingimento": 0.5919732441471572,
                                "descontoRs": 0
                            },
                            {
                                "id": 3,
                                "codigo": "1549482",
                                "razaoSocial": "S.C. CIMENTO E TRANSPORTE LTDA",
                                "produto": "Rejuntes",
                                "volume": 0.14,
                                "meta": 0.32,
                                "atingimento": 0.43750000000000006,
                                "descontoRs": 0
                            },
                            {
                                "id": 4,
                                "codigo": "1549482",
                                "razaoSocial": "S.C. CIMENTO E TRANSPORTE LTDA",
                                "produto": "Colantes",
                                "volume": 8.8,
                                "meta": 32.2,
                                "atingimento": 0.2732919254658385,
                                "descontoRs": 0
                            }
                        ],
                        "clienteId": 196783,
                        "inicioMes": "2026-06-01T00:00:00"
                    },
                    {
                        "id": 1967831,
                        "codigo": "1549482",
                        "razaoSocial": "S.C. CIMENTO E TRANSPORTE LTDA",
                        "aceite": true,
                        "volume": 483.44,
                        "meta": 596.6,
                        "atingimento": 0.8103251759973181,
                        "descontoRs": 0,
                        "verMais": [
                            {
                                "id": 3,
                                "codigo": "1549482",
                                "razaoSocial": "S.C. CIMENTO E TRANSPORTE LTDA",
                                "produto": "Rejuntes",
                                "volume": 0.24,
                                "meta": 0.6,
                                "atingimento": 0.4,
                                "descontoRs": 0
                            },
                            {
                                "id": 1,
                                "codigo": "1549482",
                                "razaoSocial": "S.C. CIMENTO E TRANSPORTE LTDA",
                                "produto": "Cimentos",
                                "volume": 472,
                                "meta": 576,
                                "atingimento": 0.8194444444444444,
                                "descontoRs": 0
                            },
                            {
                                "id": 4,
                                "codigo": "1549482",
                                "razaoSocial": "S.C. CIMENTO E TRANSPORTE LTDA",
                                "produto": "Colantes",
                                "volume": 11.2,
                                "meta": 20,
                                "atingimento": 0.5599999999999999,
                                "descontoRs": 0
                            }
                        ],
                        "clienteId": 196783,
                        "inicioMes": "2026-07-01T00:00:00"
                    },
                    {
                        "id": 1967830,
                        "codigo": "1549482",
                        "razaoSocial": "S.C. CIMENTO E TRANSPORTE LTDA",
                        "aceite": false,
                        "volume": 4,
                        "meta": 9.2,
                        "atingimento": 0.4347826086956522,
                        "descontoRs": 0,
                        "verMais": [
                            {
                                "id": 6,
                                "codigo": "1549482",
                                "razaoSocial": "S.C. CIMENTO E TRANSPORTE LTDA",
                                "produto": "Basicas",
                                "volume": 4,
                                "meta": 9.2,
                                "atingimento": 0.4347826086956522,
                                "descontoRs": 0
                            }
                        ],
                        "clienteId": 196783,
                        "inicioMes": "2026-07-01T00:00:00"
                    },
                    {
                        "id": 1967831,
                        "codigo": "1549482",
                        "razaoSocial": "S.C. CIMENTO E TRANSPORTE LTDA",
                        "aceite": true,
                        "volume": 1.44,
                        "meta": 14,
                        "atingimento": 0.10285714285714286,
                        "descontoRs": 0,
                        "verMais": [
                            {
                                "id": 4,
                                "codigo": "1549482",
                                "razaoSocial": "S.C. CIMENTO E TRANSPORTE LTDA",
                                "produto": "Colantes",
                                "volume": 1.44,
                                "meta": 14,
                                "atingimento": 0.10285714285714286,
                                "descontoRs": 0
                            }
                        ],
                        "clienteId": 196783,
                        "inicioMes": "2026-08-01T00:00:00"
                    },
                    {
                        "id": 1968311,
                        "codigo": "1499807",
                        "razaoSocial": "JOSE CARLOS CARDOSO",
                        "aceite": true,
                        "volume": 0,
                        "meta": 57.48,
                        "atingimento": 0,
                        "descontoRs": 0,
                        "verMais": [
                            {
                                "id": 4,
                                "codigo": "1499807",
                                "razaoSocial": "JOSE CARLOS CARDOSO",
                                "produto": "Colantes",
                                "volume": 0,
                                "meta": 6.5,
                                "atingimento": 0,
                                "descontoRs": 0
                            },
                            {
                                "id": 2,
                                "codigo": "1499807",
                                "razaoSocial": "JOSE CARLOS CARDOSO",
                                "produto": "Impermeabilizantes",
                                "volume": 0,
                                "meta": 0.26,
                                "atingimento": 0,
                                "descontoRs": 0
                            },
                            {
                                "id": 1,
                                "codigo": "1499807",
                                "razaoSocial": "JOSE CARLOS CARDOSO",
                                "produto": "Cimentos",
                                "volume": 0,
                                "meta": 50,
                                "atingimento": 0,
                                "descontoRs": 0
                            },
                            {
                                "id": 3,
                                "codigo": "1499807",
                                "razaoSocial": "JOSE CARLOS CARDOSO",
                                "produto": "Rejuntes",
                                "volume": 0,
                                "meta": 0.72,
                                "atingimento": 0,
                                "descontoRs": 0
                            }
                        ],
                        "clienteId": 196831,
                        "inicioMes": "2026-08-01T00:00:00"
                    },
                    {
                        "id": 1968311,
                        "codigo": "1499807",
                        "razaoSocial": "JOSE CARLOS CARDOSO",
                        "aceite": true,
                        "volume": 14.5,
                        "meta": 74.58,
                        "atingimento": 0.19442209707696434,
                        "descontoRs": 0,
                        "verMais": [
                            {
                                "id": 2,
                                "codigo": "1499807",
                                "razaoSocial": "JOSE CARLOS CARDOSO",
                                "produto": "Impermeabilizantes",
                                "volume": 0,
                                "meta": 0.2,
                                "atingimento": 0,
                                "descontoRs": 0
                            },
                            {
                                "id": 4,
                                "codigo": "1499807",
                                "razaoSocial": "JOSE CARLOS CARDOSO",
                                "produto": "Colantes",
                                "volume": 0,
                                "meta": 14,
                                "atingimento": 0,
                                "descontoRs": 0
                            },
                            {
                                "id": 3,
                                "codigo": "1499807",
                                "razaoSocial": "JOSE CARLOS CARDOSO",
                                "produto": "Rejuntes",
                                "volume": 0,
                                "meta": 0.38,
                                "atingimento": 0,
                                "descontoRs": 0
                            },
                            {
                                "id": 1,
                                "codigo": "1499807",
                                "razaoSocial": "JOSE CARLOS CARDOSO",
                                "produto": "Cimentos",
                                "volume": 14.5,
                                "meta": 60,
                                "atingimento": 0.24166666666666667,
                                "descontoRs": 0
                            }
                        ],
                        "clienteId": 196831,
                        "inicioMes": "2026-07-01T00:00:00"
                    },
                    {
                        "id": 1968321,
                        "codigo": "1475411",
                        "razaoSocial": "BARUK DISTRIBUIDORA DE CIMENTO LTDA",
                        "aceite": true,
                        "volume": 0,
                        "meta": 168.3,
                        "atingimento": 0,
                        "descontoRs": 0,
                        "verMais": [
                            {
                                "id": 3,
                                "codigo": "1475411",
                                "razaoSocial": "BARUK DISTRIBUIDORA DE CIMENTO LTDA",
                                "produto": "Rejuntes",
                                "volume": 0,
                                "meta": 0.3,
                                "atingimento": 0,
                                "descontoRs": 0
                            },
                            {
                                "id": 1,
                                "codigo": "1475411",
                                "razaoSocial": "BARUK DISTRIBUIDORA DE CIMENTO LTDA",
                                "produto": "Cimentos",
                                "volume": 0,
                                "meta": 168,
                                "atingimento": 0,
                                "descontoRs": 0
                            }
                        ],
                        "clienteId": 196832,
                        "inicioMes": "2026-07-01T00:00:00"
                    },
                    {
                        "id": 1968321,
                        "codigo": "1475411",
                        "razaoSocial": "BARUK DISTRIBUIDORA DE CIMENTO LTDA",
                        "aceite": true,
                        "volume": 188.36,
                        "meta": 87.2,
                        "atingimento": 2.160091743119266,
                        "descontoRs": 875.6,
                        "verMais": [
                            {
                                "id": 1,
                                "codigo": "1475411",
                                "razaoSocial": "BARUK DISTRIBUIDORA DE CIMENTO LTDA",
                                "produto": "Cimentos",
                                "volume": 188,
                                "meta": 87,
                                "atingimento": 2.160919540229885,
                                "descontoRs": 765.6
                            },
                            {
                                "id": 3,
                                "codigo": "1475411",
                                "razaoSocial": "BARUK DISTRIBUIDORA DE CIMENTO LTDA",
                                "produto": "Rejuntes",
                                "volume": 0.36,
                                "meta": 0.2,
                                "atingimento": 1.7999999999999998,
                                "descontoRs": 110
                            }
                        ],
                        "clienteId": 196832,
                        "inicioMes": "2026-04-01T00:00:00"
                    },
                    {
                        "id": 1968321,
                        "codigo": "1475411",
                        "razaoSocial": "BARUK DISTRIBUIDORA DE CIMENTO LTDA",
                        "aceite": true,
                        "volume": 84.12,
                        "meta": 162.368,
                        "atingimento": 0.5180823807646827,
                        "descontoRs": 0,
                        "verMais": [
                            {
                                "id": 3,
                                "codigo": "1475411",
                                "razaoSocial": "BARUK DISTRIBUIDORA DE CIMENTO LTDA",
                                "produto": "Rejuntes",
                                "volume": 0.12,
                                "meta": 0.368,
                                "atingimento": 0.32608695652173914,
                                "descontoRs": 0
                            },
                            {
                                "id": 1,
                                "codigo": "1475411",
                                "razaoSocial": "BARUK DISTRIBUIDORA DE CIMENTO LTDA",
                                "produto": "Cimentos",
                                "volume": 84,
                                "meta": 162,
                                "atingimento": 0.5185185185185185,
                                "descontoRs": 0
                            }
                        ],
                        "clienteId": 196832,
                        "inicioMes": "2026-06-01T00:00:00"
                    },
                    {
                        "id": 1968520,
                        "codigo": "1303008",
                        "razaoSocial": "POCAO MATERIAL DE CONSTRUCAO LTDA",
                        "aceite": false,
                        "volume": 0,
                        "meta": 23.75,
                        "atingimento": 0,
                        "descontoRs": 0,
                        "verMais": [
                            {
                                "id": 4,
                                "codigo": "1303008",
                                "razaoSocial": "POCAO MATERIAL DE CONSTRUCAO LTDA",
                                "produto": "Colantes",
                                "volume": 0,
                                "meta": 5.75,
                                "atingimento": 0,
                                "descontoRs": 0
                            },
                            {
                                "id": 1,
                                "codigo": "1303008",
                                "razaoSocial": "POCAO MATERIAL DE CONSTRUCAO LTDA",
                                "produto": "Cimentos",
                                "volume": 0,
                                "meta": 18,
                                "atingimento": 0,
                                "descontoRs": 0
                            }
                        ],
                        "clienteId": 196852,
                        "inicioMes": "2026-08-01T00:00:00"
                    },
                    {
                        "id": 1968631,
                        "codigo": "1185509",
                        "razaoSocial": "CASA COMERCIO MATERIAIS CONSTRUCAO",
                        "aceite": true,
                        "volume": 3.08,
                        "meta": 7.130000000000001,
                        "atingimento": 0.4319775596072931,
                        "descontoRs": 0,
                        "verMais": [
                            {
                                "id": 2,
                                "codigo": "1185509",
                                "razaoSocial": "CASA COMERCIO MATERIAIS CONSTRUCAO",
                                "produto": "Impermeabilizantes",
                                "volume": 0,
                                "meta": 0.23,
                                "atingimento": 0,
                                "descontoRs": 0
                            },
                            {
                                "id": 5,
                                "codigo": "1185509",
                                "razaoSocial": "CASA COMERCIO MATERIAIS CONSTRUCAO",
                                "produto": "Cales",
                                "volume": 3.08,
                                "meta": 6.9,
                                "atingimento": 0.4463768115942029,
                                "descontoRs": 0
                            }
                        ],
                        "clienteId": 196863,
                        "inicioMes": "2026-05-01T00:00:00"
                    },
                    {
                        "id": 1968631,
                        "codigo": "1185509",
                        "razaoSocial": "CASA COMERCIO MATERIAIS CONSTRUCAO",
                        "aceite": true,
                        "volume": 55.08,
                        "meta": 63.2,
                        "atingimento": 0.8715189873417721,
                        "descontoRs": 0,
                        "verMais": [
                            {
                                "id": 3,
                                "codigo": "1185509",
                                "razaoSocial": "CASA COMERCIO MATERIAIS CONSTRUCAO",
                                "produto": "Rejuntes",
                                "volume": 0,
                                "meta": 0.2,
                                "atingimento": 0,
                                "descontoRs": 0
                            },
                            {
                                "id": 5,
                                "codigo": "1185509",
                                "razaoSocial": "CASA COMERCIO MATERIAIS CONSTRUCAO",
                                "produto": "Cales",
                                "volume": 3.08,
                                "meta": 5,
                                "atingimento": 0.616,
                                "descontoRs": 0
                            },
                            {
                                "id": 1,
                                "codigo": "1185509",
                                "razaoSocial": "CASA COMERCIO MATERIAIS CONSTRUCAO",
                                "produto": "Cimentos",
                                "volume": 52,
                                "meta": 58,
                                "atingimento": 0.896551724137931,
                                "descontoRs": 0
                            }
                        ],
                        "clienteId": 196863,
                        "inicioMes": "2026-04-01T00:00:00"
                    },
                    {
                        "id": 1968630,
                        "codigo": "1185509",
                        "razaoSocial": "CASA COMERCIO MATERIAIS CONSTRUCAO",
                        "aceite": false,
                        "volume": 0,
                        "meta": 84.34,
                        "atingimento": 0,
                        "descontoRs": 0,
                        "verMais": [
                            {
                                "id": 1,
                                "codigo": "1185509",
                                "razaoSocial": "CASA COMERCIO MATERIAIS CONSTRUCAO",
                                "produto": "Cimentos",
                                "volume": 0,
                                "meta": 84,
                                "atingimento": 0,
                                "descontoRs": 0
                            },
                            {
                                "id": 2,
                                "codigo": "1185509",
                                "razaoSocial": "CASA COMERCIO MATERIAIS CONSTRUCAO",
                                "produto": "Impermeabilizantes",
                                "volume": 0,
                                "meta": 0.34,
                                "atingimento": 0,
                                "descontoRs": 0
                            }
                        ],
                        "clienteId": 196863,
                        "inicioMes": "2026-08-01T00:00:00"
                    },
                    {
                        "id": 1968540,
                        "codigo": "1146279",
                        "razaoSocial": "PAULO FERROS MATERIAIS PARA",
                        "grupoCentralizador": "AREIÃO",
                        "aceite": false,
                        "volume": 0,
                        "meta": 2.0199999999999996,
                        "atingimento": 0,
                        "descontoRs": 0,
                        "verMais": [
                            {
                                "id": 3,
                                "codigo": "1146279",
                                "razaoSocial": "PAULO FERROS MATERIAIS PARA",
                                "grupoCentralizador": "AREIÃO",
                                "produto": "Rejuntes",
                                "volume": 0,
                                "meta": 0.01,
                                "atingimento": 0,
                                "descontoRs": 0
                            },
                            {
                                "id": 1,
                                "codigo": "1146279",
                                "razaoSocial": "PAULO FERROS MATERIAIS PARA",
                                "grupoCentralizador": "AREIÃO",
                                "produto": "Cimentos",
                                "volume": 0,
                                "meta": 2,
                                "atingimento": 0,
                                "descontoRs": 0
                            },
                            {
                                "id": 4,
                                "codigo": "1146279",
                                "razaoSocial": "PAULO FERROS MATERIAIS PARA",
                                "grupoCentralizador": "AREIÃO",
                                "produto": "Colantes",
                                "volume": 0,
                                "meta": 0.01,
                                "atingimento": 0,
                                "descontoRs": 0
                            }
                        ],
                        "clienteId": 196854,
                        "inicioMes": "2026-08-01T00:00:00"
                    },
                    {
                        "id": 1968541,
                        "codigo": "1146279",
                        "razaoSocial": "PAULO FERROS MATERIAIS PARA",
                        "grupoCentralizador": "AREIÃO",
                        "aceite": true,
                        "volume": 12.2,
                        "meta": 0,
                        "descontoRs": 0,
                        "verMais": [
                            {
                                "id": 4,
                                "codigo": "1146279",
                                "razaoSocial": "PAULO FERROS MATERIAIS PARA",
                                "grupoCentralizador": "AREIÃO",
                                "produto": "Colantes",
                                "volume": 0.2,
                                "meta": 0,
                                "descontoRs": 0
                            },
                            {
                                "id": 2,
                                "codigo": "1146279",
                                "razaoSocial": "PAULO FERROS MATERIAIS PARA",
                                "grupoCentralizador": "AREIÃO",
                                "produto": "Impermeabilizantes",
                                "volume": 0,
                                "meta": 0,
                                "descontoRs": 0
                            },
                            {
                                "id": 1,
                                "codigo": "1146279",
                                "razaoSocial": "PAULO FERROS MATERIAIS PARA",
                                "grupoCentralizador": "AREIÃO",
                                "produto": "Cimentos",
                                "volume": 12,
                                "meta": 0,
                                "descontoRs": 0
                            }
                        ],
                        "clienteId": 196854,
                        "inicioMes": "2026-07-01T00:00:00"
                    },
                    {
                        "id": 1735410,
                        "codigo": "1654458",
                        "razaoSocial": "AREIAO TERRA FORTE COMERCIO DE",
                        "grupoCentralizador": "AREIÃO",
                        "aceite": false,
                        "volume": 0,
                        "meta": 57.13,
                        "atingimento": 0,
                        "descontoRs": 0,
                        "verMais": [
                            {
                                "id": 4,
                                "codigo": "1654458",
                                "razaoSocial": "AREIAO TERRA FORTE COMERCIO DE",
                                "grupoCentralizador": "AREIÃO",
                                "produto": "Colantes",
                                "volume": 0,
                                "meta": 6.9,
                                "atingimento": 0,
                                "descontoRs": 0
                            },
                            {
                                "id": 3,
                                "codigo": "1654458",
                                "razaoSocial": "AREIAO TERRA FORTE COMERCIO DE",
                                "grupoCentralizador": "AREIÃO",
                                "produto": "Rejuntes",
                                "volume": 0,
                                "meta": 0.23,
                                "atingimento": 0,
                                "descontoRs": 0
                            },
                            {
                                "id": 1,
                                "codigo": "1654458",
                                "razaoSocial": "AREIAO TERRA FORTE COMERCIO DE",
                                "grupoCentralizador": "AREIÃO",
                                "produto": "Cimentos",
                                "volume": 0,
                                "meta": 50,
                                "atingimento": 0,
                                "descontoRs": 0
                            }
                        ],
                        "clienteId": 173541,
                        "inicioMes": "2026-08-01T00:00:00"
                    },
                    {
                        "id": 1735411,
                        "codigo": "1654458",
                        "razaoSocial": "AREIAO TERRA FORTE COMERCIO DE",
                        "grupoCentralizador": "AREIÃO",
                        "aceite": true,
                        "volume": 16.6,
                        "meta": 36.2,
                        "atingimento": 0.4585635359116022,
                        "descontoRs": 448,
                        "verMais": [
                            {
                                "id": 1,
                                "codigo": "1654458",
                                "razaoSocial": "AREIAO TERRA FORTE COMERCIO DE",
                                "grupoCentralizador": "AREIÃO",
                                "produto": "Cimentos",
                                "volume": 16,
                                "meta": 30,
                                "atingimento": 0.5333333333333333,
                                "descontoRs": 448
                            },
                            {
                                "id": 4,
                                "codigo": "1654458",
                                "razaoSocial": "AREIAO TERRA FORTE COMERCIO DE",
                                "grupoCentralizador": "AREIÃO",
                                "produto": "Colantes",
                                "volume": 0.6,
                                "meta": 6,
                                "atingimento": 0.09999999999999999,
                                "descontoRs": 0
                            },
                            {
                                "id": 2,
                                "codigo": "1654458",
                                "razaoSocial": "AREIAO TERRA FORTE COMERCIO DE",
                                "grupoCentralizador": "AREIÃO",
                                "produto": "Impermeabilizantes",
                                "volume": 0,
                                "meta": 0.2,
                                "atingimento": 0,
                                "descontoRs": 0
                            }
                        ],
                        "clienteId": 173541,
                        "inicioMes": "2026-07-01T00:00:00"
                    },
                    {
                        "id": 1968291,
                        "codigo": "1544786",
                        "razaoSocial": "COSTA ATACADISTA DA CONSTRUCAO LTDA",
                        "grupoCentralizador": "COSTA ATACADISTA",
                        "aceite": true,
                        "volume": 42.336,
                        "meta": 43,
                        "atingimento": 0.9845581395348837,
                        "descontoRs": 1344,
                        "verMais": [
                            {
                                "id": 3,
                                "codigo": "1544786",
                                "razaoSocial": "COSTA ATACADISTA DA CONSTRUCAO LTDA",
                                "grupoCentralizador": "COSTA ATACADISTA",
                                "produto": "Rejuntes",
                                "volume": 0.12,
                                "meta": 0.6,
                                "atingimento": 0.2,
                                "descontoRs": 0
                            },
                            {
                                "id": 4,
                                "codigo": "1544786",
                                "razaoSocial": "COSTA ATACADISTA DA CONSTRUCAO LTDA",
                                "grupoCentralizador": "COSTA ATACADISTA",
                                "produto": "Colantes",
                                "volume": 42,
                                "meta": 42,
                                "atingimento": 1,
                                "descontoRs": 1344
                            },
                            {
                                "id": 2,
                                "codigo": "1544786",
                                "razaoSocial": "COSTA ATACADISTA DA CONSTRUCAO LTDA",
                                "grupoCentralizador": "COSTA ATACADISTA",
                                "produto": "Impermeabilizantes",
                                "volume": 0.216,
                                "meta": 0.4,
                                "atingimento": 0.5399999999999999,
                                "descontoRs": 0
                            }
                        ],
                        "clienteId": 196829,
                        "inicioMes": "2026-05-01T00:00:00"
                    },
                    {
                        "id": 1968291,
                        "codigo": "1544786",
                        "razaoSocial": "COSTA ATACADISTA DA CONSTRUCAO LTDA",
                        "grupoCentralizador": "COSTA ATACADISTA",
                        "aceite": true,
                        "volume": 236.47,
                        "meta": 228.82000000000002,
                        "atingimento": 1.0334323922734026,
                        "descontoRs": 4454,
                        "verMais": [
                            {
                                "id": 4,
                                "codigo": "1544786",
                                "razaoSocial": "COSTA ATACADISTA DA CONSTRUCAO LTDA",
                                "grupoCentralizador": "COSTA ATACADISTA",
                                "produto": "Colantes",
                                "volume": 38,
                                "meta": 38,
                                "atingimento": 1,
                                "descontoRs": 1520
                            },
                            {
                                "id": 3,
                                "codigo": "1544786",
                                "razaoSocial": "COSTA ATACADISTA DA CONSTRUCAO LTDA",
                                "grupoCentralizador": "COSTA ATACADISTA",
                                "produto": "Rejuntes",
                                "volume": 0.2,
                                "meta": 0.52,
                                "atingimento": 0.38461538461538464,
                                "descontoRs": 0
                            },
                            {
                                "id": 1,
                                "codigo": "1544786",
                                "razaoSocial": "COSTA ATACADISTA DA CONSTRUCAO LTDA",
                                "grupoCentralizador": "COSTA ATACADISTA",
                                "produto": "Cimentos",
                                "volume": 198,
                                "meta": 190,
                                "atingimento": 1.0421052631578946,
                                "descontoRs": 2772
                            },
                            {
                                "id": 2,
                                "codigo": "1544786",
                                "razaoSocial": "COSTA ATACADISTA DA CONSTRUCAO LTDA",
                                "grupoCentralizador": "COSTA ATACADISTA",
                                "produto": "Impermeabilizantes",
                                "volume": 0.27,
                                "meta": 0.3,
                                "atingimento": 0.9000000000000001,
                                "descontoRs": 162
                            }
                        ],
                        "clienteId": 196829,
                        "inicioMes": "2026-07-01T00:00:00"
                    },
                    {
                        "id": 1968291,
                        "codigo": "1544786",
                        "razaoSocial": "COSTA ATACADISTA DA CONSTRUCAO LTDA",
                        "grupoCentralizador": "COSTA ATACADISTA",
                        "aceite": true,
                        "volume": 169.01600000000002,
                        "meta": 129.8,
                        "atingimento": 1.3021263482280432,
                        "descontoRs": 2673,
                        "verMais": [
                            {
                                "id": 1,
                                "codigo": "1544786",
                                "razaoSocial": "COSTA ATACADISTA DA CONSTRUCAO LTDA",
                                "grupoCentralizador": "COSTA ATACADISTA",
                                "produto": "Cimentos",
                                "volume": 138,
                                "meta": 105,
                                "atingimento": 1.3142857142857143,
                                "descontoRs": 1617
                            },
                            {
                                "id": 3,
                                "codigo": "1544786",
                                "razaoSocial": "COSTA ATACADISTA DA CONSTRUCAO LTDA",
                                "grupoCentralizador": "COSTA ATACADISTA",
                                "produto": "Rejuntes",
                                "volume": 0,
                                "meta": 0.5,
                                "atingimento": 0,
                                "descontoRs": 0
                            },
                            {
                                "id": 4,
                                "codigo": "1544786",
                                "razaoSocial": "COSTA ATACADISTA DA CONSTRUCAO LTDA",
                                "grupoCentralizador": "COSTA ATACADISTA",
                                "produto": "Colantes",
                                "volume": 30.8,
                                "meta": 24,
                                "atingimento": 1.2833333333333334,
                                "descontoRs": 1056
                            },
                            {
                                "id": 2,
                                "codigo": "1544786",
                                "razaoSocial": "COSTA ATACADISTA DA CONSTRUCAO LTDA",
                                "grupoCentralizador": "COSTA ATACADISTA",
                                "produto": "Impermeabilizantes",
                                "volume": 0.216,
                                "meta": 0.3,
                                "atingimento": 0.72,
                                "descontoRs": 0
                            }
                        ],
                        "clienteId": 196829,
                        "inicioMes": "2026-04-01T00:00:00"
                    },
                    {
                        "id": 1968291,
                        "codigo": "1544786",
                        "razaoSocial": "COSTA ATACADISTA DA CONSTRUCAO LTDA",
                        "grupoCentralizador": "COSTA ATACADISTA",
                        "aceite": true,
                        "volume": 0,
                        "meta": 196.46,
                        "atingimento": 0,
                        "descontoRs": 0,
                        "verMais": [
                            {
                                "id": 4,
                                "codigo": "1544786",
                                "razaoSocial": "COSTA ATACADISTA DA CONSTRUCAO LTDA",
                                "grupoCentralizador": "COSTA ATACADISTA",
                                "produto": "Colantes",
                                "volume": 0,
                                "meta": 42,
                                "atingimento": 0,
                                "descontoRs": 0
                            },
                            {
                                "id": 2,
                                "codigo": "1544786",
                                "razaoSocial": "COSTA ATACADISTA DA CONSTRUCAO LTDA",
                                "grupoCentralizador": "COSTA ATACADISTA",
                                "produto": "Impermeabilizantes",
                                "volume": 0,
                                "meta": 0.2,
                                "atingimento": 0,
                                "descontoRs": 0
                            },
                            {
                                "id": 3,
                                "codigo": "1544786",
                                "razaoSocial": "COSTA ATACADISTA DA CONSTRUCAO LTDA",
                                "grupoCentralizador": "COSTA ATACADISTA",
                                "produto": "Rejuntes",
                                "volume": 0,
                                "meta": 0.26,
                                "atingimento": 0,
                                "descontoRs": 0
                            },
                            {
                                "id": 1,
                                "codigo": "1544786",
                                "razaoSocial": "COSTA ATACADISTA DA CONSTRUCAO LTDA",
                                "grupoCentralizador": "COSTA ATACADISTA",
                                "produto": "Cimentos",
                                "volume": 0,
                                "meta": 154,
                                "atingimento": 0,
                                "descontoRs": 0
                            }
                        ],
                        "clienteId": 196829,
                        "inicioMes": "2026-08-01T00:00:00"
                    },
                    {
                        "id": 545381,
                        "codigo": "1056239",
                        "razaoSocial": "MARGETEC MATERIAIS PARA CONSTRUCAO",
                        "grupoCentralizador": "AMARELINHO",
                        "aceite": true,
                        "volume": 95.83500000000001,
                        "meta": 74.9,
                        "atingimento": 1.2795060080106808,
                        "descontoRs": 1056,
                        "verMais": [
                            {
                                "id": 1,
                                "codigo": "1056239",
                                "razaoSocial": "MARGETEC MATERIAIS PARA CONSTRUCAO",
                                "grupoCentralizador": "AMARELINHO",
                                "produto": "Cimentos",
                                "volume": 83,
                                "meta": 60,
                                "atingimento": 1.3833333333333333,
                                "descontoRs": 924
                            },
                            {
                                "id": 4,
                                "codigo": "1056239",
                                "razaoSocial": "MARGETEC MATERIAIS PARA CONSTRUCAO",
                                "grupoCentralizador": "AMARELINHO",
                                "produto": "Colantes",
                                "volume": 12.12,
                                "meta": 14.3,
                                "atingimento": 0.8475524475524474,
                                "descontoRs": 0
                            },
                            {
                                "id": 3,
                                "codigo": "1056239",
                                "razaoSocial": "MARGETEC MATERIAIS PARA CONSTRUCAO",
                                "grupoCentralizador": "AMARELINHO",
                                "produto": "Rejuntes",
                                "volume": 0.28,
                                "meta": 0.4,
                                "atingimento": 0.7000000000000001,
                                "descontoRs": 0
                            },
                            {
                                "id": 2,
                                "codigo": "1056239",
                                "razaoSocial": "MARGETEC MATERIAIS PARA CONSTRUCAO",
                                "grupoCentralizador": "AMARELINHO",
                                "produto": "Impermeabilizantes",
                                "volume": 0.435,
                                "meta": 0.2,
                                "atingimento": 2.175,
                                "descontoRs": 132
                            }
                        ],
                        "clienteId": 54538,
                        "inicioMes": "2026-04-01T00:00:00"
                    },
                    {
                        "id": 190051,
                        "codigo": "1053116",
                        "razaoSocial": "MARGETEL COMERCIO DE MATERIAIS",
                        "grupoCentralizador": "AMARELINHO",
                        "aceite": true,
                        "volume": 64.4,
                        "meta": 100.7,
                        "atingimento": 0.6395233366434956,
                        "descontoRs": 776,
                        "verMais": [
                            {
                                "id": 4,
                                "codigo": "1053116",
                                "razaoSocial": "MARGETEL COMERCIO DE MATERIAIS",
                                "grupoCentralizador": "AMARELINHO",
                                "produto": "Colantes",
                                "volume": 22,
                                "meta": 20,
                                "atingimento": 1.1,
                                "descontoRs": 616
                            },
                            {
                                "id": 3,
                                "codigo": "1053116",
                                "razaoSocial": "MARGETEL COMERCIO DE MATERIAIS",
                                "grupoCentralizador": "AMARELINHO",
                                "produto": "Rejuntes",
                                "volume": 0.4,
                                "meta": 0.4,
                                "atingimento": 1,
                                "descontoRs": 160
                            },
                            {
                                "id": 2,
                                "codigo": "1053116",
                                "razaoSocial": "MARGETEL COMERCIO DE MATERIAIS",
                                "grupoCentralizador": "AMARELINHO",
                                "produto": "Impermeabilizantes",
                                "volume": 0,
                                "meta": 0.3,
                                "atingimento": 0,
                                "descontoRs": 0
                            },
                            {
                                "id": 1,
                                "codigo": "1053116",
                                "razaoSocial": "MARGETEL COMERCIO DE MATERIAIS",
                                "grupoCentralizador": "AMARELINHO",
                                "produto": "Cimentos",
                                "volume": 42,
                                "meta": 80,
                                "atingimento": 0.525,
                                "descontoRs": 0
                            }
                        ],
                        "clienteId": 19005,
                        "inicioMes": "2026-05-01T00:00:00"
                    },
                    {
                        "id": 11305400,
                        "codigo": "1904962",
                        "razaoSocial": "CASA DUTRA REVENDEDORA DE MATERIAIS",
                        "grupoCentralizador": "TOCA LOJA DISTRIBUIDORA",
                        "aceite": false,
                        "volume": 0,
                        "meta": 2.0299999999999994,
                        "atingimento": 0,
                        "descontoRs": 0,
                        "verMais": [
                            {
                                "id": 2,
                                "codigo": "1904962",
                                "razaoSocial": "CASA DUTRA REVENDEDORA DE MATERIAIS",
                                "grupoCentralizador": "TOCA LOJA DISTRIBUIDORA",
                                "produto": "Impermeabilizantes",
                                "volume": 0,
                                "meta": 0.01,
                                "atingimento": 0,
                                "descontoRs": 0
                            },
                            {
                                "id": 1,
                                "codigo": "1904962",
                                "razaoSocial": "CASA DUTRA REVENDEDORA DE MATERIAIS",
                                "grupoCentralizador": "TOCA LOJA DISTRIBUIDORA",
                                "produto": "Cimentos",
                                "volume": 0,
                                "meta": 2,
                                "atingimento": 0,
                                "descontoRs": 0
                            },
                            {
                                "id": 4,
                                "codigo": "1904962",
                                "razaoSocial": "CASA DUTRA REVENDEDORA DE MATERIAIS",
                                "grupoCentralizador": "TOCA LOJA DISTRIBUIDORA",
                                "produto": "Colantes",
                                "volume": 0,
                                "meta": 0.01,
                                "atingimento": 0,
                                "descontoRs": 0
                            },
                            {
                                "id": 3,
                                "codigo": "1904962",
                                "razaoSocial": "CASA DUTRA REVENDEDORA DE MATERIAIS",
                                "grupoCentralizador": "TOCA LOJA DISTRIBUIDORA",
                                "produto": "Rejuntes",
                                "volume": 0,
                                "meta": 0.01,
                                "atingimento": 0,
                                "descontoRs": 0
                            }
                        ],
                        "clienteId": 1130540,
                        "inicioMes": "2026-08-01T00:00:00"
                    },
                    {
                        "id": 11305401,
                        "codigo": "1904962",
                        "razaoSocial": "CASA DUTRA REVENDEDORA DE MATERIAIS",
                        "grupoCentralizador": "TOCA LOJA DISTRIBUIDORA",
                        "aceite": true,
                        "volume": 0,
                        "meta": 21.099999999999998,
                        "atingimento": 0,
                        "descontoRs": 0,
                        "verMais": [
                            {
                                "id": 1,
                                "codigo": "1904962",
                                "razaoSocial": "CASA DUTRA REVENDEDORA DE MATERIAIS",
                                "grupoCentralizador": "TOCA LOJA DISTRIBUIDORA",
                                "produto": "Cimentos",
                                "volume": 0,
                                "meta": 16,
                                "atingimento": 0,
                                "descontoRs": 0
                            },
                            {
                                "id": 3,
                                "codigo": "1904962",
                                "razaoSocial": "CASA DUTRA REVENDEDORA DE MATERIAIS",
                                "grupoCentralizador": "TOCA LOJA DISTRIBUIDORA",
                                "produto": "Rejuntes",
                                "volume": 0,
                                "meta": 0.3,
                                "atingimento": 0,
                                "descontoRs": 0
                            },
                            {
                                "id": 4,
                                "codigo": "1904962",
                                "razaoSocial": "CASA DUTRA REVENDEDORA DE MATERIAIS",
                                "grupoCentralizador": "TOCA LOJA DISTRIBUIDORA",
                                "produto": "Colantes",
                                "volume": 0,
                                "meta": 4.6,
                                "atingimento": 0,
                                "descontoRs": 0
                            },
                            {
                                "id": 2,
                                "codigo": "1904962",
                                "razaoSocial": "CASA DUTRA REVENDEDORA DE MATERIAIS",
                                "grupoCentralizador": "TOCA LOJA DISTRIBUIDORA",
                                "produto": "Impermeabilizantes",
                                "volume": 0,
                                "meta": 0.2,
                                "atingimento": 0,
                                "descontoRs": 0
                            }
                        ],
                        "clienteId": 1130540,
                        "inicioMes": "2026-06-01T00:00:00"
                    },
                    {
                        "id": 11305401,
                        "codigo": "1904962",
                        "razaoSocial": "CASA DUTRA REVENDEDORA DE MATERIAIS",
                        "grupoCentralizador": "TOCA LOJA DISTRIBUIDORA",
                        "aceite": true,
                        "volume": 0,
                        "meta": 0,
                        "descontoRs": 0,
                        "verMais": [
                            {
                                "id": 4,
                                "codigo": "1904962",
                                "razaoSocial": "CASA DUTRA REVENDEDORA DE MATERIAIS",
                                "grupoCentralizador": "TOCA LOJA DISTRIBUIDORA",
                                "produto": "Colantes",
                                "volume": 0,
                                "meta": 0,
                                "descontoRs": 0
                            },
                            {
                                "id": 1,
                                "codigo": "1904962",
                                "razaoSocial": "CASA DUTRA REVENDEDORA DE MATERIAIS",
                                "grupoCentralizador": "TOCA LOJA DISTRIBUIDORA",
                                "produto": "Cimentos",
                                "volume": 0,
                                "meta": 0,
                                "descontoRs": 0
                            },
                            {
                                "id": 2,
                                "codigo": "1904962",
                                "razaoSocial": "CASA DUTRA REVENDEDORA DE MATERIAIS",
                                "grupoCentralizador": "TOCA LOJA DISTRIBUIDORA",
                                "produto": "Impermeabilizantes",
                                "volume": 0,
                                "meta": 0,
                                "descontoRs": 0
                            },
                            {
                                "id": 3,
                                "codigo": "1904962",
                                "razaoSocial": "CASA DUTRA REVENDEDORA DE MATERIAIS",
                                "grupoCentralizador": "TOCA LOJA DISTRIBUIDORA",
                                "produto": "Rejuntes",
                                "volume": 0,
                                "meta": 0,
                                "descontoRs": 0
                            }
                        ],
                        "clienteId": 1130540,
                        "inicioMes": "2026-07-01T00:00:00"
                    },
                    {
                        "id": 6623310,
                        "codigo": "1842155",
                        "razaoSocial": "TOCA LOJA DISTRIBUIDORA LTDA",
                        "grupoCentralizador": "TOCA LOJA DISTRIBUIDORA",
                        "aceite": false,
                        "volume": 0,
                        "meta": 216.88,
                        "atingimento": 0,
                        "descontoRs": 0,
                        "verMais": [
                            {
                                "id": 3,
                                "codigo": "1842155",
                                "razaoSocial": "TOCA LOJA DISTRIBUIDORA LTDA",
                                "grupoCentralizador": "TOCA LOJA DISTRIBUIDORA",
                                "produto": "Rejuntes",
                                "volume": 0,
                                "meta": 0.34,
                                "atingimento": 0,
                                "descontoRs": 0
                            },
                            {
                                "id": 1,
                                "codigo": "1842155",
                                "razaoSocial": "TOCA LOJA DISTRIBUIDORA LTDA",
                                "grupoCentralizador": "TOCA LOJA DISTRIBUIDORA",
                                "produto": "Cimentos",
                                "volume": 0,
                                "meta": 184,
                                "atingimento": 0,
                                "descontoRs": 0
                            },
                            {
                                "id": 2,
                                "codigo": "1842155",
                                "razaoSocial": "TOCA LOJA DISTRIBUIDORA LTDA",
                                "grupoCentralizador": "TOCA LOJA DISTRIBUIDORA",
                                "produto": "Impermeabilizantes",
                                "volume": 0,
                                "meta": 0.34,
                                "atingimento": 0,
                                "descontoRs": 0
                            },
                            {
                                "id": 4,
                                "codigo": "1842155",
                                "razaoSocial": "TOCA LOJA DISTRIBUIDORA LTDA",
                                "grupoCentralizador": "TOCA LOJA DISTRIBUIDORA",
                                "produto": "Colantes",
                                "volume": 0,
                                "meta": 32.2,
                                "atingimento": 0,
                                "descontoRs": 0
                            }
                        ],
                        "clienteId": 662331,
                        "inicioMes": "2026-08-01T00:00:00"
                    },
                    {
                        "id": 6623311,
                        "codigo": "1842155",
                        "razaoSocial": "TOCA LOJA DISTRIBUIDORA LTDA",
                        "grupoCentralizador": "TOCA LOJA DISTRIBUIDORA",
                        "aceite": true,
                        "volume": 54.9,
                        "meta": 140.945,
                        "atingimento": 0.38951364007236866,
                        "descontoRs": 0,
                        "verMais": [
                            {
                                "id": 5,
                                "codigo": "1842155",
                                "razaoSocial": "TOCA LOJA DISTRIBUIDORA LTDA",
                                "grupoCentralizador": "TOCA LOJA DISTRIBUIDORA",
                                "produto": "Cales",
                                "volume": 0,
                                "meta": 4.6,
                                "atingimento": 0,
                                "descontoRs": 0
                            },
                            {
                                "id": 4,
                                "codigo": "1842155",
                                "razaoSocial": "TOCA LOJA DISTRIBUIDORA LTDA",
                                "grupoCentralizador": "TOCA LOJA DISTRIBUIDORA",
                                "produto": "Colantes",
                                "volume": 2.4,
                                "meta": 16,
                                "atingimento": 0.15,
                                "descontoRs": 0
                            },
                            {
                                "id": 3,
                                "codigo": "1842155",
                                "razaoSocial": "TOCA LOJA DISTRIBUIDORA LTDA",
                                "grupoCentralizador": "TOCA LOJA DISTRIBUIDORA",
                                "produto": "Rejuntes",
                                "volume": 0,
                                "meta": 0.345,
                                "atingimento": 0,
                                "descontoRs": 0
                            },
                            {
                                "id": 1,
                                "codigo": "1842155",
                                "razaoSocial": "TOCA LOJA DISTRIBUIDORA LTDA",
                                "grupoCentralizador": "TOCA LOJA DISTRIBUIDORA",
                                "produto": "Cimentos",
                                "volume": 52.5,
                                "meta": 120,
                                "atingimento": 0.4375,
                                "descontoRs": 0
                            }
                        ],
                        "clienteId": 662331,
                        "inicioMes": "2026-05-01T00:00:00"
                    },
                    {
                        "id": 6623311,
                        "codigo": "1842155",
                        "razaoSocial": "TOCA LOJA DISTRIBUIDORA LTDA",
                        "grupoCentralizador": "TOCA LOJA DISTRIBUIDORA",
                        "aceite": true,
                        "volume": 186.5,
                        "meta": 170.79999999999998,
                        "atingimento": 1.09192037470726,
                        "descontoRs": 2625,
                        "verMais": [
                            {
                                "id": 4,
                                "codigo": "1842155",
                                "razaoSocial": "TOCA LOJA DISTRIBUIDORA LTDA",
                                "grupoCentralizador": "TOCA LOJA DISTRIBUIDORA",
                                "produto": "Colantes",
                                "volume": 32.8,
                                "meta": 18,
                                "atingimento": 1.822222222222222,
                                "descontoRs": 693
                            },
                            {
                                "id": 3,
                                "codigo": "1842155",
                                "razaoSocial": "TOCA LOJA DISTRIBUIDORA LTDA",
                                "grupoCentralizador": "TOCA LOJA DISTRIBUIDORA",
                                "produto": "Rejuntes",
                                "volume": 0.02,
                                "meta": 0.6,
                                "atingimento": 0.03333333333333333,
                                "descontoRs": 0
                            },
                            {
                                "id": 1,
                                "codigo": "1842155",
                                "razaoSocial": "TOCA LOJA DISTRIBUIDORA LTDA",
                                "grupoCentralizador": "TOCA LOJA DISTRIBUIDORA",
                                "produto": "Cimentos",
                                "volume": 153.5,
                                "meta": 152,
                                "atingimento": 1.0098684210526316,
                                "descontoRs": 1842
                            },
                            {
                                "id": 2,
                                "codigo": "1842155",
                                "razaoSocial": "TOCA LOJA DISTRIBUIDORA LTDA",
                                "grupoCentralizador": "TOCA LOJA DISTRIBUIDORA",
                                "produto": "Impermeabilizantes",
                                "volume": 0.18,
                                "meta": 0.2,
                                "atingimento": 0.8999999999999999,
                                "descontoRs": 90
                            }
                        ],
                        "clienteId": 662331,
                        "inicioMes": "2026-07-01T00:00:00"
                    },
                    {
                        "id": 6623311,
                        "codigo": "1842155",
                        "razaoSocial": "TOCA LOJA DISTRIBUIDORA LTDA",
                        "grupoCentralizador": "TOCA LOJA DISTRIBUIDORA",
                        "aceite": true,
                        "volume": 187.776,
                        "meta": 79.60000000000001,
                        "atingimento": 2.358994974874372,
                        "descontoRs": 1220.5,
                        "verMais": [
                            {
                                "id": 5,
                                "codigo": "1842155",
                                "razaoSocial": "TOCA LOJA DISTRIBUIDORA LTDA",
                                "grupoCentralizador": "TOCA LOJA DISTRIBUIDORA",
                                "produto": "Cales",
                                "volume": 4.16,
                                "meta": 4,
                                "atingimento": 1.04,
                                "descontoRs": 104
                            },
                            {
                                "id": 1,
                                "codigo": "1842155",
                                "razaoSocial": "TOCA LOJA DISTRIBUIDORA LTDA",
                                "grupoCentralizador": "TOCA LOJA DISTRIBUIDORA",
                                "produto": "Cimentos",
                                "volume": 157,
                                "meta": 70,
                                "atingimento": 2.242857142857143,
                                "descontoRs": 924
                            },
                            {
                                "id": 4,
                                "codigo": "1842155",
                                "razaoSocial": "TOCA LOJA DISTRIBUIDORA LTDA",
                                "grupoCentralizador": "TOCA LOJA DISTRIBUIDORA",
                                "produto": "Colantes",
                                "volume": 26.4,
                                "meta": 5,
                                "atingimento": 5.279999999999999,
                                "descontoRs": 192.5
                            },
                            {
                                "id": 2,
                                "codigo": "1842155",
                                "razaoSocial": "TOCA LOJA DISTRIBUIDORA LTDA",
                                "grupoCentralizador": "TOCA LOJA DISTRIBUIDORA",
                                "produto": "Impermeabilizantes",
                                "volume": 0.216,
                                "meta": 0.4,
                                "atingimento": 0.5399999999999999,
                                "descontoRs": 0
                            },
                            {
                                "id": 3,
                                "codigo": "1842155",
                                "razaoSocial": "TOCA LOJA DISTRIBUIDORA LTDA",
                                "grupoCentralizador": "TOCA LOJA DISTRIBUIDORA",
                                "produto": "Rejuntes",
                                "volume": 0,
                                "meta": 0.2,
                                "atingimento": 0,
                                "descontoRs": 0
                            }
                        ],
                        "clienteId": 662331,
                        "inicioMes": "2026-04-01T00:00:00"
                    },
                    {
                        "id": 6631921,
                        "codigo": "1842703",
                        "razaoSocial": "EDUARDO HENRIQUE EMICO DE ASSIS",
                        "grupoCentralizador": "VORTEX",
                        "aceite": true,
                        "volume": 0,
                        "meta": 14.3,
                        "atingimento": 0,
                        "descontoRs": 0,
                        "verMais": [
                            {
                                "id": 4,
                                "codigo": "1842703",
                                "razaoSocial": "EDUARDO HENRIQUE EMICO DE ASSIS",
                                "grupoCentralizador": "VORTEX",
                                "produto": "Colantes",
                                "volume": 0,
                                "meta": 2,
                                "atingimento": 0,
                                "descontoRs": 0
                            },
                            {
                                "id": 1,
                                "codigo": "1842703",
                                "razaoSocial": "EDUARDO HENRIQUE EMICO DE ASSIS",
                                "grupoCentralizador": "VORTEX",
                                "produto": "Cimentos",
                                "volume": 0,
                                "meta": 12,
                                "atingimento": 0,
                                "descontoRs": 0
                            },
                            {
                                "id": 3,
                                "codigo": "1842703",
                                "razaoSocial": "EDUARDO HENRIQUE EMICO DE ASSIS",
                                "grupoCentralizador": "VORTEX",
                                "produto": "Rejuntes",
                                "volume": 0,
                                "meta": 0.3,
                                "atingimento": 0,
                                "descontoRs": 0
                            }
                        ],
                        "clienteId": 663192,
                        "inicioMes": "2026-06-01T00:00:00"
                    },
                    {
                        "id": 6631921,
                        "codigo": "1842703",
                        "razaoSocial": "EDUARDO HENRIQUE EMICO DE ASSIS",
                        "grupoCentralizador": "VORTEX",
                        "aceite": true,
                        "volume": 14,
                        "meta": 0,
                        "descontoRs": 0,
                        "verMais": [
                            {
                                "id": 4,
                                "codigo": "1842703",
                                "razaoSocial": "EDUARDO HENRIQUE EMICO DE ASSIS",
                                "grupoCentralizador": "VORTEX",
                                "produto": "Colantes",
                                "volume": 2,
                                "meta": 0,
                                "descontoRs": 0
                            },
                            {
                                "id": 3,
                                "codigo": "1842703",
                                "razaoSocial": "EDUARDO HENRIQUE EMICO DE ASSIS",
                                "grupoCentralizador": "VORTEX",
                                "produto": "Rejuntes",
                                "volume": 0,
                                "meta": 0,
                                "descontoRs": 0
                            },
                            {
                                "id": 1,
                                "codigo": "1842703",
                                "razaoSocial": "EDUARDO HENRIQUE EMICO DE ASSIS",
                                "grupoCentralizador": "VORTEX",
                                "produto": "Cimentos",
                                "volume": 12,
                                "meta": 0,
                                "descontoRs": 0
                            }
                        ],
                        "clienteId": 663192,
                        "inicioMes": "2026-07-01T00:00:00"
                    },
                    {
                        "id": 1968641,
                        "codigo": "1226922",
                        "razaoSocial": "PEQUENO E POPULAR MATERIAIS PARA CO",
                        "grupoCentralizador": "VORTEX",
                        "aceite": true,
                        "volume": 13.2,
                        "meta": 0,
                        "descontoRs": 0,
                        "verMais": [
                            {
                                "id": 4,
                                "codigo": "1226922",
                                "razaoSocial": "PEQUENO E POPULAR MATERIAIS PARA CO",
                                "grupoCentralizador": "VORTEX",
                                "produto": "Colantes",
                                "volume": 1.2,
                                "meta": 0,
                                "descontoRs": 0
                            },
                            {
                                "id": 1,
                                "codigo": "1226922",
                                "razaoSocial": "PEQUENO E POPULAR MATERIAIS PARA CO",
                                "grupoCentralizador": "VORTEX",
                                "produto": "Cimentos",
                                "volume": 12,
                                "meta": 0,
                                "descontoRs": 0
                            },
                            {
                                "id": 3,
                                "codigo": "1226922",
                                "razaoSocial": "PEQUENO E POPULAR MATERIAIS PARA CO",
                                "grupoCentralizador": "VORTEX",
                                "produto": "Rejuntes",
                                "volume": 0,
                                "meta": 0,
                                "descontoRs": 0
                            }
                        ],
                        "clienteId": 196864,
                        "inicioMes": "2026-07-01T00:00:00"
                    },
                    {
                        "id": 1968641,
                        "codigo": "1226922",
                        "razaoSocial": "PEQUENO E POPULAR MATERIAIS PARA CO",
                        "grupoCentralizador": "VORTEX",
                        "aceite": true,
                        "volume": 0,
                        "meta": 12.2,
                        "atingimento": 0,
                        "descontoRs": 0,
                        "verMais": [
                            {
                                "id": 3,
                                "codigo": "1226922",
                                "razaoSocial": "PEQUENO E POPULAR MATERIAIS PARA CO",
                                "grupoCentralizador": "VORTEX",
                                "produto": "Rejuntes",
                                "volume": 0,
                                "meta": 0.2,
                                "atingimento": 0,
                                "descontoRs": 0
                            },
                            {
                                "id": 1,
                                "codigo": "1226922",
                                "razaoSocial": "PEQUENO E POPULAR MATERIAIS PARA CO",
                                "grupoCentralizador": "VORTEX",
                                "produto": "Cimentos",
                                "volume": 0,
                                "meta": 12,
                                "atingimento": 0,
                                "descontoRs": 0
                            }
                        ],
                        "clienteId": 196864,
                        "inicioMes": "2026-06-01T00:00:00"
                    },
                    {
                        "id": 1968351,
                        "codigo": "1345157",
                        "razaoSocial": "JOSE MATEUS DE ASSIS   ME",
                        "grupoCentralizador": "VORTEX",
                        "aceite": true,
                        "volume": 0,
                        "meta": 12.2,
                        "atingimento": 0,
                        "descontoRs": 0,
                        "verMais": [
                            {
                                "id": 1,
                                "codigo": "1345157",
                                "razaoSocial": "JOSE MATEUS DE ASSIS   ME",
                                "grupoCentralizador": "VORTEX",
                                "produto": "Cimentos",
                                "volume": 0,
                                "meta": 12,
                                "atingimento": 0,
                                "descontoRs": 0
                            },
                            {
                                "id": 2,
                                "codigo": "1345157",
                                "razaoSocial": "JOSE MATEUS DE ASSIS   ME",
                                "grupoCentralizador": "VORTEX",
                                "produto": "Impermeabilizantes",
                                "volume": 0,
                                "meta": 0.2,
                                "atingimento": 0,
                                "descontoRs": 0
                            }
                        ],
                        "clienteId": 196835,
                        "inicioMes": "2026-06-01T00:00:00"
                    },
                    {
                        "id": 1968351,
                        "codigo": "1345157",
                        "razaoSocial": "JOSE MATEUS DE ASSIS   ME",
                        "grupoCentralizador": "VORTEX",
                        "aceite": true,
                        "volume": 12.8,
                        "meta": 38.6,
                        "atingimento": 0.3316062176165803,
                        "descontoRs": 492.8,
                        "verMais": [
                            {
                                "id": 3,
                                "codigo": "1345157",
                                "razaoSocial": "JOSE MATEUS DE ASSIS   ME",
                                "grupoCentralizador": "VORTEX",
                                "produto": "Rejuntes",
                                "volume": 0,
                                "meta": 0.6,
                                "atingimento": 0,
                                "descontoRs": 0
                            },
                            {
                                "id": 1,
                                "codigo": "1345157",
                                "razaoSocial": "JOSE MATEUS DE ASSIS   ME",
                                "grupoCentralizador": "VORTEX",
                                "produto": "Cimentos",
                                "volume": 12,
                                "meta": 32,
                                "atingimento": 0.375,
                                "descontoRs": 492.8
                            },
                            {
                                "id": 4,
                                "codigo": "1345157",
                                "razaoSocial": "JOSE MATEUS DE ASSIS   ME",
                                "grupoCentralizador": "VORTEX",
                                "produto": "Colantes",
                                "volume": 0.8,
                                "meta": 6,
                                "atingimento": 0.13333333333333333,
                                "descontoRs": 0
                            }
                        ],
                        "clienteId": 196835,
                        "inicioMes": "2026-07-01T00:00:00"
                    },
                    {
                        "id": 542191,
                        "codigo": "1108711",
                        "razaoSocial": "ARNALDO ANDRADE CORREIA GUARULHOS",
                        "grupoCentralizador": "LENYSIO TELHAS",
                        "aceite": true,
                        "volume": 0,
                        "meta": 16,
                        "atingimento": 0,
                        "descontoRs": 0,
                        "verMais": [
                            {
                                "id": 1,
                                "codigo": "1108711",
                                "razaoSocial": "ARNALDO ANDRADE CORREIA GUARULHOS",
                                "grupoCentralizador": "LENYSIO TELHAS",
                                "produto": "Cimentos",
                                "volume": 0,
                                "meta": 16,
                                "atingimento": 0,
                                "descontoRs": 0
                            }
                        ],
                        "clienteId": 54219,
                        "inicioMes": "2026-08-01T00:00:00"
                    },
                    {
                        "id": 542191,
                        "codigo": "1108711",
                        "razaoSocial": "ARNALDO ANDRADE CORREIA GUARULHOS",
                        "grupoCentralizador": "LENYSIO TELHAS",
                        "aceite": true,
                        "volume": 22.799999999999997,
                        "meta": 28.1,
                        "atingimento": 0.8113879003558717,
                        "descontoRs": 0,
                        "verMais": [
                            {
                                "id": 3,
                                "codigo": "1108711",
                                "razaoSocial": "ARNALDO ANDRADE CORREIA GUARULHOS",
                                "grupoCentralizador": "LENYSIO TELHAS",
                                "produto": "Rejuntes",
                                "volume": 0.4,
                                "meta": 0.5,
                                "atingimento": 0.8,
                                "descontoRs": 0
                            },
                            {
                                "id": 4,
                                "codigo": "1108711",
                                "razaoSocial": "ARNALDO ANDRADE CORREIA GUARULHOS",
                                "grupoCentralizador": "LENYSIO TELHAS",
                                "produto": "Colantes",
                                "volume": 22.4,
                                "meta": 27.6,
                                "atingimento": 0.8115942028985507,
                                "descontoRs": 0
                            }
                        ],
                        "clienteId": 54219,
                        "inicioMes": "2026-06-01T00:00:00"
                    },
                    {
                        "id": 542191,
                        "codigo": "1108711",
                        "razaoSocial": "ARNALDO ANDRADE CORREIA GUARULHOS",
                        "grupoCentralizador": "LENYSIO TELHAS",
                        "aceite": true,
                        "volume": 33.2,
                        "meta": 28.4,
                        "atingimento": 1.1690140845070425,
                        "descontoRs": 646.8,
                        "verMais": [
                            {
                                "id": 1,
                                "codigo": "1108711",
                                "razaoSocial": "ARNALDO ANDRADE CORREIA GUARULHOS",
                                "grupoCentralizador": "LENYSIO TELHAS",
                                "produto": "Cimentos",
                                "volume": 20,
                                "meta": 14,
                                "atingimento": 1.4285714285714286,
                                "descontoRs": 184.8
                            },
                            {
                                "id": 3,
                                "codigo": "1108711",
                                "razaoSocial": "ARNALDO ANDRADE CORREIA GUARULHOS",
                                "grupoCentralizador": "LENYSIO TELHAS",
                                "produto": "Rejuntes",
                                "volume": 0,
                                "meta": 0.4,
                                "atingimento": 0,
                                "descontoRs": 0
                            },
                            {
                                "id": 4,
                                "codigo": "1108711",
                                "razaoSocial": "ARNALDO ANDRADE CORREIA GUARULHOS",
                                "grupoCentralizador": "LENYSIO TELHAS",
                                "produto": "Colantes",
                                "volume": 13.2,
                                "meta": 14,
                                "atingimento": 0.9428571428571428,
                                "descontoRs": 462
                            }
                        ],
                        "clienteId": 54219,
                        "inicioMes": "2026-04-01T00:00:00"
                    },
                    {
                        "id": 542191,
                        "codigo": "1108711",
                        "razaoSocial": "ARNALDO ANDRADE CORREIA GUARULHOS",
                        "grupoCentralizador": "LENYSIO TELHAS",
                        "aceite": true,
                        "volume": 39.28,
                        "meta": 37.92,
                        "atingimento": 1.0358649789029535,
                        "descontoRs": 1369.08,
                        "verMais": [
                            {
                                "id": 3,
                                "codigo": "1108711",
                                "razaoSocial": "ARNALDO ANDRADE CORREIA GUARULHOS",
                                "grupoCentralizador": "LENYSIO TELHAS",
                                "produto": "Rejuntes",
                                "volume": 0.48,
                                "meta": 0.52,
                                "atingimento": 0.923076923076923,
                                "descontoRs": 288
                            },
                            {
                                "id": 4,
                                "codigo": "1108711",
                                "razaoSocial": "ARNALDO ANDRADE CORREIA GUARULHOS",
                                "grupoCentralizador": "LENYSIO TELHAS",
                                "produto": "Colantes",
                                "volume": 26.8,
                                "meta": 23.4,
                                "atingimento": 1.1452991452991454,
                                "descontoRs": 1081.08
                            },
                            {
                                "id": 1,
                                "codigo": "1108711",
                                "razaoSocial": "ARNALDO ANDRADE CORREIA GUARULHOS",
                                "grupoCentralizador": "LENYSIO TELHAS",
                                "produto": "Cimentos",
                                "volume": 12,
                                "meta": 14,
                                "atingimento": 0.8571428571428571,
                                "descontoRs": 0
                            }
                        ],
                        "clienteId": 54219,
                        "inicioMes": "2026-05-01T00:00:00"
                    },
                    {
                        "id": 542191,
                        "codigo": "1108711",
                        "razaoSocial": "ARNALDO ANDRADE CORREIA GUARULHOS",
                        "grupoCentralizador": "LENYSIO TELHAS",
                        "aceite": true,
                        "volume": 52.54,
                        "meta": 0,
                        "descontoRs": 0,
                        "verMais": [
                            {
                                "id": 1,
                                "codigo": "1108711",
                                "razaoSocial": "ARNALDO ANDRADE CORREIA GUARULHOS",
                                "grupoCentralizador": "LENYSIO TELHAS",
                                "produto": "Cimentos",
                                "volume": 16,
                                "meta": 0,
                                "descontoRs": 0
                            },
                            {
                                "id": 3,
                                "codigo": "1108711",
                                "razaoSocial": "ARNALDO ANDRADE CORREIA GUARULHOS",
                                "grupoCentralizador": "LENYSIO TELHAS",
                                "produto": "Rejuntes",
                                "volume": 0.54,
                                "meta": 0,
                                "descontoRs": 0
                            },
                            {
                                "id": 4,
                                "codigo": "1108711",
                                "razaoSocial": "ARNALDO ANDRADE CORREIA GUARULHOS",
                                "grupoCentralizador": "LENYSIO TELHAS",
                                "produto": "Colantes",
                                "volume": 36,
                                "meta": 0,
                                "descontoRs": 0
                            },
                            {
                                "id": 2,
                                "codigo": "1108711",
                                "razaoSocial": "ARNALDO ANDRADE CORREIA GUARULHOS",
                                "grupoCentralizador": "LENYSIO TELHAS",
                                "produto": "Impermeabilizantes",
                                "volume": 0,
                                "meta": 0,
                                "descontoRs": 0
                            }
                        ],
                        "clienteId": 54219,
                        "inicioMes": "2026-07-01T00:00:00"
                    },
                    {
                        "id": 542241,
                        "codigo": "1146294",
                        "razaoSocial": "LENYSIO TELHAS LTDA",
                        "grupoCentralizador": "LENYSIO TELHAS",
                        "aceite": true,
                        "volume": 14,
                        "meta": 14.23,
                        "atingimento": 0.9838369641602248,
                        "descontoRs": 184.8,
                        "verMais": [
                            {
                                "id": 2,
                                "codigo": "1146294",
                                "razaoSocial": "LENYSIO TELHAS LTDA",
                                "grupoCentralizador": "LENYSIO TELHAS",
                                "produto": "Impermeabilizantes",
                                "volume": 0,
                                "meta": 0.23,
                                "atingimento": 0,
                                "descontoRs": 0
                            },
                            {
                                "id": 1,
                                "codigo": "1146294",
                                "razaoSocial": "LENYSIO TELHAS LTDA",
                                "grupoCentralizador": "LENYSIO TELHAS",
                                "produto": "Cimentos",
                                "volume": 14,
                                "meta": 14,
                                "atingimento": 1,
                                "descontoRs": 184.8
                            }
                        ],
                        "clienteId": 54224,
                        "inicioMes": "2026-06-01T00:00:00"
                    },
                    {
                        "id": 542241,
                        "codigo": "1146294",
                        "razaoSocial": "LENYSIO TELHAS LTDA",
                        "grupoCentralizador": "LENYSIO TELHAS",
                        "aceite": true,
                        "volume": 4.1,
                        "meta": 42.8,
                        "atingimento": 0.09579439252336448,
                        "descontoRs": 1807.2,
                        "verMais": [
                            {
                                "id": 4,
                                "codigo": "1146294",
                                "razaoSocial": "LENYSIO TELHAS LTDA",
                                "grupoCentralizador": "LENYSIO TELHAS",
                                "produto": "Colantes",
                                "volume": 2,
                                "meta": 28,
                                "atingimento": 0.07142857142857142,
                                "descontoRs": 1232
                            },
                            {
                                "id": 3,
                                "codigo": "1146294",
                                "razaoSocial": "LENYSIO TELHAS LTDA",
                                "grupoCentralizador": "LENYSIO TELHAS",
                                "produto": "Rejuntes",
                                "volume": 0.1,
                                "meta": 0.6,
                                "atingimento": 0.16666666666666669,
                                "descontoRs": 390.4
                            },
                            {
                                "id": 2,
                                "codigo": "1146294",
                                "razaoSocial": "LENYSIO TELHAS LTDA",
                                "grupoCentralizador": "LENYSIO TELHAS",
                                "produto": "Impermeabilizantes",
                                "volume": 0,
                                "meta": 0.2,
                                "atingimento": 0,
                                "descontoRs": 0
                            },
                            {
                                "id": 1,
                                "codigo": "1146294",
                                "razaoSocial": "LENYSIO TELHAS LTDA",
                                "grupoCentralizador": "LENYSIO TELHAS",
                                "produto": "Cimentos",
                                "volume": 2,
                                "meta": 14,
                                "atingimento": 0.14285714285714285,
                                "descontoRs": 184.8
                            }
                        ],
                        "clienteId": 54224,
                        "inicioMes": "2026-07-01T00:00:00"
                    },
                    {
                        "id": 542241,
                        "codigo": "1146294",
                        "razaoSocial": "LENYSIO TELHAS LTDA",
                        "grupoCentralizador": "LENYSIO TELHAS",
                        "aceite": true,
                        "volume": 0,
                        "meta": 24.5,
                        "atingimento": 0,
                        "descontoRs": 0,
                        "verMais": [
                            {
                                "id": 4,
                                "codigo": "1146294",
                                "razaoSocial": "LENYSIO TELHAS LTDA",
                                "grupoCentralizador": "LENYSIO TELHAS",
                                "produto": "Colantes",
                                "volume": 0,
                                "meta": 24,
                                "atingimento": 0,
                                "descontoRs": 0
                            },
                            {
                                "id": 1,
                                "codigo": "1146294",
                                "razaoSocial": "LENYSIO TELHAS LTDA",
                                "grupoCentralizador": "LENYSIO TELHAS",
                                "produto": "Cimentos",
                                "volume": 0,
                                "meta": 0,
                                "descontoRs": 0
                            },
                            {
                                "id": 3,
                                "codigo": "1146294",
                                "razaoSocial": "LENYSIO TELHAS LTDA",
                                "grupoCentralizador": "LENYSIO TELHAS",
                                "produto": "Rejuntes",
                                "volume": 0,
                                "meta": 0.5,
                                "atingimento": 0,
                                "descontoRs": 0
                            }
                        ],
                        "clienteId": 54224,
                        "inicioMes": "2026-08-01T00:00:00"
                    },
                    {
                        "id": 1803090,
                        "codigo": "1247422",
                        "razaoSocial": "DOIS IRMAOS CASIMIRO MATERIAIS PARA",
                        "grupoCentralizador": "IRMÃOS CASIMIRO",
                        "aceite": false,
                        "volume": 0,
                        "meta": 2.03,
                        "atingimento": 0,
                        "descontoRs": 0,
                        "verMais": [
                            {
                                "id": 3,
                                "codigo": "1247422",
                                "razaoSocial": "DOIS IRMAOS CASIMIRO MATERIAIS PARA",
                                "grupoCentralizador": "IRMÃOS CASIMIRO",
                                "produto": "Rejuntes",
                                "volume": 0,
                                "meta": 0.01,
                                "atingimento": 0,
                                "descontoRs": 0
                            },
                            {
                                "id": 2,
                                "codigo": "1247422",
                                "razaoSocial": "DOIS IRMAOS CASIMIRO MATERIAIS PARA",
                                "grupoCentralizador": "IRMÃOS CASIMIRO",
                                "produto": "Impermeabilizantes",
                                "volume": 0,
                                "meta": 0.01,
                                "atingimento": 0,
                                "descontoRs": 0
                            },
                            {
                                "id": 1,
                                "codigo": "1247422",
                                "razaoSocial": "DOIS IRMAOS CASIMIRO MATERIAIS PARA",
                                "grupoCentralizador": "IRMÃOS CASIMIRO",
                                "produto": "Cimentos",
                                "volume": 0,
                                "meta": 2,
                                "atingimento": 0,
                                "descontoRs": 0
                            },
                            {
                                "id": 4,
                                "codigo": "1247422",
                                "razaoSocial": "DOIS IRMAOS CASIMIRO MATERIAIS PARA",
                                "grupoCentralizador": "IRMÃOS CASIMIRO",
                                "produto": "Colantes",
                                "volume": 0,
                                "meta": 0.01,
                                "atingimento": 0,
                                "descontoRs": 0
                            }
                        ],
                        "clienteId": 180309,
                        "inicioMes": "2026-08-01T00:00:00"
                    },
                    {
                        "id": 1968620,
                        "codigo": "1052267",
                        "razaoSocial": "CASIMIRO DEPOSITO DE MATERIAIS PARA",
                        "grupoCentralizador": "IRMÃOS CASIMIRO",
                        "aceite": false,
                        "volume": 0,
                        "meta": 125.96000000000001,
                        "atingimento": 0,
                        "descontoRs": 0,
                        "verMais": [
                            {
                                "id": 3,
                                "codigo": "1052267",
                                "razaoSocial": "CASIMIRO DEPOSITO DE MATERIAIS PARA",
                                "grupoCentralizador": "IRMÃOS CASIMIRO",
                                "produto": "Rejuntes",
                                "volume": 0,
                                "meta": 0.23,
                                "atingimento": 0,
                                "descontoRs": 0
                            },
                            {
                                "id": 2,
                                "codigo": "1052267",
                                "razaoSocial": "CASIMIRO DEPOSITO DE MATERIAIS PARA",
                                "grupoCentralizador": "IRMÃOS CASIMIRO",
                                "produto": "Impermeabilizantes",
                                "volume": 0,
                                "meta": 0.23,
                                "atingimento": 0,
                                "descontoRs": 0
                            },
                            {
                                "id": 4,
                                "codigo": "1052267",
                                "razaoSocial": "CASIMIRO DEPOSITO DE MATERIAIS PARA",
                                "grupoCentralizador": "IRMÃOS CASIMIRO",
                                "produto": "Colantes",
                                "volume": 0,
                                "meta": 11.5,
                                "atingimento": 0,
                                "descontoRs": 0
                            },
                            {
                                "id": 1,
                                "codigo": "1052267",
                                "razaoSocial": "CASIMIRO DEPOSITO DE MATERIAIS PARA",
                                "grupoCentralizador": "IRMÃOS CASIMIRO",
                                "produto": "Cimentos",
                                "volume": 0,
                                "meta": 114,
                                "atingimento": 0,
                                "descontoRs": 0
                            }
                        ],
                        "clienteId": 196862,
                        "inicioMes": "2026-08-01T00:00:00"
                    },
                    {
                        "id": 542620,
                        "codigo": "1145966",
                        "razaoSocial": "MS MADEIRAS E MATERIAIS PARA",
                        "grupoCentralizador": "MADEIREIRA PRIMAVERA",
                        "aceite": false,
                        "volume": 0,
                        "meta": 2.1399999999999997,
                        "atingimento": 0,
                        "descontoRs": 0,
                        "verMais": [
                            {
                                "id": 4,
                                "codigo": "1145966",
                                "razaoSocial": "MS MADEIRAS E MATERIAIS PARA",
                                "grupoCentralizador": "MADEIREIRA PRIMAVERA",
                                "produto": "Colantes",
                                "volume": 0,
                                "meta": 0.01,
                                "atingimento": 0,
                                "descontoRs": 0
                            },
                            {
                                "id": 1,
                                "codigo": "1145966",
                                "razaoSocial": "MS MADEIRAS E MATERIAIS PARA",
                                "grupoCentralizador": "MADEIREIRA PRIMAVERA",
                                "produto": "Cimentos",
                                "volume": 0,
                                "meta": 2,
                                "atingimento": 0,
                                "descontoRs": 0
                            },
                            {
                                "id": 2,
                                "codigo": "1145966",
                                "razaoSocial": "MS MADEIRAS E MATERIAIS PARA",
                                "grupoCentralizador": "MADEIREIRA PRIMAVERA",
                                "produto": "Impermeabilizantes",
                                "volume": 0,
                                "meta": 0.01,
                                "atingimento": 0,
                                "descontoRs": 0
                            },
                            {
                                "id": 3,
                                "codigo": "1145966",
                                "razaoSocial": "MS MADEIRAS E MATERIAIS PARA",
                                "grupoCentralizador": "MADEIREIRA PRIMAVERA",
                                "produto": "Rejuntes",
                                "volume": 0,
                                "meta": 0.12,
                                "atingimento": 0,
                                "descontoRs": 0
                            }
                        ],
                        "clienteId": 54262,
                        "inicioMes": "2026-08-01T00:00:00"
                    },
                    {
                        "id": 539931,
                        "codigo": "1366359",
                        "razaoSocial": "DEPOSITO MATERIAL DE CONSTRUCAO 3S",
                        "grupoCentralizador": "MADEIREIRA PRIMAVERA",
                        "aceite": true,
                        "volume": 26,
                        "meta": 36.2,
                        "atingimento": 0.718232044198895,
                        "descontoRs": 0,
                        "verMais": [
                            {
                                "id": 1,
                                "codigo": "1366359",
                                "razaoSocial": "DEPOSITO MATERIAL DE CONSTRUCAO 3S",
                                "grupoCentralizador": "MADEIREIRA PRIMAVERA",
                                "produto": "Cimentos",
                                "volume": 26,
                                "meta": 36,
                                "atingimento": 0.7222222222222222,
                                "descontoRs": 0
                            },
                            {
                                "id": 2,
                                "codigo": "1366359",
                                "razaoSocial": "DEPOSITO MATERIAL DE CONSTRUCAO 3S",
                                "grupoCentralizador": "MADEIREIRA PRIMAVERA",
                                "produto": "Impermeabilizantes",
                                "volume": 0,
                                "meta": 0.2,
                                "atingimento": 0,
                                "descontoRs": 0
                            }
                        ],
                        "clienteId": 53993,
                        "inicioMes": "2026-07-01T00:00:00"
                    },
                    {
                        "id": 539931,
                        "codigo": "1366359",
                        "razaoSocial": "DEPOSITO MATERIAL DE CONSTRUCAO 3S",
                        "grupoCentralizador": "MADEIREIRA PRIMAVERA",
                        "aceite": true,
                        "volume": 40,
                        "meta": 28.2,
                        "atingimento": 1.4184397163120568,
                        "descontoRs": 295.68,
                        "verMais": [
                            {
                                "id": 2,
                                "codigo": "1366359",
                                "razaoSocial": "DEPOSITO MATERIAL DE CONSTRUCAO 3S",
                                "grupoCentralizador": "MADEIREIRA PRIMAVERA",
                                "produto": "Impermeabilizantes",
                                "volume": 0,
                                "meta": 0.2,
                                "atingimento": 0,
                                "descontoRs": 0
                            },
                            {
                                "id": 1,
                                "codigo": "1366359",
                                "razaoSocial": "DEPOSITO MATERIAL DE CONSTRUCAO 3S",
                                "grupoCentralizador": "MADEIREIRA PRIMAVERA",
                                "produto": "Cimentos",
                                "volume": 40,
                                "meta": 28,
                                "atingimento": 1.4285714285714286,
                                "descontoRs": 295.68
                            }
                        ],
                        "clienteId": 53993,
                        "inicioMes": "2026-05-01T00:00:00"
                    },
                    {
                        "id": 539931,
                        "codigo": "1366359",
                        "razaoSocial": "DEPOSITO MATERIAL DE CONSTRUCAO 3S",
                        "grupoCentralizador": "MADEIREIRA PRIMAVERA",
                        "aceite": true,
                        "volume": 38.9,
                        "meta": 24.2,
                        "atingimento": 1.6074380165289257,
                        "descontoRs": 308,
                        "verMais": [
                            {
                                "id": 2,
                                "codigo": "1366359",
                                "razaoSocial": "DEPOSITO MATERIAL DE CONSTRUCAO 3S",
                                "grupoCentralizador": "MADEIREIRA PRIMAVERA",
                                "produto": "Impermeabilizantes",
                                "volume": 0,
                                "meta": 0.2,
                                "atingimento": 0,
                                "descontoRs": 0
                            },
                            {
                                "id": 4,
                                "codigo": "1366359",
                                "razaoSocial": "DEPOSITO MATERIAL DE CONSTRUCAO 3S",
                                "grupoCentralizador": "MADEIREIRA PRIMAVERA",
                                "produto": "Colantes",
                                "volume": 0.4,
                                "meta": 4,
                                "atingimento": 0.1,
                                "descontoRs": 0
                            },
                            {
                                "id": 1,
                                "codigo": "1366359",
                                "razaoSocial": "DEPOSITO MATERIAL DE CONSTRUCAO 3S",
                                "grupoCentralizador": "MADEIREIRA PRIMAVERA",
                                "produto": "Cimentos",
                                "volume": 38.5,
                                "meta": 20,
                                "atingimento": 1.925,
                                "descontoRs": 308
                            }
                        ],
                        "clienteId": 53993,
                        "inicioMes": "2026-04-01T00:00:00"
                    },
                    {
                        "id": 539930,
                        "codigo": "1366359",
                        "razaoSocial": "DEPOSITO MATERIAL DE CONSTRUCAO 3S",
                        "grupoCentralizador": "MADEIREIRA PRIMAVERA",
                        "aceite": false,
                        "volume": 0,
                        "meta": 36.669999999999995,
                        "atingimento": 0,
                        "descontoRs": 0,
                        "verMais": [
                            {
                                "id": 1,
                                "codigo": "1366359",
                                "razaoSocial": "DEPOSITO MATERIAL DE CONSTRUCAO 3S",
                                "grupoCentralizador": "MADEIREIRA PRIMAVERA",
                                "produto": "Cimentos",
                                "volume": 0,
                                "meta": 34,
                                "atingimento": 0,
                                "descontoRs": 0
                            },
                            {
                                "id": 2,
                                "codigo": "1366359",
                                "razaoSocial": "DEPOSITO MATERIAL DE CONSTRUCAO 3S",
                                "grupoCentralizador": "MADEIREIRA PRIMAVERA",
                                "produto": "Impermeabilizantes",
                                "volume": 0,
                                "meta": 0.23,
                                "atingimento": 0,
                                "descontoRs": 0
                            },
                            {
                                "id": 3,
                                "codigo": "1366359",
                                "razaoSocial": "DEPOSITO MATERIAL DE CONSTRUCAO 3S",
                                "grupoCentralizador": "MADEIREIRA PRIMAVERA",
                                "produto": "Rejuntes",
                                "volume": 0,
                                "meta": 0.14,
                                "atingimento": 0,
                                "descontoRs": 0
                            },
                            {
                                "id": 4,
                                "codigo": "1366359",
                                "razaoSocial": "DEPOSITO MATERIAL DE CONSTRUCAO 3S",
                                "grupoCentralizador": "MADEIREIRA PRIMAVERA",
                                "produto": "Colantes",
                                "volume": 0,
                                "meta": 2.3,
                                "atingimento": 0,
                                "descontoRs": 0
                            }
                        ],
                        "clienteId": 53993,
                        "inicioMes": "2026-08-01T00:00:00"
                    },
                    {
                        "id": 1968371,
                        "codigo": "1325063",
                        "razaoSocial": "JAPA EMPORIO DA CONSTRUCAO LTDA",
                        "grupoCentralizador": "JAPA EMPÓRIO",
                        "aceite": true,
                        "volume": 317.608,
                        "meta": 305.2,
                        "atingimento": 1.0406553079947576,
                        "descontoRs": 3804,
                        "verMais": [
                            {
                                "id": 1,
                                "codigo": "1325063",
                                "razaoSocial": "JAPA EMPORIO DA CONSTRUCAO LTDA",
                                "grupoCentralizador": "JAPA EMPÓRIO",
                                "produto": "Cimentos",
                                "volume": 317,
                                "meta": 300,
                                "atingimento": 1.0566666666666666,
                                "descontoRs": 3804
                            },
                            {
                                "id": 5,
                                "codigo": "1325063",
                                "razaoSocial": "JAPA EMPORIO DA CONSTRUCAO LTDA",
                                "grupoCentralizador": "JAPA EMPÓRIO",
                                "produto": "Cales",
                                "volume": 0.608,
                                "meta": 5.2,
                                "atingimento": 0.11692307692307692,
                                "descontoRs": 0
                            }
                        ],
                        "clienteId": 196837,
                        "inicioMes": "2026-05-01T00:00:00"
                    },
                    {
                        "id": 1968371,
                        "codigo": "1325063",
                        "razaoSocial": "JAPA EMPORIO DA CONSTRUCAO LTDA",
                        "grupoCentralizador": "JAPA EMPÓRIO",
                        "aceite": true,
                        "volume": 195.85,
                        "meta": 258.4,
                        "atingimento": 0.7579334365325078,
                        "descontoRs": 658,
                        "verMais": [
                            {
                                "id": 6,
                                "codigo": "1325063",
                                "razaoSocial": "JAPA EMPORIO DA CONSTRUCAO LTDA",
                                "grupoCentralizador": "JAPA EMPÓRIO",
                                "produto": "Basicas",
                                "volume": 6.2,
                                "meta": 5,
                                "atingimento": 1.24,
                                "descontoRs": 121
                            },
                            {
                                "id": 1,
                                "codigo": "1325063",
                                "razaoSocial": "JAPA EMPORIO DA CONSTRUCAO LTDA",
                                "grupoCentralizador": "JAPA EMPÓRIO",
                                "produto": "Cimentos",
                                "volume": 178,
                                "meta": 244,
                                "atingimento": 0.7295081967213115,
                                "descontoRs": 0
                            },
                            {
                                "id": 4,
                                "codigo": "1325063",
                                "razaoSocial": "JAPA EMPORIO DA CONSTRUCAO LTDA",
                                "grupoCentralizador": "JAPA EMPÓRIO",
                                "produto": "Colantes",
                                "volume": 11.2,
                                "meta": 9,
                                "atingimento": 1.2444444444444445,
                                "descontoRs": 297
                            },
                            {
                                "id": 2,
                                "codigo": "1325063",
                                "razaoSocial": "JAPA EMPORIO DA CONSTRUCAO LTDA",
                                "grupoCentralizador": "JAPA EMPÓRIO",
                                "produto": "Impermeabilizantes",
                                "volume": 0.27,
                                "meta": 0.2,
                                "atingimento": 1.35,
                                "descontoRs": 132
                            },
                            {
                                "id": 3,
                                "codigo": "1325063",
                                "razaoSocial": "JAPA EMPORIO DA CONSTRUCAO LTDA",
                                "grupoCentralizador": "JAPA EMPÓRIO",
                                "produto": "Rejuntes",
                                "volume": 0.18,
                                "meta": 0.2,
                                "atingimento": 0.8999999999999999,
                                "descontoRs": 108
                            }
                        ],
                        "clienteId": 196837,
                        "inicioMes": "2026-04-01T00:00:00"
                    },
                    {
                        "id": -1,
                        "cards": [
                            {
                                "produto": "Cimentos",
                                "clientesCampanha": 23,
                                "clientesAtingindoMeta": 0,
                                "progressoVolume": 62.5,
                                "limiteProgressoVolume": 1384,
                                "progressoDesconto": 0,
                                "limiteProgressoDesconto": 20203.199999999993
                            },
                            {
                                "produto": "Rejuntes",
                                "clientesCampanha": 13,
                                "clientesAtingindoMeta": 0,
                                "progressoVolume": 0,
                                "limiteProgressoVolume": 3.03,
                                "progressoDesconto": 0,
                                "limiteProgressoDesconto": 2751.5000000000005
                            },
                            {
                                "produto": "Colantes",
                                "clientesCampanha": 21,
                                "clientesAtingindoMeta": 0,
                                "progressoVolume": 7.4399999999999995,
                                "limiteProgressoVolume": 213.74,
                                "progressoDesconto": 0,
                                "limiteProgressoDesconto": 8542.569999999998
                            },
                            {
                                "produto": "Impermeabilizantes",
                                "clientesCampanha": 16,
                                "clientesAtingindoMeta": 0,
                                "progressoVolume": 0.037,
                                "limiteProgressoVolume": 3.379999999999999,
                                "progressoDesconto": 0,
                                "limiteProgressoDesconto": 2069.1
                            },
                            {
                                "produto": "Cales",
                                "clientesCampanha": 0,
                                "clientesAtingindoMeta": 0,
                                "progressoVolume": 0,
                                "limiteProgressoVolume": 0,
                                "progressoDesconto": 0,
                                "limiteProgressoDesconto": 0
                            },
                            {
                                "produto": "Basicas",
                                "clientesCampanha": 0,
                                "clientesAtingindoMeta": 0,
                                "progressoVolume": 0,
                                "limiteProgressoVolume": 0,
                                "progressoDesconto": 0,
                                "limiteProgressoDesconto": 0
                            }
                        ]
                    },
                    {
                        "id": -2,
                        "cards": [
                            {
                                "produto": "Cimentos",
                                "clientesCampanha": 21,
                                "clientesAtingindoMeta": 10,
                                "progressoVolume": 1429,
                                "limiteProgressoVolume": 1784,
                                "progressoDesconto": 10235.599999999999,
                                "limiteProgressoDesconto": 25981.6
                            },
                            {
                                "produto": "Rejuntes",
                                "clientesCampanha": 17,
                                "clientesAtingindoMeta": 1,
                                "progressoVolume": 1.3800000000000001,
                                "limiteProgressoVolume": 7.199999999999999,
                                "progressoDesconto": 390.4,
                                "limiteProgressoDesconto": 4630.8
                            },
                            {
                                "produto": "Colantes",
                                "clientesCampanha": 18,
                                "clientesAtingindoMeta": 4,
                                "progressoVolume": 146,
                                "limiteProgressoVolume": 178,
                                "progressoDesconto": 3599,
                                "limiteProgressoDesconto": 6705
                            },
                            {
                                "produto": "Impermeabilizantes",
                                "clientesCampanha": 15,
                                "clientesAtingindoMeta": 5,
                                "progressoVolume": 1.404,
                                "limiteProgressoVolume": 2.6000000000000005,
                                "progressoDesconto": 632,
                                "limiteProgressoDesconto": 1390
                            },
                            {
                                "produto": "Cales",
                                "clientesCampanha": 0,
                                "clientesAtingindoMeta": 0,
                                "progressoVolume": 0,
                                "limiteProgressoVolume": 0,
                                "progressoDesconto": 0,
                                "limiteProgressoDesconto": 0
                            },
                            {
                                "produto": "Basicas",
                                "clientesCampanha": 1,
                                "clientesAtingindoMeta": 0,
                                "progressoVolume": 4,
                                "limiteProgressoVolume": 9.2,
                                "progressoDesconto": 0,
                                "limiteProgressoDesconto": 222.64
                            }
                        ]
                    },
                    {
                        "id": -3,
                        "metasNegociadas": [
                            {
                                "clienteId": 662331,
                                "codigo": "1842155",
                                "razaoSocial": "TOCA LOJA DISTRIBUIDORA LTDA",
                                "metaOficial": 216.88,
                                "inicioMes": "2026-08-01T00:00:00"
                            },
                            {
                                "clienteId": 196829,
                                "codigo": "1544786",
                                "razaoSocial": "COSTA ATACADISTA DA CONSTRUCAO LTDA",
                                "metaOficial": 196.46,
                                "inicioMes": "2026-08-01T00:00:00"
                            },
                            {
                                "clienteId": 173314,
                                "codigo": "1153600",
                                "razaoSocial": "DEPOSITO CABUCU LTDA",
                                "metaOficial": 187.66,
                                "inicioMes": "2026-08-01T00:00:00"
                            },
                            {
                                "clienteId": 54397,
                                "codigo": "1059853",
                                "razaoSocial": "L  E F  MATERIAIS PARA CONSTRUCAO",
                                "metaOficial": 140.4,
                                "inicioMes": "2026-08-01T00:00:00"
                            },
                            {
                                "clienteId": 173312,
                                "codigo": "1597012",
                                "razaoSocial": "LAILA VIANA DE SOUZA",
                                "metaOficial": 138.2,
                                "inicioMes": "2026-08-01T00:00:00"
                            }
                        ]
                    },
                    {
                        "id": -4,
                        "metasNegociadas": [
                            {
                                "clienteId": 196783,
                                "codigo": "1549482",
                                "razaoSocial": "S.C. CIMENTO E TRANSPORTE LTDA",
                                "metaOficial": 605.8000000000001,
                                "inicioMes": "2026-07-01T00:00:00"
                            },
                            {
                                "clienteId": 196829,
                                "codigo": "1544786",
                                "razaoSocial": "COSTA ATACADISTA DA CONSTRUCAO LTDA",
                                "metaOficial": 228.82000000000002,
                                "inicioMes": "2026-07-01T00:00:00"
                            },
                            {
                                "clienteId": 173312,
                                "codigo": "1597012",
                                "razaoSocial": "LAILA VIANA DE SOUZA",
                                "metaOficial": 194.9,
                                "inicioMes": "2026-07-01T00:00:00"
                            },
                            {
                                "clienteId": 662331,
                                "codigo": "1842155",
                                "razaoSocial": "TOCA LOJA DISTRIBUIDORA LTDA",
                                "metaOficial": 170.79999999999998,
                                "inicioMes": "2026-07-01T00:00:00"
                            },
                            {
                                "clienteId": 196832,
                                "codigo": "1475411",
                                "razaoSocial": "BARUK DISTRIBUIDORA DE CIMENTO LTDA",
                                "metaOficial": 168.3,
                                "inicioMes": "2026-07-01T00:00:00"
                            }
                        ]
                    },
                    {
                        "id": -5,
                        "proximosMeta": [
                            {
                                "clienteId": 196783,
                                "codigo": "1549482",
                                "razaoSocial": "S.C. CIMENTO E TRANSPORTE LTDA",
                                "atingido": 1.44,
                                "gap": 12.56,
                                "inicioMes": "2026-08-01T00:00:00"
                            },
                            {
                                "clienteId": 54219,
                                "codigo": "1108711",
                                "razaoSocial": "ARNALDO ANDRADE CORREIA GUARULHOS",
                                "atingido": 0,
                                "gap": 16,
                                "inicioMes": "2026-08-01T00:00:00"
                            },
                            {
                                "clienteId": 54224,
                                "codigo": "1146294",
                                "razaoSocial": "LENYSIO TELHAS LTDA",
                                "atingido": 0,
                                "gap": 24.5,
                                "inicioMes": "2026-08-01T00:00:00"
                            },
                            {
                                "clienteId": 196831,
                                "codigo": "1499807",
                                "razaoSocial": "JOSE CARLOS CARDOSO",
                                "atingido": 0,
                                "gap": 57.48,
                                "inicioMes": "2026-08-01T00:00:00"
                            },
                            {
                                "clienteId": 173312,
                                "codigo": "1597012",
                                "razaoSocial": "LAILA VIANA DE SOUZA",
                                "atingido": 14,
                                "gap": 124.19999999999999,
                                "inicioMes": "2026-08-01T00:00:00"
                            }
                        ]
                    },
                    {
                        "id": -6,
                        "proximosMeta": []
                    },
                    {
                        "id": -7,
                        "linhaTempoDesconto": [
                            {
                                "inicioMes": "2026-07-01T00:00:00",
                                "realizado": 1056,
                                "clienteId": 53200,
                                "codigo": "1712601",
                                "razaoSocial": "CONSTRU MIX MATERIAIS PARA",
                                "gap": -96,
                                "aceite": true,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-07-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 53200,
                                "codigo": "1712601",
                                "razaoSocial": "CONSTRU MIX MATERIAIS PARA",
                                "gap": 360,
                                "aceite": true,
                                "produto": "Rejuntes"
                            },
                            {
                                "inicioMes": "2026-06-01T00:00:00",
                                "realizado": 102.4,
                                "clienteId": 53200,
                                "codigo": "1712601",
                                "razaoSocial": "CONSTRU MIX MATERIAIS PARA",
                                "gap": -6.400000000000006,
                                "aceite": true,
                                "produto": "Colantes"
                            },
                            {
                                "inicioMes": "2026-06-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 53200,
                                "codigo": "1712601",
                                "razaoSocial": "CONSTRU MIX MATERIAIS PARA",
                                "gap": 96,
                                "aceite": true,
                                "produto": "Impermeabilizantes"
                            },
                            {
                                "inicioMes": "2026-06-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 53200,
                                "codigo": "1712601",
                                "razaoSocial": "CONSTRU MIX MATERIAIS PARA",
                                "gap": 1008,
                                "aceite": true,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-05-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 53200,
                                "codigo": "1712601",
                                "razaoSocial": "CONSTRU MIX MATERIAIS PARA",
                                "gap": 80,
                                "aceite": true,
                                "produto": "Colantes"
                            },
                            {
                                "inicioMes": "2026-05-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 53200,
                                "codigo": "1712601",
                                "razaoSocial": "CONSTRU MIX MATERIAIS PARA",
                                "gap": 80,
                                "aceite": true,
                                "produto": "Impermeabilizantes"
                            },
                            {
                                "inicioMes": "2026-04-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 53200,
                                "codigo": "1712601",
                                "razaoSocial": "CONSTRU MIX MATERIAIS PARA",
                                "gap": 100,
                                "aceite": true,
                                "produto": "Colantes"
                            },
                            {
                                "inicioMes": "2026-04-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 53200,
                                "codigo": "1712601",
                                "razaoSocial": "CONSTRU MIX MATERIAIS PARA",
                                "gap": 100,
                                "aceite": true,
                                "produto": "Impermeabilizantes"
                            },
                            {
                                "inicioMes": "2026-04-01T00:00:00",
                                "realizado": 792,
                                "clienteId": 53200,
                                "codigo": "1712601",
                                "razaoSocial": "CONSTRU MIX MATERIAIS PARA",
                                "gap": -72,
                                "aceite": true,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-06-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 53206,
                                "codigo": "1714523",
                                "razaoSocial": "QUEIROZ MATERIAIS PARA CONSTRUCAO",
                                "gap": 236.8,
                                "aceite": true,
                                "produto": "Colantes"
                            },
                            {
                                "inicioMes": "2026-06-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 53206,
                                "codigo": "1714523",
                                "razaoSocial": "QUEIROZ MATERIAIS PARA CONSTRUCAO",
                                "gap": 768,
                                "aceite": true,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-06-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 53206,
                                "codigo": "1714523",
                                "razaoSocial": "QUEIROZ MATERIAIS PARA CONSTRUCAO",
                                "gap": 165.888,
                                "aceite": true,
                                "produto": "Rejuntes"
                            },
                            {
                                "inicioMes": "2026-06-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 53206,
                                "codigo": "1714523",
                                "razaoSocial": "QUEIROZ MATERIAIS PARA CONSTRUCAO",
                                "gap": 192,
                                "aceite": true,
                                "produto": "Impermeabilizantes"
                            },
                            {
                                "inicioMes": "2026-08-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 53206,
                                "codigo": "1714523",
                                "razaoSocial": "QUEIROZ MATERIAIS PARA CONSTRUCAO",
                                "gap": 985.6,
                                "aceite": false,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-08-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 53206,
                                "codigo": "1714523",
                                "razaoSocial": "QUEIROZ MATERIAIS PARA CONSTRUCAO",
                                "gap": 151.8,
                                "aceite": false,
                                "produto": "Impermeabilizantes"
                            },
                            {
                                "inicioMes": "2026-08-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 53206,
                                "codigo": "1714523",
                                "razaoSocial": "QUEIROZ MATERIAIS PARA CONSTRUCAO",
                                "gap": 506,
                                "aceite": false,
                                "produto": "Colantes"
                            },
                            {
                                "inicioMes": "2026-08-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 53375,
                                "codigo": "1630142",
                                "razaoSocial": "GUIOMAR RIOS DE MATOS",
                                "gap": 242,
                                "aceite": false,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-04-01T00:00:00",
                                "realizado": 211.2,
                                "clienteId": 53375,
                                "codigo": "1630142",
                                "razaoSocial": "GUIOMAR RIOS DE MATOS",
                                "gap": -19.19999999999999,
                                "aceite": true,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-04-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 53375,
                                "codigo": "1630142",
                                "razaoSocial": "GUIOMAR RIOS DE MATOS",
                                "gap": 100,
                                "aceite": true,
                                "produto": "Rejuntes"
                            },
                            {
                                "inicioMes": "2026-04-01T00:00:00",
                                "realizado": 132,
                                "clienteId": 53406,
                                "codigo": "1650357",
                                "razaoSocial": "ANDERSON RIBEIRO NASCIMENTO",
                                "gap": -12,
                                "aceite": true,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-08-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 53560,
                                "codigo": "1547404",
                                "razaoSocial": "RODRIGO RODRIGUES CASA E FERRAGEM",
                                "gap": 151.79999999999998,
                                "aceite": false,
                                "produto": "Colantes"
                            },
                            {
                                "inicioMes": "2026-08-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 53560,
                                "codigo": "1547404",
                                "razaoSocial": "RODRIGO RODRIGUES CASA E FERRAGEM",
                                "gap": 308,
                                "aceite": false,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-05-01T00:00:00",
                                "realizado": 364.8,
                                "clienteId": 53855,
                                "codigo": "1424685",
                                "razaoSocial": "ESS MATERIAIS P  CONSTRUCAO LTDA",
                                "gap": 38.39999999999998,
                                "aceite": true,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-05-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 53855,
                                "codigo": "1424685",
                                "razaoSocial": "ESS MATERIAIS P  CONSTRUCAO LTDA",
                                "gap": 80,
                                "aceite": true,
                                "produto": "Impermeabilizantes"
                            },
                            {
                                "inicioMes": "2026-05-01T00:00:00",
                                "realizado": 88,
                                "clienteId": 53855,
                                "codigo": "1424685",
                                "razaoSocial": "ESS MATERIAIS P  CONSTRUCAO LTDA",
                                "gap": -8,
                                "aceite": true,
                                "produto": "Colantes"
                            },
                            {
                                "inicioMes": "2026-05-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 53855,
                                "codigo": "1424685",
                                "razaoSocial": "ESS MATERIAIS P  CONSTRUCAO LTDA",
                                "gap": 80,
                                "aceite": true,
                                "produto": "Rejuntes"
                            },
                            {
                                "inicioMes": "2026-07-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 53855,
                                "codigo": "1424685",
                                "razaoSocial": "ESS MATERIAIS P  CONSTRUCAO LTDA",
                                "gap": 360,
                                "aceite": true,
                                "produto": "Rejuntes"
                            },
                            {
                                "inicioMes": "2026-07-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 53855,
                                "codigo": "1424685",
                                "razaoSocial": "ESS MATERIAIS P  CONSTRUCAO LTDA",
                                "gap": 280,
                                "aceite": true,
                                "produto": "Colantes"
                            },
                            {
                                "inicioMes": "2026-07-01T00:00:00",
                                "realizado": 456,
                                "clienteId": 53855,
                                "codigo": "1424685",
                                "razaoSocial": "ESS MATERIAIS P  CONSTRUCAO LTDA",
                                "gap": -24,
                                "aceite": true,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-07-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 53855,
                                "codigo": "1424685",
                                "razaoSocial": "ESS MATERIAIS P  CONSTRUCAO LTDA",
                                "gap": 120,
                                "aceite": true,
                                "produto": "Impermeabilizantes"
                            },
                            {
                                "inicioMes": "2026-04-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 53855,
                                "codigo": "1424685",
                                "razaoSocial": "ESS MATERIAIS P  CONSTRUCAO LTDA",
                                "gap": 120,
                                "aceite": true,
                                "produto": "Rejuntes"
                            },
                            {
                                "inicioMes": "2026-04-01T00:00:00",
                                "realizado": 193.6,
                                "clienteId": 53855,
                                "codigo": "1424685",
                                "razaoSocial": "ESS MATERIAIS P  CONSTRUCAO LTDA",
                                "gap": -17.599999999999994,
                                "aceite": true,
                                "produto": "Colantes"
                            },
                            {
                                "inicioMes": "2026-04-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 53855,
                                "codigo": "1424685",
                                "razaoSocial": "ESS MATERIAIS P  CONSTRUCAO LTDA",
                                "gap": 120,
                                "aceite": true,
                                "produto": "Impermeabilizantes"
                            },
                            {
                                "inicioMes": "2026-04-01T00:00:00",
                                "realizado": 338.8,
                                "clienteId": 53855,
                                "codigo": "1424685",
                                "razaoSocial": "ESS MATERIAIS P  CONSTRUCAO LTDA",
                                "gap": -30.80000000000001,
                                "aceite": true,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-08-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 53855,
                                "codigo": "1424685",
                                "razaoSocial": "ESS MATERIAIS P  CONSTRUCAO LTDA",
                                "gap": 265.65000000000003,
                                "aceite": false,
                                "produto": "Colantes"
                            },
                            {
                                "inicioMes": "2026-08-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 53855,
                                "codigo": "1424685",
                                "razaoSocial": "ESS MATERIAIS P  CONSTRUCAO LTDA",
                                "gap": 660,
                                "aceite": false,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-08-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 53855,
                                "codigo": "1424685",
                                "razaoSocial": "ESS MATERIAIS P  CONSTRUCAO LTDA",
                                "gap": 151.8,
                                "aceite": false,
                                "produto": "Impermeabilizantes"
                            },
                            {
                                "inicioMes": "2026-07-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 53959,
                                "codigo": "1367732",
                                "razaoSocial": "NOVA CARMELA III COMERCIO DE",
                                "gap": 360,
                                "aceite": true,
                                "produto": "Rejuntes"
                            },
                            {
                                "inicioMes": "2026-07-01T00:00:00",
                                "realizado": 108,
                                "clienteId": 53959,
                                "codigo": "1367732",
                                "razaoSocial": "NOVA CARMELA III COMERCIO DE",
                                "gap": 12,
                                "aceite": true,
                                "produto": "Impermeabilizantes"
                            },
                            {
                                "inicioMes": "2026-07-01T00:00:00",
                                "realizado": 211.2,
                                "clienteId": 53959,
                                "codigo": "1367732",
                                "razaoSocial": "NOVA CARMELA III COMERCIO DE",
                                "gap": -19.19999999999999,
                                "aceite": true,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-07-01T00:00:00",
                                "realizado": 154,
                                "clienteId": 53959,
                                "codigo": "1367732",
                                "razaoSocial": "NOVA CARMELA III COMERCIO DE",
                                "gap": -14,
                                "aceite": true,
                                "produto": "Colantes"
                            },
                            {
                                "inicioMes": "2026-08-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 53959,
                                "codigo": "1367732",
                                "razaoSocial": "NOVA CARMELA III COMERCIO DE",
                                "gap": 523.6,
                                "aceite": false,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-08-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 53959,
                                "codigo": "1367732",
                                "razaoSocial": "NOVA CARMELA III COMERCIO DE",
                                "gap": 189.75,
                                "aceite": false,
                                "produto": "Colantes"
                            },
                            {
                                "inicioMes": "2026-08-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 53959,
                                "codigo": "1367732",
                                "razaoSocial": "NOVA CARMELA III COMERCIO DE",
                                "gap": 151.8,
                                "aceite": false,
                                "produto": "Impermeabilizantes"
                            },
                            {
                                "inicioMes": "2026-08-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 53959,
                                "codigo": "1367732",
                                "razaoSocial": "NOVA CARMELA III COMERCIO DE",
                                "gap": 202.4,
                                "aceite": false,
                                "produto": "Rejuntes"
                            },
                            {
                                "inicioMes": "2026-06-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 54090,
                                "codigo": "1320574",
                                "razaoSocial": "COMERCIO DE FERRAGENS CORREIA LTDA",
                                "gap": 288,
                                "aceite": true,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-06-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 54090,
                                "codigo": "1320574",
                                "razaoSocial": "COMERCIO DE FERRAGENS CORREIA LTDA",
                                "gap": 64,
                                "aceite": true,
                                "produto": "Colantes"
                            },
                            {
                                "inicioMes": "2026-06-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 54090,
                                "codigo": "1320574",
                                "razaoSocial": "COMERCIO DE FERRAGENS CORREIA LTDA",
                                "gap": 155.51999999999998,
                                "aceite": true,
                                "produto": "Rejuntes"
                            },
                            {
                                "inicioMes": "2026-04-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 54090,
                                "codigo": "1320574",
                                "razaoSocial": "COMERCIO DE FERRAGENS CORREIA LTDA",
                                "gap": 198,
                                "aceite": true,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-04-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 54090,
                                "codigo": "1320574",
                                "razaoSocial": "COMERCIO DE FERRAGENS CORREIA LTDA",
                                "gap": 100,
                                "aceite": true,
                                "produto": "Colantes"
                            },
                            {
                                "inicioMes": "2026-04-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 54090,
                                "codigo": "1320574",
                                "razaoSocial": "COMERCIO DE FERRAGENS CORREIA LTDA",
                                "gap": 100,
                                "aceite": true,
                                "produto": "Impermeabilizantes"
                            },
                            {
                                "inicioMes": "2026-07-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 54090,
                                "codigo": "1320574",
                                "razaoSocial": "COMERCIO DE FERRAGENS CORREIA LTDA",
                                "gap": 130,
                                "aceite": true,
                                "produto": "Colantes"
                            },
                            {
                                "inicioMes": "2026-07-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 54090,
                                "codigo": "1320574",
                                "razaoSocial": "COMERCIO DE FERRAGENS CORREIA LTDA",
                                "gap": 360,
                                "aceite": true,
                                "produto": "Rejuntes"
                            },
                            {
                                "inicioMes": "2026-07-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 54090,
                                "codigo": "1320574",
                                "razaoSocial": "COMERCIO DE FERRAGENS CORREIA LTDA",
                                "gap": 336,
                                "aceite": true,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-07-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 54090,
                                "codigo": "1320574",
                                "razaoSocial": "COMERCIO DE FERRAGENS CORREIA LTDA",
                                "gap": 100,
                                "aceite": true,
                                "produto": "Impermeabilizantes"
                            },
                            {
                                "inicioMes": "2026-04-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 54200,
                                "codigo": "1173049",
                                "razaoSocial": "GUARUTELHA MATERIAIS PARA",
                                "gap": 480,
                                "aceite": true,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-05-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 173312,
                                "codigo": "1597012",
                                "razaoSocial": "LAILA VIANA DE SOUZA",
                                "gap": 2016,
                                "aceite": true,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-05-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 173312,
                                "codigo": "1597012",
                                "razaoSocial": "LAILA VIANA DE SOUZA",
                                "gap": 96,
                                "aceite": true,
                                "produto": "Impermeabilizantes"
                            },
                            {
                                "inicioMes": "2026-08-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 173312,
                                "codigo": "1597012",
                                "razaoSocial": "LAILA VIANA DE SOUZA",
                                "gap": 480,
                                "aceite": true,
                                "produto": "Colantes"
                            },
                            {
                                "inicioMes": "2026-08-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 173312,
                                "codigo": "1597012",
                                "razaoSocial": "LAILA VIANA DE SOUZA",
                                "gap": 100,
                                "aceite": true,
                                "produto": "Impermeabilizantes"
                            },
                            {
                                "inicioMes": "2026-08-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 173312,
                                "codigo": "1597012",
                                "razaoSocial": "LAILA VIANA DE SOUZA",
                                "gap": 1764,
                                "aceite": true,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-07-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 173312,
                                "codigo": "1597012",
                                "razaoSocial": "LAILA VIANA DE SOUZA",
                                "gap": 2520,
                                "aceite": true,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-07-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 173312,
                                "codigo": "1597012",
                                "razaoSocial": "LAILA VIANA DE SOUZA",
                                "gap": 360,
                                "aceite": true,
                                "produto": "Rejuntes"
                            },
                            {
                                "inicioMes": "2026-07-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 173312,
                                "codigo": "1597012",
                                "razaoSocial": "LAILA VIANA DE SOUZA",
                                "gap": 490,
                                "aceite": true,
                                "produto": "Colantes"
                            },
                            {
                                "inicioMes": "2026-07-01T00:00:00",
                                "realizado": 162,
                                "clienteId": 173312,
                                "codigo": "1597012",
                                "razaoSocial": "LAILA VIANA DE SOUZA",
                                "gap": -12,
                                "aceite": true,
                                "produto": "Impermeabilizantes"
                            },
                            {
                                "inicioMes": "2026-04-01T00:00:00",
                                "realizado": 1993.2,
                                "clienteId": 173312,
                                "codigo": "1597012",
                                "razaoSocial": "LAILA VIANA DE SOUZA",
                                "gap": -181.20000000000005,
                                "aceite": true,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-04-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 173312,
                                "codigo": "1597012",
                                "razaoSocial": "LAILA VIANA DE SOUZA",
                                "gap": 100,
                                "aceite": true,
                                "produto": "Cales"
                            },
                            {
                                "inicioMes": "2026-04-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 173312,
                                "codigo": "1597012",
                                "razaoSocial": "LAILA VIANA DE SOUZA",
                                "gap": 350,
                                "aceite": true,
                                "produto": "Colantes"
                            },
                            {
                                "inicioMes": "2026-04-01T00:00:00",
                                "realizado": 110,
                                "clienteId": 173312,
                                "codigo": "1597012",
                                "razaoSocial": "LAILA VIANA DE SOUZA",
                                "gap": -10,
                                "aceite": true,
                                "produto": "Impermeabilizantes"
                            },
                            {
                                "inicioMes": "2026-04-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 173312,
                                "codigo": "1597012",
                                "razaoSocial": "LAILA VIANA DE SOUZA",
                                "gap": 100,
                                "aceite": true,
                                "produto": "Rejuntes"
                            },
                            {
                                "inicioMes": "2026-05-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 173314,
                                "codigo": "1153600",
                                "razaoSocial": "DEPOSITO CABUCU LTDA",
                                "gap": 80,
                                "aceite": true,
                                "produto": "Impermeabilizantes"
                            },
                            {
                                "inicioMes": "2026-05-01T00:00:00",
                                "realizado": 1203.84,
                                "clienteId": 173314,
                                "codigo": "1153600",
                                "razaoSocial": "DEPOSITO CABUCU LTDA",
                                "gap": -109.44000000000005,
                                "aceite": true,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-05-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 173314,
                                "codigo": "1153600",
                                "razaoSocial": "DEPOSITO CABUCU LTDA",
                                "gap": 115,
                                "aceite": true,
                                "produto": "Rejuntes"
                            },
                            {
                                "inicioMes": "2026-05-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 173314,
                                "codigo": "1153600",
                                "razaoSocial": "DEPOSITO CABUCU LTDA",
                                "gap": 436.8,
                                "aceite": true,
                                "produto": "Colantes"
                            },
                            {
                                "inicioMes": "2026-04-01T00:00:00",
                                "realizado": 1056,
                                "clienteId": 173314,
                                "codigo": "1153600",
                                "razaoSocial": "DEPOSITO CABUCU LTDA",
                                "gap": -96,
                                "aceite": true,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-04-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 173314,
                                "codigo": "1153600",
                                "razaoSocial": "DEPOSITO CABUCU LTDA",
                                "gap": 100,
                                "aceite": true,
                                "produto": "Impermeabilizantes"
                            },
                            {
                                "inicioMes": "2026-04-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 173314,
                                "codigo": "1153600",
                                "razaoSocial": "DEPOSITO CABUCU LTDA",
                                "gap": 100,
                                "aceite": true,
                                "produto": "Colantes"
                            },
                            {
                                "inicioMes": "2026-07-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 173314,
                                "codigo": "1153600",
                                "razaoSocial": "DEPOSITO CABUCU LTDA",
                                "gap": 560,
                                "aceite": true,
                                "produto": "Colantes"
                            },
                            {
                                "inicioMes": "2026-07-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 173314,
                                "codigo": "1153600",
                                "razaoSocial": "DEPOSITO CABUCU LTDA",
                                "gap": 420,
                                "aceite": true,
                                "produto": "Rejuntes"
                            },
                            {
                                "inicioMes": "2026-07-01T00:00:00",
                                "realizado": 110,
                                "clienteId": 173314,
                                "codigo": "1153600",
                                "razaoSocial": "DEPOSITO CABUCU LTDA",
                                "gap": -10,
                                "aceite": true,
                                "produto": "Impermeabilizantes"
                            },
                            {
                                "inicioMes": "2026-07-01T00:00:00",
                                "realizado": 2340.8,
                                "clienteId": 173314,
                                "codigo": "1153600",
                                "razaoSocial": "DEPOSITO CABUCU LTDA",
                                "gap": -212.80000000000018,
                                "aceite": true,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-08-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 173314,
                                "codigo": "1153600",
                                "razaoSocial": "DEPOSITO CABUCU LTDA",
                                "gap": 126.5,
                                "aceite": false,
                                "produto": "Impermeabilizantes"
                            },
                            {
                                "inicioMes": "2026-08-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 173314,
                                "codigo": "1153600",
                                "razaoSocial": "DEPOSITO CABUCU LTDA",
                                "gap": 227.70000000000002,
                                "aceite": false,
                                "produto": "Rejuntes"
                            },
                            {
                                "inicioMes": "2026-08-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 173314,
                                "codigo": "1153600",
                                "razaoSocial": "DEPOSITO CABUCU LTDA",
                                "gap": 354.2,
                                "aceite": false,
                                "produto": "Colantes"
                            },
                            {
                                "inicioMes": "2026-08-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 173314,
                                "codigo": "1153600",
                                "razaoSocial": "DEPOSITO CABUCU LTDA",
                                "gap": 2741.2000000000003,
                                "aceite": false,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-06-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 54397,
                                "codigo": "1059853",
                                "razaoSocial": "L  E F  MATERIAIS PARA CONSTRUCAO",
                                "gap": 512,
                                "aceite": true,
                                "produto": "Colantes"
                            },
                            {
                                "inicioMes": "2026-06-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 54397,
                                "codigo": "1059853",
                                "razaoSocial": "L  E F  MATERIAIS PARA CONSTRUCAO",
                                "gap": 176,
                                "aceite": true,
                                "produto": "Basicas"
                            },
                            {
                                "inicioMes": "2026-06-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 54397,
                                "codigo": "1059853",
                                "razaoSocial": "L  E F  MATERIAIS PARA CONSTRUCAO",
                                "gap": 259.2,
                                "aceite": true,
                                "produto": "Rejuntes"
                            },
                            {
                                "inicioMes": "2026-06-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 54397,
                                "codigo": "1059853",
                                "razaoSocial": "L  E F  MATERIAIS PARA CONSTRUCAO",
                                "gap": 1464,
                                "aceite": true,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-05-01T00:00:00",
                                "realizado": 1195.2,
                                "clienteId": 54397,
                                "codigo": "1059853",
                                "razaoSocial": "L  E F  MATERIAIS PARA CONSTRUCAO",
                                "gap": 72,
                                "aceite": true,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-05-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 54397,
                                "codigo": "1059853",
                                "razaoSocial": "L  E F  MATERIAIS PARA CONSTRUCAO",
                                "gap": 80,
                                "aceite": true,
                                "produto": "Rejuntes"
                            },
                            {
                                "inicioMes": "2026-05-01T00:00:00",
                                "realizado": 532,
                                "clienteId": 54397,
                                "codigo": "1059853",
                                "razaoSocial": "L  E F  MATERIAIS PARA CONSTRUCAO",
                                "gap": 31.5,
                                "aceite": true,
                                "produto": "Colantes"
                            },
                            {
                                "inicioMes": "2026-05-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 54397,
                                "codigo": "1059853",
                                "razaoSocial": "L  E F  MATERIAIS PARA CONSTRUCAO",
                                "gap": 287.5,
                                "aceite": true,
                                "produto": "Impermeabilizantes"
                            },
                            {
                                "inicioMes": "2026-08-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 54397,
                                "codigo": "1059853",
                                "razaoSocial": "L  E F  MATERIAIS PARA CONSTRUCAO",
                                "gap": 1764,
                                "aceite": true,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-08-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 54397,
                                "codigo": "1059853",
                                "razaoSocial": "L  E F  MATERIAIS PARA CONSTRUCAO",
                                "gap": 560,
                                "aceite": true,
                                "produto": "Colantes"
                            },
                            {
                                "inicioMes": "2026-08-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 54397,
                                "codigo": "1059853",
                                "razaoSocial": "L  E F  MATERIAIS PARA CONSTRUCAO",
                                "gap": 240,
                                "aceite": true,
                                "produto": "Impermeabilizantes"
                            },
                            {
                                "inicioMes": "2026-05-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 54548,
                                "codigo": "1055957",
                                "razaoSocial": "ITO BEL MATERIAIS PARA CONSTRUCAO",
                                "gap": 80,
                                "aceite": true,
                                "produto": "Impermeabilizantes"
                            },
                            {
                                "inicioMes": "2026-05-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 54548,
                                "codigo": "1055957",
                                "razaoSocial": "ITO BEL MATERIAIS PARA CONSTRUCAO",
                                "gap": 384,
                                "aceite": true,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-08-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 54548,
                                "codigo": "1055957",
                                "razaoSocial": "ITO BEL MATERIAIS PARA CONSTRUCAO",
                                "gap": 151.79999999999998,
                                "aceite": false,
                                "produto": "Colantes"
                            },
                            {
                                "inicioMes": "2026-08-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 54548,
                                "codigo": "1055957",
                                "razaoSocial": "ITO BEL MATERIAIS PARA CONSTRUCAO",
                                "gap": 484,
                                "aceite": false,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-08-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 54548,
                                "codigo": "1055957",
                                "razaoSocial": "ITO BEL MATERIAIS PARA CONSTRUCAO",
                                "gap": 126.5,
                                "aceite": false,
                                "produto": "Impermeabilizantes"
                            },
                            {
                                "inicioMes": "2026-04-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 54548,
                                "codigo": "1055957",
                                "razaoSocial": "ITO BEL MATERIAIS PARA CONSTRUCAO",
                                "gap": 100,
                                "aceite": true,
                                "produto": "Impermeabilizantes"
                            },
                            {
                                "inicioMes": "2026-04-01T00:00:00",
                                "realizado": 330,
                                "clienteId": 54548,
                                "codigo": "1055957",
                                "razaoSocial": "ITO BEL MATERIAIS PARA CONSTRUCAO",
                                "gap": -30,
                                "aceite": true,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-04-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 54548,
                                "codigo": "1055957",
                                "razaoSocial": "ITO BEL MATERIAIS PARA CONSTRUCAO",
                                "gap": 100,
                                "aceite": true,
                                "produto": "Colantes"
                            },
                            {
                                "inicioMes": "2026-07-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 54548,
                                "codigo": "1055957",
                                "razaoSocial": "ITO BEL MATERIAIS PARA CONSTRUCAO",
                                "gap": 100,
                                "aceite": true,
                                "produto": "Impermeabilizantes"
                            },
                            {
                                "inicioMes": "2026-07-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 54548,
                                "codigo": "1055957",
                                "razaoSocial": "ITO BEL MATERIAIS PARA CONSTRUCAO",
                                "gap": 130,
                                "aceite": true,
                                "produto": "Colantes"
                            },
                            {
                                "inicioMes": "2026-07-01T00:00:00",
                                "realizado": 432,
                                "clienteId": 54548,
                                "codigo": "1055957",
                                "razaoSocial": "ITO BEL MATERIAIS PARA CONSTRUCAO",
                                "gap": -24,
                                "aceite": true,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-04-01T00:00:00",
                                "realizado": 360,
                                "clienteId": 57133,
                                "codigo": "1054953",
                                "razaoSocial": "DEPOSITO DE MATERIAIS PARA",
                                "gap": 24,
                                "aceite": true,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-04-01T00:00:00",
                                "realizado": 242,
                                "clienteId": 196783,
                                "codigo": "1549482",
                                "razaoSocial": "S.C. CIMENTO E TRANSPORTE LTDA",
                                "gap": -22,
                                "aceite": true,
                                "produto": "Colantes"
                            },
                            {
                                "inicioMes": "2026-04-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 196783,
                                "codigo": "1549482",
                                "razaoSocial": "S.C. CIMENTO E TRANSPORTE LTDA",
                                "gap": 120,
                                "aceite": true,
                                "produto": "Impermeabilizantes"
                            },
                            {
                                "inicioMes": "2026-04-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 196783,
                                "codigo": "1549482",
                                "razaoSocial": "S.C. CIMENTO E TRANSPORTE LTDA",
                                "gap": 220,
                                "aceite": true,
                                "produto": "Basicas"
                            },
                            {
                                "inicioMes": "2026-04-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 196783,
                                "codigo": "1549482",
                                "razaoSocial": "S.C. CIMENTO E TRANSPORTE LTDA",
                                "gap": 400,
                                "aceite": true,
                                "produto": "Rejuntes"
                            },
                            {
                                "inicioMes": "2026-04-01T00:00:00",
                                "realizado": 7920,
                                "clienteId": 196783,
                                "codigo": "1549482",
                                "razaoSocial": "S.C. CIMENTO E TRANSPORTE LTDA",
                                "gap": -720,
                                "aceite": true,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-05-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 196783,
                                "codigo": "1549482",
                                "razaoSocial": "S.C. CIMENTO E TRANSPORTE LTDA",
                                "gap": 115,
                                "aceite": true,
                                "produto": "Impermeabilizantes"
                            },
                            {
                                "inicioMes": "2026-06-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 196783,
                                "codigo": "1549482",
                                "razaoSocial": "S.C. CIMENTO E TRANSPORTE LTDA",
                                "gap": 7893.599999999999,
                                "aceite": true,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-06-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 196783,
                                "codigo": "1549482",
                                "razaoSocial": "S.C. CIMENTO E TRANSPORTE LTDA",
                                "gap": 166.4,
                                "aceite": true,
                                "produto": "Rejuntes"
                            },
                            {
                                "inicioMes": "2026-06-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 196783,
                                "codigo": "1549482",
                                "razaoSocial": "S.C. CIMENTO E TRANSPORTE LTDA",
                                "gap": 1416.8000000000002,
                                "aceite": true,
                                "produto": "Colantes"
                            },
                            {
                                "inicioMes": "2026-07-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 196783,
                                "codigo": "1549482",
                                "razaoSocial": "S.C. CIMENTO E TRANSPORTE LTDA",
                                "gap": 360,
                                "aceite": true,
                                "produto": "Rejuntes"
                            },
                            {
                                "inicioMes": "2026-07-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 196783,
                                "codigo": "1549482",
                                "razaoSocial": "S.C. CIMENTO E TRANSPORTE LTDA",
                                "gap": 10137.6,
                                "aceite": true,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-07-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 196783,
                                "codigo": "1549482",
                                "razaoSocial": "S.C. CIMENTO E TRANSPORTE LTDA",
                                "gap": 800,
                                "aceite": true,
                                "produto": "Colantes"
                            },
                            {
                                "inicioMes": "2026-07-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 196783,
                                "codigo": "1549482",
                                "razaoSocial": "S.C. CIMENTO E TRANSPORTE LTDA",
                                "gap": 222.64,
                                "aceite": false,
                                "produto": "Basicas"
                            },
                            {
                                "inicioMes": "2026-08-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 196783,
                                "codigo": "1549482",
                                "razaoSocial": "S.C. CIMENTO E TRANSPORTE LTDA",
                                "gap": 560,
                                "aceite": true,
                                "produto": "Colantes"
                            },
                            {
                                "inicioMes": "2026-08-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 196831,
                                "codigo": "1499807",
                                "razaoSocial": "JOSE CARLOS CARDOSO",
                                "gap": 234,
                                "aceite": true,
                                "produto": "Colantes"
                            },
                            {
                                "inicioMes": "2026-08-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 196831,
                                "codigo": "1499807",
                                "razaoSocial": "JOSE CARLOS CARDOSO",
                                "gap": 156,
                                "aceite": true,
                                "produto": "Impermeabilizantes"
                            },
                            {
                                "inicioMes": "2026-08-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 196831,
                                "codigo": "1499807",
                                "razaoSocial": "JOSE CARLOS CARDOSO",
                                "gap": 840,
                                "aceite": true,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-08-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 196831,
                                "codigo": "1499807",
                                "razaoSocial": "JOSE CARLOS CARDOSO",
                                "gap": 691.1999999999999,
                                "aceite": true,
                                "produto": "Rejuntes"
                            },
                            {
                                "inicioMes": "2026-07-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 196831,
                                "codigo": "1499807",
                                "razaoSocial": "JOSE CARLOS CARDOSO",
                                "gap": 100,
                                "aceite": true,
                                "produto": "Impermeabilizantes"
                            },
                            {
                                "inicioMes": "2026-07-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 196831,
                                "codigo": "1499807",
                                "razaoSocial": "JOSE CARLOS CARDOSO",
                                "gap": 455,
                                "aceite": true,
                                "produto": "Colantes"
                            },
                            {
                                "inicioMes": "2026-07-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 196831,
                                "codigo": "1499807",
                                "razaoSocial": "JOSE CARLOS CARDOSO",
                                "gap": 273.6,
                                "aceite": true,
                                "produto": "Rejuntes"
                            },
                            {
                                "inicioMes": "2026-07-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 196831,
                                "codigo": "1499807",
                                "razaoSocial": "JOSE CARLOS CARDOSO",
                                "gap": 840,
                                "aceite": true,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-07-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 196832,
                                "codigo": "1475411",
                                "razaoSocial": "BARUK DISTRIBUIDORA DE CIMENTO LTDA",
                                "gap": 180,
                                "aceite": true,
                                "produto": "Rejuntes"
                            },
                            {
                                "inicioMes": "2026-07-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 196832,
                                "codigo": "1475411",
                                "razaoSocial": "BARUK DISTRIBUIDORA DE CIMENTO LTDA",
                                "gap": 2016,
                                "aceite": true,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-04-01T00:00:00",
                                "realizado": 765.6,
                                "clienteId": 196832,
                                "codigo": "1475411",
                                "razaoSocial": "BARUK DISTRIBUIDORA DE CIMENTO LTDA",
                                "gap": -69.60000000000002,
                                "aceite": true,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-04-01T00:00:00",
                                "realizado": 110,
                                "clienteId": 196832,
                                "codigo": "1475411",
                                "razaoSocial": "BARUK DISTRIBUIDORA DE CIMENTO LTDA",
                                "gap": -10,
                                "aceite": true,
                                "produto": "Rejuntes"
                            },
                            {
                                "inicioMes": "2026-06-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 196832,
                                "codigo": "1475411",
                                "razaoSocial": "BARUK DISTRIBUIDORA DE CIMENTO LTDA",
                                "gap": 238.464,
                                "aceite": true,
                                "produto": "Rejuntes"
                            },
                            {
                                "inicioMes": "2026-06-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 196832,
                                "codigo": "1475411",
                                "razaoSocial": "BARUK DISTRIBUIDORA DE CIMENTO LTDA",
                                "gap": 1944,
                                "aceite": true,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-08-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 196852,
                                "codigo": "1303008",
                                "razaoSocial": "POCAO MATERIAL DE CONSTRUCAO LTDA",
                                "gap": 158.125,
                                "aceite": false,
                                "produto": "Colantes"
                            },
                            {
                                "inicioMes": "2026-08-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 196852,
                                "codigo": "1303008",
                                "razaoSocial": "POCAO MATERIAL DE CONSTRUCAO LTDA",
                                "gap": 158.4,
                                "aceite": false,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-05-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 196863,
                                "codigo": "1185509",
                                "razaoSocial": "CASA COMERCIO MATERIAIS CONSTRUCAO",
                                "gap": 115,
                                "aceite": true,
                                "produto": "Impermeabilizantes"
                            },
                            {
                                "inicioMes": "2026-05-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 196863,
                                "codigo": "1185509",
                                "razaoSocial": "CASA COMERCIO MATERIAIS CONSTRUCAO",
                                "gap": 172.5,
                                "aceite": true,
                                "produto": "Cales"
                            },
                            {
                                "inicioMes": "2026-04-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 196863,
                                "codigo": "1185509",
                                "razaoSocial": "CASA COMERCIO MATERIAIS CONSTRUCAO",
                                "gap": 100,
                                "aceite": true,
                                "produto": "Rejuntes"
                            },
                            {
                                "inicioMes": "2026-04-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 196863,
                                "codigo": "1185509",
                                "razaoSocial": "CASA COMERCIO MATERIAIS CONSTRUCAO",
                                "gap": 125,
                                "aceite": true,
                                "produto": "Cales"
                            },
                            {
                                "inicioMes": "2026-04-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 196863,
                                "codigo": "1185509",
                                "razaoSocial": "CASA COMERCIO MATERIAIS CONSTRUCAO",
                                "gap": 696,
                                "aceite": true,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-08-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 196863,
                                "codigo": "1185509",
                                "razaoSocial": "CASA COMERCIO MATERIAIS CONSTRUCAO",
                                "gap": 924,
                                "aceite": false,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-08-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 196863,
                                "codigo": "1185509",
                                "razaoSocial": "CASA COMERCIO MATERIAIS CONSTRUCAO",
                                "gap": 261.8,
                                "aceite": false,
                                "produto": "Impermeabilizantes"
                            },
                            {
                                "inicioMes": "2026-08-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 196854,
                                "codigo": "1146279",
                                "razaoSocial": "PAULO FERROS MATERIAIS PARA",
                                "gap": 8.8,
                                "grupoCentralizador": "AREIÃO",
                                "aceite": false,
                                "produto": "Rejuntes"
                            },
                            {
                                "inicioMes": "2026-08-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 196854,
                                "codigo": "1146279",
                                "razaoSocial": "PAULO FERROS MATERIAIS PARA",
                                "gap": 35.2,
                                "grupoCentralizador": "AREIÃO",
                                "aceite": false,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-08-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 196854,
                                "codigo": "1146279",
                                "razaoSocial": "PAULO FERROS MATERIAIS PARA",
                                "gap": 0.44,
                                "grupoCentralizador": "AREIÃO",
                                "aceite": false,
                                "produto": "Colantes"
                            },
                            {
                                "inicioMes": "2026-07-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 196854,
                                "codigo": "1146279",
                                "razaoSocial": "PAULO FERROS MATERIAIS PARA",
                                "gap": 0,
                                "grupoCentralizador": "AREIÃO",
                                "aceite": true,
                                "produto": "Colantes"
                            },
                            {
                                "inicioMes": "2026-07-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 196854,
                                "codigo": "1146279",
                                "razaoSocial": "PAULO FERROS MATERIAIS PARA",
                                "gap": 0,
                                "grupoCentralizador": "AREIÃO",
                                "aceite": true,
                                "produto": "Impermeabilizantes"
                            },
                            {
                                "inicioMes": "2026-07-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 196854,
                                "codigo": "1146279",
                                "razaoSocial": "PAULO FERROS MATERIAIS PARA",
                                "gap": 0,
                                "grupoCentralizador": "AREIÃO",
                                "aceite": true,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-08-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 173541,
                                "codigo": "1654458",
                                "razaoSocial": "AREIAO TERRA FORTE COMERCIO DE",
                                "gap": 303.6,
                                "grupoCentralizador": "AREIÃO",
                                "aceite": false,
                                "produto": "Colantes"
                            },
                            {
                                "inicioMes": "2026-08-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 173541,
                                "codigo": "1654458",
                                "razaoSocial": "AREIAO TERRA FORTE COMERCIO DE",
                                "gap": 202.4,
                                "grupoCentralizador": "AREIÃO",
                                "aceite": false,
                                "produto": "Rejuntes"
                            },
                            {
                                "inicioMes": "2026-08-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 173541,
                                "codigo": "1654458",
                                "razaoSocial": "AREIAO TERRA FORTE COMERCIO DE",
                                "gap": 880.0000000000001,
                                "grupoCentralizador": "AREIÃO",
                                "aceite": false,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-07-01T00:00:00",
                                "realizado": 448,
                                "clienteId": 173541,
                                "codigo": "1654458",
                                "razaoSocial": "AREIAO TERRA FORTE COMERCIO DE",
                                "gap": 32,
                                "grupoCentralizador": "AREIÃO",
                                "aceite": true,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-07-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 173541,
                                "codigo": "1654458",
                                "razaoSocial": "AREIAO TERRA FORTE COMERCIO DE",
                                "gap": 240,
                                "grupoCentralizador": "AREIÃO",
                                "aceite": true,
                                "produto": "Colantes"
                            },
                            {
                                "inicioMes": "2026-07-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 173541,
                                "codigo": "1654458",
                                "razaoSocial": "AREIAO TERRA FORTE COMERCIO DE",
                                "gap": 120,
                                "grupoCentralizador": "AREIÃO",
                                "aceite": true,
                                "produto": "Impermeabilizantes"
                            },
                            {
                                "inicioMes": "2026-05-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 196829,
                                "codigo": "1544786",
                                "razaoSocial": "COSTA ATACADISTA DA CONSTRUCAO LTDA",
                                "gap": 240,
                                "grupoCentralizador": "COSTA ATACADISTA",
                                "aceite": true,
                                "produto": "Rejuntes"
                            },
                            {
                                "inicioMes": "2026-05-01T00:00:00",
                                "realizado": 1344,
                                "clienteId": 196829,
                                "codigo": "1544786",
                                "razaoSocial": "COSTA ATACADISTA DA CONSTRUCAO LTDA",
                                "gap": 0,
                                "grupoCentralizador": "COSTA ATACADISTA",
                                "aceite": true,
                                "produto": "Colantes"
                            },
                            {
                                "inicioMes": "2026-05-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 196829,
                                "codigo": "1544786",
                                "razaoSocial": "COSTA ATACADISTA DA CONSTRUCAO LTDA",
                                "gap": 224,
                                "grupoCentralizador": "COSTA ATACADISTA",
                                "aceite": true,
                                "produto": "Impermeabilizantes"
                            },
                            {
                                "inicioMes": "2026-07-01T00:00:00",
                                "realizado": 1520,
                                "clienteId": 196829,
                                "codigo": "1544786",
                                "razaoSocial": "COSTA ATACADISTA DA CONSTRUCAO LTDA",
                                "gap": 0,
                                "grupoCentralizador": "COSTA ATACADISTA",
                                "aceite": true,
                                "produto": "Colantes"
                            },
                            {
                                "inicioMes": "2026-07-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 196829,
                                "codigo": "1544786",
                                "razaoSocial": "COSTA ATACADISTA DA CONSTRUCAO LTDA",
                                "gap": 499.20000000000005,
                                "grupoCentralizador": "COSTA ATACADISTA",
                                "aceite": true,
                                "produto": "Rejuntes"
                            },
                            {
                                "inicioMes": "2026-07-01T00:00:00",
                                "realizado": 2772,
                                "clienteId": 196829,
                                "codigo": "1544786",
                                "razaoSocial": "COSTA ATACADISTA DA CONSTRUCAO LTDA",
                                "gap": -112,
                                "grupoCentralizador": "COSTA ATACADISTA",
                                "aceite": true,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-07-01T00:00:00",
                                "realizado": 162,
                                "clienteId": 196829,
                                "codigo": "1544786",
                                "razaoSocial": "COSTA ATACADISTA DA CONSTRUCAO LTDA",
                                "gap": 18,
                                "grupoCentralizador": "COSTA ATACADISTA",
                                "aceite": true,
                                "produto": "Impermeabilizantes"
                            },
                            {
                                "inicioMes": "2026-04-01T00:00:00",
                                "realizado": 1617,
                                "clienteId": 196829,
                                "codigo": "1544786",
                                "razaoSocial": "COSTA ATACADISTA DA CONSTRUCAO LTDA",
                                "gap": -147,
                                "grupoCentralizador": "COSTA ATACADISTA",
                                "aceite": true,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-04-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 196829,
                                "codigo": "1544786",
                                "razaoSocial": "COSTA ATACADISTA DA CONSTRUCAO LTDA",
                                "gap": 300,
                                "grupoCentralizador": "COSTA ATACADISTA",
                                "aceite": true,
                                "produto": "Rejuntes"
                            },
                            {
                                "inicioMes": "2026-04-01T00:00:00",
                                "realizado": 1056,
                                "clienteId": 196829,
                                "codigo": "1544786",
                                "razaoSocial": "COSTA ATACADISTA DA CONSTRUCAO LTDA",
                                "gap": -96,
                                "grupoCentralizador": "COSTA ATACADISTA",
                                "aceite": true,
                                "produto": "Colantes"
                            },
                            {
                                "inicioMes": "2026-04-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 196829,
                                "codigo": "1544786",
                                "razaoSocial": "COSTA ATACADISTA DA CONSTRUCAO LTDA",
                                "gap": 180,
                                "grupoCentralizador": "COSTA ATACADISTA",
                                "aceite": true,
                                "produto": "Impermeabilizantes"
                            },
                            {
                                "inicioMes": "2026-08-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 196829,
                                "codigo": "1544786",
                                "razaoSocial": "COSTA ATACADISTA DA CONSTRUCAO LTDA",
                                "gap": 1680,
                                "grupoCentralizador": "COSTA ATACADISTA",
                                "aceite": true,
                                "produto": "Colantes"
                            },
                            {
                                "inicioMes": "2026-08-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 196829,
                                "codigo": "1544786",
                                "razaoSocial": "COSTA ATACADISTA DA CONSTRUCAO LTDA",
                                "gap": 120,
                                "grupoCentralizador": "COSTA ATACADISTA",
                                "aceite": true,
                                "produto": "Impermeabilizantes"
                            },
                            {
                                "inicioMes": "2026-08-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 196829,
                                "codigo": "1544786",
                                "razaoSocial": "COSTA ATACADISTA DA CONSTRUCAO LTDA",
                                "gap": 249.60000000000002,
                                "grupoCentralizador": "COSTA ATACADISTA",
                                "aceite": true,
                                "produto": "Rejuntes"
                            },
                            {
                                "inicioMes": "2026-08-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 196829,
                                "codigo": "1544786",
                                "razaoSocial": "COSTA ATACADISTA DA CONSTRUCAO LTDA",
                                "gap": 2464,
                                "grupoCentralizador": "COSTA ATACADISTA",
                                "aceite": true,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-04-01T00:00:00",
                                "realizado": 924,
                                "clienteId": 54538,
                                "codigo": "1056239",
                                "razaoSocial": "MARGETEC MATERIAIS PARA CONSTRUCAO",
                                "gap": -84,
                                "grupoCentralizador": "AMARELINHO",
                                "aceite": true,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-04-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 54538,
                                "codigo": "1056239",
                                "razaoSocial": "MARGETEC MATERIAIS PARA CONSTRUCAO",
                                "gap": 572,
                                "grupoCentralizador": "AMARELINHO",
                                "aceite": true,
                                "produto": "Colantes"
                            },
                            {
                                "inicioMes": "2026-04-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 54538,
                                "codigo": "1056239",
                                "razaoSocial": "MARGETEC MATERIAIS PARA CONSTRUCAO",
                                "gap": 240,
                                "grupoCentralizador": "AMARELINHO",
                                "aceite": true,
                                "produto": "Rejuntes"
                            },
                            {
                                "inicioMes": "2026-04-01T00:00:00",
                                "realizado": 132,
                                "clienteId": 54538,
                                "codigo": "1056239",
                                "razaoSocial": "MARGETEC MATERIAIS PARA CONSTRUCAO",
                                "gap": -12,
                                "grupoCentralizador": "AMARELINHO",
                                "aceite": true,
                                "produto": "Impermeabilizantes"
                            },
                            {
                                "inicioMes": "2026-05-01T00:00:00",
                                "realizado": 616,
                                "clienteId": 19005,
                                "codigo": "1053116",
                                "razaoSocial": "MARGETEL COMERCIO DE MATERIAIS",
                                "gap": -56,
                                "grupoCentralizador": "AMARELINHO",
                                "aceite": true,
                                "produto": "Colantes"
                            },
                            {
                                "inicioMes": "2026-05-01T00:00:00",
                                "realizado": 160,
                                "clienteId": 19005,
                                "codigo": "1053116",
                                "razaoSocial": "MARGETEL COMERCIO DE MATERIAIS",
                                "gap": 0,
                                "grupoCentralizador": "AMARELINHO",
                                "aceite": true,
                                "produto": "Rejuntes"
                            },
                            {
                                "inicioMes": "2026-05-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 19005,
                                "codigo": "1053116",
                                "razaoSocial": "MARGETEL COMERCIO DE MATERIAIS",
                                "gap": 120,
                                "grupoCentralizador": "AMARELINHO",
                                "aceite": true,
                                "produto": "Impermeabilizantes"
                            },
                            {
                                "inicioMes": "2026-05-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 19005,
                                "codigo": "1053116",
                                "razaoSocial": "MARGETEL COMERCIO DE MATERIAIS",
                                "gap": 896,
                                "grupoCentralizador": "AMARELINHO",
                                "aceite": true,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-08-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 1130540,
                                "codigo": "1904962",
                                "razaoSocial": "CASA DUTRA REVENDEDORA DE MATERIAIS",
                                "gap": 5.5,
                                "grupoCentralizador": "TOCA LOJA DISTRIBUIDORA",
                                "aceite": false,
                                "produto": "Impermeabilizantes"
                            },
                            {
                                "inicioMes": "2026-08-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 1130540,
                                "codigo": "1904962",
                                "razaoSocial": "CASA DUTRA REVENDEDORA DE MATERIAIS",
                                "gap": 30.8,
                                "grupoCentralizador": "TOCA LOJA DISTRIBUIDORA",
                                "aceite": false,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-08-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 1130540,
                                "codigo": "1904962",
                                "razaoSocial": "CASA DUTRA REVENDEDORA DE MATERIAIS",
                                "gap": 0.44,
                                "grupoCentralizador": "TOCA LOJA DISTRIBUIDORA",
                                "aceite": false,
                                "produto": "Colantes"
                            },
                            {
                                "inicioMes": "2026-08-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 1130540,
                                "codigo": "1904962",
                                "razaoSocial": "CASA DUTRA REVENDEDORA DE MATERIAIS",
                                "gap": 8.8,
                                "grupoCentralizador": "TOCA LOJA DISTRIBUIDORA",
                                "aceite": false,
                                "produto": "Rejuntes"
                            },
                            {
                                "inicioMes": "2026-06-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 1130540,
                                "codigo": "1904962",
                                "razaoSocial": "CASA DUTRA REVENDEDORA DE MATERIAIS",
                                "gap": 176,
                                "grupoCentralizador": "TOCA LOJA DISTRIBUIDORA",
                                "aceite": true,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-06-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 1130540,
                                "codigo": "1904962",
                                "razaoSocial": "CASA DUTRA REVENDEDORA DE MATERIAIS",
                                "gap": 91.2,
                                "grupoCentralizador": "TOCA LOJA DISTRIBUIDORA",
                                "aceite": true,
                                "produto": "Rejuntes"
                            },
                            {
                                "inicioMes": "2026-06-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 1130540,
                                "codigo": "1904962",
                                "razaoSocial": "CASA DUTRA REVENDEDORA DE MATERIAIS",
                                "gap": 126.49999999999999,
                                "grupoCentralizador": "TOCA LOJA DISTRIBUIDORA",
                                "aceite": true,
                                "produto": "Colantes"
                            },
                            {
                                "inicioMes": "2026-06-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 1130540,
                                "codigo": "1904962",
                                "razaoSocial": "CASA DUTRA REVENDEDORA DE MATERIAIS",
                                "gap": 80,
                                "grupoCentralizador": "TOCA LOJA DISTRIBUIDORA",
                                "aceite": true,
                                "produto": "Impermeabilizantes"
                            },
                            {
                                "inicioMes": "2026-07-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 1130540,
                                "codigo": "1904962",
                                "razaoSocial": "CASA DUTRA REVENDEDORA DE MATERIAIS",
                                "gap": 0,
                                "grupoCentralizador": "TOCA LOJA DISTRIBUIDORA",
                                "aceite": true,
                                "produto": "Colantes"
                            },
                            {
                                "inicioMes": "2026-07-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 1130540,
                                "codigo": "1904962",
                                "razaoSocial": "CASA DUTRA REVENDEDORA DE MATERIAIS",
                                "gap": 0,
                                "grupoCentralizador": "TOCA LOJA DISTRIBUIDORA",
                                "aceite": true,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-07-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 1130540,
                                "codigo": "1904962",
                                "razaoSocial": "CASA DUTRA REVENDEDORA DE MATERIAIS",
                                "gap": 0,
                                "grupoCentralizador": "TOCA LOJA DISTRIBUIDORA",
                                "aceite": true,
                                "produto": "Impermeabilizantes"
                            },
                            {
                                "inicioMes": "2026-07-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 1130540,
                                "codigo": "1904962",
                                "razaoSocial": "CASA DUTRA REVENDEDORA DE MATERIAIS",
                                "gap": 0,
                                "grupoCentralizador": "TOCA LOJA DISTRIBUIDORA",
                                "aceite": true,
                                "produto": "Rejuntes"
                            },
                            {
                                "inicioMes": "2026-08-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 662331,
                                "codigo": "1842155",
                                "razaoSocial": "TOCA LOJA DISTRIBUIDORA LTDA",
                                "gap": 299.20000000000005,
                                "grupoCentralizador": "TOCA LOJA DISTRIBUIDORA",
                                "aceite": false,
                                "produto": "Rejuntes"
                            },
                            {
                                "inicioMes": "2026-08-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 662331,
                                "codigo": "1842155",
                                "razaoSocial": "TOCA LOJA DISTRIBUIDORA LTDA",
                                "gap": 2833.6,
                                "grupoCentralizador": "TOCA LOJA DISTRIBUIDORA",
                                "aceite": false,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-08-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 662331,
                                "codigo": "1842155",
                                "razaoSocial": "TOCA LOJA DISTRIBUIDORA LTDA",
                                "gap": 187,
                                "grupoCentralizador": "TOCA LOJA DISTRIBUIDORA",
                                "aceite": false,
                                "produto": "Impermeabilizantes"
                            },
                            {
                                "inicioMes": "2026-08-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 662331,
                                "codigo": "1842155",
                                "razaoSocial": "TOCA LOJA DISTRIBUIDORA LTDA",
                                "gap": 1416.8000000000002,
                                "grupoCentralizador": "TOCA LOJA DISTRIBUIDORA",
                                "aceite": false,
                                "produto": "Colantes"
                            },
                            {
                                "inicioMes": "2026-05-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 662331,
                                "codigo": "1842155",
                                "razaoSocial": "TOCA LOJA DISTRIBUIDORA LTDA",
                                "gap": 114.99999999999999,
                                "grupoCentralizador": "TOCA LOJA DISTRIBUIDORA",
                                "aceite": true,
                                "produto": "Cales"
                            },
                            {
                                "inicioMes": "2026-05-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 662331,
                                "codigo": "1842155",
                                "razaoSocial": "TOCA LOJA DISTRIBUIDORA LTDA",
                                "gap": 448,
                                "grupoCentralizador": "TOCA LOJA DISTRIBUIDORA",
                                "aceite": true,
                                "produto": "Colantes"
                            },
                            {
                                "inicioMes": "2026-05-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 662331,
                                "codigo": "1842155",
                                "razaoSocial": "TOCA LOJA DISTRIBUIDORA LTDA",
                                "gap": 241.49999999999997,
                                "grupoCentralizador": "TOCA LOJA DISTRIBUIDORA",
                                "aceite": true,
                                "produto": "Rejuntes"
                            },
                            {
                                "inicioMes": "2026-05-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 662331,
                                "codigo": "1842155",
                                "razaoSocial": "TOCA LOJA DISTRIBUIDORA LTDA",
                                "gap": 1152,
                                "grupoCentralizador": "TOCA LOJA DISTRIBUIDORA",
                                "aceite": true,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-07-01T00:00:00",
                                "realizado": 693,
                                "clienteId": 662331,
                                "codigo": "1842155",
                                "razaoSocial": "TOCA LOJA DISTRIBUIDORA LTDA",
                                "gap": -63,
                                "grupoCentralizador": "TOCA LOJA DISTRIBUIDORA",
                                "aceite": true,
                                "produto": "Colantes"
                            },
                            {
                                "inicioMes": "2026-07-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 662331,
                                "codigo": "1842155",
                                "razaoSocial": "TOCA LOJA DISTRIBUIDORA LTDA",
                                "gap": 366,
                                "grupoCentralizador": "TOCA LOJA DISTRIBUIDORA",
                                "aceite": true,
                                "produto": "Rejuntes"
                            },
                            {
                                "inicioMes": "2026-07-01T00:00:00",
                                "realizado": 1842,
                                "clienteId": 662331,
                                "codigo": "1842155",
                                "razaoSocial": "TOCA LOJA DISTRIBUIDORA LTDA",
                                "gap": -18,
                                "grupoCentralizador": "TOCA LOJA DISTRIBUIDORA",
                                "aceite": true,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-07-01T00:00:00",
                                "realizado": 90,
                                "clienteId": 662331,
                                "codigo": "1842155",
                                "razaoSocial": "TOCA LOJA DISTRIBUIDORA LTDA",
                                "gap": 10,
                                "grupoCentralizador": "TOCA LOJA DISTRIBUIDORA",
                                "aceite": true,
                                "produto": "Impermeabilizantes"
                            },
                            {
                                "inicioMes": "2026-04-01T00:00:00",
                                "realizado": 104,
                                "clienteId": 662331,
                                "codigo": "1842155",
                                "razaoSocial": "TOCA LOJA DISTRIBUIDORA LTDA",
                                "gap": -4,
                                "grupoCentralizador": "TOCA LOJA DISTRIBUIDORA",
                                "aceite": true,
                                "produto": "Cales"
                            },
                            {
                                "inicioMes": "2026-04-01T00:00:00",
                                "realizado": 924,
                                "clienteId": 662331,
                                "codigo": "1842155",
                                "razaoSocial": "TOCA LOJA DISTRIBUIDORA LTDA",
                                "gap": -84,
                                "grupoCentralizador": "TOCA LOJA DISTRIBUIDORA",
                                "aceite": true,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-04-01T00:00:00",
                                "realizado": 192.5,
                                "clienteId": 662331,
                                "codigo": "1842155",
                                "razaoSocial": "TOCA LOJA DISTRIBUIDORA LTDA",
                                "gap": -17.5,
                                "grupoCentralizador": "TOCA LOJA DISTRIBUIDORA",
                                "aceite": true,
                                "produto": "Colantes"
                            },
                            {
                                "inicioMes": "2026-04-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 662331,
                                "codigo": "1842155",
                                "razaoSocial": "TOCA LOJA DISTRIBUIDORA LTDA",
                                "gap": 200,
                                "grupoCentralizador": "TOCA LOJA DISTRIBUIDORA",
                                "aceite": true,
                                "produto": "Impermeabilizantes"
                            },
                            {
                                "inicioMes": "2026-04-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 662331,
                                "codigo": "1842155",
                                "razaoSocial": "TOCA LOJA DISTRIBUIDORA LTDA",
                                "gap": 100,
                                "grupoCentralizador": "TOCA LOJA DISTRIBUIDORA",
                                "aceite": true,
                                "produto": "Rejuntes"
                            },
                            {
                                "inicioMes": "2026-06-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 663192,
                                "codigo": "1842703",
                                "razaoSocial": "EDUARDO HENRIQUE EMICO DE ASSIS",
                                "gap": 50,
                                "grupoCentralizador": "VORTEX",
                                "aceite": true,
                                "produto": "Colantes"
                            },
                            {
                                "inicioMes": "2026-06-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 663192,
                                "codigo": "1842703",
                                "razaoSocial": "EDUARDO HENRIQUE EMICO DE ASSIS",
                                "gap": 158.39999999999998,
                                "grupoCentralizador": "VORTEX",
                                "aceite": true,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-06-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 663192,
                                "codigo": "1842703",
                                "razaoSocial": "EDUARDO HENRIQUE EMICO DE ASSIS",
                                "gap": 91.2,
                                "grupoCentralizador": "VORTEX",
                                "aceite": true,
                                "produto": "Rejuntes"
                            },
                            {
                                "inicioMes": "2026-07-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 663192,
                                "codigo": "1842703",
                                "razaoSocial": "EDUARDO HENRIQUE EMICO DE ASSIS",
                                "gap": 0,
                                "grupoCentralizador": "VORTEX",
                                "aceite": true,
                                "produto": "Colantes"
                            },
                            {
                                "inicioMes": "2026-07-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 663192,
                                "codigo": "1842703",
                                "razaoSocial": "EDUARDO HENRIQUE EMICO DE ASSIS",
                                "gap": 0,
                                "grupoCentralizador": "VORTEX",
                                "aceite": true,
                                "produto": "Rejuntes"
                            },
                            {
                                "inicioMes": "2026-07-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 663192,
                                "codigo": "1842703",
                                "razaoSocial": "EDUARDO HENRIQUE EMICO DE ASSIS",
                                "gap": 0,
                                "grupoCentralizador": "VORTEX",
                                "aceite": true,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-07-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 196864,
                                "codigo": "1226922",
                                "razaoSocial": "PEQUENO E POPULAR MATERIAIS PARA CO",
                                "gap": 0,
                                "grupoCentralizador": "VORTEX",
                                "aceite": true,
                                "produto": "Colantes"
                            },
                            {
                                "inicioMes": "2026-07-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 196864,
                                "codigo": "1226922",
                                "razaoSocial": "PEQUENO E POPULAR MATERIAIS PARA CO",
                                "gap": 0,
                                "grupoCentralizador": "VORTEX",
                                "aceite": true,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-07-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 196864,
                                "codigo": "1226922",
                                "razaoSocial": "PEQUENO E POPULAR MATERIAIS PARA CO",
                                "gap": 0,
                                "grupoCentralizador": "VORTEX",
                                "aceite": true,
                                "produto": "Rejuntes"
                            },
                            {
                                "inicioMes": "2026-06-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 196864,
                                "codigo": "1226922",
                                "razaoSocial": "PEQUENO E POPULAR MATERIAIS PARA CO",
                                "gap": 103.68,
                                "grupoCentralizador": "VORTEX",
                                "aceite": true,
                                "produto": "Rejuntes"
                            },
                            {
                                "inicioMes": "2026-06-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 196864,
                                "codigo": "1226922",
                                "razaoSocial": "PEQUENO E POPULAR MATERIAIS PARA CO",
                                "gap": 158.39999999999998,
                                "grupoCentralizador": "VORTEX",
                                "aceite": true,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-06-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 196835,
                                "codigo": "1345157",
                                "razaoSocial": "JOSE MATEUS DE ASSIS   ME",
                                "gap": 158.39999999999998,
                                "grupoCentralizador": "VORTEX",
                                "aceite": true,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-06-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 196835,
                                "codigo": "1345157",
                                "razaoSocial": "JOSE MATEUS DE ASSIS   ME",
                                "gap": 80,
                                "grupoCentralizador": "VORTEX",
                                "aceite": true,
                                "produto": "Impermeabilizantes"
                            },
                            {
                                "inicioMes": "2026-07-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 196835,
                                "codigo": "1345157",
                                "razaoSocial": "JOSE MATEUS DE ASSIS   ME",
                                "gap": 366,
                                "grupoCentralizador": "VORTEX",
                                "aceite": true,
                                "produto": "Rejuntes"
                            },
                            {
                                "inicioMes": "2026-07-01T00:00:00",
                                "realizado": 492.8,
                                "clienteId": 196835,
                                "codigo": "1345157",
                                "razaoSocial": "JOSE MATEUS DE ASSIS   ME",
                                "gap": -44.80000000000001,
                                "grupoCentralizador": "VORTEX",
                                "aceite": true,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-07-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 196835,
                                "codigo": "1345157",
                                "razaoSocial": "JOSE MATEUS DE ASSIS   ME",
                                "gap": 210,
                                "grupoCentralizador": "VORTEX",
                                "aceite": true,
                                "produto": "Colantes"
                            },
                            {
                                "inicioMes": "2026-08-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 54219,
                                "codigo": "1108711",
                                "razaoSocial": "ARNALDO ANDRADE CORREIA GUARULHOS",
                                "gap": 224,
                                "grupoCentralizador": "LENYSIO TELHAS",
                                "aceite": true,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-06-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 54219,
                                "codigo": "1108711",
                                "razaoSocial": "ARNALDO ANDRADE CORREIA GUARULHOS",
                                "gap": 259.2,
                                "grupoCentralizador": "LENYSIO TELHAS",
                                "aceite": true,
                                "produto": "Rejuntes"
                            },
                            {
                                "inicioMes": "2026-06-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 54219,
                                "codigo": "1108711",
                                "razaoSocial": "ARNALDO ANDRADE CORREIA GUARULHOS",
                                "gap": 971.5200000000001,
                                "grupoCentralizador": "LENYSIO TELHAS",
                                "aceite": true,
                                "produto": "Colantes"
                            },
                            {
                                "inicioMes": "2026-04-01T00:00:00",
                                "realizado": 184.8,
                                "clienteId": 54219,
                                "codigo": "1108711",
                                "razaoSocial": "ARNALDO ANDRADE CORREIA GUARULHOS",
                                "gap": -16.80000000000001,
                                "grupoCentralizador": "LENYSIO TELHAS",
                                "aceite": true,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-04-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 54219,
                                "codigo": "1108711",
                                "razaoSocial": "ARNALDO ANDRADE CORREIA GUARULHOS",
                                "gap": 280,
                                "grupoCentralizador": "LENYSIO TELHAS",
                                "aceite": true,
                                "produto": "Rejuntes"
                            },
                            {
                                "inicioMes": "2026-04-01T00:00:00",
                                "realizado": 462,
                                "clienteId": 54219,
                                "codigo": "1108711",
                                "razaoSocial": "ARNALDO ANDRADE CORREIA GUARULHOS",
                                "gap": 28,
                                "grupoCentralizador": "LENYSIO TELHAS",
                                "aceite": true,
                                "produto": "Colantes"
                            },
                            {
                                "inicioMes": "2026-05-01T00:00:00",
                                "realizado": 288,
                                "clienteId": 54219,
                                "codigo": "1108711",
                                "razaoSocial": "ARNALDO ANDRADE CORREIA GUARULHOS",
                                "gap": 24,
                                "grupoCentralizador": "LENYSIO TELHAS",
                                "aceite": true,
                                "produto": "Rejuntes"
                            },
                            {
                                "inicioMes": "2026-05-01T00:00:00",
                                "realizado": 1081.08,
                                "clienteId": 54219,
                                "codigo": "1108711",
                                "razaoSocial": "ARNALDO ANDRADE CORREIA GUARULHOS",
                                "gap": -98.27999999999997,
                                "grupoCentralizador": "LENYSIO TELHAS",
                                "aceite": true,
                                "produto": "Colantes"
                            },
                            {
                                "inicioMes": "2026-05-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 54219,
                                "codigo": "1108711",
                                "razaoSocial": "ARNALDO ANDRADE CORREIA GUARULHOS",
                                "gap": 134.4,
                                "grupoCentralizador": "LENYSIO TELHAS",
                                "aceite": true,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-07-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 54219,
                                "codigo": "1108711",
                                "razaoSocial": "ARNALDO ANDRADE CORREIA GUARULHOS",
                                "gap": 0,
                                "grupoCentralizador": "LENYSIO TELHAS",
                                "aceite": true,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-07-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 54219,
                                "codigo": "1108711",
                                "razaoSocial": "ARNALDO ANDRADE CORREIA GUARULHOS",
                                "gap": 0,
                                "grupoCentralizador": "LENYSIO TELHAS",
                                "aceite": true,
                                "produto": "Rejuntes"
                            },
                            {
                                "inicioMes": "2026-07-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 54219,
                                "codigo": "1108711",
                                "razaoSocial": "ARNALDO ANDRADE CORREIA GUARULHOS",
                                "gap": 0,
                                "grupoCentralizador": "LENYSIO TELHAS",
                                "aceite": true,
                                "produto": "Colantes"
                            },
                            {
                                "inicioMes": "2026-07-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 54219,
                                "codigo": "1108711",
                                "razaoSocial": "ARNALDO ANDRADE CORREIA GUARULHOS",
                                "gap": 0,
                                "grupoCentralizador": "LENYSIO TELHAS",
                                "aceite": true,
                                "produto": "Impermeabilizantes"
                            },
                            {
                                "inicioMes": "2026-06-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 54224,
                                "codigo": "1146294",
                                "razaoSocial": "LENYSIO TELHAS LTDA",
                                "gap": 115,
                                "grupoCentralizador": "LENYSIO TELHAS",
                                "aceite": true,
                                "produto": "Impermeabilizantes"
                            },
                            {
                                "inicioMes": "2026-06-01T00:00:00",
                                "realizado": 184.8,
                                "clienteId": 54224,
                                "codigo": "1146294",
                                "razaoSocial": "LENYSIO TELHAS LTDA",
                                "gap": -2.842170943040401E-14,
                                "grupoCentralizador": "LENYSIO TELHAS",
                                "aceite": true,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-07-01T00:00:00",
                                "realizado": 1232,
                                "clienteId": 54224,
                                "codigo": "1146294",
                                "razaoSocial": "LENYSIO TELHAS LTDA",
                                "gap": -112,
                                "grupoCentralizador": "LENYSIO TELHAS",
                                "aceite": true,
                                "produto": "Colantes"
                            },
                            {
                                "inicioMes": "2026-07-01T00:00:00",
                                "realizado": 390.4,
                                "clienteId": 54224,
                                "codigo": "1146294",
                                "razaoSocial": "LENYSIO TELHAS LTDA",
                                "gap": -24.399999999999977,
                                "grupoCentralizador": "LENYSIO TELHAS",
                                "aceite": true,
                                "produto": "Rejuntes"
                            },
                            {
                                "inicioMes": "2026-07-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 54224,
                                "codigo": "1146294",
                                "razaoSocial": "LENYSIO TELHAS LTDA",
                                "gap": 100,
                                "grupoCentralizador": "LENYSIO TELHAS",
                                "aceite": true,
                                "produto": "Impermeabilizantes"
                            },
                            {
                                "inicioMes": "2026-07-01T00:00:00",
                                "realizado": 184.8,
                                "clienteId": 54224,
                                "codigo": "1146294",
                                "razaoSocial": "LENYSIO TELHAS LTDA",
                                "gap": -16.80000000000001,
                                "grupoCentralizador": "LENYSIO TELHAS",
                                "aceite": true,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-08-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 54224,
                                "codigo": "1146294",
                                "razaoSocial": "LENYSIO TELHAS LTDA",
                                "gap": 960,
                                "grupoCentralizador": "LENYSIO TELHAS",
                                "aceite": true,
                                "produto": "Colantes"
                            },
                            {
                                "inicioMes": "2026-08-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 54224,
                                "codigo": "1146294",
                                "razaoSocial": "LENYSIO TELHAS LTDA",
                                "gap": 0,
                                "grupoCentralizador": "LENYSIO TELHAS",
                                "aceite": true,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-08-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 54224,
                                "codigo": "1146294",
                                "razaoSocial": "LENYSIO TELHAS LTDA",
                                "gap": 450,
                                "grupoCentralizador": "LENYSIO TELHAS",
                                "aceite": true,
                                "produto": "Rejuntes"
                            },
                            {
                                "inicioMes": "2026-08-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 180309,
                                "codigo": "1247422",
                                "razaoSocial": "DOIS IRMAOS CASIMIRO MATERIAIS PARA",
                                "gap": 8.8,
                                "grupoCentralizador": "IRMÃOS CASIMIRO",
                                "aceite": false,
                                "produto": "Rejuntes"
                            },
                            {
                                "inicioMes": "2026-08-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 180309,
                                "codigo": "1247422",
                                "razaoSocial": "DOIS IRMAOS CASIMIRO MATERIAIS PARA",
                                "gap": 5.5,
                                "grupoCentralizador": "IRMÃOS CASIMIRO",
                                "aceite": false,
                                "produto": "Impermeabilizantes"
                            },
                            {
                                "inicioMes": "2026-08-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 180309,
                                "codigo": "1247422",
                                "razaoSocial": "DOIS IRMAOS CASIMIRO MATERIAIS PARA",
                                "gap": 30.8,
                                "grupoCentralizador": "IRMÃOS CASIMIRO",
                                "aceite": false,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-08-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 180309,
                                "codigo": "1247422",
                                "razaoSocial": "DOIS IRMAOS CASIMIRO MATERIAIS PARA",
                                "gap": 0.44,
                                "grupoCentralizador": "IRMÃOS CASIMIRO",
                                "aceite": false,
                                "produto": "Colantes"
                            },
                            {
                                "inicioMes": "2026-08-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 196862,
                                "codigo": "1052267",
                                "razaoSocial": "CASIMIRO DEPOSITO DE MATERIAIS PARA",
                                "gap": 202.4,
                                "grupoCentralizador": "IRMÃOS CASIMIRO",
                                "aceite": false,
                                "produto": "Rejuntes"
                            },
                            {
                                "inicioMes": "2026-08-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 196862,
                                "codigo": "1052267",
                                "razaoSocial": "CASIMIRO DEPOSITO DE MATERIAIS PARA",
                                "gap": 126.5,
                                "grupoCentralizador": "IRMÃOS CASIMIRO",
                                "aceite": false,
                                "produto": "Impermeabilizantes"
                            },
                            {
                                "inicioMes": "2026-08-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 196862,
                                "codigo": "1052267",
                                "razaoSocial": "CASIMIRO DEPOSITO DE MATERIAIS PARA",
                                "gap": 506,
                                "grupoCentralizador": "IRMÃOS CASIMIRO",
                                "aceite": false,
                                "produto": "Colantes"
                            },
                            {
                                "inicioMes": "2026-08-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 196862,
                                "codigo": "1052267",
                                "razaoSocial": "CASIMIRO DEPOSITO DE MATERIAIS PARA",
                                "gap": 1755.6000000000001,
                                "grupoCentralizador": "IRMÃOS CASIMIRO",
                                "aceite": false,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-08-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 54262,
                                "codigo": "1145966",
                                "razaoSocial": "MS MADEIRAS E MATERIAIS PARA",
                                "gap": 0.275,
                                "grupoCentralizador": "MADEIREIRA PRIMAVERA",
                                "aceite": false,
                                "produto": "Colantes"
                            },
                            {
                                "inicioMes": "2026-08-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 54262,
                                "codigo": "1145966",
                                "razaoSocial": "MS MADEIRAS E MATERIAIS PARA",
                                "gap": 30.8,
                                "grupoCentralizador": "MADEIREIRA PRIMAVERA",
                                "aceite": false,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-08-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 54262,
                                "codigo": "1145966",
                                "razaoSocial": "MS MADEIRAS E MATERIAIS PARA",
                                "gap": 6.6000000000000005,
                                "grupoCentralizador": "MADEIREIRA PRIMAVERA",
                                "aceite": false,
                                "produto": "Impermeabilizantes"
                            },
                            {
                                "inicioMes": "2026-08-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 54262,
                                "codigo": "1145966",
                                "razaoSocial": "MS MADEIRAS E MATERIAIS PARA",
                                "gap": 92.39999999999999,
                                "grupoCentralizador": "MADEIREIRA PRIMAVERA",
                                "aceite": false,
                                "produto": "Rejuntes"
                            },
                            {
                                "inicioMes": "2026-07-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 53993,
                                "codigo": "1366359",
                                "razaoSocial": "DEPOSITO MATERIAL DE CONSTRUCAO 3S",
                                "gap": 432,
                                "grupoCentralizador": "MADEIREIRA PRIMAVERA",
                                "aceite": true,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-07-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 53993,
                                "codigo": "1366359",
                                "razaoSocial": "DEPOSITO MATERIAL DE CONSTRUCAO 3S",
                                "gap": 100,
                                "grupoCentralizador": "MADEIREIRA PRIMAVERA",
                                "aceite": true,
                                "produto": "Impermeabilizantes"
                            },
                            {
                                "inicioMes": "2026-05-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 53993,
                                "codigo": "1366359",
                                "razaoSocial": "DEPOSITO MATERIAL DE CONSTRUCAO 3S",
                                "gap": 80,
                                "grupoCentralizador": "MADEIREIRA PRIMAVERA",
                                "aceite": true,
                                "produto": "Impermeabilizantes"
                            },
                            {
                                "inicioMes": "2026-05-01T00:00:00",
                                "realizado": 295.68,
                                "clienteId": 53993,
                                "codigo": "1366359",
                                "razaoSocial": "DEPOSITO MATERIAL DE CONSTRUCAO 3S",
                                "gap": -26.879999999999995,
                                "grupoCentralizador": "MADEIREIRA PRIMAVERA",
                                "aceite": true,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-04-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 53993,
                                "codigo": "1366359",
                                "razaoSocial": "DEPOSITO MATERIAL DE CONSTRUCAO 3S",
                                "gap": 120,
                                "grupoCentralizador": "MADEIREIRA PRIMAVERA",
                                "aceite": true,
                                "produto": "Impermeabilizantes"
                            },
                            {
                                "inicioMes": "2026-04-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 53993,
                                "codigo": "1366359",
                                "razaoSocial": "DEPOSITO MATERIAL DE CONSTRUCAO 3S",
                                "gap": 120,
                                "grupoCentralizador": "MADEIREIRA PRIMAVERA",
                                "aceite": true,
                                "produto": "Colantes"
                            },
                            {
                                "inicioMes": "2026-04-01T00:00:00",
                                "realizado": 308,
                                "clienteId": 53993,
                                "codigo": "1366359",
                                "razaoSocial": "DEPOSITO MATERIAL DE CONSTRUCAO 3S",
                                "gap": -28,
                                "grupoCentralizador": "MADEIREIRA PRIMAVERA",
                                "aceite": true,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-08-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 53993,
                                "codigo": "1366359",
                                "razaoSocial": "DEPOSITO MATERIAL DE CONSTRUCAO 3S",
                                "gap": 523.6,
                                "grupoCentralizador": "MADEIREIRA PRIMAVERA",
                                "aceite": false,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-08-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 53993,
                                "codigo": "1366359",
                                "razaoSocial": "DEPOSITO MATERIAL DE CONSTRUCAO 3S",
                                "gap": 151.8,
                                "grupoCentralizador": "MADEIREIRA PRIMAVERA",
                                "aceite": false,
                                "produto": "Impermeabilizantes"
                            },
                            {
                                "inicioMes": "2026-08-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 53993,
                                "codigo": "1366359",
                                "razaoSocial": "DEPOSITO MATERIAL DE CONSTRUCAO 3S",
                                "gap": 107.80000000000001,
                                "grupoCentralizador": "MADEIREIRA PRIMAVERA",
                                "aceite": false,
                                "produto": "Rejuntes"
                            },
                            {
                                "inicioMes": "2026-08-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 53993,
                                "codigo": "1366359",
                                "razaoSocial": "DEPOSITO MATERIAL DE CONSTRUCAO 3S",
                                "gap": 63.24999999999999,
                                "grupoCentralizador": "MADEIREIRA PRIMAVERA",
                                "aceite": false,
                                "produto": "Colantes"
                            },
                            {
                                "inicioMes": "2026-05-01T00:00:00",
                                "realizado": 3804,
                                "clienteId": 196837,
                                "codigo": "1325063",
                                "razaoSocial": "JAPA EMPORIO DA CONSTRUCAO LTDA",
                                "gap": -204,
                                "grupoCentralizador": "JAPA EMPÓRIO",
                                "aceite": true,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-05-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 196837,
                                "codigo": "1325063",
                                "razaoSocial": "JAPA EMPORIO DA CONSTRUCAO LTDA",
                                "gap": 156,
                                "grupoCentralizador": "JAPA EMPÓRIO",
                                "aceite": true,
                                "produto": "Cales"
                            },
                            {
                                "inicioMes": "2026-04-01T00:00:00",
                                "realizado": 121,
                                "clienteId": 196837,
                                "codigo": "1325063",
                                "razaoSocial": "JAPA EMPORIO DA CONSTRUCAO LTDA",
                                "gap": -11,
                                "grupoCentralizador": "JAPA EMPÓRIO",
                                "aceite": true,
                                "produto": "Basicas"
                            },
                            {
                                "inicioMes": "2026-04-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 196837,
                                "codigo": "1325063",
                                "razaoSocial": "JAPA EMPORIO DA CONSTRUCAO LTDA",
                                "gap": 2440,
                                "grupoCentralizador": "JAPA EMPÓRIO",
                                "aceite": true,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-04-01T00:00:00",
                                "realizado": 297,
                                "clienteId": 196837,
                                "codigo": "1325063",
                                "razaoSocial": "JAPA EMPORIO DA CONSTRUCAO LTDA",
                                "gap": -27,
                                "grupoCentralizador": "JAPA EMPÓRIO",
                                "aceite": true,
                                "produto": "Colantes"
                            },
                            {
                                "inicioMes": "2026-04-01T00:00:00",
                                "realizado": 132,
                                "clienteId": 196837,
                                "codigo": "1325063",
                                "razaoSocial": "JAPA EMPORIO DA CONSTRUCAO LTDA",
                                "gap": -12,
                                "grupoCentralizador": "JAPA EMPÓRIO",
                                "aceite": true,
                                "produto": "Impermeabilizantes"
                            },
                            {
                                "inicioMes": "2026-04-01T00:00:00",
                                "realizado": 108,
                                "clienteId": 196837,
                                "codigo": "1325063",
                                "razaoSocial": "JAPA EMPORIO DA CONSTRUCAO LTDA",
                                "gap": 12,
                                "grupoCentralizador": "JAPA EMPÓRIO",
                                "aceite": true,
                                "produto": "Rejuntes"
                            }
                        ]
                    },
                    {
                        "id": -8,
                        "linhaTempoVolume": [
                            {
                                "inicioMes": "2026-07-01T00:00:00",
                                "realizado": 100,
                                "clienteId": 53200,
                                "codigo": "1712601",
                                "razaoSocial": "CONSTRU MIX MATERIAIS PARA",
                                "gap": -20,
                                "aceite": true,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-07-01T00:00:00",
                                "realizado": 0.02,
                                "clienteId": 53200,
                                "codigo": "1712601",
                                "razaoSocial": "CONSTRU MIX MATERIAIS PARA",
                                "gap": 0.58,
                                "aceite": true,
                                "produto": "Rejuntes"
                            },
                            {
                                "inicioMes": "2026-06-01T00:00:00",
                                "realizado": 3.2,
                                "clienteId": 53200,
                                "codigo": "1712601",
                                "razaoSocial": "CONSTRU MIX MATERIAIS PARA",
                                "gap": -0.20000000000000018,
                                "aceite": true,
                                "produto": "Colantes"
                            },
                            {
                                "inicioMes": "2026-06-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 53200,
                                "codigo": "1712601",
                                "razaoSocial": "CONSTRU MIX MATERIAIS PARA",
                                "gap": 0.2,
                                "aceite": true,
                                "produto": "Impermeabilizantes"
                            },
                            {
                                "inicioMes": "2026-06-01T00:00:00",
                                "realizado": 60,
                                "clienteId": 53200,
                                "codigo": "1712601",
                                "razaoSocial": "CONSTRU MIX MATERIAIS PARA",
                                "gap": 24,
                                "aceite": true,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-05-01T00:00:00",
                                "realizado": 2,
                                "clienteId": 53200,
                                "codigo": "1712601",
                                "razaoSocial": "CONSTRU MIX MATERIAIS PARA",
                                "gap": 2,
                                "aceite": true,
                                "produto": "Colantes"
                            },
                            {
                                "inicioMes": "2026-05-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 53200,
                                "codigo": "1712601",
                                "razaoSocial": "CONSTRU MIX MATERIAIS PARA",
                                "gap": 0.2,
                                "aceite": true,
                                "produto": "Impermeabilizantes"
                            },
                            {
                                "inicioMes": "2026-04-01T00:00:00",
                                "realizado": 2.8,
                                "clienteId": 53200,
                                "codigo": "1712601",
                                "razaoSocial": "CONSTRU MIX MATERIAIS PARA",
                                "gap": 1.2000000000000002,
                                "aceite": true,
                                "produto": "Colantes"
                            },
                            {
                                "inicioMes": "2026-04-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 53200,
                                "codigo": "1712601",
                                "razaoSocial": "CONSTRU MIX MATERIAIS PARA",
                                "gap": 0.2,
                                "aceite": true,
                                "produto": "Impermeabilizantes"
                            },
                            {
                                "inicioMes": "2026-04-01T00:00:00",
                                "realizado": 74,
                                "clienteId": 53200,
                                "codigo": "1712601",
                                "razaoSocial": "CONSTRU MIX MATERIAIS PARA",
                                "gap": -14,
                                "aceite": true,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-06-01T00:00:00",
                                "realizado": 4.8,
                                "clienteId": 53206,
                                "codigo": "1714523",
                                "razaoSocial": "QUEIROZ MATERIAIS PARA CONSTRUCAO",
                                "gap": 2.6000000000000005,
                                "aceite": true,
                                "produto": "Colantes"
                            },
                            {
                                "inicioMes": "2026-06-01T00:00:00",
                                "realizado": 43,
                                "clienteId": 53206,
                                "codigo": "1714523",
                                "razaoSocial": "QUEIROZ MATERIAIS PARA CONSTRUCAO",
                                "gap": 21,
                                "aceite": true,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-06-01T00:00:00",
                                "realizado": 0.14,
                                "clienteId": 53206,
                                "codigo": "1714523",
                                "razaoSocial": "QUEIROZ MATERIAIS PARA CONSTRUCAO",
                                "gap": 0.18,
                                "aceite": true,
                                "produto": "Rejuntes"
                            },
                            {
                                "inicioMes": "2026-06-01T00:00:00",
                                "realizado": 0.106,
                                "clienteId": 53206,
                                "codigo": "1714523",
                                "razaoSocial": "QUEIROZ MATERIAIS PARA CONSTRUCAO",
                                "gap": 0.29400000000000004,
                                "aceite": true,
                                "produto": "Impermeabilizantes"
                            },
                            {
                                "inicioMes": "2026-08-01T00:00:00",
                                "realizado": 10,
                                "clienteId": 53206,
                                "codigo": "1714523",
                                "razaoSocial": "QUEIROZ MATERIAIS PARA CONSTRUCAO",
                                "gap": 54,
                                "aceite": false,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-08-01T00:00:00",
                                "realizado": 0.037,
                                "clienteId": 53206,
                                "codigo": "1714523",
                                "razaoSocial": "QUEIROZ MATERIAIS PARA CONSTRUCAO",
                                "gap": 0.193,
                                "aceite": false,
                                "produto": "Impermeabilizantes"
                            },
                            {
                                "inicioMes": "2026-08-01T00:00:00",
                                "realizado": 2,
                                "clienteId": 53206,
                                "codigo": "1714523",
                                "razaoSocial": "QUEIROZ MATERIAIS PARA CONSTRUCAO",
                                "gap": 9.5,
                                "aceite": false,
                                "produto": "Colantes"
                            },
                            {
                                "inicioMes": "2026-08-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 53375,
                                "codigo": "1630142",
                                "razaoSocial": "GUIOMAR RIOS DE MATOS",
                                "gap": 22,
                                "aceite": false,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-04-01T00:00:00",
                                "realizado": 20,
                                "clienteId": 53375,
                                "codigo": "1630142",
                                "razaoSocial": "GUIOMAR RIOS DE MATOS",
                                "gap": -4,
                                "aceite": true,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-04-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 53375,
                                "codigo": "1630142",
                                "razaoSocial": "GUIOMAR RIOS DE MATOS",
                                "gap": 0.2,
                                "aceite": true,
                                "produto": "Rejuntes"
                            },
                            {
                                "inicioMes": "2026-04-01T00:00:00",
                                "realizado": 11,
                                "clienteId": 53406,
                                "codigo": "1650357",
                                "razaoSocial": "ANDERSON RIBEIRO NASCIMENTO",
                                "gap": -1,
                                "aceite": true,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-08-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 53560,
                                "codigo": "1547404",
                                "razaoSocial": "RODRIGO RODRIGUES CASA E FERRAGEM",
                                "gap": 4.6,
                                "aceite": false,
                                "produto": "Colantes"
                            },
                            {
                                "inicioMes": "2026-08-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 53560,
                                "codigo": "1547404",
                                "razaoSocial": "RODRIGO RODRIGUES CASA E FERRAGEM",
                                "gap": 28,
                                "aceite": false,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-05-01T00:00:00",
                                "realizado": 38,
                                "clienteId": 53855,
                                "codigo": "1424685",
                                "razaoSocial": "ESS MATERIAIS P  CONSTRUCAO LTDA",
                                "gap": 4,
                                "aceite": true,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-05-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 53855,
                                "codigo": "1424685",
                                "razaoSocial": "ESS MATERIAIS P  CONSTRUCAO LTDA",
                                "gap": 0.2,
                                "aceite": true,
                                "produto": "Impermeabilizantes"
                            },
                            {
                                "inicioMes": "2026-05-01T00:00:00",
                                "realizado": 5,
                                "clienteId": 53855,
                                "codigo": "1424685",
                                "razaoSocial": "ESS MATERIAIS P  CONSTRUCAO LTDA",
                                "gap": -1,
                                "aceite": true,
                                "produto": "Colantes"
                            },
                            {
                                "inicioMes": "2026-05-01T00:00:00",
                                "realizado": 0.02,
                                "clienteId": 53855,
                                "codigo": "1424685",
                                "razaoSocial": "ESS MATERIAIS P  CONSTRUCAO LTDA",
                                "gap": 0.18000000000000002,
                                "aceite": true,
                                "produto": "Rejuntes"
                            },
                            {
                                "inicioMes": "2026-07-01T00:00:00",
                                "realizado": 0.04,
                                "clienteId": 53855,
                                "codigo": "1424685",
                                "razaoSocial": "ESS MATERIAIS P  CONSTRUCAO LTDA",
                                "gap": 0.5599999999999999,
                                "aceite": true,
                                "produto": "Rejuntes"
                            },
                            {
                                "inicioMes": "2026-07-01T00:00:00",
                                "realizado": 4.8,
                                "clienteId": 53855,
                                "codigo": "1424685",
                                "razaoSocial": "ESS MATERIAIS P  CONSTRUCAO LTDA",
                                "gap": 3.2,
                                "aceite": true,
                                "produto": "Colantes"
                            },
                            {
                                "inicioMes": "2026-07-01T00:00:00",
                                "realizado": 38,
                                "clienteId": 53855,
                                "codigo": "1424685",
                                "razaoSocial": "ESS MATERIAIS P  CONSTRUCAO LTDA",
                                "gap": -2,
                                "aceite": true,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-07-01T00:00:00",
                                "realizado": 0.126,
                                "clienteId": 53855,
                                "codigo": "1424685",
                                "razaoSocial": "ESS MATERIAIS P  CONSTRUCAO LTDA",
                                "gap": 0.07400000000000001,
                                "aceite": true,
                                "produto": "Impermeabilizantes"
                            },
                            {
                                "inicioMes": "2026-04-01T00:00:00",
                                "realizado": 0.04,
                                "clienteId": 53855,
                                "codigo": "1424685",
                                "razaoSocial": "ESS MATERIAIS P  CONSTRUCAO LTDA",
                                "gap": 0.16,
                                "aceite": true,
                                "produto": "Rejuntes"
                            },
                            {
                                "inicioMes": "2026-04-01T00:00:00",
                                "realizado": 5.2,
                                "clienteId": 53855,
                                "codigo": "1424685",
                                "razaoSocial": "ESS MATERIAIS P  CONSTRUCAO LTDA",
                                "gap": -0.7999999999999998,
                                "aceite": true,
                                "produto": "Colantes"
                            },
                            {
                                "inicioMes": "2026-04-01T00:00:00",
                                "realizado": 0.108,
                                "clienteId": 53855,
                                "codigo": "1424685",
                                "razaoSocial": "ESS MATERIAIS P  CONSTRUCAO LTDA",
                                "gap": 0.09200000000000001,
                                "aceite": true,
                                "produto": "Impermeabilizantes"
                            },
                            {
                                "inicioMes": "2026-04-01T00:00:00",
                                "realizado": 36,
                                "clienteId": 53855,
                                "codigo": "1424685",
                                "razaoSocial": "ESS MATERIAIS P  CONSTRUCAO LTDA",
                                "gap": -14,
                                "aceite": true,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-08-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 53855,
                                "codigo": "1424685",
                                "razaoSocial": "ESS MATERIAIS P  CONSTRUCAO LTDA",
                                "gap": 6.9,
                                "aceite": false,
                                "produto": "Colantes"
                            },
                            {
                                "inicioMes": "2026-08-01T00:00:00",
                                "realizado": 14,
                                "clienteId": 53855,
                                "codigo": "1424685",
                                "razaoSocial": "ESS MATERIAIS P  CONSTRUCAO LTDA",
                                "gap": 36,
                                "aceite": false,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-08-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 53855,
                                "codigo": "1424685",
                                "razaoSocial": "ESS MATERIAIS P  CONSTRUCAO LTDA",
                                "gap": 0.23,
                                "aceite": false,
                                "produto": "Impermeabilizantes"
                            },
                            {
                                "inicioMes": "2026-07-01T00:00:00",
                                "realizado": 0.06,
                                "clienteId": 53959,
                                "codigo": "1367732",
                                "razaoSocial": "NOVA CARMELA III COMERCIO DE",
                                "gap": 0.54,
                                "aceite": true,
                                "produto": "Rejuntes"
                            },
                            {
                                "inicioMes": "2026-07-01T00:00:00",
                                "realizado": 0.18,
                                "clienteId": 53959,
                                "codigo": "1367732",
                                "razaoSocial": "NOVA CARMELA III COMERCIO DE",
                                "gap": 0.020000000000000018,
                                "aceite": true,
                                "produto": "Impermeabilizantes"
                            },
                            {
                                "inicioMes": "2026-07-01T00:00:00",
                                "realizado": 44,
                                "clienteId": 53959,
                                "codigo": "1367732",
                                "razaoSocial": "NOVA CARMELA III COMERCIO DE",
                                "gap": -28,
                                "aceite": true,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-07-01T00:00:00",
                                "realizado": 5.6,
                                "clienteId": 53959,
                                "codigo": "1367732",
                                "razaoSocial": "NOVA CARMELA III COMERCIO DE",
                                "gap": -1.5999999999999996,
                                "aceite": true,
                                "produto": "Colantes"
                            },
                            {
                                "inicioMes": "2026-08-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 53959,
                                "codigo": "1367732",
                                "razaoSocial": "NOVA CARMELA III COMERCIO DE",
                                "gap": 34,
                                "aceite": false,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-08-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 53959,
                                "codigo": "1367732",
                                "razaoSocial": "NOVA CARMELA III COMERCIO DE",
                                "gap": 5.75,
                                "aceite": false,
                                "produto": "Colantes"
                            },
                            {
                                "inicioMes": "2026-08-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 53959,
                                "codigo": "1367732",
                                "razaoSocial": "NOVA CARMELA III COMERCIO DE",
                                "gap": 0.23,
                                "aceite": false,
                                "produto": "Impermeabilizantes"
                            },
                            {
                                "inicioMes": "2026-08-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 53959,
                                "codigo": "1367732",
                                "razaoSocial": "NOVA CARMELA III COMERCIO DE",
                                "gap": 0.23,
                                "aceite": false,
                                "produto": "Rejuntes"
                            },
                            {
                                "inicioMes": "2026-06-01T00:00:00",
                                "realizado": 16,
                                "clienteId": 54090,
                                "codigo": "1320574",
                                "razaoSocial": "COMERCIO DE FERRAGENS CORREIA LTDA",
                                "gap": 8,
                                "aceite": true,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-06-01T00:00:00",
                                "realizado": 1.6,
                                "clienteId": 54090,
                                "codigo": "1320574",
                                "razaoSocial": "COMERCIO DE FERRAGENS CORREIA LTDA",
                                "gap": 0.3999999999999999,
                                "aceite": true,
                                "produto": "Colantes"
                            },
                            {
                                "inicioMes": "2026-06-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 54090,
                                "codigo": "1320574",
                                "razaoSocial": "COMERCIO DE FERRAGENS CORREIA LTDA",
                                "gap": 0.3,
                                "aceite": true,
                                "produto": "Rejuntes"
                            },
                            {
                                "inicioMes": "2026-04-01T00:00:00",
                                "realizado": 14,
                                "clienteId": 54090,
                                "codigo": "1320574",
                                "razaoSocial": "COMERCIO DE FERRAGENS CORREIA LTDA",
                                "gap": 2.5,
                                "aceite": true,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-04-01T00:00:00",
                                "realizado": 0.4,
                                "clienteId": 54090,
                                "codigo": "1320574",
                                "razaoSocial": "COMERCIO DE FERRAGENS CORREIA LTDA",
                                "gap": 3.6,
                                "aceite": true,
                                "produto": "Colantes"
                            },
                            {
                                "inicioMes": "2026-04-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 54090,
                                "codigo": "1320574",
                                "razaoSocial": "COMERCIO DE FERRAGENS CORREIA LTDA",
                                "gap": 0.2,
                                "aceite": true,
                                "produto": "Impermeabilizantes"
                            },
                            {
                                "inicioMes": "2026-07-01T00:00:00",
                                "realizado": 0.4,
                                "clienteId": 54090,
                                "codigo": "1320574",
                                "razaoSocial": "COMERCIO DE FERRAGENS CORREIA LTDA",
                                "gap": 3.6,
                                "aceite": true,
                                "produto": "Colantes"
                            },
                            {
                                "inicioMes": "2026-07-01T00:00:00",
                                "realizado": 0.04,
                                "clienteId": 54090,
                                "codigo": "1320574",
                                "razaoSocial": "COMERCIO DE FERRAGENS CORREIA LTDA",
                                "gap": 0.5599999999999999,
                                "aceite": true,
                                "produto": "Rejuntes"
                            },
                            {
                                "inicioMes": "2026-07-01T00:00:00",
                                "realizado": 18,
                                "clienteId": 54090,
                                "codigo": "1320574",
                                "razaoSocial": "COMERCIO DE FERRAGENS CORREIA LTDA",
                                "gap": 10,
                                "aceite": true,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-07-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 54090,
                                "codigo": "1320574",
                                "razaoSocial": "COMERCIO DE FERRAGENS CORREIA LTDA",
                                "gap": 0.2,
                                "aceite": true,
                                "produto": "Impermeabilizantes"
                            },
                            {
                                "inicioMes": "2026-04-01T00:00:00",
                                "realizado": 26,
                                "clienteId": 54200,
                                "codigo": "1173049",
                                "razaoSocial": "GUARUTELHA MATERIAIS PARA",
                                "gap": 14,
                                "aceite": true,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-05-01T00:00:00",
                                "realizado": 115.5,
                                "clienteId": 173312,
                                "codigo": "1597012",
                                "razaoSocial": "LAILA VIANA DE SOUZA",
                                "gap": 94.5,
                                "aceite": true,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-05-01T00:00:00",
                                "realizado": 0.108,
                                "clienteId": 173312,
                                "codigo": "1597012",
                                "razaoSocial": "LAILA VIANA DE SOUZA",
                                "gap": 0.132,
                                "aceite": true,
                                "produto": "Impermeabilizantes"
                            },
                            {
                                "inicioMes": "2026-08-01T00:00:00",
                                "realizado": 2,
                                "clienteId": 173312,
                                "codigo": "1597012",
                                "razaoSocial": "LAILA VIANA DE SOUZA",
                                "gap": 10,
                                "aceite": true,
                                "produto": "Colantes"
                            },
                            {
                                "inicioMes": "2026-08-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 173312,
                                "codigo": "1597012",
                                "razaoSocial": "LAILA VIANA DE SOUZA",
                                "gap": 0.2,
                                "aceite": true,
                                "produto": "Impermeabilizantes"
                            },
                            {
                                "inicioMes": "2026-08-01T00:00:00",
                                "realizado": 12,
                                "clienteId": 173312,
                                "codigo": "1597012",
                                "razaoSocial": "LAILA VIANA DE SOUZA",
                                "gap": 114,
                                "aceite": true,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-07-01T00:00:00",
                                "realizado": 73,
                                "clienteId": 173312,
                                "codigo": "1597012",
                                "razaoSocial": "LAILA VIANA DE SOUZA",
                                "gap": 107,
                                "aceite": true,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-07-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 173312,
                                "codigo": "1597012",
                                "razaoSocial": "LAILA VIANA DE SOUZA",
                                "gap": 0.6,
                                "aceite": true,
                                "produto": "Rejuntes"
                            },
                            {
                                "inicioMes": "2026-07-01T00:00:00",
                                "realizado": 7.6,
                                "clienteId": 173312,
                                "codigo": "1597012",
                                "razaoSocial": "LAILA VIANA DE SOUZA",
                                "gap": 6.4,
                                "aceite": true,
                                "produto": "Colantes"
                            },
                            {
                                "inicioMes": "2026-07-01T00:00:00",
                                "realizado": 0.324,
                                "clienteId": 173312,
                                "codigo": "1597012",
                                "razaoSocial": "LAILA VIANA DE SOUZA",
                                "gap": -0.02400000000000002,
                                "aceite": true,
                                "produto": "Impermeabilizantes"
                            },
                            {
                                "inicioMes": "2026-04-01T00:00:00",
                                "realizado": 226.75,
                                "clienteId": 173312,
                                "codigo": "1597012",
                                "razaoSocial": "LAILA VIANA DE SOUZA",
                                "gap": -75.75,
                                "aceite": true,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-04-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 173312,
                                "codigo": "1597012",
                                "razaoSocial": "LAILA VIANA DE SOUZA",
                                "gap": 4,
                                "aceite": true,
                                "produto": "Cales"
                            },
                            {
                                "inicioMes": "2026-04-01T00:00:00",
                                "realizado": 5.2,
                                "clienteId": 173312,
                                "codigo": "1597012",
                                "razaoSocial": "LAILA VIANA DE SOUZA",
                                "gap": 4.8,
                                "aceite": true,
                                "produto": "Colantes"
                            },
                            {
                                "inicioMes": "2026-04-01T00:00:00",
                                "realizado": 0.324,
                                "clienteId": 173312,
                                "codigo": "1597012",
                                "razaoSocial": "LAILA VIANA DE SOUZA",
                                "gap": -0.124,
                                "aceite": true,
                                "produto": "Impermeabilizantes"
                            },
                            {
                                "inicioMes": "2026-04-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 173312,
                                "codigo": "1597012",
                                "razaoSocial": "LAILA VIANA DE SOUZA",
                                "gap": 0.2,
                                "aceite": true,
                                "produto": "Rejuntes"
                            },
                            {
                                "inicioMes": "2026-05-01T00:00:00",
                                "realizado": 0.126,
                                "clienteId": 173314,
                                "codigo": "1153600",
                                "razaoSocial": "DEPOSITO CABUCU LTDA",
                                "gap": 0.07400000000000001,
                                "aceite": true,
                                "produto": "Impermeabilizantes"
                            },
                            {
                                "inicioMes": "2026-05-01T00:00:00",
                                "realizado": 144,
                                "clienteId": 173314,
                                "codigo": "1153600",
                                "razaoSocial": "DEPOSITO CABUCU LTDA",
                                "gap": -30,
                                "aceite": true,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-05-01T00:00:00",
                                "realizado": 0.14,
                                "clienteId": 173314,
                                "codigo": "1153600",
                                "razaoSocial": "DEPOSITO CABUCU LTDA",
                                "gap": 0.09,
                                "aceite": true,
                                "produto": "Rejuntes"
                            },
                            {
                                "inicioMes": "2026-05-01T00:00:00",
                                "realizado": 3.2,
                                "clienteId": 173314,
                                "codigo": "1153600",
                                "razaoSocial": "DEPOSITO CABUCU LTDA",
                                "gap": 7.2,
                                "aceite": true,
                                "produto": "Colantes"
                            },
                            {
                                "inicioMes": "2026-04-01T00:00:00",
                                "realizado": 154,
                                "clienteId": 173314,
                                "codigo": "1153600",
                                "razaoSocial": "DEPOSITO CABUCU LTDA",
                                "gap": -74,
                                "aceite": true,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-04-01T00:00:00",
                                "realizado": 0.09,
                                "clienteId": 173314,
                                "codigo": "1153600",
                                "razaoSocial": "DEPOSITO CABUCU LTDA",
                                "gap": 0.11000000000000001,
                                "aceite": true,
                                "produto": "Impermeabilizantes"
                            },
                            {
                                "inicioMes": "2026-04-01T00:00:00",
                                "realizado": 2,
                                "clienteId": 173314,
                                "codigo": "1153600",
                                "razaoSocial": "DEPOSITO CABUCU LTDA",
                                "gap": 2,
                                "aceite": true,
                                "produto": "Colantes"
                            },
                            {
                                "inicioMes": "2026-07-01T00:00:00",
                                "realizado": 0.4,
                                "clienteId": 173314,
                                "codigo": "1153600",
                                "razaoSocial": "DEPOSITO CABUCU LTDA",
                                "gap": 13.6,
                                "aceite": true,
                                "produto": "Colantes"
                            },
                            {
                                "inicioMes": "2026-07-01T00:00:00",
                                "realizado": 0.12,
                                "clienteId": 173314,
                                "codigo": "1153600",
                                "razaoSocial": "DEPOSITO CABUCU LTDA",
                                "gap": 0.48,
                                "aceite": true,
                                "produto": "Rejuntes"
                            },
                            {
                                "inicioMes": "2026-07-01T00:00:00",
                                "realizado": 0.324,
                                "clienteId": 173314,
                                "codigo": "1153600",
                                "razaoSocial": "DEPOSITO CABUCU LTDA",
                                "gap": -0.124,
                                "aceite": true,
                                "produto": "Impermeabilizantes"
                            },
                            {
                                "inicioMes": "2026-07-01T00:00:00",
                                "realizado": 174,
                                "clienteId": 173314,
                                "codigo": "1153600",
                                "razaoSocial": "DEPOSITO CABUCU LTDA",
                                "gap": -22,
                                "aceite": true,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-08-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 173314,
                                "codigo": "1153600",
                                "razaoSocial": "DEPOSITO CABUCU LTDA",
                                "gap": 0.23,
                                "aceite": false,
                                "produto": "Impermeabilizantes"
                            },
                            {
                                "inicioMes": "2026-08-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 173314,
                                "codigo": "1153600",
                                "razaoSocial": "DEPOSITO CABUCU LTDA",
                                "gap": 0.23,
                                "aceite": false,
                                "produto": "Rejuntes"
                            },
                            {
                                "inicioMes": "2026-08-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 173314,
                                "codigo": "1153600",
                                "razaoSocial": "DEPOSITO CABUCU LTDA",
                                "gap": 9.2,
                                "aceite": false,
                                "produto": "Colantes"
                            },
                            {
                                "inicioMes": "2026-08-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 173314,
                                "codigo": "1153600",
                                "razaoSocial": "DEPOSITO CABUCU LTDA",
                                "gap": 178,
                                "aceite": false,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-06-01T00:00:00",
                                "realizado": 12.8,
                                "clienteId": 54397,
                                "codigo": "1059853",
                                "razaoSocial": "L  E F  MATERIAIS PARA CONSTRUCAO",
                                "gap": 3.1999999999999993,
                                "aceite": true,
                                "produto": "Colantes"
                            },
                            {
                                "inicioMes": "2026-06-01T00:00:00",
                                "realizado": 0.8,
                                "clienteId": 54397,
                                "codigo": "1059853",
                                "razaoSocial": "L  E F  MATERIAIS PARA CONSTRUCAO",
                                "gap": 7.2,
                                "aceite": true,
                                "produto": "Basicas"
                            },
                            {
                                "inicioMes": "2026-06-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 54397,
                                "codigo": "1059853",
                                "razaoSocial": "L  E F  MATERIAIS PARA CONSTRUCAO",
                                "gap": 0.5,
                                "aceite": true,
                                "produto": "Rejuntes"
                            },
                            {
                                "inicioMes": "2026-06-01T00:00:00",
                                "realizado": 101.5,
                                "clienteId": 54397,
                                "codigo": "1059853",
                                "razaoSocial": "L  E F  MATERIAIS PARA CONSTRUCAO",
                                "gap": 20.5,
                                "aceite": true,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-05-01T00:00:00",
                                "realizado": 124.5,
                                "clienteId": 54397,
                                "codigo": "1059853",
                                "razaoSocial": "L  E F  MATERIAIS PARA CONSTRUCAO",
                                "gap": 7.5,
                                "aceite": true,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-05-01T00:00:00",
                                "realizado": 0.02,
                                "clienteId": 54397,
                                "codigo": "1059853",
                                "razaoSocial": "L  E F  MATERIAIS PARA CONSTRUCAO",
                                "gap": 0.18000000000000002,
                                "aceite": true,
                                "produto": "Rejuntes"
                            },
                            {
                                "inicioMes": "2026-05-01T00:00:00",
                                "realizado": 15.2,
                                "clienteId": 54397,
                                "codigo": "1059853",
                                "razaoSocial": "L  E F  MATERIAIS PARA CONSTRUCAO",
                                "gap": 0.9000000000000021,
                                "aceite": true,
                                "produto": "Colantes"
                            },
                            {
                                "inicioMes": "2026-05-01T00:00:00",
                                "realizado": 0.374,
                                "clienteId": 54397,
                                "codigo": "1059853",
                                "razaoSocial": "L  E F  MATERIAIS PARA CONSTRUCAO",
                                "gap": 0.20099999999999996,
                                "aceite": true,
                                "produto": "Impermeabilizantes"
                            },
                            {
                                "inicioMes": "2026-08-01T00:00:00",
                                "realizado": 12.5,
                                "clienteId": 54397,
                                "codigo": "1059853",
                                "razaoSocial": "L  E F  MATERIAIS PARA CONSTRUCAO",
                                "gap": 113.5,
                                "aceite": true,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-08-01T00:00:00",
                                "realizado": 2,
                                "clienteId": 54397,
                                "codigo": "1059853",
                                "razaoSocial": "L  E F  MATERIAIS PARA CONSTRUCAO",
                                "gap": 12,
                                "aceite": true,
                                "produto": "Colantes"
                            },
                            {
                                "inicioMes": "2026-08-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 54397,
                                "codigo": "1059853",
                                "razaoSocial": "L  E F  MATERIAIS PARA CONSTRUCAO",
                                "gap": 0.4,
                                "aceite": true,
                                "produto": "Impermeabilizantes"
                            },
                            {
                                "inicioMes": "2026-05-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 54548,
                                "codigo": "1055957",
                                "razaoSocial": "ITO BEL MATERIAIS PARA CONSTRUCAO",
                                "gap": 0.2,
                                "aceite": true,
                                "produto": "Impermeabilizantes"
                            },
                            {
                                "inicioMes": "2026-05-01T00:00:00",
                                "realizado": 22,
                                "clienteId": 54548,
                                "codigo": "1055957",
                                "razaoSocial": "ITO BEL MATERIAIS PARA CONSTRUCAO",
                                "gap": 18,
                                "aceite": true,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-08-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 54548,
                                "codigo": "1055957",
                                "razaoSocial": "ITO BEL MATERIAIS PARA CONSTRUCAO",
                                "gap": 4.6,
                                "aceite": false,
                                "produto": "Colantes"
                            },
                            {
                                "inicioMes": "2026-08-01T00:00:00",
                                "realizado": 14,
                                "clienteId": 54548,
                                "codigo": "1055957",
                                "razaoSocial": "ITO BEL MATERIAIS PARA CONSTRUCAO",
                                "gap": 30,
                                "aceite": false,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-08-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 54548,
                                "codigo": "1055957",
                                "razaoSocial": "ITO BEL MATERIAIS PARA CONSTRUCAO",
                                "gap": 0.23,
                                "aceite": false,
                                "produto": "Impermeabilizantes"
                            },
                            {
                                "inicioMes": "2026-04-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 54548,
                                "codigo": "1055957",
                                "razaoSocial": "ITO BEL MATERIAIS PARA CONSTRUCAO",
                                "gap": 0.2,
                                "aceite": true,
                                "produto": "Impermeabilizantes"
                            },
                            {
                                "inicioMes": "2026-04-01T00:00:00",
                                "realizado": 28,
                                "clienteId": 54548,
                                "codigo": "1055957",
                                "razaoSocial": "ITO BEL MATERIAIS PARA CONSTRUCAO",
                                "gap": -3,
                                "aceite": true,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-04-01T00:00:00",
                                "realizado": 2.8,
                                "clienteId": 54548,
                                "codigo": "1055957",
                                "razaoSocial": "ITO BEL MATERIAIS PARA CONSTRUCAO",
                                "gap": 1.2000000000000002,
                                "aceite": true,
                                "produto": "Colantes"
                            },
                            {
                                "inicioMes": "2026-07-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 54548,
                                "codigo": "1055957",
                                "razaoSocial": "ITO BEL MATERIAIS PARA CONSTRUCAO",
                                "gap": 0.2,
                                "aceite": true,
                                "produto": "Impermeabilizantes"
                            },
                            {
                                "inicioMes": "2026-07-01T00:00:00",
                                "realizado": 2.4,
                                "clienteId": 54548,
                                "codigo": "1055957",
                                "razaoSocial": "ITO BEL MATERIAIS PARA CONSTRUCAO",
                                "gap": 1.6,
                                "aceite": true,
                                "produto": "Colantes"
                            },
                            {
                                "inicioMes": "2026-07-01T00:00:00",
                                "realizado": 36,
                                "clienteId": 54548,
                                "codigo": "1055957",
                                "razaoSocial": "ITO BEL MATERIAIS PARA CONSTRUCAO",
                                "gap": -2,
                                "aceite": true,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-04-01T00:00:00",
                                "realizado": 30,
                                "clienteId": 57133,
                                "codigo": "1054953",
                                "razaoSocial": "DEPOSITO DE MATERIAIS PARA",
                                "gap": 2,
                                "aceite": true,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-04-01T00:00:00",
                                "realizado": 10.4,
                                "clienteId": 196783,
                                "codigo": "1549482",
                                "razaoSocial": "S.C. CIMENTO E TRANSPORTE LTDA",
                                "gap": -4.9,
                                "aceite": true,
                                "produto": "Colantes"
                            },
                            {
                                "inicioMes": "2026-04-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 196783,
                                "codigo": "1549482",
                                "razaoSocial": "S.C. CIMENTO E TRANSPORTE LTDA",
                                "gap": 0.2,
                                "aceite": true,
                                "produto": "Impermeabilizantes"
                            },
                            {
                                "inicioMes": "2026-04-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 196783,
                                "codigo": "1549482",
                                "razaoSocial": "S.C. CIMENTO E TRANSPORTE LTDA",
                                "gap": 10,
                                "aceite": true,
                                "produto": "Basicas"
                            },
                            {
                                "inicioMes": "2026-04-01T00:00:00",
                                "realizado": 0.1,
                                "clienteId": 196783,
                                "codigo": "1549482",
                                "razaoSocial": "S.C. CIMENTO E TRANSPORTE LTDA",
                                "gap": 0.4,
                                "aceite": true,
                                "produto": "Rejuntes"
                            },
                            {
                                "inicioMes": "2026-04-01T00:00:00",
                                "realizado": 519.5,
                                "clienteId": 196783,
                                "codigo": "1549482",
                                "razaoSocial": "S.C. CIMENTO E TRANSPORTE LTDA",
                                "gap": -69.5,
                                "aceite": true,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-05-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 196783,
                                "codigo": "1549482",
                                "razaoSocial": "S.C. CIMENTO E TRANSPORTE LTDA",
                                "gap": 0.23,
                                "aceite": true,
                                "produto": "Impermeabilizantes"
                            },
                            {
                                "inicioMes": "2026-06-01T00:00:00",
                                "realizado": 354,
                                "clienteId": 196783,
                                "codigo": "1549482",
                                "razaoSocial": "S.C. CIMENTO E TRANSPORTE LTDA",
                                "gap": 244,
                                "aceite": true,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-06-01T00:00:00",
                                "realizado": 0.14,
                                "clienteId": 196783,
                                "codigo": "1549482",
                                "razaoSocial": "S.C. CIMENTO E TRANSPORTE LTDA",
                                "gap": 0.18,
                                "aceite": true,
                                "produto": "Rejuntes"
                            },
                            {
                                "inicioMes": "2026-06-01T00:00:00",
                                "realizado": 8.8,
                                "clienteId": 196783,
                                "codigo": "1549482",
                                "razaoSocial": "S.C. CIMENTO E TRANSPORTE LTDA",
                                "gap": 23.400000000000002,
                                "aceite": true,
                                "produto": "Colantes"
                            },
                            {
                                "inicioMes": "2026-07-01T00:00:00",
                                "realizado": 0.24,
                                "clienteId": 196783,
                                "codigo": "1549482",
                                "razaoSocial": "S.C. CIMENTO E TRANSPORTE LTDA",
                                "gap": 0.36,
                                "aceite": true,
                                "produto": "Rejuntes"
                            },
                            {
                                "inicioMes": "2026-07-01T00:00:00",
                                "realizado": 472,
                                "clienteId": 196783,
                                "codigo": "1549482",
                                "razaoSocial": "S.C. CIMENTO E TRANSPORTE LTDA",
                                "gap": 104,
                                "aceite": true,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-07-01T00:00:00",
                                "realizado": 11.2,
                                "clienteId": 196783,
                                "codigo": "1549482",
                                "razaoSocial": "S.C. CIMENTO E TRANSPORTE LTDA",
                                "gap": 8.8,
                                "aceite": true,
                                "produto": "Colantes"
                            },
                            {
                                "inicioMes": "2026-07-01T00:00:00",
                                "realizado": 4,
                                "clienteId": 196783,
                                "codigo": "1549482",
                                "razaoSocial": "S.C. CIMENTO E TRANSPORTE LTDA",
                                "gap": 5.199999999999999,
                                "aceite": false,
                                "produto": "Basicas"
                            },
                            {
                                "inicioMes": "2026-08-01T00:00:00",
                                "realizado": 1.44,
                                "clienteId": 196783,
                                "codigo": "1549482",
                                "razaoSocial": "S.C. CIMENTO E TRANSPORTE LTDA",
                                "gap": 12.56,
                                "aceite": true,
                                "produto": "Colantes"
                            },
                            {
                                "inicioMes": "2026-08-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 196831,
                                "codigo": "1499807",
                                "razaoSocial": "JOSE CARLOS CARDOSO",
                                "gap": 6.5,
                                "aceite": true,
                                "produto": "Colantes"
                            },
                            {
                                "inicioMes": "2026-08-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 196831,
                                "codigo": "1499807",
                                "razaoSocial": "JOSE CARLOS CARDOSO",
                                "gap": 0.26,
                                "aceite": true,
                                "produto": "Impermeabilizantes"
                            },
                            {
                                "inicioMes": "2026-08-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 196831,
                                "codigo": "1499807",
                                "razaoSocial": "JOSE CARLOS CARDOSO",
                                "gap": 50,
                                "aceite": true,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-08-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 196831,
                                "codigo": "1499807",
                                "razaoSocial": "JOSE CARLOS CARDOSO",
                                "gap": 0.72,
                                "aceite": true,
                                "produto": "Rejuntes"
                            },
                            {
                                "inicioMes": "2026-07-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 196831,
                                "codigo": "1499807",
                                "razaoSocial": "JOSE CARLOS CARDOSO",
                                "gap": 0.2,
                                "aceite": true,
                                "produto": "Impermeabilizantes"
                            },
                            {
                                "inicioMes": "2026-07-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 196831,
                                "codigo": "1499807",
                                "razaoSocial": "JOSE CARLOS CARDOSO",
                                "gap": 14,
                                "aceite": true,
                                "produto": "Colantes"
                            },
                            {
                                "inicioMes": "2026-07-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 196831,
                                "codigo": "1499807",
                                "razaoSocial": "JOSE CARLOS CARDOSO",
                                "gap": 0.38,
                                "aceite": true,
                                "produto": "Rejuntes"
                            },
                            {
                                "inicioMes": "2026-07-01T00:00:00",
                                "realizado": 14.5,
                                "clienteId": 196831,
                                "codigo": "1499807",
                                "razaoSocial": "JOSE CARLOS CARDOSO",
                                "gap": 45.5,
                                "aceite": true,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-07-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 196832,
                                "codigo": "1475411",
                                "razaoSocial": "BARUK DISTRIBUIDORA DE CIMENTO LTDA",
                                "gap": 0.3,
                                "aceite": true,
                                "produto": "Rejuntes"
                            },
                            {
                                "inicioMes": "2026-07-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 196832,
                                "codigo": "1475411",
                                "razaoSocial": "BARUK DISTRIBUIDORA DE CIMENTO LTDA",
                                "gap": 168,
                                "aceite": true,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-04-01T00:00:00",
                                "realizado": 188,
                                "clienteId": 196832,
                                "codigo": "1475411",
                                "razaoSocial": "BARUK DISTRIBUIDORA DE CIMENTO LTDA",
                                "gap": -101,
                                "aceite": true,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-04-01T00:00:00",
                                "realizado": 0.36,
                                "clienteId": 196832,
                                "codigo": "1475411",
                                "razaoSocial": "BARUK DISTRIBUIDORA DE CIMENTO LTDA",
                                "gap": -0.15999999999999998,
                                "aceite": true,
                                "produto": "Rejuntes"
                            },
                            {
                                "inicioMes": "2026-06-01T00:00:00",
                                "realizado": 0.12,
                                "clienteId": 196832,
                                "codigo": "1475411",
                                "razaoSocial": "BARUK DISTRIBUIDORA DE CIMENTO LTDA",
                                "gap": 0.248,
                                "aceite": true,
                                "produto": "Rejuntes"
                            },
                            {
                                "inicioMes": "2026-06-01T00:00:00",
                                "realizado": 84,
                                "clienteId": 196832,
                                "codigo": "1475411",
                                "razaoSocial": "BARUK DISTRIBUIDORA DE CIMENTO LTDA",
                                "gap": 78,
                                "aceite": true,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-08-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 196852,
                                "codigo": "1303008",
                                "razaoSocial": "POCAO MATERIAL DE CONSTRUCAO LTDA",
                                "gap": 5.75,
                                "aceite": false,
                                "produto": "Colantes"
                            },
                            {
                                "inicioMes": "2026-08-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 196852,
                                "codigo": "1303008",
                                "razaoSocial": "POCAO MATERIAL DE CONSTRUCAO LTDA",
                                "gap": 18,
                                "aceite": false,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-05-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 196863,
                                "codigo": "1185509",
                                "razaoSocial": "CASA COMERCIO MATERIAIS CONSTRUCAO",
                                "gap": 0.23,
                                "aceite": true,
                                "produto": "Impermeabilizantes"
                            },
                            {
                                "inicioMes": "2026-05-01T00:00:00",
                                "realizado": 3.08,
                                "clienteId": 196863,
                                "codigo": "1185509",
                                "razaoSocial": "CASA COMERCIO MATERIAIS CONSTRUCAO",
                                "gap": 3.8200000000000003,
                                "aceite": true,
                                "produto": "Cales"
                            },
                            {
                                "inicioMes": "2026-04-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 196863,
                                "codigo": "1185509",
                                "razaoSocial": "CASA COMERCIO MATERIAIS CONSTRUCAO",
                                "gap": 0.2,
                                "aceite": true,
                                "produto": "Rejuntes"
                            },
                            {
                                "inicioMes": "2026-04-01T00:00:00",
                                "realizado": 3.08,
                                "clienteId": 196863,
                                "codigo": "1185509",
                                "razaoSocial": "CASA COMERCIO MATERIAIS CONSTRUCAO",
                                "gap": 1.92,
                                "aceite": true,
                                "produto": "Cales"
                            },
                            {
                                "inicioMes": "2026-04-01T00:00:00",
                                "realizado": 52,
                                "clienteId": 196863,
                                "codigo": "1185509",
                                "razaoSocial": "CASA COMERCIO MATERIAIS CONSTRUCAO",
                                "gap": 6,
                                "aceite": true,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-08-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 196863,
                                "codigo": "1185509",
                                "razaoSocial": "CASA COMERCIO MATERIAIS CONSTRUCAO",
                                "gap": 84,
                                "aceite": false,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-08-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 196863,
                                "codigo": "1185509",
                                "razaoSocial": "CASA COMERCIO MATERIAIS CONSTRUCAO",
                                "gap": 0.34,
                                "aceite": false,
                                "produto": "Impermeabilizantes"
                            },
                            {
                                "inicioMes": "2026-08-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 196854,
                                "codigo": "1146279",
                                "razaoSocial": "PAULO FERROS MATERIAIS PARA",
                                "gap": 0.01,
                                "grupoCentralizador": "AREIÃO",
                                "aceite": false,
                                "produto": "Rejuntes"
                            },
                            {
                                "inicioMes": "2026-08-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 196854,
                                "codigo": "1146279",
                                "razaoSocial": "PAULO FERROS MATERIAIS PARA",
                                "gap": 2,
                                "grupoCentralizador": "AREIÃO",
                                "aceite": false,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-08-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 196854,
                                "codigo": "1146279",
                                "razaoSocial": "PAULO FERROS MATERIAIS PARA",
                                "gap": 0.01,
                                "grupoCentralizador": "AREIÃO",
                                "aceite": false,
                                "produto": "Colantes"
                            },
                            {
                                "inicioMes": "2026-07-01T00:00:00",
                                "realizado": 0.2,
                                "clienteId": 196854,
                                "codigo": "1146279",
                                "razaoSocial": "PAULO FERROS MATERIAIS PARA",
                                "gap": -0.2,
                                "grupoCentralizador": "AREIÃO",
                                "aceite": true,
                                "produto": "Colantes"
                            },
                            {
                                "inicioMes": "2026-07-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 196854,
                                "codigo": "1146279",
                                "razaoSocial": "PAULO FERROS MATERIAIS PARA",
                                "gap": 0,
                                "grupoCentralizador": "AREIÃO",
                                "aceite": true,
                                "produto": "Impermeabilizantes"
                            },
                            {
                                "inicioMes": "2026-07-01T00:00:00",
                                "realizado": 12,
                                "clienteId": 196854,
                                "codigo": "1146279",
                                "razaoSocial": "PAULO FERROS MATERIAIS PARA",
                                "gap": -12,
                                "grupoCentralizador": "AREIÃO",
                                "aceite": true,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-08-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 173541,
                                "codigo": "1654458",
                                "razaoSocial": "AREIAO TERRA FORTE COMERCIO DE",
                                "gap": 6.9,
                                "grupoCentralizador": "AREIÃO",
                                "aceite": false,
                                "produto": "Colantes"
                            },
                            {
                                "inicioMes": "2026-08-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 173541,
                                "codigo": "1654458",
                                "razaoSocial": "AREIAO TERRA FORTE COMERCIO DE",
                                "gap": 0.23,
                                "grupoCentralizador": "AREIÃO",
                                "aceite": false,
                                "produto": "Rejuntes"
                            },
                            {
                                "inicioMes": "2026-08-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 173541,
                                "codigo": "1654458",
                                "razaoSocial": "AREIAO TERRA FORTE COMERCIO DE",
                                "gap": 50,
                                "grupoCentralizador": "AREIÃO",
                                "aceite": false,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-07-01T00:00:00",
                                "realizado": 16,
                                "clienteId": 173541,
                                "codigo": "1654458",
                                "razaoSocial": "AREIAO TERRA FORTE COMERCIO DE",
                                "gap": 14,
                                "grupoCentralizador": "AREIÃO",
                                "aceite": true,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-07-01T00:00:00",
                                "realizado": 0.6,
                                "clienteId": 173541,
                                "codigo": "1654458",
                                "razaoSocial": "AREIAO TERRA FORTE COMERCIO DE",
                                "gap": 5.4,
                                "grupoCentralizador": "AREIÃO",
                                "aceite": true,
                                "produto": "Colantes"
                            },
                            {
                                "inicioMes": "2026-07-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 173541,
                                "codigo": "1654458",
                                "razaoSocial": "AREIAO TERRA FORTE COMERCIO DE",
                                "gap": 0.2,
                                "grupoCentralizador": "AREIÃO",
                                "aceite": true,
                                "produto": "Impermeabilizantes"
                            },
                            {
                                "inicioMes": "2026-05-01T00:00:00",
                                "realizado": 0.12,
                                "clienteId": 196829,
                                "codigo": "1544786",
                                "razaoSocial": "COSTA ATACADISTA DA CONSTRUCAO LTDA",
                                "gap": 0.48,
                                "grupoCentralizador": "COSTA ATACADISTA",
                                "aceite": true,
                                "produto": "Rejuntes"
                            },
                            {
                                "inicioMes": "2026-05-01T00:00:00",
                                "realizado": 42,
                                "clienteId": 196829,
                                "codigo": "1544786",
                                "razaoSocial": "COSTA ATACADISTA DA CONSTRUCAO LTDA",
                                "gap": 0,
                                "grupoCentralizador": "COSTA ATACADISTA",
                                "aceite": true,
                                "produto": "Colantes"
                            },
                            {
                                "inicioMes": "2026-05-01T00:00:00",
                                "realizado": 0.216,
                                "clienteId": 196829,
                                "codigo": "1544786",
                                "razaoSocial": "COSTA ATACADISTA DA CONSTRUCAO LTDA",
                                "gap": 0.18400000000000002,
                                "grupoCentralizador": "COSTA ATACADISTA",
                                "aceite": true,
                                "produto": "Impermeabilizantes"
                            },
                            {
                                "inicioMes": "2026-07-01T00:00:00",
                                "realizado": 38,
                                "clienteId": 196829,
                                "codigo": "1544786",
                                "razaoSocial": "COSTA ATACADISTA DA CONSTRUCAO LTDA",
                                "gap": 0,
                                "grupoCentralizador": "COSTA ATACADISTA",
                                "aceite": true,
                                "produto": "Colantes"
                            },
                            {
                                "inicioMes": "2026-07-01T00:00:00",
                                "realizado": 0.2,
                                "clienteId": 196829,
                                "codigo": "1544786",
                                "razaoSocial": "COSTA ATACADISTA DA CONSTRUCAO LTDA",
                                "gap": 0.32,
                                "grupoCentralizador": "COSTA ATACADISTA",
                                "aceite": true,
                                "produto": "Rejuntes"
                            },
                            {
                                "inicioMes": "2026-07-01T00:00:00",
                                "realizado": 198,
                                "clienteId": 196829,
                                "codigo": "1544786",
                                "razaoSocial": "COSTA ATACADISTA DA CONSTRUCAO LTDA",
                                "gap": -8,
                                "grupoCentralizador": "COSTA ATACADISTA",
                                "aceite": true,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-07-01T00:00:00",
                                "realizado": 0.27,
                                "clienteId": 196829,
                                "codigo": "1544786",
                                "razaoSocial": "COSTA ATACADISTA DA CONSTRUCAO LTDA",
                                "gap": 0.02999999999999997,
                                "grupoCentralizador": "COSTA ATACADISTA",
                                "aceite": true,
                                "produto": "Impermeabilizantes"
                            },
                            {
                                "inicioMes": "2026-04-01T00:00:00",
                                "realizado": 138,
                                "clienteId": 196829,
                                "codigo": "1544786",
                                "razaoSocial": "COSTA ATACADISTA DA CONSTRUCAO LTDA",
                                "gap": -33,
                                "grupoCentralizador": "COSTA ATACADISTA",
                                "aceite": true,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-04-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 196829,
                                "codigo": "1544786",
                                "razaoSocial": "COSTA ATACADISTA DA CONSTRUCAO LTDA",
                                "gap": 0.5,
                                "grupoCentralizador": "COSTA ATACADISTA",
                                "aceite": true,
                                "produto": "Rejuntes"
                            },
                            {
                                "inicioMes": "2026-04-01T00:00:00",
                                "realizado": 30.8,
                                "clienteId": 196829,
                                "codigo": "1544786",
                                "razaoSocial": "COSTA ATACADISTA DA CONSTRUCAO LTDA",
                                "gap": -6.800000000000001,
                                "grupoCentralizador": "COSTA ATACADISTA",
                                "aceite": true,
                                "produto": "Colantes"
                            },
                            {
                                "inicioMes": "2026-04-01T00:00:00",
                                "realizado": 0.216,
                                "clienteId": 196829,
                                "codigo": "1544786",
                                "razaoSocial": "COSTA ATACADISTA DA CONSTRUCAO LTDA",
                                "gap": 0.08399999999999999,
                                "grupoCentralizador": "COSTA ATACADISTA",
                                "aceite": true,
                                "produto": "Impermeabilizantes"
                            },
                            {
                                "inicioMes": "2026-08-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 196829,
                                "codigo": "1544786",
                                "razaoSocial": "COSTA ATACADISTA DA CONSTRUCAO LTDA",
                                "gap": 42,
                                "grupoCentralizador": "COSTA ATACADISTA",
                                "aceite": true,
                                "produto": "Colantes"
                            },
                            {
                                "inicioMes": "2026-08-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 196829,
                                "codigo": "1544786",
                                "razaoSocial": "COSTA ATACADISTA DA CONSTRUCAO LTDA",
                                "gap": 0.2,
                                "grupoCentralizador": "COSTA ATACADISTA",
                                "aceite": true,
                                "produto": "Impermeabilizantes"
                            },
                            {
                                "inicioMes": "2026-08-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 196829,
                                "codigo": "1544786",
                                "razaoSocial": "COSTA ATACADISTA DA CONSTRUCAO LTDA",
                                "gap": 0.26,
                                "grupoCentralizador": "COSTA ATACADISTA",
                                "aceite": true,
                                "produto": "Rejuntes"
                            },
                            {
                                "inicioMes": "2026-08-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 196829,
                                "codigo": "1544786",
                                "razaoSocial": "COSTA ATACADISTA DA CONSTRUCAO LTDA",
                                "gap": 154,
                                "grupoCentralizador": "COSTA ATACADISTA",
                                "aceite": true,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-04-01T00:00:00",
                                "realizado": 83,
                                "clienteId": 54538,
                                "codigo": "1056239",
                                "razaoSocial": "MARGETEC MATERIAIS PARA CONSTRUCAO",
                                "gap": -23,
                                "grupoCentralizador": "AMARELINHO",
                                "aceite": true,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-04-01T00:00:00",
                                "realizado": 12.12,
                                "clienteId": 54538,
                                "codigo": "1056239",
                                "razaoSocial": "MARGETEC MATERIAIS PARA CONSTRUCAO",
                                "gap": 2.1800000000000015,
                                "grupoCentralizador": "AMARELINHO",
                                "aceite": true,
                                "produto": "Colantes"
                            },
                            {
                                "inicioMes": "2026-04-01T00:00:00",
                                "realizado": 0.28,
                                "clienteId": 54538,
                                "codigo": "1056239",
                                "razaoSocial": "MARGETEC MATERIAIS PARA CONSTRUCAO",
                                "gap": 0.12,
                                "grupoCentralizador": "AMARELINHO",
                                "aceite": true,
                                "produto": "Rejuntes"
                            },
                            {
                                "inicioMes": "2026-04-01T00:00:00",
                                "realizado": 0.435,
                                "clienteId": 54538,
                                "codigo": "1056239",
                                "razaoSocial": "MARGETEC MATERIAIS PARA CONSTRUCAO",
                                "gap": -0.235,
                                "grupoCentralizador": "AMARELINHO",
                                "aceite": true,
                                "produto": "Impermeabilizantes"
                            },
                            {
                                "inicioMes": "2026-05-01T00:00:00",
                                "realizado": 22,
                                "clienteId": 19005,
                                "codigo": "1053116",
                                "razaoSocial": "MARGETEL COMERCIO DE MATERIAIS",
                                "gap": -2,
                                "grupoCentralizador": "AMARELINHO",
                                "aceite": true,
                                "produto": "Colantes"
                            },
                            {
                                "inicioMes": "2026-05-01T00:00:00",
                                "realizado": 0.4,
                                "clienteId": 19005,
                                "codigo": "1053116",
                                "razaoSocial": "MARGETEL COMERCIO DE MATERIAIS",
                                "gap": 0,
                                "grupoCentralizador": "AMARELINHO",
                                "aceite": true,
                                "produto": "Rejuntes"
                            },
                            {
                                "inicioMes": "2026-05-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 19005,
                                "codigo": "1053116",
                                "razaoSocial": "MARGETEL COMERCIO DE MATERIAIS",
                                "gap": 0.3,
                                "grupoCentralizador": "AMARELINHO",
                                "aceite": true,
                                "produto": "Impermeabilizantes"
                            },
                            {
                                "inicioMes": "2026-05-01T00:00:00",
                                "realizado": 42,
                                "clienteId": 19005,
                                "codigo": "1053116",
                                "razaoSocial": "MARGETEL COMERCIO DE MATERIAIS",
                                "gap": 38,
                                "grupoCentralizador": "AMARELINHO",
                                "aceite": true,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-08-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 1130540,
                                "codigo": "1904962",
                                "razaoSocial": "CASA DUTRA REVENDEDORA DE MATERIAIS",
                                "gap": 0.01,
                                "grupoCentralizador": "TOCA LOJA DISTRIBUIDORA",
                                "aceite": false,
                                "produto": "Impermeabilizantes"
                            },
                            {
                                "inicioMes": "2026-08-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 1130540,
                                "codigo": "1904962",
                                "razaoSocial": "CASA DUTRA REVENDEDORA DE MATERIAIS",
                                "gap": 2,
                                "grupoCentralizador": "TOCA LOJA DISTRIBUIDORA",
                                "aceite": false,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-08-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 1130540,
                                "codigo": "1904962",
                                "razaoSocial": "CASA DUTRA REVENDEDORA DE MATERIAIS",
                                "gap": 0.01,
                                "grupoCentralizador": "TOCA LOJA DISTRIBUIDORA",
                                "aceite": false,
                                "produto": "Colantes"
                            },
                            {
                                "inicioMes": "2026-08-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 1130540,
                                "codigo": "1904962",
                                "razaoSocial": "CASA DUTRA REVENDEDORA DE MATERIAIS",
                                "gap": 0.01,
                                "grupoCentralizador": "TOCA LOJA DISTRIBUIDORA",
                                "aceite": false,
                                "produto": "Rejuntes"
                            },
                            {
                                "inicioMes": "2026-06-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 1130540,
                                "codigo": "1904962",
                                "razaoSocial": "CASA DUTRA REVENDEDORA DE MATERIAIS",
                                "gap": 16,
                                "grupoCentralizador": "TOCA LOJA DISTRIBUIDORA",
                                "aceite": true,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-06-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 1130540,
                                "codigo": "1904962",
                                "razaoSocial": "CASA DUTRA REVENDEDORA DE MATERIAIS",
                                "gap": 0.3,
                                "grupoCentralizador": "TOCA LOJA DISTRIBUIDORA",
                                "aceite": true,
                                "produto": "Rejuntes"
                            },
                            {
                                "inicioMes": "2026-06-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 1130540,
                                "codigo": "1904962",
                                "razaoSocial": "CASA DUTRA REVENDEDORA DE MATERIAIS",
                                "gap": 4.6,
                                "grupoCentralizador": "TOCA LOJA DISTRIBUIDORA",
                                "aceite": true,
                                "produto": "Colantes"
                            },
                            {
                                "inicioMes": "2026-06-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 1130540,
                                "codigo": "1904962",
                                "razaoSocial": "CASA DUTRA REVENDEDORA DE MATERIAIS",
                                "gap": 0.2,
                                "grupoCentralizador": "TOCA LOJA DISTRIBUIDORA",
                                "aceite": true,
                                "produto": "Impermeabilizantes"
                            },
                            {
                                "inicioMes": "2026-07-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 1130540,
                                "codigo": "1904962",
                                "razaoSocial": "CASA DUTRA REVENDEDORA DE MATERIAIS",
                                "gap": 0,
                                "grupoCentralizador": "TOCA LOJA DISTRIBUIDORA",
                                "aceite": true,
                                "produto": "Colantes"
                            },
                            {
                                "inicioMes": "2026-07-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 1130540,
                                "codigo": "1904962",
                                "razaoSocial": "CASA DUTRA REVENDEDORA DE MATERIAIS",
                                "gap": 0,
                                "grupoCentralizador": "TOCA LOJA DISTRIBUIDORA",
                                "aceite": true,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-07-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 1130540,
                                "codigo": "1904962",
                                "razaoSocial": "CASA DUTRA REVENDEDORA DE MATERIAIS",
                                "gap": 0,
                                "grupoCentralizador": "TOCA LOJA DISTRIBUIDORA",
                                "aceite": true,
                                "produto": "Impermeabilizantes"
                            },
                            {
                                "inicioMes": "2026-07-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 1130540,
                                "codigo": "1904962",
                                "razaoSocial": "CASA DUTRA REVENDEDORA DE MATERIAIS",
                                "gap": 0,
                                "grupoCentralizador": "TOCA LOJA DISTRIBUIDORA",
                                "aceite": true,
                                "produto": "Rejuntes"
                            },
                            {
                                "inicioMes": "2026-08-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 662331,
                                "codigo": "1842155",
                                "razaoSocial": "TOCA LOJA DISTRIBUIDORA LTDA",
                                "gap": 0.34,
                                "grupoCentralizador": "TOCA LOJA DISTRIBUIDORA",
                                "aceite": false,
                                "produto": "Rejuntes"
                            },
                            {
                                "inicioMes": "2026-08-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 662331,
                                "codigo": "1842155",
                                "razaoSocial": "TOCA LOJA DISTRIBUIDORA LTDA",
                                "gap": 184,
                                "grupoCentralizador": "TOCA LOJA DISTRIBUIDORA",
                                "aceite": false,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-08-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 662331,
                                "codigo": "1842155",
                                "razaoSocial": "TOCA LOJA DISTRIBUIDORA LTDA",
                                "gap": 0.34,
                                "grupoCentralizador": "TOCA LOJA DISTRIBUIDORA",
                                "aceite": false,
                                "produto": "Impermeabilizantes"
                            },
                            {
                                "inicioMes": "2026-08-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 662331,
                                "codigo": "1842155",
                                "razaoSocial": "TOCA LOJA DISTRIBUIDORA LTDA",
                                "gap": 32.2,
                                "grupoCentralizador": "TOCA LOJA DISTRIBUIDORA",
                                "aceite": false,
                                "produto": "Colantes"
                            },
                            {
                                "inicioMes": "2026-05-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 662331,
                                "codigo": "1842155",
                                "razaoSocial": "TOCA LOJA DISTRIBUIDORA LTDA",
                                "gap": 4.6,
                                "grupoCentralizador": "TOCA LOJA DISTRIBUIDORA",
                                "aceite": true,
                                "produto": "Cales"
                            },
                            {
                                "inicioMes": "2026-05-01T00:00:00",
                                "realizado": 2.4,
                                "clienteId": 662331,
                                "codigo": "1842155",
                                "razaoSocial": "TOCA LOJA DISTRIBUIDORA LTDA",
                                "gap": 13.6,
                                "grupoCentralizador": "TOCA LOJA DISTRIBUIDORA",
                                "aceite": true,
                                "produto": "Colantes"
                            },
                            {
                                "inicioMes": "2026-05-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 662331,
                                "codigo": "1842155",
                                "razaoSocial": "TOCA LOJA DISTRIBUIDORA LTDA",
                                "gap": 0.345,
                                "grupoCentralizador": "TOCA LOJA DISTRIBUIDORA",
                                "aceite": true,
                                "produto": "Rejuntes"
                            },
                            {
                                "inicioMes": "2026-05-01T00:00:00",
                                "realizado": 52.5,
                                "clienteId": 662331,
                                "codigo": "1842155",
                                "razaoSocial": "TOCA LOJA DISTRIBUIDORA LTDA",
                                "gap": 67.5,
                                "grupoCentralizador": "TOCA LOJA DISTRIBUIDORA",
                                "aceite": true,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-07-01T00:00:00",
                                "realizado": 32.8,
                                "clienteId": 662331,
                                "codigo": "1842155",
                                "razaoSocial": "TOCA LOJA DISTRIBUIDORA LTDA",
                                "gap": -14.799999999999997,
                                "grupoCentralizador": "TOCA LOJA DISTRIBUIDORA",
                                "aceite": true,
                                "produto": "Colantes"
                            },
                            {
                                "inicioMes": "2026-07-01T00:00:00",
                                "realizado": 0.02,
                                "clienteId": 662331,
                                "codigo": "1842155",
                                "razaoSocial": "TOCA LOJA DISTRIBUIDORA LTDA",
                                "gap": 0.58,
                                "grupoCentralizador": "TOCA LOJA DISTRIBUIDORA",
                                "aceite": true,
                                "produto": "Rejuntes"
                            },
                            {
                                "inicioMes": "2026-07-01T00:00:00",
                                "realizado": 153.5,
                                "clienteId": 662331,
                                "codigo": "1842155",
                                "razaoSocial": "TOCA LOJA DISTRIBUIDORA LTDA",
                                "gap": -1.5,
                                "grupoCentralizador": "TOCA LOJA DISTRIBUIDORA",
                                "aceite": true,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-07-01T00:00:00",
                                "realizado": 0.18,
                                "clienteId": 662331,
                                "codigo": "1842155",
                                "razaoSocial": "TOCA LOJA DISTRIBUIDORA LTDA",
                                "gap": 0.020000000000000018,
                                "grupoCentralizador": "TOCA LOJA DISTRIBUIDORA",
                                "aceite": true,
                                "produto": "Impermeabilizantes"
                            },
                            {
                                "inicioMes": "2026-04-01T00:00:00",
                                "realizado": 4.16,
                                "clienteId": 662331,
                                "codigo": "1842155",
                                "razaoSocial": "TOCA LOJA DISTRIBUIDORA LTDA",
                                "gap": -0.16000000000000014,
                                "grupoCentralizador": "TOCA LOJA DISTRIBUIDORA",
                                "aceite": true,
                                "produto": "Cales"
                            },
                            {
                                "inicioMes": "2026-04-01T00:00:00",
                                "realizado": 157,
                                "clienteId": 662331,
                                "codigo": "1842155",
                                "razaoSocial": "TOCA LOJA DISTRIBUIDORA LTDA",
                                "gap": -87,
                                "grupoCentralizador": "TOCA LOJA DISTRIBUIDORA",
                                "aceite": true,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-04-01T00:00:00",
                                "realizado": 26.4,
                                "clienteId": 662331,
                                "codigo": "1842155",
                                "razaoSocial": "TOCA LOJA DISTRIBUIDORA LTDA",
                                "gap": -21.4,
                                "grupoCentralizador": "TOCA LOJA DISTRIBUIDORA",
                                "aceite": true,
                                "produto": "Colantes"
                            },
                            {
                                "inicioMes": "2026-04-01T00:00:00",
                                "realizado": 0.216,
                                "clienteId": 662331,
                                "codigo": "1842155",
                                "razaoSocial": "TOCA LOJA DISTRIBUIDORA LTDA",
                                "gap": 0.18400000000000002,
                                "grupoCentralizador": "TOCA LOJA DISTRIBUIDORA",
                                "aceite": true,
                                "produto": "Impermeabilizantes"
                            },
                            {
                                "inicioMes": "2026-04-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 662331,
                                "codigo": "1842155",
                                "razaoSocial": "TOCA LOJA DISTRIBUIDORA LTDA",
                                "gap": 0.2,
                                "grupoCentralizador": "TOCA LOJA DISTRIBUIDORA",
                                "aceite": true,
                                "produto": "Rejuntes"
                            },
                            {
                                "inicioMes": "2026-06-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 663192,
                                "codigo": "1842703",
                                "razaoSocial": "EDUARDO HENRIQUE EMICO DE ASSIS",
                                "gap": 2,
                                "grupoCentralizador": "VORTEX",
                                "aceite": true,
                                "produto": "Colantes"
                            },
                            {
                                "inicioMes": "2026-06-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 663192,
                                "codigo": "1842703",
                                "razaoSocial": "EDUARDO HENRIQUE EMICO DE ASSIS",
                                "gap": 12,
                                "grupoCentralizador": "VORTEX",
                                "aceite": true,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-06-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 663192,
                                "codigo": "1842703",
                                "razaoSocial": "EDUARDO HENRIQUE EMICO DE ASSIS",
                                "gap": 0.3,
                                "grupoCentralizador": "VORTEX",
                                "aceite": true,
                                "produto": "Rejuntes"
                            },
                            {
                                "inicioMes": "2026-07-01T00:00:00",
                                "realizado": 2,
                                "clienteId": 663192,
                                "codigo": "1842703",
                                "razaoSocial": "EDUARDO HENRIQUE EMICO DE ASSIS",
                                "gap": -2,
                                "grupoCentralizador": "VORTEX",
                                "aceite": true,
                                "produto": "Colantes"
                            },
                            {
                                "inicioMes": "2026-07-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 663192,
                                "codigo": "1842703",
                                "razaoSocial": "EDUARDO HENRIQUE EMICO DE ASSIS",
                                "gap": 0,
                                "grupoCentralizador": "VORTEX",
                                "aceite": true,
                                "produto": "Rejuntes"
                            },
                            {
                                "inicioMes": "2026-07-01T00:00:00",
                                "realizado": 12,
                                "clienteId": 663192,
                                "codigo": "1842703",
                                "razaoSocial": "EDUARDO HENRIQUE EMICO DE ASSIS",
                                "gap": -12,
                                "grupoCentralizador": "VORTEX",
                                "aceite": true,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-07-01T00:00:00",
                                "realizado": 1.2,
                                "clienteId": 196864,
                                "codigo": "1226922",
                                "razaoSocial": "PEQUENO E POPULAR MATERIAIS PARA CO",
                                "gap": -1.2,
                                "grupoCentralizador": "VORTEX",
                                "aceite": true,
                                "produto": "Colantes"
                            },
                            {
                                "inicioMes": "2026-07-01T00:00:00",
                                "realizado": 12,
                                "clienteId": 196864,
                                "codigo": "1226922",
                                "razaoSocial": "PEQUENO E POPULAR MATERIAIS PARA CO",
                                "gap": -12,
                                "grupoCentralizador": "VORTEX",
                                "aceite": true,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-07-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 196864,
                                "codigo": "1226922",
                                "razaoSocial": "PEQUENO E POPULAR MATERIAIS PARA CO",
                                "gap": 0,
                                "grupoCentralizador": "VORTEX",
                                "aceite": true,
                                "produto": "Rejuntes"
                            },
                            {
                                "inicioMes": "2026-06-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 196864,
                                "codigo": "1226922",
                                "razaoSocial": "PEQUENO E POPULAR MATERIAIS PARA CO",
                                "gap": 0.2,
                                "grupoCentralizador": "VORTEX",
                                "aceite": true,
                                "produto": "Rejuntes"
                            },
                            {
                                "inicioMes": "2026-06-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 196864,
                                "codigo": "1226922",
                                "razaoSocial": "PEQUENO E POPULAR MATERIAIS PARA CO",
                                "gap": 12,
                                "grupoCentralizador": "VORTEX",
                                "aceite": true,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-06-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 196835,
                                "codigo": "1345157",
                                "razaoSocial": "JOSE MATEUS DE ASSIS   ME",
                                "gap": 12,
                                "grupoCentralizador": "VORTEX",
                                "aceite": true,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-06-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 196835,
                                "codigo": "1345157",
                                "razaoSocial": "JOSE MATEUS DE ASSIS   ME",
                                "gap": 0.2,
                                "grupoCentralizador": "VORTEX",
                                "aceite": true,
                                "produto": "Impermeabilizantes"
                            },
                            {
                                "inicioMes": "2026-07-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 196835,
                                "codigo": "1345157",
                                "razaoSocial": "JOSE MATEUS DE ASSIS   ME",
                                "gap": 0.6,
                                "grupoCentralizador": "VORTEX",
                                "aceite": true,
                                "produto": "Rejuntes"
                            },
                            {
                                "inicioMes": "2026-07-01T00:00:00",
                                "realizado": 12,
                                "clienteId": 196835,
                                "codigo": "1345157",
                                "razaoSocial": "JOSE MATEUS DE ASSIS   ME",
                                "gap": 20,
                                "grupoCentralizador": "VORTEX",
                                "aceite": true,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-07-01T00:00:00",
                                "realizado": 0.8,
                                "clienteId": 196835,
                                "codigo": "1345157",
                                "razaoSocial": "JOSE MATEUS DE ASSIS   ME",
                                "gap": 5.2,
                                "grupoCentralizador": "VORTEX",
                                "aceite": true,
                                "produto": "Colantes"
                            },
                            {
                                "inicioMes": "2026-08-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 54219,
                                "codigo": "1108711",
                                "razaoSocial": "ARNALDO ANDRADE CORREIA GUARULHOS",
                                "gap": 16,
                                "grupoCentralizador": "LENYSIO TELHAS",
                                "aceite": true,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-06-01T00:00:00",
                                "realizado": 0.4,
                                "clienteId": 54219,
                                "codigo": "1108711",
                                "razaoSocial": "ARNALDO ANDRADE CORREIA GUARULHOS",
                                "gap": 0.09999999999999998,
                                "grupoCentralizador": "LENYSIO TELHAS",
                                "aceite": true,
                                "produto": "Rejuntes"
                            },
                            {
                                "inicioMes": "2026-06-01T00:00:00",
                                "realizado": 22.4,
                                "clienteId": 54219,
                                "codigo": "1108711",
                                "razaoSocial": "ARNALDO ANDRADE CORREIA GUARULHOS",
                                "gap": 5.200000000000003,
                                "grupoCentralizador": "LENYSIO TELHAS",
                                "aceite": true,
                                "produto": "Colantes"
                            },
                            {
                                "inicioMes": "2026-04-01T00:00:00",
                                "realizado": 20,
                                "clienteId": 54219,
                                "codigo": "1108711",
                                "razaoSocial": "ARNALDO ANDRADE CORREIA GUARULHOS",
                                "gap": -6,
                                "grupoCentralizador": "LENYSIO TELHAS",
                                "aceite": true,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-04-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 54219,
                                "codigo": "1108711",
                                "razaoSocial": "ARNALDO ANDRADE CORREIA GUARULHOS",
                                "gap": 0.4,
                                "grupoCentralizador": "LENYSIO TELHAS",
                                "aceite": true,
                                "produto": "Rejuntes"
                            },
                            {
                                "inicioMes": "2026-04-01T00:00:00",
                                "realizado": 13.2,
                                "clienteId": 54219,
                                "codigo": "1108711",
                                "razaoSocial": "ARNALDO ANDRADE CORREIA GUARULHOS",
                                "gap": 0.8000000000000007,
                                "grupoCentralizador": "LENYSIO TELHAS",
                                "aceite": true,
                                "produto": "Colantes"
                            },
                            {
                                "inicioMes": "2026-05-01T00:00:00",
                                "realizado": 0.48,
                                "clienteId": 54219,
                                "codigo": "1108711",
                                "razaoSocial": "ARNALDO ANDRADE CORREIA GUARULHOS",
                                "gap": 0.040000000000000036,
                                "grupoCentralizador": "LENYSIO TELHAS",
                                "aceite": true,
                                "produto": "Rejuntes"
                            },
                            {
                                "inicioMes": "2026-05-01T00:00:00",
                                "realizado": 26.8,
                                "clienteId": 54219,
                                "codigo": "1108711",
                                "razaoSocial": "ARNALDO ANDRADE CORREIA GUARULHOS",
                                "gap": -3.400000000000002,
                                "grupoCentralizador": "LENYSIO TELHAS",
                                "aceite": true,
                                "produto": "Colantes"
                            },
                            {
                                "inicioMes": "2026-05-01T00:00:00",
                                "realizado": 12,
                                "clienteId": 54219,
                                "codigo": "1108711",
                                "razaoSocial": "ARNALDO ANDRADE CORREIA GUARULHOS",
                                "gap": 2,
                                "grupoCentralizador": "LENYSIO TELHAS",
                                "aceite": true,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-07-01T00:00:00",
                                "realizado": 16,
                                "clienteId": 54219,
                                "codigo": "1108711",
                                "razaoSocial": "ARNALDO ANDRADE CORREIA GUARULHOS",
                                "gap": -16,
                                "grupoCentralizador": "LENYSIO TELHAS",
                                "aceite": true,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-07-01T00:00:00",
                                "realizado": 0.54,
                                "clienteId": 54219,
                                "codigo": "1108711",
                                "razaoSocial": "ARNALDO ANDRADE CORREIA GUARULHOS",
                                "gap": -0.54,
                                "grupoCentralizador": "LENYSIO TELHAS",
                                "aceite": true,
                                "produto": "Rejuntes"
                            },
                            {
                                "inicioMes": "2026-07-01T00:00:00",
                                "realizado": 36,
                                "clienteId": 54219,
                                "codigo": "1108711",
                                "razaoSocial": "ARNALDO ANDRADE CORREIA GUARULHOS",
                                "gap": -36,
                                "grupoCentralizador": "LENYSIO TELHAS",
                                "aceite": true,
                                "produto": "Colantes"
                            },
                            {
                                "inicioMes": "2026-07-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 54219,
                                "codigo": "1108711",
                                "razaoSocial": "ARNALDO ANDRADE CORREIA GUARULHOS",
                                "gap": 0,
                                "grupoCentralizador": "LENYSIO TELHAS",
                                "aceite": true,
                                "produto": "Impermeabilizantes"
                            },
                            {
                                "inicioMes": "2026-06-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 54224,
                                "codigo": "1146294",
                                "razaoSocial": "LENYSIO TELHAS LTDA",
                                "gap": 0.23,
                                "grupoCentralizador": "LENYSIO TELHAS",
                                "aceite": true,
                                "produto": "Impermeabilizantes"
                            },
                            {
                                "inicioMes": "2026-06-01T00:00:00",
                                "realizado": 14,
                                "clienteId": 54224,
                                "codigo": "1146294",
                                "razaoSocial": "LENYSIO TELHAS LTDA",
                                "gap": 0,
                                "grupoCentralizador": "LENYSIO TELHAS",
                                "aceite": true,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-07-01T00:00:00",
                                "realizado": 2,
                                "clienteId": 54224,
                                "codigo": "1146294",
                                "razaoSocial": "LENYSIO TELHAS LTDA",
                                "gap": 26,
                                "grupoCentralizador": "LENYSIO TELHAS",
                                "aceite": true,
                                "produto": "Colantes"
                            },
                            {
                                "inicioMes": "2026-07-01T00:00:00",
                                "realizado": 0.1,
                                "clienteId": 54224,
                                "codigo": "1146294",
                                "razaoSocial": "LENYSIO TELHAS LTDA",
                                "gap": 0.5,
                                "grupoCentralizador": "LENYSIO TELHAS",
                                "aceite": true,
                                "produto": "Rejuntes"
                            },
                            {
                                "inicioMes": "2026-07-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 54224,
                                "codigo": "1146294",
                                "razaoSocial": "LENYSIO TELHAS LTDA",
                                "gap": 0.2,
                                "grupoCentralizador": "LENYSIO TELHAS",
                                "aceite": true,
                                "produto": "Impermeabilizantes"
                            },
                            {
                                "inicioMes": "2026-07-01T00:00:00",
                                "realizado": 2,
                                "clienteId": 54224,
                                "codigo": "1146294",
                                "razaoSocial": "LENYSIO TELHAS LTDA",
                                "gap": 12,
                                "grupoCentralizador": "LENYSIO TELHAS",
                                "aceite": true,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-08-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 54224,
                                "codigo": "1146294",
                                "razaoSocial": "LENYSIO TELHAS LTDA",
                                "gap": 24,
                                "grupoCentralizador": "LENYSIO TELHAS",
                                "aceite": true,
                                "produto": "Colantes"
                            },
                            {
                                "inicioMes": "2026-08-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 54224,
                                "codigo": "1146294",
                                "razaoSocial": "LENYSIO TELHAS LTDA",
                                "gap": 0,
                                "grupoCentralizador": "LENYSIO TELHAS",
                                "aceite": true,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-08-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 54224,
                                "codigo": "1146294",
                                "razaoSocial": "LENYSIO TELHAS LTDA",
                                "gap": 0.5,
                                "grupoCentralizador": "LENYSIO TELHAS",
                                "aceite": true,
                                "produto": "Rejuntes"
                            },
                            {
                                "inicioMes": "2026-08-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 180309,
                                "codigo": "1247422",
                                "razaoSocial": "DOIS IRMAOS CASIMIRO MATERIAIS PARA",
                                "gap": 0.01,
                                "grupoCentralizador": "IRMÃOS CASIMIRO",
                                "aceite": false,
                                "produto": "Rejuntes"
                            },
                            {
                                "inicioMes": "2026-08-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 180309,
                                "codigo": "1247422",
                                "razaoSocial": "DOIS IRMAOS CASIMIRO MATERIAIS PARA",
                                "gap": 0.01,
                                "grupoCentralizador": "IRMÃOS CASIMIRO",
                                "aceite": false,
                                "produto": "Impermeabilizantes"
                            },
                            {
                                "inicioMes": "2026-08-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 180309,
                                "codigo": "1247422",
                                "razaoSocial": "DOIS IRMAOS CASIMIRO MATERIAIS PARA",
                                "gap": 2,
                                "grupoCentralizador": "IRMÃOS CASIMIRO",
                                "aceite": false,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-08-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 180309,
                                "codigo": "1247422",
                                "razaoSocial": "DOIS IRMAOS CASIMIRO MATERIAIS PARA",
                                "gap": 0.01,
                                "grupoCentralizador": "IRMÃOS CASIMIRO",
                                "aceite": false,
                                "produto": "Colantes"
                            },
                            {
                                "inicioMes": "2026-08-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 196862,
                                "codigo": "1052267",
                                "razaoSocial": "CASIMIRO DEPOSITO DE MATERIAIS PARA",
                                "gap": 0.23,
                                "grupoCentralizador": "IRMÃOS CASIMIRO",
                                "aceite": false,
                                "produto": "Rejuntes"
                            },
                            {
                                "inicioMes": "2026-08-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 196862,
                                "codigo": "1052267",
                                "razaoSocial": "CASIMIRO DEPOSITO DE MATERIAIS PARA",
                                "gap": 0.23,
                                "grupoCentralizador": "IRMÃOS CASIMIRO",
                                "aceite": false,
                                "produto": "Impermeabilizantes"
                            },
                            {
                                "inicioMes": "2026-08-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 196862,
                                "codigo": "1052267",
                                "razaoSocial": "CASIMIRO DEPOSITO DE MATERIAIS PARA",
                                "gap": 11.5,
                                "grupoCentralizador": "IRMÃOS CASIMIRO",
                                "aceite": false,
                                "produto": "Colantes"
                            },
                            {
                                "inicioMes": "2026-08-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 196862,
                                "codigo": "1052267",
                                "razaoSocial": "CASIMIRO DEPOSITO DE MATERIAIS PARA",
                                "gap": 114,
                                "grupoCentralizador": "IRMÃOS CASIMIRO",
                                "aceite": false,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-08-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 54262,
                                "codigo": "1145966",
                                "razaoSocial": "MS MADEIRAS E MATERIAIS PARA",
                                "gap": 0.01,
                                "grupoCentralizador": "MADEIREIRA PRIMAVERA",
                                "aceite": false,
                                "produto": "Colantes"
                            },
                            {
                                "inicioMes": "2026-08-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 54262,
                                "codigo": "1145966",
                                "razaoSocial": "MS MADEIRAS E MATERIAIS PARA",
                                "gap": 2,
                                "grupoCentralizador": "MADEIREIRA PRIMAVERA",
                                "aceite": false,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-08-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 54262,
                                "codigo": "1145966",
                                "razaoSocial": "MS MADEIRAS E MATERIAIS PARA",
                                "gap": 0.01,
                                "grupoCentralizador": "MADEIREIRA PRIMAVERA",
                                "aceite": false,
                                "produto": "Impermeabilizantes"
                            },
                            {
                                "inicioMes": "2026-08-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 54262,
                                "codigo": "1145966",
                                "razaoSocial": "MS MADEIRAS E MATERIAIS PARA",
                                "gap": 0.12,
                                "grupoCentralizador": "MADEIREIRA PRIMAVERA",
                                "aceite": false,
                                "produto": "Rejuntes"
                            },
                            {
                                "inicioMes": "2026-07-01T00:00:00",
                                "realizado": 26,
                                "clienteId": 53993,
                                "codigo": "1366359",
                                "razaoSocial": "DEPOSITO MATERIAL DE CONSTRUCAO 3S",
                                "gap": 10,
                                "grupoCentralizador": "MADEIREIRA PRIMAVERA",
                                "aceite": true,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-07-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 53993,
                                "codigo": "1366359",
                                "razaoSocial": "DEPOSITO MATERIAL DE CONSTRUCAO 3S",
                                "gap": 0.2,
                                "grupoCentralizador": "MADEIREIRA PRIMAVERA",
                                "aceite": true,
                                "produto": "Impermeabilizantes"
                            },
                            {
                                "inicioMes": "2026-05-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 53993,
                                "codigo": "1366359",
                                "razaoSocial": "DEPOSITO MATERIAL DE CONSTRUCAO 3S",
                                "gap": 0.2,
                                "grupoCentralizador": "MADEIREIRA PRIMAVERA",
                                "aceite": true,
                                "produto": "Impermeabilizantes"
                            },
                            {
                                "inicioMes": "2026-05-01T00:00:00",
                                "realizado": 40,
                                "clienteId": 53993,
                                "codigo": "1366359",
                                "razaoSocial": "DEPOSITO MATERIAL DE CONSTRUCAO 3S",
                                "gap": -12,
                                "grupoCentralizador": "MADEIREIRA PRIMAVERA",
                                "aceite": true,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-04-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 53993,
                                "codigo": "1366359",
                                "razaoSocial": "DEPOSITO MATERIAL DE CONSTRUCAO 3S",
                                "gap": 0.2,
                                "grupoCentralizador": "MADEIREIRA PRIMAVERA",
                                "aceite": true,
                                "produto": "Impermeabilizantes"
                            },
                            {
                                "inicioMes": "2026-04-01T00:00:00",
                                "realizado": 0.4,
                                "clienteId": 53993,
                                "codigo": "1366359",
                                "razaoSocial": "DEPOSITO MATERIAL DE CONSTRUCAO 3S",
                                "gap": 3.6,
                                "grupoCentralizador": "MADEIREIRA PRIMAVERA",
                                "aceite": true,
                                "produto": "Colantes"
                            },
                            {
                                "inicioMes": "2026-04-01T00:00:00",
                                "realizado": 38.5,
                                "clienteId": 53993,
                                "codigo": "1366359",
                                "razaoSocial": "DEPOSITO MATERIAL DE CONSTRUCAO 3S",
                                "gap": -18.5,
                                "grupoCentralizador": "MADEIREIRA PRIMAVERA",
                                "aceite": true,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-08-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 53993,
                                "codigo": "1366359",
                                "razaoSocial": "DEPOSITO MATERIAL DE CONSTRUCAO 3S",
                                "gap": 34,
                                "grupoCentralizador": "MADEIREIRA PRIMAVERA",
                                "aceite": false,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-08-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 53993,
                                "codigo": "1366359",
                                "razaoSocial": "DEPOSITO MATERIAL DE CONSTRUCAO 3S",
                                "gap": 0.23,
                                "grupoCentralizador": "MADEIREIRA PRIMAVERA",
                                "aceite": false,
                                "produto": "Impermeabilizantes"
                            },
                            {
                                "inicioMes": "2026-08-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 53993,
                                "codigo": "1366359",
                                "razaoSocial": "DEPOSITO MATERIAL DE CONSTRUCAO 3S",
                                "gap": 0.14,
                                "grupoCentralizador": "MADEIREIRA PRIMAVERA",
                                "aceite": false,
                                "produto": "Rejuntes"
                            },
                            {
                                "inicioMes": "2026-08-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 53993,
                                "codigo": "1366359",
                                "razaoSocial": "DEPOSITO MATERIAL DE CONSTRUCAO 3S",
                                "gap": 2.3,
                                "grupoCentralizador": "MADEIREIRA PRIMAVERA",
                                "aceite": false,
                                "produto": "Colantes"
                            },
                            {
                                "inicioMes": "2026-05-01T00:00:00",
                                "realizado": 317,
                                "clienteId": 196837,
                                "codigo": "1325063",
                                "razaoSocial": "JAPA EMPORIO DA CONSTRUCAO LTDA",
                                "gap": -17,
                                "grupoCentralizador": "JAPA EMPÓRIO",
                                "aceite": true,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-05-01T00:00:00",
                                "realizado": 0.608,
                                "clienteId": 196837,
                                "codigo": "1325063",
                                "razaoSocial": "JAPA EMPORIO DA CONSTRUCAO LTDA",
                                "gap": 4.5920000000000005,
                                "grupoCentralizador": "JAPA EMPÓRIO",
                                "aceite": true,
                                "produto": "Cales"
                            },
                            {
                                "inicioMes": "2026-04-01T00:00:00",
                                "realizado": 6.2,
                                "clienteId": 196837,
                                "codigo": "1325063",
                                "razaoSocial": "JAPA EMPORIO DA CONSTRUCAO LTDA",
                                "gap": -1.2000000000000002,
                                "grupoCentralizador": "JAPA EMPÓRIO",
                                "aceite": true,
                                "produto": "Basicas"
                            },
                            {
                                "inicioMes": "2026-04-01T00:00:00",
                                "realizado": 178,
                                "clienteId": 196837,
                                "codigo": "1325063",
                                "razaoSocial": "JAPA EMPORIO DA CONSTRUCAO LTDA",
                                "gap": 66,
                                "grupoCentralizador": "JAPA EMPÓRIO",
                                "aceite": true,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-04-01T00:00:00",
                                "realizado": 11.2,
                                "clienteId": 196837,
                                "codigo": "1325063",
                                "razaoSocial": "JAPA EMPORIO DA CONSTRUCAO LTDA",
                                "gap": -2.1999999999999993,
                                "grupoCentralizador": "JAPA EMPÓRIO",
                                "aceite": true,
                                "produto": "Colantes"
                            },
                            {
                                "inicioMes": "2026-04-01T00:00:00",
                                "realizado": 0.27,
                                "clienteId": 196837,
                                "codigo": "1325063",
                                "razaoSocial": "JAPA EMPORIO DA CONSTRUCAO LTDA",
                                "gap": -0.07,
                                "grupoCentralizador": "JAPA EMPÓRIO",
                                "aceite": true,
                                "produto": "Impermeabilizantes"
                            },
                            {
                                "inicioMes": "2026-04-01T00:00:00",
                                "realizado": 0.18,
                                "clienteId": 196837,
                                "codigo": "1325063",
                                "razaoSocial": "JAPA EMPORIO DA CONSTRUCAO LTDA",
                                "gap": 0.020000000000000018,
                                "grupoCentralizador": "JAPA EMPÓRIO",
                                "aceite": true,
                                "produto": "Rejuntes"
                            }
                        ]
                    },
                    {
                        "id": -9,
                        "filtros": {
                            "gruposCentralizadores": [
                                null,
                                "AREIÃO",
                                "COSTA ATACADISTA",
                                "AMARELINHO",
                                "TOCA LOJA DISTRIBUIDORA",
                                "VORTEX",
                                "LENYSIO TELHAS",
                                "IRMÃOS CASIMIRO",
                                "MADEIREIRA PRIMAVERA",
                                "JAPA EMPÓRIO"
                            ],
                            "gruposProduto": [
                                "Cimentos",
                                "Rejuntes",
                                "Colantes",
                                "Impermeabilizantes",
                                "Cales",
                                "Basicas"
                            ]
                        }
                    },
                    {
                        "id": -10,
                        "createdAt": "2026-08-07T09:20:06.3336303"
                    }
                ]
            },
            {
                "id": 970,
                "codigoVendedor": "266993",
                "nomeVendedor": "DANIELLE DE SOUZA SAMPAIO",
                "basesBateuLevou": [
                    {
                        "id": 647061,
                        "codigo": "1697436",
                        "razaoSocial": "JEFERSON ILTON DE MEDEIROS DANTAS",
                        "aceite": true,
                        "volume": 10,
                        "meta": 28.6,
                        "atingimento": 0.34965034965034963,
                        "descontoRs": 0,
                        "verMais": [
                            {
                                "id": 1,
                                "codigo": "1697436",
                                "razaoSocial": "JEFERSON ILTON DE MEDEIROS DANTAS",
                                "produto": "Cimentos",
                                "volume": 10,
                                "meta": 24,
                                "atingimento": 0.4166666666666667,
                                "descontoRs": 0
                            },
                            {
                                "id": 3,
                                "codigo": "1697436",
                                "razaoSocial": "JEFERSON ILTON DE MEDEIROS DANTAS",
                                "produto": "Rejuntes",
                                "volume": 0,
                                "meta": 0.3,
                                "atingimento": 0,
                                "descontoRs": 0
                            },
                            {
                                "id": 2,
                                "codigo": "1697436",
                                "razaoSocial": "JEFERSON ILTON DE MEDEIROS DANTAS",
                                "produto": "Impermeabilizantes",
                                "volume": 0,
                                "meta": 0.3,
                                "atingimento": 0,
                                "descontoRs": 0
                            },
                            {
                                "id": 4,
                                "codigo": "1697436",
                                "razaoSocial": "JEFERSON ILTON DE MEDEIROS DANTAS",
                                "produto": "Colantes",
                                "volume": 0,
                                "meta": 4,
                                "atingimento": 0,
                                "descontoRs": 0
                            }
                        ],
                        "clienteId": 64706,
                        "inicioMes": "2026-04-01T00:00:00"
                    },
                    {
                        "id": 647060,
                        "codigo": "1697436",
                        "razaoSocial": "JEFERSON ILTON DE MEDEIROS DANTAS",
                        "aceite": false,
                        "volume": 6,
                        "meta": 33.17,
                        "atingimento": 0.18088634308109736,
                        "descontoRs": 0,
                        "verMais": [
                            {
                                "id": 1,
                                "codigo": "1697436",
                                "razaoSocial": "JEFERSON ILTON DE MEDEIROS DANTAS",
                                "produto": "Cimentos",
                                "volume": 6,
                                "meta": 28,
                                "atingimento": 0.21428571428571427,
                                "descontoRs": 0
                            },
                            {
                                "id": 4,
                                "codigo": "1697436",
                                "razaoSocial": "JEFERSON ILTON DE MEDEIROS DANTAS",
                                "produto": "Colantes",
                                "volume": 0,
                                "meta": 4.6,
                                "atingimento": 0,
                                "descontoRs": 0
                            },
                            {
                                "id": 2,
                                "codigo": "1697436",
                                "razaoSocial": "JEFERSON ILTON DE MEDEIROS DANTAS",
                                "produto": "Impermeabilizantes",
                                "volume": 0,
                                "meta": 0.23,
                                "atingimento": 0,
                                "descontoRs": 0
                            },
                            {
                                "id": 3,
                                "codigo": "1697436",
                                "razaoSocial": "JEFERSON ILTON DE MEDEIROS DANTAS",
                                "produto": "Rejuntes",
                                "volume": 0,
                                "meta": 0.34,
                                "atingimento": 0,
                                "descontoRs": 0
                            }
                        ],
                        "clienteId": 64706,
                        "inicioMes": "2026-08-01T00:00:00"
                    },
                    {
                        "id": 647061,
                        "codigo": "1697436",
                        "razaoSocial": "JEFERSON ILTON DE MEDEIROS DANTAS",
                        "aceite": true,
                        "volume": 16,
                        "meta": 29.29,
                        "atingimento": 0.5462615227039945,
                        "descontoRs": 0,
                        "verMais": [
                            {
                                "id": 3,
                                "codigo": "1697436",
                                "razaoSocial": "JEFERSON ILTON DE MEDEIROS DANTAS",
                                "produto": "Rejuntes",
                                "volume": 0,
                                "meta": 0.345,
                                "atingimento": 0,
                                "descontoRs": 0
                            },
                            {
                                "id": 1,
                                "codigo": "1697436",
                                "razaoSocial": "JEFERSON ILTON DE MEDEIROS DANTAS",
                                "produto": "Cimentos",
                                "volume": 16,
                                "meta": 24,
                                "atingimento": 0.6666666666666666,
                                "descontoRs": 0
                            },
                            {
                                "id": 2,
                                "codigo": "1697436",
                                "razaoSocial": "JEFERSON ILTON DE MEDEIROS DANTAS",
                                "produto": "Impermeabilizantes",
                                "volume": 0,
                                "meta": 0.345,
                                "atingimento": 0,
                                "descontoRs": 0
                            },
                            {
                                "id": 4,
                                "codigo": "1697436",
                                "razaoSocial": "JEFERSON ILTON DE MEDEIROS DANTAS",
                                "produto": "Colantes",
                                "volume": 0,
                                "meta": 4.6,
                                "atingimento": 0,
                                "descontoRs": 0
                            }
                        ],
                        "clienteId": 64706,
                        "inicioMes": "2026-05-01T00:00:00"
                    },
                    {
                        "id": 1073091,
                        "codigo": "1424376",
                        "razaoSocial": "GEOVANE BARROS DE OLIVEIRA",
                        "aceite": true,
                        "volume": 10.3,
                        "meta": 21.29,
                        "atingimento": 0.4837952090183185,
                        "descontoRs": 0,
                        "verMais": [
                            {
                                "id": 4,
                                "codigo": "1424376",
                                "razaoSocial": "GEOVANE BARROS DE OLIVEIRA",
                                "produto": "Colantes",
                                "volume": 0.3,
                                "meta": 4.6,
                                "atingimento": 0.06521739130434782,
                                "descontoRs": 0
                            },
                            {
                                "id": 3,
                                "codigo": "1424376",
                                "razaoSocial": "GEOVANE BARROS DE OLIVEIRA",
                                "produto": "Rejuntes",
                                "volume": 0,
                                "meta": 0.345,
                                "atingimento": 0,
                                "descontoRs": 0
                            },
                            {
                                "id": 2,
                                "codigo": "1424376",
                                "razaoSocial": "GEOVANE BARROS DE OLIVEIRA",
                                "produto": "Impermeabilizantes",
                                "volume": 0,
                                "meta": 0.345,
                                "atingimento": 0,
                                "descontoRs": 0
                            },
                            {
                                "id": 1,
                                "codigo": "1424376",
                                "razaoSocial": "GEOVANE BARROS DE OLIVEIRA",
                                "produto": "Cimentos",
                                "volume": 10,
                                "meta": 16,
                                "atingimento": 0.625,
                                "descontoRs": 0
                            }
                        ],
                        "clienteId": 107309,
                        "inicioMes": "2026-05-01T00:00:00"
                    },
                    {
                        "id": 1073091,
                        "codigo": "1424376",
                        "razaoSocial": "GEOVANE BARROS DE OLIVEIRA",
                        "aceite": true,
                        "volume": 12.6,
                        "meta": 21.6,
                        "atingimento": 0.5833333333333333,
                        "descontoRs": 0,
                        "verMais": [
                            {
                                "id": 4,
                                "codigo": "1424376",
                                "razaoSocial": "GEOVANE BARROS DE OLIVEIRA",
                                "produto": "Colantes",
                                "volume": 0.6,
                                "meta": 4,
                                "atingimento": 0.15,
                                "descontoRs": 0
                            },
                            {
                                "id": 3,
                                "codigo": "1424376",
                                "razaoSocial": "GEOVANE BARROS DE OLIVEIRA",
                                "produto": "Rejuntes",
                                "volume": 0,
                                "meta": 0.3,
                                "atingimento": 0,
                                "descontoRs": 0
                            },
                            {
                                "id": 2,
                                "codigo": "1424376",
                                "razaoSocial": "GEOVANE BARROS DE OLIVEIRA",
                                "produto": "Impermeabilizantes",
                                "volume": 0,
                                "meta": 0.3,
                                "atingimento": 0,
                                "descontoRs": 0
                            },
                            {
                                "id": 1,
                                "codigo": "1424376",
                                "razaoSocial": "GEOVANE BARROS DE OLIVEIRA",
                                "produto": "Cimentos",
                                "volume": 12,
                                "meta": 17,
                                "atingimento": 0.7058823529411765,
                                "descontoRs": 0
                            }
                        ],
                        "clienteId": 107309,
                        "inicioMes": "2026-04-01T00:00:00"
                    },
                    {
                        "id": 1073090,
                        "codigo": "1424376",
                        "razaoSocial": "GEOVANE BARROS DE OLIVEIRA",
                        "aceite": false,
                        "volume": 2,
                        "meta": 31.17,
                        "atingimento": 0.06416426050689765,
                        "descontoRs": 0,
                        "verMais": [
                            {
                                "id": 3,
                                "codigo": "1424376",
                                "razaoSocial": "GEOVANE BARROS DE OLIVEIRA",
                                "produto": "Rejuntes",
                                "volume": 0,
                                "meta": 0.34,
                                "atingimento": 0,
                                "descontoRs": 0
                            },
                            {
                                "id": 4,
                                "codigo": "1424376",
                                "razaoSocial": "GEOVANE BARROS DE OLIVEIRA",
                                "produto": "Colantes",
                                "volume": 0,
                                "meta": 4.6,
                                "atingimento": 0,
                                "descontoRs": 0
                            },
                            {
                                "id": 2,
                                "codigo": "1424376",
                                "razaoSocial": "GEOVANE BARROS DE OLIVEIRA",
                                "produto": "Impermeabilizantes",
                                "volume": 0,
                                "meta": 0.23,
                                "atingimento": 0,
                                "descontoRs": 0
                            },
                            {
                                "id": 1,
                                "codigo": "1424376",
                                "razaoSocial": "GEOVANE BARROS DE OLIVEIRA",
                                "produto": "Cimentos",
                                "volume": 2,
                                "meta": 26,
                                "atingimento": 0.07692307692307693,
                                "descontoRs": 0
                            }
                        ],
                        "clienteId": 107309,
                        "inicioMes": "2026-08-01T00:00:00"
                    },
                    {
                        "id": 1073131,
                        "codigo": "1706517",
                        "razaoSocial": "DEPOSITO LIMA LTDA",
                        "aceite": true,
                        "volume": 30,
                        "meta": 51.29,
                        "atingimento": 0.5849093390524469,
                        "descontoRs": 0,
                        "verMais": [
                            {
                                "id": 3,
                                "codigo": "1706517",
                                "razaoSocial": "DEPOSITO LIMA LTDA",
                                "produto": "Rejuntes",
                                "volume": 0,
                                "meta": 0.345,
                                "atingimento": 0,
                                "descontoRs": 0
                            },
                            {
                                "id": 2,
                                "codigo": "1706517",
                                "razaoSocial": "DEPOSITO LIMA LTDA",
                                "produto": "Impermeabilizantes",
                                "volume": 0,
                                "meta": 0.345,
                                "atingimento": 0,
                                "descontoRs": 0
                            },
                            {
                                "id": 4,
                                "codigo": "1706517",
                                "razaoSocial": "DEPOSITO LIMA LTDA",
                                "produto": "Colantes",
                                "volume": 0,
                                "meta": 4.6,
                                "atingimento": 0,
                                "descontoRs": 0
                            },
                            {
                                "id": 1,
                                "codigo": "1706517",
                                "razaoSocial": "DEPOSITO LIMA LTDA",
                                "produto": "Cimentos",
                                "volume": 30,
                                "meta": 46,
                                "atingimento": 0.6521739130434783,
                                "descontoRs": 0
                            }
                        ],
                        "clienteId": 107313,
                        "inicioMes": "2026-05-01T00:00:00"
                    },
                    {
                        "id": 1073131,
                        "codigo": "1706517",
                        "razaoSocial": "DEPOSITO LIMA LTDA",
                        "aceite": true,
                        "volume": 20,
                        "meta": 36.989999999999995,
                        "atingimento": 0.5406866720735335,
                        "descontoRs": 0,
                        "verMais": [
                            {
                                "id": 4,
                                "codigo": "1706517",
                                "razaoSocial": "DEPOSITO LIMA LTDA",
                                "produto": "Colantes",
                                "volume": 0,
                                "meta": 2.3,
                                "atingimento": 0,
                                "descontoRs": 0
                            },
                            {
                                "id": 1,
                                "codigo": "1706517",
                                "razaoSocial": "DEPOSITO LIMA LTDA",
                                "produto": "Cimentos",
                                "volume": 20,
                                "meta": 34,
                                "atingimento": 0.5882352941176471,
                                "descontoRs": 0
                            },
                            {
                                "id": 3,
                                "codigo": "1706517",
                                "razaoSocial": "DEPOSITO LIMA LTDA",
                                "produto": "Rejuntes",
                                "volume": 0,
                                "meta": 0.345,
                                "atingimento": 0,
                                "descontoRs": 0
                            },
                            {
                                "id": 2,
                                "codigo": "1706517",
                                "razaoSocial": "DEPOSITO LIMA LTDA",
                                "produto": "Impermeabilizantes",
                                "volume": 0,
                                "meta": 0.345,
                                "atingimento": 0,
                                "descontoRs": 0
                            }
                        ],
                        "clienteId": 107313,
                        "inicioMes": "2026-06-01T00:00:00"
                    },
                    {
                        "id": 1073130,
                        "codigo": "1706517",
                        "razaoSocial": "DEPOSITO LIMA LTDA",
                        "aceite": false,
                        "volume": 10,
                        "meta": 42.23,
                        "atingimento": 0.23679848448969928,
                        "descontoRs": 0,
                        "verMais": [
                            {
                                "id": 2,
                                "codigo": "1706517",
                                "razaoSocial": "DEPOSITO LIMA LTDA",
                                "produto": "Impermeabilizantes",
                                "volume": 0,
                                "meta": 0.23,
                                "atingimento": 0,
                                "descontoRs": 0
                            },
                            {
                                "id": 1,
                                "codigo": "1706517",
                                "razaoSocial": "DEPOSITO LIMA LTDA",
                                "produto": "Cimentos",
                                "volume": 10,
                                "meta": 42,
                                "atingimento": 0.23809523809523808,
                                "descontoRs": 0
                            }
                        ],
                        "clienteId": 107313,
                        "inicioMes": "2026-08-01T00:00:00"
                    },
                    {
                        "id": 1073130,
                        "codigo": "1706517",
                        "razaoSocial": "DEPOSITO LIMA LTDA",
                        "aceite": false,
                        "volume": 0.3,
                        "meta": 2.3,
                        "atingimento": 0.13043478260869565,
                        "descontoRs": 0,
                        "verMais": [
                            {
                                "id": 4,
                                "codigo": "1706517",
                                "razaoSocial": "DEPOSITO LIMA LTDA",
                                "produto": "Colantes",
                                "volume": 0.3,
                                "meta": 2.3,
                                "atingimento": 0.13043478260869565,
                                "descontoRs": 0
                            }
                        ],
                        "clienteId": 107313,
                        "inicioMes": "2026-07-01T00:00:00"
                    },
                    {
                        "id": 1073161,
                        "codigo": "1733883",
                        "razaoSocial": "EDIFICA MATERIAIS PARA CONSTRUCAO",
                        "aceite": true,
                        "volume": 31.8,
                        "meta": 50.4,
                        "atingimento": 0.6309523809523809,
                        "descontoRs": 604.032,
                        "verMais": [
                            {
                                "id": 4,
                                "codigo": "1733883",
                                "razaoSocial": "EDIFICA MATERIAIS PARA CONSTRUCAO",
                                "produto": "Colantes",
                                "volume": 17.55,
                                "meta": 10.4,
                                "atingimento": 1.6875,
                                "descontoRs": 604.032
                            },
                            {
                                "id": 1,
                                "codigo": "1733883",
                                "razaoSocial": "EDIFICA MATERIAIS PARA CONSTRUCAO",
                                "produto": "Cimentos",
                                "volume": 14.25,
                                "meta": 40,
                                "atingimento": 0.35625,
                                "descontoRs": 0
                            }
                        ],
                        "clienteId": 107316,
                        "inicioMes": "2026-07-01T00:00:00"
                    },
                    {
                        "id": 1073160,
                        "codigo": "1733883",
                        "razaoSocial": "EDIFICA MATERIAIS PARA CONSTRUCAO",
                        "aceite": false,
                        "volume": 0,
                        "meta": 48.43,
                        "atingimento": 0,
                        "descontoRs": 0,
                        "verMais": [
                            {
                                "id": 2,
                                "codigo": "1733883",
                                "razaoSocial": "EDIFICA MATERIAIS PARA CONSTRUCAO",
                                "produto": "Impermeabilizantes",
                                "volume": 0,
                                "meta": 0.29,
                                "atingimento": 0,
                                "descontoRs": 0
                            },
                            {
                                "id": 3,
                                "codigo": "1733883",
                                "razaoSocial": "EDIFICA MATERIAIS PARA CONSTRUCAO",
                                "produto": "Rejuntes",
                                "volume": 0,
                                "meta": 0.34,
                                "atingimento": 0,
                                "descontoRs": 0
                            },
                            {
                                "id": 4,
                                "codigo": "1733883",
                                "razaoSocial": "EDIFICA MATERIAIS PARA CONSTRUCAO",
                                "produto": "Colantes",
                                "volume": 0,
                                "meta": 13.8,
                                "atingimento": 0,
                                "descontoRs": 0
                            },
                            {
                                "id": 1,
                                "codigo": "1733883",
                                "razaoSocial": "EDIFICA MATERIAIS PARA CONSTRUCAO",
                                "produto": "Cimentos",
                                "volume": 0,
                                "meta": 34,
                                "atingimento": 0,
                                "descontoRs": 0
                            }
                        ],
                        "clienteId": 107316,
                        "inicioMes": "2026-08-01T00:00:00"
                    },
                    {
                        "id": 1073171,
                        "codigo": "1778028",
                        "razaoSocial": "MARCOPISOS LTDA",
                        "aceite": true,
                        "volume": 1.5,
                        "meta": 19.9,
                        "atingimento": 0.07537688442211056,
                        "descontoRs": 0,
                        "verMais": [
                            {
                                "id": 3,
                                "codigo": "1778028",
                                "razaoSocial": "MARCOPISOS LTDA",
                                "produto": "Rejuntes",
                                "volume": 0,
                                "meta": 0.3,
                                "atingimento": 0,
                                "descontoRs": 0
                            },
                            {
                                "id": 1,
                                "codigo": "1778028",
                                "razaoSocial": "MARCOPISOS LTDA",
                                "produto": "Cimentos",
                                "volume": 0,
                                "meta": 14,
                                "atingimento": 0,
                                "descontoRs": 0
                            },
                            {
                                "id": 2,
                                "codigo": "1778028",
                                "razaoSocial": "MARCOPISOS LTDA",
                                "produto": "Impermeabilizantes",
                                "volume": 0,
                                "meta": 0.6,
                                "atingimento": 0,
                                "descontoRs": 0
                            },
                            {
                                "id": 4,
                                "codigo": "1778028",
                                "razaoSocial": "MARCOPISOS LTDA",
                                "produto": "Colantes",
                                "volume": 1.5,
                                "meta": 5,
                                "atingimento": 0.3,
                                "descontoRs": 0
                            }
                        ],
                        "clienteId": 107317,
                        "inicioMes": "2026-04-01T00:00:00"
                    },
                    {
                        "id": 1342100,
                        "codigo": "1130442",
                        "razaoSocial": "J  AUGUSTO PINHEIRO PAPELARIA",
                        "aceite": false,
                        "volume": 0.75,
                        "meta": 10.75,
                        "atingimento": 0.06976744186046512,
                        "descontoRs": 0,
                        "verMais": [
                            {
                                "id": 1,
                                "codigo": "1130442",
                                "razaoSocial": "J  AUGUSTO PINHEIRO PAPELARIA",
                                "produto": "Cimentos",
                                "volume": 0.75,
                                "meta": 10.75,
                                "atingimento": 0.06976744186046512,
                                "descontoRs": 0
                            }
                        ],
                        "clienteId": 134210,
                        "inicioMes": "2026-04-01T00:00:00"
                    },
                    {
                        "id": 1760681,
                        "codigo": "1724963",
                        "razaoSocial": "MENEZES CIMENTOS LTDA",
                        "aceite": true,
                        "volume": 626.3199999999999,
                        "meta": 555.5999999999999,
                        "atingimento": 1.1272858171346294,
                        "descontoRs": 12100,
                        "verMais": [
                            {
                                "id": 3,
                                "codigo": "1724963",
                                "razaoSocial": "MENEZES CIMENTOS LTDA",
                                "produto": "Rejuntes",
                                "volume": 0.02,
                                "meta": 0.3,
                                "atingimento": 0.06666666666666667,
                                "descontoRs": 0
                            },
                            {
                                "id": 1,
                                "codigo": "1724963",
                                "razaoSocial": "MENEZES CIMENTOS LTDA",
                                "produto": "Cimentos",
                                "volume": 626,
                                "meta": 550,
                                "atingimento": 1.1381818181818182,
                                "descontoRs": 12100
                            },
                            {
                                "id": 2,
                                "codigo": "1724963",
                                "razaoSocial": "MENEZES CIMENTOS LTDA",
                                "produto": "Impermeabilizantes",
                                "volume": 0,
                                "meta": 0.3,
                                "atingimento": 0,
                                "descontoRs": 0
                            },
                            {
                                "id": 4,
                                "codigo": "1724963",
                                "razaoSocial": "MENEZES CIMENTOS LTDA",
                                "produto": "Colantes",
                                "volume": 0.3,
                                "meta": 5,
                                "atingimento": 0.06,
                                "descontoRs": 0
                            }
                        ],
                        "clienteId": 176068,
                        "inicioMes": "2026-06-01T00:00:00"
                    },
                    {
                        "id": 1760681,
                        "codigo": "1724963",
                        "razaoSocial": "MENEZES CIMENTOS LTDA",
                        "aceite": true,
                        "volume": 714.3199999999999,
                        "meta": 573.96,
                        "atingimento": 1.2445466583037144,
                        "descontoRs": 12496,
                        "verMais": [
                            {
                                "id": 1,
                                "codigo": "1724963",
                                "razaoSocial": "MENEZES CIMENTOS LTDA",
                                "produto": "Cimentos",
                                "volume": 714,
                                "meta": 568,
                                "atingimento": 1.2570422535211268,
                                "descontoRs": 12496
                            },
                            {
                                "id": 3,
                                "codigo": "1724963",
                                "razaoSocial": "MENEZES CIMENTOS LTDA",
                                "produto": "Rejuntes",
                                "volume": 0.02,
                                "meta": 0.38,
                                "atingimento": 0.05263157894736842,
                                "descontoRs": 0
                            },
                            {
                                "id": 4,
                                "codigo": "1724963",
                                "razaoSocial": "MENEZES CIMENTOS LTDA",
                                "produto": "Colantes",
                                "volume": 0.3,
                                "meta": 5.2,
                                "atingimento": 0.05769230769230769,
                                "descontoRs": 0
                            },
                            {
                                "id": 2,
                                "codigo": "1724963",
                                "razaoSocial": "MENEZES CIMENTOS LTDA",
                                "produto": "Impermeabilizantes",
                                "volume": 0,
                                "meta": 0.38,
                                "atingimento": 0,
                                "descontoRs": 0
                            }
                        ],
                        "clienteId": 176068,
                        "inicioMes": "2026-07-01T00:00:00"
                    },
                    {
                        "id": 1760681,
                        "codigo": "1724963",
                        "razaoSocial": "MENEZES CIMENTOS LTDA",
                        "aceite": true,
                        "volume": 587.222,
                        "meta": 515.6,
                        "atingimento": 1.1389100077579517,
                        "descontoRs": 8976,
                        "verMais": [
                            {
                                "id": 3,
                                "codigo": "1724963",
                                "razaoSocial": "MENEZES CIMENTOS LTDA",
                                "produto": "Rejuntes",
                                "volume": 0.2,
                                "meta": 0.3,
                                "atingimento": 0.6666666666666667,
                                "descontoRs": 0
                            },
                            {
                                "id": 4,
                                "codigo": "1724963",
                                "razaoSocial": "MENEZES CIMENTOS LTDA",
                                "produto": "Colantes",
                                "volume": 0.99,
                                "meta": 5,
                                "atingimento": 0.198,
                                "descontoRs": 0
                            },
                            {
                                "id": 2,
                                "codigo": "1724963",
                                "razaoSocial": "MENEZES CIMENTOS LTDA",
                                "produto": "Impermeabilizantes",
                                "volume": 0.032,
                                "meta": 0.3,
                                "atingimento": 0.10666666666666667,
                                "descontoRs": 0
                            },
                            {
                                "id": 1,
                                "codigo": "1724963",
                                "razaoSocial": "MENEZES CIMENTOS LTDA",
                                "produto": "Cimentos",
                                "volume": 586,
                                "meta": 510,
                                "atingimento": 1.1490196078431372,
                                "descontoRs": 8976
                            }
                        ],
                        "clienteId": 176068,
                        "inicioMes": "2026-04-01T00:00:00"
                    },
                    {
                        "id": 1760690,
                        "codigo": "1759677",
                        "razaoSocial": "ELLAS MATERIAIS DE CONSTRUCOES LTDA",
                        "aceite": false,
                        "volume": 12.4,
                        "meta": 71.17,
                        "atingimento": 0.17423071518898411,
                        "descontoRs": 0,
                        "verMais": [
                            {
                                "id": 1,
                                "codigo": "1759677",
                                "razaoSocial": "ELLAS MATERIAIS DE CONSTRUCOES LTDA",
                                "produto": "Cimentos",
                                "volume": 10,
                                "meta": 66,
                                "atingimento": 0.15151515151515152,
                                "descontoRs": 0
                            },
                            {
                                "id": 2,
                                "codigo": "1759677",
                                "razaoSocial": "ELLAS MATERIAIS DE CONSTRUCOES LTDA",
                                "produto": "Impermeabilizantes",
                                "volume": 0,
                                "meta": 0.23,
                                "atingimento": 0,
                                "descontoRs": 0
                            },
                            {
                                "id": 4,
                                "codigo": "1759677",
                                "razaoSocial": "ELLAS MATERIAIS DE CONSTRUCOES LTDA",
                                "produto": "Colantes",
                                "volume": 2.4,
                                "meta": 4.6,
                                "atingimento": 0.5217391304347826,
                                "descontoRs": 0
                            },
                            {
                                "id": 3,
                                "codigo": "1759677",
                                "razaoSocial": "ELLAS MATERIAIS DE CONSTRUCOES LTDA",
                                "produto": "Rejuntes",
                                "volume": 0,
                                "meta": 0.34,
                                "atingimento": 0,
                                "descontoRs": 0
                            }
                        ],
                        "clienteId": 176069,
                        "inicioMes": "2026-08-01T00:00:00"
                    },
                    {
                        "id": 1760690,
                        "codigo": "1759677",
                        "razaoSocial": "ELLAS MATERIAIS DE CONSTRUCOES LTDA",
                        "aceite": false,
                        "volume": 12.858,
                        "meta": 48.44,
                        "atingimento": 0.26544178364987614,
                        "descontoRs": 0,
                        "verMais": [
                            {
                                "id": 3,
                                "codigo": "1759677",
                                "razaoSocial": "ELLAS MATERIAIS DE CONSTRUCOES LTDA",
                                "produto": "Rejuntes",
                                "volume": 0.1,
                                "meta": 0.345,
                                "atingimento": 0.2898550724637682,
                                "descontoRs": 0
                            },
                            {
                                "id": 4,
                                "codigo": "1759677",
                                "razaoSocial": "ELLAS MATERIAIS DE CONSTRUCOES LTDA",
                                "produto": "Colantes",
                                "volume": 2.4,
                                "meta": 5.75,
                                "atingimento": 0.41739130434782606,
                                "descontoRs": 0
                            },
                            {
                                "id": 2,
                                "codigo": "1759677",
                                "razaoSocial": "ELLAS MATERIAIS DE CONSTRUCOES LTDA",
                                "produto": "Impermeabilizantes",
                                "volume": 0.108,
                                "meta": 0.345,
                                "atingimento": 0.3130434782608696,
                                "descontoRs": 0
                            },
                            {
                                "id": 1,
                                "codigo": "1759677",
                                "razaoSocial": "ELLAS MATERIAIS DE CONSTRUCOES LTDA",
                                "produto": "Cimentos",
                                "volume": 10.25,
                                "meta": 42,
                                "atingimento": 0.24404761904761904,
                                "descontoRs": 0
                            }
                        ],
                        "clienteId": 176069,
                        "inicioMes": "2026-06-01T00:00:00"
                    },
                    {
                        "id": 645051,
                        "codigo": "1068160",
                        "razaoSocial": "LETICIA CAVALCANTE HOLANDA",
                        "aceite": true,
                        "volume": 0.9,
                        "meta": 2,
                        "atingimento": 0.45,
                        "descontoRs": 0,
                        "verMais": [
                            {
                                "id": 4,
                                "codigo": "1068160",
                                "razaoSocial": "LETICIA CAVALCANTE HOLANDA",
                                "produto": "Colantes",
                                "volume": 0.9,
                                "meta": 2,
                                "atingimento": 0.45,
                                "descontoRs": 0
                            }
                        ],
                        "clienteId": 64505,
                        "inicioMes": "2026-07-01T00:00:00"
                    },
                    {
                        "id": 645050,
                        "codigo": "1068160",
                        "razaoSocial": "LETICIA CAVALCANTE HOLANDA",
                        "aceite": false,
                        "volume": 0,
                        "meta": 45.17,
                        "atingimento": 0,
                        "descontoRs": 0,
                        "verMais": [
                            {
                                "id": 2,
                                "codigo": "1068160",
                                "razaoSocial": "LETICIA CAVALCANTE HOLANDA",
                                "produto": "Impermeabilizantes",
                                "volume": 0,
                                "meta": 0.23,
                                "atingimento": 0,
                                "descontoRs": 0
                            },
                            {
                                "id": 3,
                                "codigo": "1068160",
                                "razaoSocial": "LETICIA CAVALCANTE HOLANDA",
                                "produto": "Rejuntes",
                                "volume": 0,
                                "meta": 0.34,
                                "atingimento": 0,
                                "descontoRs": 0
                            },
                            {
                                "id": 4,
                                "codigo": "1068160",
                                "razaoSocial": "LETICIA CAVALCANTE HOLANDA",
                                "produto": "Colantes",
                                "volume": 0,
                                "meta": 4.6,
                                "atingimento": 0,
                                "descontoRs": 0
                            },
                            {
                                "id": 1,
                                "codigo": "1068160",
                                "razaoSocial": "LETICIA CAVALCANTE HOLANDA",
                                "produto": "Cimentos",
                                "volume": 0,
                                "meta": 40,
                                "atingimento": 0,
                                "descontoRs": 0
                            }
                        ],
                        "clienteId": 64505,
                        "inicioMes": "2026-08-01T00:00:00"
                    },
                    {
                        "id": 645051,
                        "codigo": "1068160",
                        "razaoSocial": "LETICIA CAVALCANTE HOLANDA",
                        "aceite": true,
                        "volume": 34.32,
                        "meta": 38.14,
                        "atingimento": 0.8998426848453067,
                        "descontoRs": 374,
                        "verMais": [
                            {
                                "id": 1,
                                "codigo": "1068160",
                                "razaoSocial": "LETICIA CAVALCANTE HOLANDA",
                                "produto": "Cimentos",
                                "volume": 34,
                                "meta": 34,
                                "atingimento": 1,
                                "descontoRs": 374
                            },
                            {
                                "id": 3,
                                "codigo": "1068160",
                                "razaoSocial": "LETICIA CAVALCANTE HOLANDA",
                                "produto": "Rejuntes",
                                "volume": 0.02,
                                "meta": 0.345,
                                "atingimento": 0.05797101449275363,
                                "descontoRs": 0
                            },
                            {
                                "id": 2,
                                "codigo": "1068160",
                                "razaoSocial": "LETICIA CAVALCANTE HOLANDA",
                                "produto": "Impermeabilizantes",
                                "volume": 0,
                                "meta": 0.345,
                                "atingimento": 0,
                                "descontoRs": 0
                            },
                            {
                                "id": 4,
                                "codigo": "1068160",
                                "razaoSocial": "LETICIA CAVALCANTE HOLANDA",
                                "produto": "Colantes",
                                "volume": 0.3,
                                "meta": 3.45,
                                "atingimento": 0.08695652173913043,
                                "descontoRs": 0
                            }
                        ],
                        "clienteId": 64505,
                        "inicioMes": "2026-06-01T00:00:00"
                    },
                    {
                        "id": 645051,
                        "codigo": "1068160",
                        "razaoSocial": "LETICIA CAVALCANTE HOLANDA",
                        "aceite": true,
                        "volume": 28,
                        "meta": 33.29,
                        "atingimento": 0.8410934214478822,
                        "descontoRs": 672,
                        "verMais": [
                            {
                                "id": 3,
                                "codigo": "1068160",
                                "razaoSocial": "LETICIA CAVALCANTE HOLANDA",
                                "produto": "Rejuntes",
                                "volume": 0,
                                "meta": 0.345,
                                "atingimento": 0,
                                "descontoRs": 0
                            },
                            {
                                "id": 1,
                                "codigo": "1068160",
                                "razaoSocial": "LETICIA CAVALCANTE HOLANDA",
                                "produto": "Cimentos",
                                "volume": 28,
                                "meta": 28,
                                "atingimento": 1,
                                "descontoRs": 672
                            },
                            {
                                "id": 2,
                                "codigo": "1068160",
                                "razaoSocial": "LETICIA CAVALCANTE HOLANDA",
                                "produto": "Impermeabilizantes",
                                "volume": 0,
                                "meta": 0.345,
                                "atingimento": 0,
                                "descontoRs": 0
                            },
                            {
                                "id": 4,
                                "codigo": "1068160",
                                "razaoSocial": "LETICIA CAVALCANTE HOLANDA",
                                "produto": "Colantes",
                                "volume": 0,
                                "meta": 4.6,
                                "atingimento": 0,
                                "descontoRs": 0
                            }
                        ],
                        "clienteId": 64505,
                        "inicioMes": "2026-05-01T00:00:00"
                    },
                    {
                        "id": 1801741,
                        "codigo": "1242458",
                        "razaoSocial": "DIVA MAGNA BERNARDINO FERREIRA",
                        "aceite": true,
                        "volume": 211.8,
                        "meta": 314.6,
                        "atingimento": 0.6732358550540368,
                        "descontoRs": 162,
                        "verMais": [
                            {
                                "id": 3,
                                "codigo": "1242458",
                                "razaoSocial": "DIVA MAGNA BERNARDINO FERREIRA",
                                "produto": "Rejuntes",
                                "volume": 0,
                                "meta": 0.3,
                                "atingimento": 0,
                                "descontoRs": 0
                            },
                            {
                                "id": 2,
                                "codigo": "1242458",
                                "razaoSocial": "DIVA MAGNA BERNARDINO FERREIRA",
                                "produto": "Impermeabilizantes",
                                "volume": 0,
                                "meta": 0.3,
                                "atingimento": 0,
                                "descontoRs": 0
                            },
                            {
                                "id": 1,
                                "codigo": "1242458",
                                "razaoSocial": "DIVA MAGNA BERNARDINO FERREIRA",
                                "produto": "Cimentos",
                                "volume": 207.75,
                                "meta": 310,
                                "atingimento": 0.6701612903225806,
                                "descontoRs": 0
                            },
                            {
                                "id": 4,
                                "codigo": "1242458",
                                "razaoSocial": "DIVA MAGNA BERNARDINO FERREIRA",
                                "produto": "Colantes",
                                "volume": 4.05,
                                "meta": 4,
                                "atingimento": 1.0125,
                                "descontoRs": 162
                            }
                        ],
                        "clienteId": 180174,
                        "inicioMes": "2026-04-01T00:00:00"
                    },
                    {
                        "id": 1801741,
                        "codigo": "1242458",
                        "razaoSocial": "DIVA MAGNA BERNARDINO FERREIRA",
                        "aceite": true,
                        "volume": 350.9,
                        "meta": 304.69000000000005,
                        "atingimento": 1.1516623453346022,
                        "descontoRs": 2640,
                        "verMais": [
                            {
                                "id": 1,
                                "codigo": "1242458",
                                "razaoSocial": "DIVA MAGNA BERNARDINO FERREIRA",
                                "produto": "Cimentos",
                                "volume": 348.5,
                                "meta": 300,
                                "atingimento": 1.1616666666666666,
                                "descontoRs": 2640
                            },
                            {
                                "id": 2,
                                "codigo": "1242458",
                                "razaoSocial": "DIVA MAGNA BERNARDINO FERREIRA",
                                "produto": "Impermeabilizantes",
                                "volume": 0,
                                "meta": 0.345,
                                "atingimento": 0,
                                "descontoRs": 0
                            },
                            {
                                "id": 4,
                                "codigo": "1242458",
                                "razaoSocial": "DIVA MAGNA BERNARDINO FERREIRA",
                                "produto": "Colantes",
                                "volume": 2.4,
                                "meta": 4,
                                "atingimento": 0.6,
                                "descontoRs": 0
                            },
                            {
                                "id": 3,
                                "codigo": "1242458",
                                "razaoSocial": "DIVA MAGNA BERNARDINO FERREIRA",
                                "produto": "Rejuntes",
                                "volume": 0,
                                "meta": 0.345,
                                "atingimento": 0,
                                "descontoRs": 0
                            }
                        ],
                        "clienteId": 180174,
                        "inicioMes": "2026-05-01T00:00:00"
                    },
                    {
                        "id": 1801741,
                        "codigo": "1242458",
                        "razaoSocial": "DIVA MAGNA BERNARDINO FERREIRA",
                        "aceite": true,
                        "volume": 346.35,
                        "meta": 334.76,
                        "atingimento": 1.0346218186163223,
                        "descontoRs": 6948.75,
                        "verMais": [
                            {
                                "id": 2,
                                "codigo": "1242458",
                                "razaoSocial": "DIVA MAGNA BERNARDINO FERREIRA",
                                "produto": "Impermeabilizantes",
                                "volume": 0,
                                "meta": 0.38,
                                "atingimento": 0,
                                "descontoRs": 0
                            },
                            {
                                "id": 4,
                                "codigo": "1242458",
                                "razaoSocial": "DIVA MAGNA BERNARDINO FERREIRA",
                                "produto": "Colantes",
                                "volume": 4.35,
                                "meta": 4,
                                "atingimento": 1.0875,
                                "descontoRs": 108.75
                            },
                            {
                                "id": 3,
                                "codigo": "1242458",
                                "razaoSocial": "DIVA MAGNA BERNARDINO FERREIRA",
                                "produto": "Rejuntes",
                                "volume": 0,
                                "meta": 0.38,
                                "atingimento": 0,
                                "descontoRs": 0
                            },
                            {
                                "id": 1,
                                "codigo": "1242458",
                                "razaoSocial": "DIVA MAGNA BERNARDINO FERREIRA",
                                "produto": "Cimentos",
                                "volume": 342,
                                "meta": 330,
                                "atingimento": 1.0363636363636364,
                                "descontoRs": 6840
                            }
                        ],
                        "clienteId": 180174,
                        "inicioMes": "2026-07-01T00:00:00"
                    },
                    {
                        "id": 1801741,
                        "codigo": "1242458",
                        "razaoSocial": "DIVA MAGNA BERNARDINO FERREIRA",
                        "aceite": true,
                        "volume": 74.25,
                        "meta": 324.38,
                        "atingimento": 0.22889820580800296,
                        "descontoRs": 0,
                        "verMais": [
                            {
                                "id": 4,
                                "codigo": "1242458",
                                "razaoSocial": "DIVA MAGNA BERNARDINO FERREIRA",
                                "produto": "Colantes",
                                "volume": 0,
                                "meta": 4,
                                "atingimento": 0,
                                "descontoRs": 0
                            },
                            {
                                "id": 3,
                                "codigo": "1242458",
                                "razaoSocial": "DIVA MAGNA BERNARDINO FERREIRA",
                                "produto": "Rejuntes",
                                "volume": 0,
                                "meta": 0.38,
                                "atingimento": 0,
                                "descontoRs": 0
                            },
                            {
                                "id": 1,
                                "codigo": "1242458",
                                "razaoSocial": "DIVA MAGNA BERNARDINO FERREIRA",
                                "produto": "Cimentos",
                                "volume": 74.25,
                                "meta": 320,
                                "atingimento": 0.23203125,
                                "descontoRs": 0
                            }
                        ],
                        "clienteId": 180174,
                        "inicioMes": "2026-08-01T00:00:00"
                    },
                    {
                        "id": 1969231,
                        "codigo": "1440065",
                        "razaoSocial": "F A F DA SILVA LTDA",
                        "aceite": true,
                        "volume": 93.199,
                        "meta": 81.6,
                        "atingimento": 1.1421446078431372,
                        "descontoRs": 812.8,
                        "verMais": [
                            {
                                "id": 2,
                                "codigo": "1440065",
                                "razaoSocial": "F A F DA SILVA LTDA",
                                "produto": "Impermeabilizantes",
                                "volume": 0.209,
                                "meta": 0.3,
                                "atingimento": 0.6966666666666667,
                                "descontoRs": 0
                            },
                            {
                                "id": 3,
                                "codigo": "1440065",
                                "razaoSocial": "F A F DA SILVA LTDA",
                                "produto": "Rejuntes",
                                "volume": 0.24,
                                "meta": 0.3,
                                "atingimento": 0.8,
                                "descontoRs": 0
                            },
                            {
                                "id": 1,
                                "codigo": "1440065",
                                "razaoSocial": "F A F DA SILVA LTDA",
                                "produto": "Cimentos",
                                "volume": 88.25,
                                "meta": 76,
                                "atingimento": 1.1611842105263157,
                                "descontoRs": 668.8
                            },
                            {
                                "id": 4,
                                "codigo": "1440065",
                                "razaoSocial": "F A F DA SILVA LTDA",
                                "produto": "Colantes",
                                "volume": 4.5,
                                "meta": 5,
                                "atingimento": 0.9,
                                "descontoRs": 144
                            }
                        ],
                        "clienteId": 196923,
                        "inicioMes": "2026-05-01T00:00:00"
                    },
                    {
                        "id": 1969231,
                        "codigo": "1440065",
                        "razaoSocial": "F A F DA SILVA LTDA",
                        "aceite": true,
                        "volume": 52.128,
                        "meta": 68.6,
                        "atingimento": 0.7598833819241984,
                        "descontoRs": 0,
                        "verMais": [
                            {
                                "id": 3,
                                "codigo": "1440065",
                                "razaoSocial": "F A F DA SILVA LTDA",
                                "produto": "Rejuntes",
                                "volume": 0.02,
                                "meta": 0.3,
                                "atingimento": 0.06666666666666667,
                                "descontoRs": 0
                            },
                            {
                                "id": 2,
                                "codigo": "1440065",
                                "razaoSocial": "F A F DA SILVA LTDA",
                                "produto": "Impermeabilizantes",
                                "volume": 0.108,
                                "meta": 0.3,
                                "atingimento": 0.36,
                                "descontoRs": 0
                            },
                            {
                                "id": 4,
                                "codigo": "1440065",
                                "razaoSocial": "F A F DA SILVA LTDA",
                                "produto": "Colantes",
                                "volume": 3.75,
                                "meta": 6,
                                "atingimento": 0.625,
                                "descontoRs": 0
                            },
                            {
                                "id": 1,
                                "codigo": "1440065",
                                "razaoSocial": "F A F DA SILVA LTDA",
                                "produto": "Cimentos",
                                "volume": 48.25,
                                "meta": 62,
                                "atingimento": 0.7782258064516129,
                                "descontoRs": 0
                            }
                        ],
                        "clienteId": 196923,
                        "inicioMes": "2026-04-01T00:00:00"
                    },
                    {
                        "id": 1969230,
                        "codigo": "1440065",
                        "razaoSocial": "F A F DA SILVA LTDA",
                        "aceite": false,
                        "volume": 0,
                        "meta": 109.47,
                        "atingimento": 0,
                        "descontoRs": 0,
                        "verMais": [
                            {
                                "id": 3,
                                "codigo": "1440065",
                                "razaoSocial": "F A F DA SILVA LTDA",
                                "produto": "Rejuntes",
                                "volume": 0,
                                "meta": 0.34,
                                "atingimento": 0,
                                "descontoRs": 0
                            },
                            {
                                "id": 2,
                                "codigo": "1440065",
                                "razaoSocial": "F A F DA SILVA LTDA",
                                "produto": "Impermeabilizantes",
                                "volume": 0,
                                "meta": 0.23,
                                "atingimento": 0,
                                "descontoRs": 0
                            },
                            {
                                "id": 4,
                                "codigo": "1440065",
                                "razaoSocial": "F A F DA SILVA LTDA",
                                "produto": "Colantes",
                                "volume": 0,
                                "meta": 6.9,
                                "atingimento": 0,
                                "descontoRs": 0
                            },
                            {
                                "id": 1,
                                "codigo": "1440065",
                                "razaoSocial": "F A F DA SILVA LTDA",
                                "produto": "Cimentos",
                                "volume": 0,
                                "meta": 102,
                                "atingimento": 0,
                                "descontoRs": 0
                            }
                        ],
                        "clienteId": 196923,
                        "inicioMes": "2026-08-01T00:00:00"
                    },
                    {
                        "id": 1969231,
                        "codigo": "1440065",
                        "razaoSocial": "F A F DA SILVA LTDA",
                        "aceite": true,
                        "volume": 94.52,
                        "meta": 86.6,
                        "atingimento": 1.0914549653579677,
                        "descontoRs": 1870,
                        "verMais": [
                            {
                                "id": 4,
                                "codigo": "1440065",
                                "razaoSocial": "F A F DA SILVA LTDA",
                                "produto": "Colantes",
                                "volume": 6.3,
                                "meta": 4,
                                "atingimento": 1.575,
                                "descontoRs": 110
                            },
                            {
                                "id": 1,
                                "codigo": "1440065",
                                "razaoSocial": "F A F DA SILVA LTDA",
                                "produto": "Cimentos",
                                "volume": 88,
                                "meta": 82,
                                "atingimento": 1.0731707317073171,
                                "descontoRs": 1760
                            },
                            {
                                "id": 2,
                                "codigo": "1440065",
                                "razaoSocial": "F A F DA SILVA LTDA",
                                "produto": "Impermeabilizantes",
                                "volume": 0,
                                "meta": 0.3,
                                "atingimento": 0,
                                "descontoRs": 0
                            },
                            {
                                "id": 3,
                                "codigo": "1440065",
                                "razaoSocial": "F A F DA SILVA LTDA",
                                "produto": "Rejuntes",
                                "volume": 0.22,
                                "meta": 0.3,
                                "atingimento": 0.7333333333333334,
                                "descontoRs": 0
                            }
                        ],
                        "clienteId": 196923,
                        "inicioMes": "2026-07-01T00:00:00"
                    },
                    {
                        "id": 1969410,
                        "codigo": "1068197",
                        "razaoSocial": "DEPOSITO MODELO LTDA",
                        "aceite": false,
                        "volume": 5,
                        "meta": 11,
                        "atingimento": 0.45454545454545453,
                        "descontoRs": 0,
                        "verMais": [
                            {
                                "id": 1,
                                "codigo": "1068197",
                                "razaoSocial": "DEPOSITO MODELO LTDA",
                                "produto": "Cimentos",
                                "volume": 5,
                                "meta": 11,
                                "atingimento": 0.45454545454545453,
                                "descontoRs": 0
                            }
                        ],
                        "clienteId": 196941,
                        "inicioMes": "2026-04-01T00:00:00"
                    },
                    {
                        "id": 1969501,
                        "codigo": "1065610",
                        "razaoSocial": "DEPOSITO ORIENTE DE MATERIAL DE",
                        "aceite": true,
                        "volume": 21.57,
                        "meta": 46.14,
                        "atingimento": 0.46749024707412223,
                        "descontoRs": 0,
                        "verMais": [
                            {
                                "id": 3,
                                "codigo": "1065610",
                                "razaoSocial": "DEPOSITO ORIENTE DE MATERIAL DE",
                                "produto": "Rejuntes",
                                "volume": 0.02,
                                "meta": 0.345,
                                "atingimento": 0.05797101449275363,
                                "descontoRs": 0
                            },
                            {
                                "id": 2,
                                "codigo": "1065610",
                                "razaoSocial": "DEPOSITO ORIENTE DE MATERIAL DE",
                                "produto": "Impermeabilizantes",
                                "volume": 0,
                                "meta": 0.345,
                                "atingimento": 0,
                                "descontoRs": 0
                            },
                            {
                                "id": 1,
                                "codigo": "1065610",
                                "razaoSocial": "DEPOSITO ORIENTE DE MATERIAL DE",
                                "produto": "Cimentos",
                                "volume": 20.5,
                                "meta": 42,
                                "atingimento": 0.4880952380952381,
                                "descontoRs": 0
                            },
                            {
                                "id": 4,
                                "codigo": "1065610",
                                "razaoSocial": "DEPOSITO ORIENTE DE MATERIAL DE",
                                "produto": "Colantes",
                                "volume": 1.05,
                                "meta": 3.45,
                                "atingimento": 0.30434782608695654,
                                "descontoRs": 0
                            }
                        ],
                        "clienteId": 196950,
                        "inicioMes": "2026-06-01T00:00:00"
                    },
                    {
                        "id": 1969500,
                        "codigo": "1065610",
                        "razaoSocial": "DEPOSITO ORIENTE DE MATERIAL DE",
                        "aceite": false,
                        "volume": 0,
                        "meta": 30.23,
                        "atingimento": 0,
                        "descontoRs": 0,
                        "verMais": [
                            {
                                "id": 2,
                                "codigo": "1065610",
                                "razaoSocial": "DEPOSITO ORIENTE DE MATERIAL DE",
                                "produto": "Impermeabilizantes",
                                "volume": 0,
                                "meta": 0.23,
                                "atingimento": 0,
                                "descontoRs": 0
                            },
                            {
                                "id": 1,
                                "codigo": "1065610",
                                "razaoSocial": "DEPOSITO ORIENTE DE MATERIAL DE",
                                "produto": "Cimentos",
                                "volume": 0,
                                "meta": 30,
                                "atingimento": 0,
                                "descontoRs": 0
                            }
                        ],
                        "clienteId": 196950,
                        "inicioMes": "2026-08-01T00:00:00"
                    },
                    {
                        "id": 1969501,
                        "codigo": "1065610",
                        "razaoSocial": "DEPOSITO ORIENTE DE MATERIAL DE",
                        "aceite": true,
                        "volume": 0,
                        "meta": 50.6,
                        "atingimento": 0,
                        "descontoRs": 0,
                        "verMais": [
                            {
                                "id": 3,
                                "codigo": "1065610",
                                "razaoSocial": "DEPOSITO ORIENTE DE MATERIAL DE",
                                "produto": "Rejuntes",
                                "volume": 0,
                                "meta": 0.3,
                                "atingimento": 0,
                                "descontoRs": 0
                            },
                            {
                                "id": 2,
                                "codigo": "1065610",
                                "razaoSocial": "DEPOSITO ORIENTE DE MATERIAL DE",
                                "produto": "Impermeabilizantes",
                                "volume": 0,
                                "meta": 0.3,
                                "atingimento": 0,
                                "descontoRs": 0
                            },
                            {
                                "id": 4,
                                "codigo": "1065610",
                                "razaoSocial": "DEPOSITO ORIENTE DE MATERIAL DE",
                                "produto": "Colantes",
                                "volume": 0,
                                "meta": 4,
                                "atingimento": 0,
                                "descontoRs": 0
                            },
                            {
                                "id": 1,
                                "codigo": "1065610",
                                "razaoSocial": "DEPOSITO ORIENTE DE MATERIAL DE",
                                "produto": "Cimentos",
                                "volume": 0,
                                "meta": 46,
                                "atingimento": 0,
                                "descontoRs": 0
                            }
                        ],
                        "clienteId": 196950,
                        "inicioMes": "2026-05-01T00:00:00"
                    },
                    {
                        "id": 1969501,
                        "codigo": "1065610",
                        "razaoSocial": "DEPOSITO ORIENTE DE MATERIAL DE",
                        "aceite": true,
                        "volume": 0,
                        "meta": 2,
                        "atingimento": 0,
                        "descontoRs": 0,
                        "verMais": [
                            {
                                "id": 4,
                                "codigo": "1065610",
                                "razaoSocial": "DEPOSITO ORIENTE DE MATERIAL DE",
                                "produto": "Colantes",
                                "volume": 0,
                                "meta": 2,
                                "atingimento": 0,
                                "descontoRs": 0
                            }
                        ],
                        "clienteId": 196950,
                        "inicioMes": "2026-07-01T00:00:00"
                    },
                    {
                        "id": 1987581,
                        "codigo": "1470574",
                        "razaoSocial": "LOJA DE MATERIAIS DE CONSTRUCAO",
                        "aceite": true,
                        "volume": 97.988,
                        "meta": 171.69,
                        "atingimento": 0.5707263090453725,
                        "descontoRs": 0,
                        "verMais": [
                            {
                                "id": 4,
                                "codigo": "1470574",
                                "razaoSocial": "LOJA DE MATERIAIS DE CONSTRUCAO",
                                "produto": "Colantes",
                                "volume": 7.8,
                                "meta": 11,
                                "atingimento": 0.7090909090909091,
                                "descontoRs": 0
                            },
                            {
                                "id": 2,
                                "codigo": "1470574",
                                "razaoSocial": "LOJA DE MATERIAIS DE CONSTRUCAO",
                                "produto": "Impermeabilizantes",
                                "volume": 0.108,
                                "meta": 0.345,
                                "atingimento": 0.3130434782608696,
                                "descontoRs": 0
                            },
                            {
                                "id": 1,
                                "codigo": "1470574",
                                "razaoSocial": "LOJA DE MATERIAIS DE CONSTRUCAO",
                                "produto": "Cimentos",
                                "volume": 90,
                                "meta": 160,
                                "atingimento": 0.5625,
                                "descontoRs": 0
                            },
                            {
                                "id": 3,
                                "codigo": "1470574",
                                "razaoSocial": "LOJA DE MATERIAIS DE CONSTRUCAO",
                                "produto": "Rejuntes",
                                "volume": 0.08,
                                "meta": 0.345,
                                "atingimento": 0.23188405797101452,
                                "descontoRs": 0
                            }
                        ],
                        "clienteId": 198758,
                        "inicioMes": "2026-05-01T00:00:00"
                    },
                    {
                        "id": 1987580,
                        "codigo": "1470574",
                        "razaoSocial": "LOJA DE MATERIAIS DE CONSTRUCAO",
                        "aceite": false,
                        "volume": 27.85,
                        "meta": 158.07,
                        "atingimento": 0.1761877649142785,
                        "descontoRs": 0,
                        "verMais": [
                            {
                                "id": 4,
                                "codigo": "1470574",
                                "razaoSocial": "LOJA DE MATERIAIS DE CONSTRUCAO",
                                "produto": "Colantes",
                                "volume": 5.85,
                                "meta": 11.5,
                                "atingimento": 0.508695652173913,
                                "descontoRs": 0
                            },
                            {
                                "id": 3,
                                "codigo": "1470574",
                                "razaoSocial": "LOJA DE MATERIAIS DE CONSTRUCAO",
                                "produto": "Rejuntes",
                                "volume": 0,
                                "meta": 0.34,
                                "atingimento": 0,
                                "descontoRs": 0
                            },
                            {
                                "id": 1,
                                "codigo": "1470574",
                                "razaoSocial": "LOJA DE MATERIAIS DE CONSTRUCAO",
                                "produto": "Cimentos",
                                "volume": 22,
                                "meta": 146,
                                "atingimento": 0.1506849315068493,
                                "descontoRs": 0
                            },
                            {
                                "id": 2,
                                "codigo": "1470574",
                                "razaoSocial": "LOJA DE MATERIAIS DE CONSTRUCAO",
                                "produto": "Impermeabilizantes",
                                "volume": 0,
                                "meta": 0.23,
                                "atingimento": 0,
                                "descontoRs": 0
                            }
                        ],
                        "clienteId": 198758,
                        "inicioMes": "2026-08-01T00:00:00"
                    },
                    {
                        "id": 1987581,
                        "codigo": "1470574",
                        "razaoSocial": "LOJA DE MATERIAIS DE CONSTRUCAO",
                        "aceite": true,
                        "volume": 153.754,
                        "meta": 172.32,
                        "atingimento": 0.8922585886722377,
                        "descontoRs": 926.64,
                        "verMais": [
                            {
                                "id": 1,
                                "codigo": "1470574",
                                "razaoSocial": "LOJA DE MATERIAIS DE CONSTRUCAO",
                                "produto": "Cimentos",
                                "volume": 132,
                                "meta": 156,
                                "atingimento": 0.8461538461538461,
                                "descontoRs": 0
                            },
                            {
                                "id": 2,
                                "codigo": "1470574",
                                "razaoSocial": "LOJA DE MATERIAIS DE CONSTRUCAO",
                                "produto": "Impermeabilizantes",
                                "volume": 0.144,
                                "meta": 0.38,
                                "atingimento": 0.3789473684210526,
                                "descontoRs": 0
                            },
                            {
                                "id": 3,
                                "codigo": "1470574",
                                "razaoSocial": "LOJA DE MATERIAIS DE CONSTRUCAO",
                                "produto": "Rejuntes",
                                "volume": 0.16,
                                "meta": 0.34,
                                "atingimento": 0.47058823529411764,
                                "descontoRs": 0
                            },
                            {
                                "id": 4,
                                "codigo": "1470574",
                                "razaoSocial": "LOJA DE MATERIAIS DE CONSTRUCAO",
                                "produto": "Colantes",
                                "volume": 21.45,
                                "meta": 15.6,
                                "atingimento": 1.375,
                                "descontoRs": 926.64
                            }
                        ],
                        "clienteId": 198758,
                        "inicioMes": "2026-07-01T00:00:00"
                    },
                    {
                        "id": 1987581,
                        "codigo": "1470574",
                        "razaoSocial": "LOJA DE MATERIAIS DE CONSTRUCAO",
                        "aceite": true,
                        "volume": 126.158,
                        "meta": 121.6,
                        "atingimento": 1.037483552631579,
                        "descontoRs": 1310,
                        "verMais": [
                            {
                                "id": 4,
                                "codigo": "1470574",
                                "razaoSocial": "LOJA DE MATERIAIS DE CONSTRUCAO",
                                "produto": "Colantes",
                                "volume": 9.75,
                                "meta": 11,
                                "atingimento": 0.8863636363636364,
                                "descontoRs": 0
                            },
                            {
                                "id": 2,
                                "codigo": "1470574",
                                "razaoSocial": "LOJA DE MATERIAIS DE CONSTRUCAO",
                                "produto": "Impermeabilizantes",
                                "volume": 0.108,
                                "meta": 0.3,
                                "atingimento": 0.36,
                                "descontoRs": 0
                            },
                            {
                                "id": 3,
                                "codigo": "1470574",
                                "razaoSocial": "LOJA DE MATERIAIS DE CONSTRUCAO",
                                "produto": "Rejuntes",
                                "volume": 0.3,
                                "meta": 0.3,
                                "atingimento": 1,
                                "descontoRs": 150
                            },
                            {
                                "id": 1,
                                "codigo": "1470574",
                                "razaoSocial": "LOJA DE MATERIAIS DE CONSTRUCAO",
                                "produto": "Cimentos",
                                "volume": 116,
                                "meta": 110,
                                "atingimento": 1.0545454545454545,
                                "descontoRs": 1160
                            }
                        ],
                        "clienteId": 198758,
                        "inicioMes": "2026-04-01T00:00:00"
                    },
                    {
                        "id": 11272560,
                        "codigo": "1902724",
                        "razaoSocial": "FRANCISCA ERLANIA DA SILVA",
                        "aceite": false,
                        "volume": 8.5,
                        "meta": 18.34,
                        "atingimento": 0.46346782988004365,
                        "descontoRs": 0,
                        "verMais": [
                            {
                                "id": 1,
                                "codigo": "1902724",
                                "razaoSocial": "FRANCISCA ERLANIA DA SILVA",
                                "produto": "Cimentos",
                                "volume": 8.5,
                                "meta": 18,
                                "atingimento": 0.4722222222222222,
                                "descontoRs": 0
                            },
                            {
                                "id": 2,
                                "codigo": "1902724",
                                "razaoSocial": "FRANCISCA ERLANIA DA SILVA",
                                "produto": "Impermeabilizantes",
                                "volume": 0,
                                "meta": 0.34,
                                "atingimento": 0,
                                "descontoRs": 0
                            }
                        ],
                        "clienteId": 1127256,
                        "inicioMes": "2026-07-01T00:00:00"
                    },
                    {
                        "id": 11307391,
                        "codigo": "1905118",
                        "razaoSocial": "CEARA CIMENTOS E MATERIAIS PARA",
                        "aceite": true,
                        "volume": 260.2,
                        "meta": 234.68,
                        "atingimento": 1.1087438213737855,
                        "descontoRs": 4140.8,
                        "verMais": [
                            {
                                "id": 2,
                                "codigo": "1905118",
                                "razaoSocial": "CEARA CIMENTOS E MATERIAIS PARA",
                                "produto": "Impermeabilizantes",
                                "volume": 0,
                                "meta": 0.3,
                                "atingimento": 0,
                                "descontoRs": 0
                            },
                            {
                                "id": 1,
                                "codigo": "1905118",
                                "razaoSocial": "CEARA CIMENTOS E MATERIAIS PARA",
                                "produto": "Cimentos",
                                "volume": 250,
                                "meta": 230,
                                "atingimento": 1.0869565217391304,
                                "descontoRs": 4000
                            },
                            {
                                "id": 3,
                                "codigo": "1905118",
                                "razaoSocial": "CEARA CIMENTOS E MATERIAIS PARA",
                                "produto": "Rejuntes",
                                "volume": 0.2,
                                "meta": 0.38,
                                "atingimento": 0.5263157894736842,
                                "descontoRs": 0
                            },
                            {
                                "id": 4,
                                "codigo": "1905118",
                                "razaoSocial": "CEARA CIMENTOS E MATERIAIS PARA",
                                "produto": "Colantes",
                                "volume": 10,
                                "meta": 4,
                                "atingimento": 2.5,
                                "descontoRs": 140.8
                            }
                        ],
                        "clienteId": 1130739,
                        "inicioMes": "2026-05-01T00:00:00"
                    },
                    {
                        "id": 11307391,
                        "codigo": "1905118",
                        "razaoSocial": "CEARA CIMENTOS E MATERIAIS PARA",
                        "aceite": true,
                        "volume": 238.1,
                        "meta": 263.6,
                        "atingimento": 0.9032625189681335,
                        "descontoRs": 4760,
                        "verMais": [
                            {
                                "id": 3,
                                "codigo": "1905118",
                                "razaoSocial": "CEARA CIMENTOS E MATERIAIS PARA",
                                "produto": "Rejuntes",
                                "volume": 0.1,
                                "meta": 0.3,
                                "atingimento": 0.33333333333333337,
                                "descontoRs": 0
                            },
                            {
                                "id": 2,
                                "codigo": "1905118",
                                "razaoSocial": "CEARA CIMENTOS E MATERIAIS PARA",
                                "produto": "Impermeabilizantes",
                                "volume": 0,
                                "meta": 0.3,
                                "atingimento": 0,
                                "descontoRs": 0
                            },
                            {
                                "id": 1,
                                "codigo": "1905118",
                                "razaoSocial": "CEARA CIMENTOS E MATERIAIS PARA",
                                "produto": "Cimentos",
                                "volume": 238,
                                "meta": 250,
                                "atingimento": 0.952,
                                "descontoRs": 4760
                            },
                            {
                                "id": 4,
                                "codigo": "1905118",
                                "razaoSocial": "CEARA CIMENTOS E MATERIAIS PARA",
                                "produto": "Colantes",
                                "volume": 0,
                                "meta": 13,
                                "atingimento": 0,
                                "descontoRs": 0
                            }
                        ],
                        "clienteId": 1130739,
                        "inicioMes": "2026-06-01T00:00:00"
                    },
                    {
                        "id": 11307391,
                        "codigo": "1905118",
                        "razaoSocial": "CEARA CIMENTOS E MATERIAIS PARA",
                        "aceite": true,
                        "volume": 70.02,
                        "meta": 260.5,
                        "atingimento": 0.26879078694817654,
                        "descontoRs": 0,
                        "verMais": [
                            {
                                "id": 3,
                                "codigo": "1905118",
                                "razaoSocial": "CEARA CIMENTOS E MATERIAIS PARA",
                                "produto": "Rejuntes",
                                "volume": 0.02,
                                "meta": 0.3,
                                "atingimento": 0.06666666666666667,
                                "descontoRs": 0
                            },
                            {
                                "id": 4,
                                "codigo": "1905118",
                                "razaoSocial": "CEARA CIMENTOS E MATERIAIS PARA",
                                "produto": "Colantes",
                                "volume": 0,
                                "meta": 10,
                                "atingimento": 0,
                                "descontoRs": 0
                            },
                            {
                                "id": 1,
                                "codigo": "1905118",
                                "razaoSocial": "CEARA CIMENTOS E MATERIAIS PARA",
                                "produto": "Cimentos",
                                "volume": 70,
                                "meta": 250,
                                "atingimento": 0.28,
                                "descontoRs": 0
                            },
                            {
                                "id": 2,
                                "codigo": "1905118",
                                "razaoSocial": "CEARA CIMENTOS E MATERIAIS PARA",
                                "produto": "Impermeabilizantes",
                                "volume": 0,
                                "meta": 0.2,
                                "atingimento": 0,
                                "descontoRs": 0
                            }
                        ],
                        "clienteId": 1130739,
                        "inicioMes": "2026-08-01T00:00:00"
                    },
                    {
                        "id": 1968710,
                        "codigo": "1350726",
                        "razaoSocial": "A M E MATERIAIS DE CONSTRUCAO LTDA",
                        "aceite": false,
                        "volume": 0.9,
                        "meta": 3.45,
                        "atingimento": 0.2608695652173913,
                        "descontoRs": 0,
                        "verMais": [
                            {
                                "id": 4,
                                "codigo": "1350726",
                                "razaoSocial": "A M E MATERIAIS DE CONSTRUCAO LTDA",
                                "produto": "Colantes",
                                "volume": 0.9,
                                "meta": 3.45,
                                "atingimento": 0.2608695652173913,
                                "descontoRs": 0
                            }
                        ],
                        "clienteId": 196871,
                        "inicioMes": "2026-07-01T00:00:00"
                    },
                    {
                        "id": 1968720,
                        "codigo": "1070791",
                        "razaoSocial": "FRANCISCA OTILIA DOS SANTOS SAMPAIO",
                        "aceite": false,
                        "volume": 5,
                        "meta": 19,
                        "atingimento": 0.2631578947368421,
                        "descontoRs": 0,
                        "verMais": [
                            {
                                "id": 1,
                                "codigo": "1070791",
                                "razaoSocial": "FRANCISCA OTILIA DOS SANTOS SAMPAIO",
                                "produto": "Cimentos",
                                "volume": 5,
                                "meta": 19,
                                "atingimento": 0.2631578947368421,
                                "descontoRs": 0
                            }
                        ],
                        "clienteId": 196872,
                        "inicioMes": "2026-04-01T00:00:00"
                    },
                    {
                        "id": 1968870,
                        "codigo": "1292000",
                        "razaoSocial": "SILVIO JOSE DE CASTRO SOUZA",
                        "grupoCentralizador": "CONSTRUCASTRO",
                        "aceite": false,
                        "volume": 0,
                        "meta": 28,
                        "atingimento": 0,
                        "descontoRs": 0,
                        "verMais": [
                            {
                                "id": 1,
                                "codigo": "1292000",
                                "razaoSocial": "SILVIO JOSE DE CASTRO SOUZA",
                                "grupoCentralizador": "CONSTRUCASTRO",
                                "produto": "Cimentos",
                                "volume": 0,
                                "meta": 28,
                                "atingimento": 0,
                                "descontoRs": 0
                            }
                        ],
                        "clienteId": 196887,
                        "inicioMes": "2026-04-01T00:00:00"
                    },
                    {
                        "id": 1801760,
                        "codigo": "1070059",
                        "razaoSocial": "DEIZIANE CHAVES BEZERRA",
                        "grupoCentralizador": "CONSTRUCASTRO",
                        "aceite": false,
                        "volume": 0,
                        "meta": 14,
                        "atingimento": 0,
                        "descontoRs": 0,
                        "verMais": [
                            {
                                "id": 1,
                                "codigo": "1070059",
                                "razaoSocial": "DEIZIANE CHAVES BEZERRA",
                                "grupoCentralizador": "CONSTRUCASTRO",
                                "produto": "Cimentos",
                                "volume": 0,
                                "meta": 14,
                                "atingimento": 0,
                                "descontoRs": 0
                            }
                        ],
                        "clienteId": 180176,
                        "inicioMes": "2026-04-01T00:00:00"
                    },
                    {
                        "id": 1764881,
                        "codigo": "1729941",
                        "razaoSocial": "ALM COMERCIO CONSTRUCOES E",
                        "grupoCentralizador": "IMPERIO DO CIMENTO",
                        "aceite": true,
                        "volume": 253.7,
                        "meta": 282.44000000000005,
                        "atingimento": 0.8982438748052681,
                        "descontoRs": 5544,
                        "verMais": [
                            {
                                "id": 3,
                                "codigo": "1729941",
                                "razaoSocial": "ALM COMERCIO CONSTRUCOES E",
                                "grupoCentralizador": "IMPERIO DO CIMENTO",
                                "produto": "Rejuntes",
                                "volume": 0.08,
                                "meta": 0.345,
                                "atingimento": 0.23188405797101452,
                                "descontoRs": 0
                            },
                            {
                                "id": 4,
                                "codigo": "1729941",
                                "razaoSocial": "ALM COMERCIO CONSTRUCOES E",
                                "grupoCentralizador": "IMPERIO DO CIMENTO",
                                "produto": "Colantes",
                                "volume": 1.62,
                                "meta": 5.75,
                                "atingimento": 0.2817391304347826,
                                "descontoRs": 0
                            },
                            {
                                "id": 1,
                                "codigo": "1729941",
                                "razaoSocial": "ALM COMERCIO CONSTRUCOES E",
                                "grupoCentralizador": "IMPERIO DO CIMENTO",
                                "produto": "Cimentos",
                                "volume": 252,
                                "meta": 276,
                                "atingimento": 0.9130434782608695,
                                "descontoRs": 5544
                            },
                            {
                                "id": 2,
                                "codigo": "1729941",
                                "razaoSocial": "ALM COMERCIO CONSTRUCOES E",
                                "grupoCentralizador": "IMPERIO DO CIMENTO",
                                "produto": "Impermeabilizantes",
                                "volume": 0,
                                "meta": 0.345,
                                "atingimento": 0,
                                "descontoRs": 0
                            }
                        ],
                        "clienteId": 176488,
                        "inicioMes": "2026-06-01T00:00:00"
                    },
                    {
                        "id": 1764881,
                        "codigo": "1729941",
                        "razaoSocial": "ALM COMERCIO CONSTRUCOES E",
                        "grupoCentralizador": "IMPERIO DO CIMENTO",
                        "aceite": true,
                        "volume": 251.228,
                        "meta": 284.6,
                        "atingimento": 0.8827406886858749,
                        "descontoRs": 0,
                        "verMais": [
                            {
                                "id": 4,
                                "codigo": "1729941",
                                "razaoSocial": "ALM COMERCIO CONSTRUCOES E",
                                "grupoCentralizador": "IMPERIO DO CIMENTO",
                                "produto": "Colantes",
                                "volume": 3.12,
                                "meta": 4,
                                "atingimento": 0.78,
                                "descontoRs": 0
                            },
                            {
                                "id": 3,
                                "codigo": "1729941",
                                "razaoSocial": "ALM COMERCIO CONSTRUCOES E",
                                "grupoCentralizador": "IMPERIO DO CIMENTO",
                                "produto": "Rejuntes",
                                "volume": 0,
                                "meta": 0.3,
                                "atingimento": 0,
                                "descontoRs": 0
                            },
                            {
                                "id": 1,
                                "codigo": "1729941",
                                "razaoSocial": "ALM COMERCIO CONSTRUCOES E",
                                "grupoCentralizador": "IMPERIO DO CIMENTO",
                                "produto": "Cimentos",
                                "volume": 248,
                                "meta": 280,
                                "atingimento": 0.8857142857142857,
                                "descontoRs": 0
                            },
                            {
                                "id": 2,
                                "codigo": "1729941",
                                "razaoSocial": "ALM COMERCIO CONSTRUCOES E",
                                "grupoCentralizador": "IMPERIO DO CIMENTO",
                                "produto": "Impermeabilizantes",
                                "volume": 0.108,
                                "meta": 0.3,
                                "atingimento": 0.36,
                                "descontoRs": 0
                            }
                        ],
                        "clienteId": 176488,
                        "inicioMes": "2026-05-01T00:00:00"
                    },
                    {
                        "id": 1764880,
                        "codigo": "1729941",
                        "razaoSocial": "ALM COMERCIO CONSTRUCOES E",
                        "grupoCentralizador": "IMPERIO DO CIMENTO",
                        "aceite": false,
                        "volume": 1.1340000000000001,
                        "meta": 5.17,
                        "atingimento": 0.2193423597678917,
                        "descontoRs": 0,
                        "verMais": [
                            {
                                "id": 3,
                                "codigo": "1729941",
                                "razaoSocial": "ALM COMERCIO CONSTRUCOES E",
                                "grupoCentralizador": "IMPERIO DO CIMENTO",
                                "produto": "Rejuntes",
                                "volume": 0,
                                "meta": 0.34,
                                "atingimento": 0,
                                "descontoRs": 0
                            },
                            {
                                "id": 4,
                                "codigo": "1729941",
                                "razaoSocial": "ALM COMERCIO CONSTRUCOES E",
                                "grupoCentralizador": "IMPERIO DO CIMENTO",
                                "produto": "Colantes",
                                "volume": 1.08,
                                "meta": 4.6,
                                "atingimento": 0.2347826086956522,
                                "descontoRs": 0
                            },
                            {
                                "id": 2,
                                "codigo": "1729941",
                                "razaoSocial": "ALM COMERCIO CONSTRUCOES E",
                                "grupoCentralizador": "IMPERIO DO CIMENTO",
                                "produto": "Impermeabilizantes",
                                "volume": 0.054,
                                "meta": 0.23,
                                "atingimento": 0.23478260869565215,
                                "descontoRs": 0
                            }
                        ],
                        "clienteId": 176488,
                        "inicioMes": "2026-08-01T00:00:00"
                    },
                    {
                        "id": 274131,
                        "codigo": "1598847",
                        "razaoSocial": "DISTRIBUIDORA IMPERIO DO CIMENTO",
                        "grupoCentralizador": "IMPERIO DO CIMENTO",
                        "aceite": true,
                        "volume": 14.245,
                        "meta": 224.6,
                        "atingimento": 0.06342386464826358,
                        "descontoRs": 0,
                        "verMais": [
                            {
                                "id": 3,
                                "codigo": "1598847",
                                "razaoSocial": "DISTRIBUIDORA IMPERIO DO CIMENTO",
                                "grupoCentralizador": "IMPERIO DO CIMENTO",
                                "produto": "Rejuntes",
                                "volume": 0.02,
                                "meta": 0.3,
                                "atingimento": 0.06666666666666667,
                                "descontoRs": 0
                            },
                            {
                                "id": 2,
                                "codigo": "1598847",
                                "razaoSocial": "DISTRIBUIDORA IMPERIO DO CIMENTO",
                                "grupoCentralizador": "IMPERIO DO CIMENTO",
                                "produto": "Impermeabilizantes",
                                "volume": 0,
                                "meta": 0.3,
                                "atingimento": 0,
                                "descontoRs": 0
                            },
                            {
                                "id": 1,
                                "codigo": "1598847",
                                "razaoSocial": "DISTRIBUIDORA IMPERIO DO CIMENTO",
                                "grupoCentralizador": "IMPERIO DO CIMENTO",
                                "produto": "Cimentos",
                                "volume": 14,
                                "meta": 220,
                                "atingimento": 0.06363636363636363,
                                "descontoRs": 0
                            },
                            {
                                "id": 4,
                                "codigo": "1598847",
                                "razaoSocial": "DISTRIBUIDORA IMPERIO DO CIMENTO",
                                "grupoCentralizador": "IMPERIO DO CIMENTO",
                                "produto": "Colantes",
                                "volume": 0.225,
                                "meta": 4,
                                "atingimento": 0.05625,
                                "descontoRs": 0
                            }
                        ],
                        "clienteId": 27413,
                        "inicioMes": "2026-07-01T00:00:00"
                    },
                    {
                        "id": 274131,
                        "codigo": "1598847",
                        "razaoSocial": "DISTRIBUIDORA IMPERIO DO CIMENTO",
                        "grupoCentralizador": "IMPERIO DO CIMENTO",
                        "aceite": true,
                        "volume": 14.036,
                        "meta": 315.6,
                        "atingimento": 0.044474017743979716,
                        "descontoRs": 0,
                        "verMais": [
                            {
                                "id": 4,
                                "codigo": "1598847",
                                "razaoSocial": "DISTRIBUIDORA IMPERIO DO CIMENTO",
                                "grupoCentralizador": "IMPERIO DO CIMENTO",
                                "produto": "Colantes",
                                "volume": 0,
                                "meta": 5,
                                "atingimento": 0,
                                "descontoRs": 0
                            },
                            {
                                "id": 2,
                                "codigo": "1598847",
                                "razaoSocial": "DISTRIBUIDORA IMPERIO DO CIMENTO",
                                "grupoCentralizador": "IMPERIO DO CIMENTO",
                                "produto": "Impermeabilizantes",
                                "volume": 0.036,
                                "meta": 0.3,
                                "atingimento": 0.12,
                                "descontoRs": 0
                            },
                            {
                                "id": 3,
                                "codigo": "1598847",
                                "razaoSocial": "DISTRIBUIDORA IMPERIO DO CIMENTO",
                                "grupoCentralizador": "IMPERIO DO CIMENTO",
                                "produto": "Rejuntes",
                                "volume": 0,
                                "meta": 0.3,
                                "atingimento": 0,
                                "descontoRs": 0
                            },
                            {
                                "id": 1,
                                "codigo": "1598847",
                                "razaoSocial": "DISTRIBUIDORA IMPERIO DO CIMENTO",
                                "grupoCentralizador": "IMPERIO DO CIMENTO",
                                "produto": "Cimentos",
                                "volume": 14,
                                "meta": 310,
                                "atingimento": 0.04516129032258064,
                                "descontoRs": 0
                            }
                        ],
                        "clienteId": 27413,
                        "inicioMes": "2026-04-01T00:00:00"
                    },
                    {
                        "id": 578451,
                        "codigo": "1508834",
                        "razaoSocial": "FORTE COMERCIO DE MATERIAL DE",
                        "grupoCentralizador": "FORTE COMERCIO",
                        "aceite": true,
                        "volume": 94,
                        "meta": 255.6,
                        "atingimento": 0.36776212832550864,
                        "descontoRs": 0,
                        "verMais": [
                            {
                                "id": 3,
                                "codigo": "1508834",
                                "razaoSocial": "FORTE COMERCIO DE MATERIAL DE",
                                "grupoCentralizador": "FORTE COMERCIO",
                                "produto": "Rejuntes",
                                "volume": 0,
                                "meta": 0.3,
                                "atingimento": 0,
                                "descontoRs": 0
                            },
                            {
                                "id": 4,
                                "codigo": "1508834",
                                "razaoSocial": "FORTE COMERCIO DE MATERIAL DE",
                                "grupoCentralizador": "FORTE COMERCIO",
                                "produto": "Colantes",
                                "volume": 0,
                                "meta": 5,
                                "atingimento": 0,
                                "descontoRs": 0
                            },
                            {
                                "id": 2,
                                "codigo": "1508834",
                                "razaoSocial": "FORTE COMERCIO DE MATERIAL DE",
                                "grupoCentralizador": "FORTE COMERCIO",
                                "produto": "Impermeabilizantes",
                                "volume": 0,
                                "meta": 0.3,
                                "atingimento": 0,
                                "descontoRs": 0
                            },
                            {
                                "id": 1,
                                "codigo": "1508834",
                                "razaoSocial": "FORTE COMERCIO DE MATERIAL DE",
                                "grupoCentralizador": "FORTE COMERCIO",
                                "produto": "Cimentos",
                                "volume": 94,
                                "meta": 250,
                                "atingimento": 0.376,
                                "descontoRs": 0
                            }
                        ],
                        "clienteId": 57845,
                        "inicioMes": "2026-06-01T00:00:00"
                    },
                    {
                        "id": 578451,
                        "codigo": "1508834",
                        "razaoSocial": "FORTE COMERCIO DE MATERIAL DE",
                        "grupoCentralizador": "FORTE COMERCIO",
                        "aceite": true,
                        "volume": 196,
                        "meta": 256.6,
                        "atingimento": 0.7638347622759157,
                        "descontoRs": 0,
                        "verMais": [
                            {
                                "id": 3,
                                "codigo": "1508834",
                                "razaoSocial": "FORTE COMERCIO DE MATERIAL DE",
                                "grupoCentralizador": "FORTE COMERCIO",
                                "produto": "Rejuntes",
                                "volume": 0,
                                "meta": 0.3,
                                "atingimento": 0,
                                "descontoRs": 0
                            },
                            {
                                "id": 4,
                                "codigo": "1508834",
                                "razaoSocial": "FORTE COMERCIO DE MATERIAL DE",
                                "grupoCentralizador": "FORTE COMERCIO",
                                "produto": "Colantes",
                                "volume": 0,
                                "meta": 6,
                                "atingimento": 0,
                                "descontoRs": 0
                            },
                            {
                                "id": 2,
                                "codigo": "1508834",
                                "razaoSocial": "FORTE COMERCIO DE MATERIAL DE",
                                "grupoCentralizador": "FORTE COMERCIO",
                                "produto": "Impermeabilizantes",
                                "volume": 0,
                                "meta": 0.3,
                                "atingimento": 0,
                                "descontoRs": 0
                            },
                            {
                                "id": 1,
                                "codigo": "1508834",
                                "razaoSocial": "FORTE COMERCIO DE MATERIAL DE",
                                "grupoCentralizador": "FORTE COMERCIO",
                                "produto": "Cimentos",
                                "volume": 196,
                                "meta": 250,
                                "atingimento": 0.784,
                                "descontoRs": 0
                            }
                        ],
                        "clienteId": 57845,
                        "inicioMes": "2026-04-01T00:00:00"
                    },
                    {
                        "id": 578451,
                        "codigo": "1508834",
                        "razaoSocial": "FORTE COMERCIO DE MATERIAL DE",
                        "grupoCentralizador": "FORTE COMERCIO",
                        "aceite": true,
                        "volume": 84,
                        "meta": 254.6,
                        "atingimento": 0.32992930086410055,
                        "descontoRs": 0,
                        "verMais": [
                            {
                                "id": 4,
                                "codigo": "1508834",
                                "razaoSocial": "FORTE COMERCIO DE MATERIAL DE",
                                "grupoCentralizador": "FORTE COMERCIO",
                                "produto": "Colantes",
                                "volume": 0,
                                "meta": 4,
                                "atingimento": 0,
                                "descontoRs": 0
                            },
                            {
                                "id": 2,
                                "codigo": "1508834",
                                "razaoSocial": "FORTE COMERCIO DE MATERIAL DE",
                                "grupoCentralizador": "FORTE COMERCIO",
                                "produto": "Impermeabilizantes",
                                "volume": 0,
                                "meta": 0.3,
                                "atingimento": 0,
                                "descontoRs": 0
                            },
                            {
                                "id": 3,
                                "codigo": "1508834",
                                "razaoSocial": "FORTE COMERCIO DE MATERIAL DE",
                                "grupoCentralizador": "FORTE COMERCIO",
                                "produto": "Rejuntes",
                                "volume": 0,
                                "meta": 0.3,
                                "atingimento": 0,
                                "descontoRs": 0
                            },
                            {
                                "id": 1,
                                "codigo": "1508834",
                                "razaoSocial": "FORTE COMERCIO DE MATERIAL DE",
                                "grupoCentralizador": "FORTE COMERCIO",
                                "produto": "Cimentos",
                                "volume": 84,
                                "meta": 250,
                                "atingimento": 0.336,
                                "descontoRs": 0
                            }
                        ],
                        "clienteId": 57845,
                        "inicioMes": "2026-05-01T00:00:00"
                    },
                    {
                        "id": 578451,
                        "codigo": "1508834",
                        "razaoSocial": "FORTE COMERCIO DE MATERIAL DE",
                        "grupoCentralizador": "FORTE COMERCIO",
                        "aceite": true,
                        "volume": 0,
                        "meta": 250.2,
                        "atingimento": 0,
                        "descontoRs": 0,
                        "verMais": [
                            {
                                "id": 2,
                                "codigo": "1508834",
                                "razaoSocial": "FORTE COMERCIO DE MATERIAL DE",
                                "grupoCentralizador": "FORTE COMERCIO",
                                "produto": "Impermeabilizantes",
                                "volume": 0,
                                "meta": 0.2,
                                "atingimento": 0,
                                "descontoRs": 0
                            },
                            {
                                "id": 1,
                                "codigo": "1508834",
                                "razaoSocial": "FORTE COMERCIO DE MATERIAL DE",
                                "grupoCentralizador": "FORTE COMERCIO",
                                "produto": "Cimentos",
                                "volume": 0,
                                "meta": 250,
                                "atingimento": 0,
                                "descontoRs": 0
                            }
                        ],
                        "clienteId": 57845,
                        "inicioMes": "2026-08-01T00:00:00"
                    },
                    {
                        "id": 578451,
                        "codigo": "1508834",
                        "razaoSocial": "FORTE COMERCIO DE MATERIAL DE",
                        "grupoCentralizador": "FORTE COMERCIO",
                        "aceite": true,
                        "volume": 104,
                        "meta": 250,
                        "atingimento": 0.416,
                        "descontoRs": 0,
                        "verMais": [
                            {
                                "id": 1,
                                "codigo": "1508834",
                                "razaoSocial": "FORTE COMERCIO DE MATERIAL DE",
                                "grupoCentralizador": "FORTE COMERCIO",
                                "produto": "Cimentos",
                                "volume": 104,
                                "meta": 250,
                                "atingimento": 0.416,
                                "descontoRs": 0
                            }
                        ],
                        "clienteId": 57845,
                        "inicioMes": "2026-07-01T00:00:00"
                    },
                    {
                        "id": 645071,
                        "codigo": "1710051",
                        "razaoSocial": "COMERCIAL AVENIDA MATERIAIS DE",
                        "grupoCentralizador": "COMERCIAL AVENIDA",
                        "aceite": true,
                        "volume": 56.32,
                        "meta": 59.5,
                        "atingimento": 0.9465546218487395,
                        "descontoRs": 1120,
                        "verMais": [
                            {
                                "id": 1,
                                "codigo": "1710051",
                                "razaoSocial": "COMERCIAL AVENIDA MATERIAIS DE",
                                "grupoCentralizador": "COMERCIAL AVENIDA",
                                "produto": "Cimentos",
                                "volume": 56,
                                "meta": 54,
                                "atingimento": 1.037037037037037,
                                "descontoRs": 1120
                            },
                            {
                                "id": 3,
                                "codigo": "1710051",
                                "razaoSocial": "COMERCIAL AVENIDA MATERIAIS DE",
                                "grupoCentralizador": "COMERCIAL AVENIDA",
                                "produto": "Rejuntes",
                                "volume": 0.02,
                                "meta": 0.3,
                                "atingimento": 0.06666666666666667,
                                "descontoRs": 0
                            },
                            {
                                "id": 4,
                                "codigo": "1710051",
                                "razaoSocial": "COMERCIAL AVENIDA MATERIAIS DE",
                                "grupoCentralizador": "COMERCIAL AVENIDA",
                                "produto": "Colantes",
                                "volume": 0.3,
                                "meta": 5.2,
                                "atingimento": 0.05769230769230769,
                                "descontoRs": 0
                            }
                        ],
                        "clienteId": 64507,
                        "inicioMes": "2026-07-01T00:00:00"
                    },
                    {
                        "id": 645071,
                        "codigo": "1710051",
                        "razaoSocial": "COMERCIAL AVENIDA MATERIAIS DE",
                        "grupoCentralizador": "COMERCIAL AVENIDA",
                        "aceite": true,
                        "volume": 14,
                        "meta": 52.5,
                        "atingimento": 0.26666666666666666,
                        "descontoRs": 0,
                        "verMais": [
                            {
                                "id": 1,
                                "codigo": "1710051",
                                "razaoSocial": "COMERCIAL AVENIDA MATERIAIS DE",
                                "grupoCentralizador": "COMERCIAL AVENIDA",
                                "produto": "Cimentos",
                                "volume": 14,
                                "meta": 48,
                                "atingimento": 0.2916666666666667,
                                "descontoRs": 0
                            },
                            {
                                "id": 4,
                                "codigo": "1710051",
                                "razaoSocial": "COMERCIAL AVENIDA MATERIAIS DE",
                                "grupoCentralizador": "COMERCIAL AVENIDA",
                                "produto": "Colantes",
                                "volume": 0,
                                "meta": 4,
                                "atingimento": 0,
                                "descontoRs": 0
                            },
                            {
                                "id": 3,
                                "codigo": "1710051",
                                "razaoSocial": "COMERCIAL AVENIDA MATERIAIS DE",
                                "grupoCentralizador": "COMERCIAL AVENIDA",
                                "produto": "Rejuntes",
                                "volume": 0,
                                "meta": 0.3,
                                "atingimento": 0,
                                "descontoRs": 0
                            },
                            {
                                "id": 2,
                                "codigo": "1710051",
                                "razaoSocial": "COMERCIAL AVENIDA MATERIAIS DE",
                                "grupoCentralizador": "COMERCIAL AVENIDA",
                                "produto": "Impermeabilizantes",
                                "volume": 0,
                                "meta": 0.2,
                                "atingimento": 0,
                                "descontoRs": 0
                            }
                        ],
                        "clienteId": 64507,
                        "inicioMes": "2026-08-01T00:00:00"
                    },
                    {
                        "id": 645071,
                        "codigo": "1710051",
                        "razaoSocial": "COMERCIAL AVENIDA MATERIAIS DE",
                        "grupoCentralizador": "COMERCIAL AVENIDA",
                        "aceite": true,
                        "volume": 28,
                        "meta": 73.28999999999999,
                        "atingimento": 0.3820439350525311,
                        "descontoRs": 0,
                        "verMais": [
                            {
                                "id": 4,
                                "codigo": "1710051",
                                "razaoSocial": "COMERCIAL AVENIDA MATERIAIS DE",
                                "grupoCentralizador": "COMERCIAL AVENIDA",
                                "produto": "Colantes",
                                "volume": 0,
                                "meta": 4.6,
                                "atingimento": 0,
                                "descontoRs": 0
                            },
                            {
                                "id": 2,
                                "codigo": "1710051",
                                "razaoSocial": "COMERCIAL AVENIDA MATERIAIS DE",
                                "grupoCentralizador": "COMERCIAL AVENIDA",
                                "produto": "Impermeabilizantes",
                                "volume": 0,
                                "meta": 0.345,
                                "atingimento": 0,
                                "descontoRs": 0
                            },
                            {
                                "id": 1,
                                "codigo": "1710051",
                                "razaoSocial": "COMERCIAL AVENIDA MATERIAIS DE",
                                "grupoCentralizador": "COMERCIAL AVENIDA",
                                "produto": "Cimentos",
                                "volume": 28,
                                "meta": 68,
                                "atingimento": 0.4117647058823529,
                                "descontoRs": 0
                            },
                            {
                                "id": 3,
                                "codigo": "1710051",
                                "razaoSocial": "COMERCIAL AVENIDA MATERIAIS DE",
                                "grupoCentralizador": "COMERCIAL AVENIDA",
                                "produto": "Rejuntes",
                                "volume": 0,
                                "meta": 0.345,
                                "atingimento": 0,
                                "descontoRs": 0
                            }
                        ],
                        "clienteId": 64507,
                        "inicioMes": "2026-05-01T00:00:00"
                    },
                    {
                        "id": 645071,
                        "codigo": "1710051",
                        "razaoSocial": "COMERCIAL AVENIDA MATERIAIS DE",
                        "grupoCentralizador": "COMERCIAL AVENIDA",
                        "aceite": true,
                        "volume": 42.45,
                        "meta": 66.6,
                        "atingimento": 0.6373873873873875,
                        "descontoRs": 0,
                        "verMais": [
                            {
                                "id": 4,
                                "codigo": "1710051",
                                "razaoSocial": "COMERCIAL AVENIDA MATERIAIS DE",
                                "grupoCentralizador": "COMERCIAL AVENIDA",
                                "produto": "Colantes",
                                "volume": 0.45,
                                "meta": 4,
                                "atingimento": 0.1125,
                                "descontoRs": 0
                            },
                            {
                                "id": 2,
                                "codigo": "1710051",
                                "razaoSocial": "COMERCIAL AVENIDA MATERIAIS DE",
                                "grupoCentralizador": "COMERCIAL AVENIDA",
                                "produto": "Impermeabilizantes",
                                "volume": 0,
                                "meta": 0.3,
                                "atingimento": 0,
                                "descontoRs": 0
                            },
                            {
                                "id": 3,
                                "codigo": "1710051",
                                "razaoSocial": "COMERCIAL AVENIDA MATERIAIS DE",
                                "grupoCentralizador": "COMERCIAL AVENIDA",
                                "produto": "Rejuntes",
                                "volume": 0,
                                "meta": 0.3,
                                "atingimento": 0,
                                "descontoRs": 0
                            },
                            {
                                "id": 1,
                                "codigo": "1710051",
                                "razaoSocial": "COMERCIAL AVENIDA MATERIAIS DE",
                                "grupoCentralizador": "COMERCIAL AVENIDA",
                                "produto": "Cimentos",
                                "volume": 42,
                                "meta": 62,
                                "atingimento": 0.6774193548387096,
                                "descontoRs": 0
                            }
                        ],
                        "clienteId": 64507,
                        "inicioMes": "2026-04-01T00:00:00"
                    },
                    {
                        "id": 3275951,
                        "codigo": "1067668",
                        "razaoSocial": "LEONCIO MATERIAIS DE CONSTRUCAO E C",
                        "grupoCentralizador": "GLAISON ALMEIDA",
                        "aceite": true,
                        "volume": 97.9,
                        "meta": 254.6,
                        "atingimento": 0.3845247446975648,
                        "descontoRs": 0,
                        "verMais": [
                            {
                                "id": 3,
                                "codigo": "1067668",
                                "razaoSocial": "LEONCIO MATERIAIS DE CONSTRUCAO E C",
                                "grupoCentralizador": "GLAISON ALMEIDA",
                                "produto": "Rejuntes",
                                "volume": 0,
                                "meta": 0.3,
                                "atingimento": 0,
                                "descontoRs": 0
                            },
                            {
                                "id": 2,
                                "codigo": "1067668",
                                "razaoSocial": "LEONCIO MATERIAIS DE CONSTRUCAO E C",
                                "grupoCentralizador": "GLAISON ALMEIDA",
                                "produto": "Impermeabilizantes",
                                "volume": 0,
                                "meta": 0.3,
                                "atingimento": 0,
                                "descontoRs": 0
                            },
                            {
                                "id": 4,
                                "codigo": "1067668",
                                "razaoSocial": "LEONCIO MATERIAIS DE CONSTRUCAO E C",
                                "grupoCentralizador": "GLAISON ALMEIDA",
                                "produto": "Colantes",
                                "volume": 1.65,
                                "meta": 4,
                                "atingimento": 0.4125,
                                "descontoRs": 0
                            },
                            {
                                "id": 1,
                                "codigo": "1067668",
                                "razaoSocial": "LEONCIO MATERIAIS DE CONSTRUCAO E C",
                                "grupoCentralizador": "GLAISON ALMEIDA",
                                "produto": "Cimentos",
                                "volume": 96.25,
                                "meta": 250,
                                "atingimento": 0.385,
                                "descontoRs": 0
                            }
                        ],
                        "clienteId": 327595,
                        "inicioMes": "2026-04-01T00:00:00"
                    },
                    {
                        "id": 3275951,
                        "codigo": "1067668",
                        "razaoSocial": "LEONCIO MATERIAIS DE CONSTRUCAO E C",
                        "grupoCentralizador": "GLAISON ALMEIDA",
                        "aceite": true,
                        "volume": 83.2,
                        "meta": 254.60000000000002,
                        "atingimento": 0.3267871170463472,
                        "descontoRs": 0,
                        "verMais": [
                            {
                                "id": 3,
                                "codigo": "1067668",
                                "razaoSocial": "LEONCIO MATERIAIS DE CONSTRUCAO E C",
                                "grupoCentralizador": "GLAISON ALMEIDA",
                                "produto": "Rejuntes",
                                "volume": 0,
                                "meta": 0.3,
                                "atingimento": 0,
                                "descontoRs": 0
                            },
                            {
                                "id": 4,
                                "codigo": "1067668",
                                "razaoSocial": "LEONCIO MATERIAIS DE CONSTRUCAO E C",
                                "grupoCentralizador": "GLAISON ALMEIDA",
                                "produto": "Colantes",
                                "volume": 1.2,
                                "meta": 4,
                                "atingimento": 0.3,
                                "descontoRs": 0
                            },
                            {
                                "id": 1,
                                "codigo": "1067668",
                                "razaoSocial": "LEONCIO MATERIAIS DE CONSTRUCAO E C",
                                "grupoCentralizador": "GLAISON ALMEIDA",
                                "produto": "Cimentos",
                                "volume": 82,
                                "meta": 250,
                                "atingimento": 0.328,
                                "descontoRs": 0
                            },
                            {
                                "id": 2,
                                "codigo": "1067668",
                                "razaoSocial": "LEONCIO MATERIAIS DE CONSTRUCAO E C",
                                "grupoCentralizador": "GLAISON ALMEIDA",
                                "produto": "Impermeabilizantes",
                                "volume": 0,
                                "meta": 0.3,
                                "atingimento": 0,
                                "descontoRs": 0
                            }
                        ],
                        "clienteId": 327595,
                        "inicioMes": "2026-05-01T00:00:00"
                    },
                    {
                        "id": 3275951,
                        "codigo": "1067668",
                        "razaoSocial": "LEONCIO MATERIAIS DE CONSTRUCAO E C",
                        "grupoCentralizador": "GLAISON ALMEIDA",
                        "aceite": true,
                        "volume": 254.7,
                        "meta": 254.3,
                        "atingimento": 1.0015729453401494,
                        "descontoRs": 5115,
                        "verMais": [
                            {
                                "id": 1,
                                "codigo": "1067668",
                                "razaoSocial": "LEONCIO MATERIAIS DE CONSTRUCAO E C",
                                "grupoCentralizador": "GLAISON ALMEIDA",
                                "produto": "Cimentos",
                                "volume": 250.5,
                                "meta": 250,
                                "atingimento": 1.002,
                                "descontoRs": 5010
                            },
                            {
                                "id": 4,
                                "codigo": "1067668",
                                "razaoSocial": "LEONCIO MATERIAIS DE CONSTRUCAO E C",
                                "grupoCentralizador": "GLAISON ALMEIDA",
                                "produto": "Colantes",
                                "volume": 4.2,
                                "meta": 4,
                                "atingimento": 1.05,
                                "descontoRs": 105
                            },
                            {
                                "id": 3,
                                "codigo": "1067668",
                                "razaoSocial": "LEONCIO MATERIAIS DE CONSTRUCAO E C",
                                "grupoCentralizador": "GLAISON ALMEIDA",
                                "produto": "Rejuntes",
                                "volume": 0,
                                "meta": 0.3,
                                "atingimento": 0,
                                "descontoRs": 0
                            }
                        ],
                        "clienteId": 327595,
                        "inicioMes": "2026-07-01T00:00:00"
                    },
                    {
                        "id": 3275950,
                        "codigo": "1067668",
                        "razaoSocial": "LEONCIO MATERIAIS DE CONSTRUCAO E C",
                        "grupoCentralizador": "GLAISON ALMEIDA",
                        "aceite": false,
                        "volume": 14,
                        "meta": 254.5,
                        "atingimento": 0.0550098231827112,
                        "descontoRs": 0,
                        "verMais": [
                            {
                                "id": 2,
                                "codigo": "1067668",
                                "razaoSocial": "LEONCIO MATERIAIS DE CONSTRUCAO E C",
                                "grupoCentralizador": "GLAISON ALMEIDA",
                                "produto": "Impermeabilizantes",
                                "volume": 0,
                                "meta": 0.2,
                                "atingimento": 0,
                                "descontoRs": 0
                            },
                            {
                                "id": 4,
                                "codigo": "1067668",
                                "razaoSocial": "LEONCIO MATERIAIS DE CONSTRUCAO E C",
                                "grupoCentralizador": "GLAISON ALMEIDA",
                                "produto": "Colantes",
                                "volume": 0,
                                "meta": 4,
                                "atingimento": 0,
                                "descontoRs": 0
                            },
                            {
                                "id": 1,
                                "codigo": "1067668",
                                "razaoSocial": "LEONCIO MATERIAIS DE CONSTRUCAO E C",
                                "grupoCentralizador": "GLAISON ALMEIDA",
                                "produto": "Cimentos",
                                "volume": 14,
                                "meta": 250,
                                "atingimento": 0.056,
                                "descontoRs": 0
                            },
                            {
                                "id": 3,
                                "codigo": "1067668",
                                "razaoSocial": "LEONCIO MATERIAIS DE CONSTRUCAO E C",
                                "grupoCentralizador": "GLAISON ALMEIDA",
                                "produto": "Rejuntes",
                                "volume": 0,
                                "meta": 0.3,
                                "atingimento": 0,
                                "descontoRs": 0
                            }
                        ],
                        "clienteId": 327595,
                        "inicioMes": "2026-08-01T00:00:00"
                    },
                    {
                        "id": 3275951,
                        "codigo": "1067668",
                        "razaoSocial": "LEONCIO MATERIAIS DE CONSTRUCAO E C",
                        "grupoCentralizador": "GLAISON ALMEIDA",
                        "aceite": true,
                        "volume": 166.4,
                        "meta": 255.6,
                        "atingimento": 0.6510172143974962,
                        "descontoRs": 0,
                        "verMais": [
                            {
                                "id": 3,
                                "codigo": "1067668",
                                "razaoSocial": "LEONCIO MATERIAIS DE CONSTRUCAO E C",
                                "grupoCentralizador": "GLAISON ALMEIDA",
                                "produto": "Rejuntes",
                                "volume": 0,
                                "meta": 0.3,
                                "atingimento": 0,
                                "descontoRs": 0
                            },
                            {
                                "id": 2,
                                "codigo": "1067668",
                                "razaoSocial": "LEONCIO MATERIAIS DE CONSTRUCAO E C",
                                "grupoCentralizador": "GLAISON ALMEIDA",
                                "produto": "Impermeabilizantes",
                                "volume": 0,
                                "meta": 0.3,
                                "atingimento": 0,
                                "descontoRs": 0
                            },
                            {
                                "id": 1,
                                "codigo": "1067668",
                                "razaoSocial": "LEONCIO MATERIAIS DE CONSTRUCAO E C",
                                "grupoCentralizador": "GLAISON ALMEIDA",
                                "produto": "Cimentos",
                                "volume": 162.5,
                                "meta": 250,
                                "atingimento": 0.65,
                                "descontoRs": 0
                            },
                            {
                                "id": 4,
                                "codigo": "1067668",
                                "razaoSocial": "LEONCIO MATERIAIS DE CONSTRUCAO E C",
                                "grupoCentralizador": "GLAISON ALMEIDA",
                                "produto": "Colantes",
                                "volume": 3.9,
                                "meta": 5,
                                "atingimento": 0.78,
                                "descontoRs": 0
                            }
                        ],
                        "clienteId": 327595,
                        "inicioMes": "2026-06-01T00:00:00"
                    },
                    {
                        "id": 1765811,
                        "codigo": "1672180",
                        "razaoSocial": "MARACANAU CONSTRUCOES E SERVICOS",
                        "grupoCentralizador": "MARACANAU CONSTRUCOES",
                        "aceite": true,
                        "volume": 272.34,
                        "meta": 279.6,
                        "atingimento": 0.9740343347639483,
                        "descontoRs": 4517,
                        "verMais": [
                            {
                                "id": 3,
                                "codigo": "1672180",
                                "razaoSocial": "MARACANAU CONSTRUCOES E SERVICOS",
                                "grupoCentralizador": "MARACANAU CONSTRUCOES",
                                "produto": "Rejuntes",
                                "volume": 0.34,
                                "meta": 0.3,
                                "atingimento": 1.1333333333333335,
                                "descontoRs": 165
                            },
                            {
                                "id": 4,
                                "codigo": "1672180",
                                "razaoSocial": "MARACANAU CONSTRUCOES E SERVICOS",
                                "grupoCentralizador": "MARACANAU CONSTRUCOES",
                                "produto": "Colantes",
                                "volume": 0,
                                "meta": 4,
                                "atingimento": 0,
                                "descontoRs": 0
                            },
                            {
                                "id": 1,
                                "codigo": "1672180",
                                "razaoSocial": "MARACANAU CONSTRUCOES E SERVICOS",
                                "grupoCentralizador": "MARACANAU CONSTRUCOES",
                                "produto": "Cimentos",
                                "volume": 272,
                                "meta": 275,
                                "atingimento": 0.9890909090909091,
                                "descontoRs": 4352
                            },
                            {
                                "id": 2,
                                "codigo": "1672180",
                                "razaoSocial": "MARACANAU CONSTRUCOES E SERVICOS",
                                "grupoCentralizador": "MARACANAU CONSTRUCOES",
                                "produto": "Impermeabilizantes",
                                "volume": 0,
                                "meta": 0.3,
                                "atingimento": 0,
                                "descontoRs": 0
                            }
                        ],
                        "clienteId": 176581,
                        "inicioMes": "2026-04-01T00:00:00"
                    },
                    {
                        "id": -1,
                        "cards": [
                            {
                                "produto": "Cimentos",
                                "clientesCampanha": 14,
                                "clientesAtingindoMeta": 0,
                                "progressoVolume": 222.25,
                                "limiteProgressoVolume": 1632,
                                "progressoDesconto": 0,
                                "limiteProgressoDesconto": 21594
                            },
                            {
                                "produto": "Rejuntes",
                                "clientesCampanha": 12,
                                "clientesAtingindoMeta": 0,
                                "progressoVolume": 0.02,
                                "limiteProgressoVolume": 3.999999999999999,
                                "progressoDesconto": 0,
                                "limiteProgressoDesconto": 2174
                            },
                            {
                                "produto": "Impermeabilizantes",
                                "clientesCampanha": 14,
                                "clientesAtingindoMeta": 0,
                                "progressoVolume": 0.054,
                                "limiteProgressoVolume": 3.1600000000000006,
                                "progressoDesconto": 0,
                                "limiteProgressoDesconto": 1698
                            },
                            {
                                "produto": "Colantes",
                                "clientesCampanha": 12,
                                "clientesAtingindoMeta": 0,
                                "progressoVolume": 9.33,
                                "limiteProgressoVolume": 77.19999999999999,
                                "progressoDesconto": 0,
                                "limiteProgressoDesconto": 2068
                            }
                        ]
                    },
                    {
                        "id": -2,
                        "cards": [
                            {
                                "produto": "Cimentos",
                                "clientesCampanha": 10,
                                "clientesAtingindoMeta": 5,
                                "progressoVolume": 1723.25,
                                "limiteProgressoVolume": 1968,
                                "progressoDesconto": 27226,
                                "limiteProgressoDesconto": 39598
                            },
                            {
                                "produto": "Rejuntes",
                                "clientesCampanha": 7,
                                "clientesAtingindoMeta": 0,
                                "progressoVolume": 0.44000000000000006,
                                "limiteProgressoVolume": 2.3,
                                "progressoDesconto": 0,
                                "limiteProgressoDesconto": 1243
                            },
                            {
                                "produto": "Impermeabilizantes",
                                "clientesCampanha": 6,
                                "clientesAtingindoMeta": 0,
                                "progressoVolume": 0.144,
                                "limiteProgressoVolume": 2.08,
                                "progressoDesconto": 0,
                                "limiteProgressoDesconto": 2342
                            },
                            {
                                "produto": "Colantes",
                                "clientesCampanha": 12,
                                "clientesAtingindoMeta": 5,
                                "progressoVolume": 56.775,
                                "limiteProgressoVolume": 62.150000000000006,
                                "progressoDesconto": 1854.422,
                                "limiteProgressoDesconto": 2597
                            }
                        ]
                    },
                    {
                        "id": -3,
                        "metasNegociadas": [
                            {
                                "clienteId": 180174,
                                "codigo": "1242458",
                                "razaoSocial": "DIVA MAGNA BERNARDINO FERREIRA",
                                "metaOficial": 324.38,
                                "inicioMes": "2026-08-01T00:00:00"
                            },
                            {
                                "clienteId": 1130739,
                                "codigo": "1905118",
                                "razaoSocial": "CEARA CIMENTOS E MATERIAIS PARA",
                                "metaOficial": 260.5,
                                "inicioMes": "2026-08-01T00:00:00"
                            },
                            {
                                "clienteId": 327595,
                                "codigo": "1067668",
                                "razaoSocial": "LEONCIO MATERIAIS DE CONSTRUCAO E C",
                                "metaOficial": 254.5,
                                "inicioMes": "2026-08-01T00:00:00"
                            },
                            {
                                "clienteId": 57845,
                                "codigo": "1508834",
                                "razaoSocial": "FORTE COMERCIO DE MATERIAL DE",
                                "metaOficial": 250.2,
                                "inicioMes": "2026-08-01T00:00:00"
                            },
                            {
                                "clienteId": 198758,
                                "codigo": "1470574",
                                "razaoSocial": "LOJA DE MATERIAIS DE CONSTRUCAO",
                                "metaOficial": 158.07,
                                "inicioMes": "2026-08-01T00:00:00"
                            }
                        ]
                    },
                    {
                        "id": -4,
                        "metasNegociadas": [
                            {
                                "clienteId": 176068,
                                "codigo": "1724963",
                                "razaoSocial": "MENEZES CIMENTOS LTDA",
                                "metaOficial": 573.96,
                                "inicioMes": "2026-07-01T00:00:00"
                            },
                            {
                                "clienteId": 180174,
                                "codigo": "1242458",
                                "razaoSocial": "DIVA MAGNA BERNARDINO FERREIRA",
                                "metaOficial": 334.76,
                                "inicioMes": "2026-07-01T00:00:00"
                            },
                            {
                                "clienteId": 327595,
                                "codigo": "1067668",
                                "razaoSocial": "LEONCIO MATERIAIS DE CONSTRUCAO E C",
                                "metaOficial": 254.3,
                                "inicioMes": "2026-07-01T00:00:00"
                            },
                            {
                                "clienteId": 57845,
                                "codigo": "1508834",
                                "razaoSocial": "FORTE COMERCIO DE MATERIAL DE",
                                "metaOficial": 250,
                                "inicioMes": "2026-07-01T00:00:00"
                            },
                            {
                                "clienteId": 27413,
                                "codigo": "1598847",
                                "razaoSocial": "DISTRIBUIDORA IMPERIO DO CIMENTO",
                                "metaOficial": 224.6,
                                "inicioMes": "2026-07-01T00:00:00"
                            }
                        ]
                    },
                    {
                        "id": -5,
                        "proximosMeta": [
                            {
                                "clienteId": 64507,
                                "codigo": "1710051",
                                "razaoSocial": "COMERCIAL AVENIDA MATERIAIS DE",
                                "atingido": 14,
                                "gap": 38.5,
                                "inicioMes": "2026-08-01T00:00:00"
                            },
                            {
                                "clienteId": 1130739,
                                "codigo": "1905118",
                                "razaoSocial": "CEARA CIMENTOS E MATERIAIS PARA",
                                "atingido": 70.02,
                                "gap": 190.48000000000002,
                                "inicioMes": "2026-08-01T00:00:00"
                            },
                            {
                                "clienteId": 180174,
                                "codigo": "1242458",
                                "razaoSocial": "DIVA MAGNA BERNARDINO FERREIRA",
                                "atingido": 74.25,
                                "gap": 250.13,
                                "inicioMes": "2026-08-01T00:00:00"
                            },
                            {
                                "clienteId": 57845,
                                "codigo": "1508834",
                                "razaoSocial": "FORTE COMERCIO DE MATERIAL DE",
                                "atingido": 0,
                                "gap": 250.2,
                                "inicioMes": "2026-08-01T00:00:00"
                            }
                        ]
                    },
                    {
                        "id": -6,
                        "proximosMeta": [
                            {
                                "clienteId": 64505,
                                "codigo": "1068160",
                                "razaoSocial": "LETICIA CAVALCANTE HOLANDA",
                                "atingido": 0.9,
                                "gap": 1.1,
                                "inicioMes": "2026-07-01T00:00:00"
                            },
                            {
                                "clienteId": 196950,
                                "codigo": "1065610",
                                "razaoSocial": "DEPOSITO ORIENTE DE MATERIAL DE",
                                "atingido": 0,
                                "gap": 2,
                                "inicioMes": "2026-07-01T00:00:00"
                            },
                            {
                                "clienteId": 64507,
                                "codigo": "1710051",
                                "razaoSocial": "COMERCIAL AVENIDA MATERIAIS DE",
                                "atingido": 56.32,
                                "gap": 3.1799999999999997,
                                "inicioMes": "2026-07-01T00:00:00"
                            },
                            {
                                "clienteId": 198758,
                                "codigo": "1470574",
                                "razaoSocial": "LOJA DE MATERIAIS DE CONSTRUCAO",
                                "atingido": 153.754,
                                "gap": 18.566000000000003,
                                "inicioMes": "2026-07-01T00:00:00"
                            },
                            {
                                "clienteId": 107316,
                                "codigo": "1733883",
                                "razaoSocial": "EDIFICA MATERIAIS PARA CONSTRUCAO",
                                "atingido": 31.8,
                                "gap": 18.599999999999998,
                                "inicioMes": "2026-07-01T00:00:00"
                            }
                        ]
                    },
                    {
                        "id": -7,
                        "linhaTempoDesconto": [
                            {
                                "inicioMes": "2026-04-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 64706,
                                "codigo": "1697436",
                                "razaoSocial": "JEFERSON ILTON DE MEDEIROS DANTAS",
                                "gap": 240,
                                "aceite": true,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-04-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 64706,
                                "codigo": "1697436",
                                "razaoSocial": "JEFERSON ILTON DE MEDEIROS DANTAS",
                                "gap": 150,
                                "aceite": true,
                                "produto": "Rejuntes"
                            },
                            {
                                "inicioMes": "2026-04-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 64706,
                                "codigo": "1697436",
                                "razaoSocial": "JEFERSON ILTON DE MEDEIROS DANTAS",
                                "gap": 240,
                                "aceite": true,
                                "produto": "Impermeabilizantes"
                            },
                            {
                                "inicioMes": "2026-04-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 64706,
                                "codigo": "1697436",
                                "razaoSocial": "JEFERSON ILTON DE MEDEIROS DANTAS",
                                "gap": 160,
                                "aceite": true,
                                "produto": "Colantes"
                            },
                            {
                                "inicioMes": "2026-08-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 64706,
                                "codigo": "1697436",
                                "razaoSocial": "JEFERSON ILTON DE MEDEIROS DANTAS",
                                "gap": 308,
                                "aceite": false,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-08-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 64706,
                                "codigo": "1697436",
                                "razaoSocial": "JEFERSON ILTON DE MEDEIROS DANTAS",
                                "gap": 126.49999999999999,
                                "aceite": false,
                                "produto": "Colantes"
                            },
                            {
                                "inicioMes": "2026-08-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 64706,
                                "codigo": "1697436",
                                "razaoSocial": "JEFERSON ILTON DE MEDEIROS DANTAS",
                                "gap": 126.5,
                                "aceite": false,
                                "produto": "Impermeabilizantes"
                            },
                            {
                                "inicioMes": "2026-08-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 64706,
                                "codigo": "1697436",
                                "razaoSocial": "JEFERSON ILTON DE MEDEIROS DANTAS",
                                "gap": 187,
                                "aceite": false,
                                "produto": "Rejuntes"
                            },
                            {
                                "inicioMes": "2026-05-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 64706,
                                "codigo": "1697436",
                                "razaoSocial": "JEFERSON ILTON DE MEDEIROS DANTAS",
                                "gap": 172.5,
                                "aceite": true,
                                "produto": "Rejuntes"
                            },
                            {
                                "inicioMes": "2026-05-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 64706,
                                "codigo": "1697436",
                                "razaoSocial": "JEFERSON ILTON DE MEDEIROS DANTAS",
                                "gap": 240,
                                "aceite": true,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-05-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 64706,
                                "codigo": "1697436",
                                "razaoSocial": "JEFERSON ILTON DE MEDEIROS DANTAS",
                                "gap": 345,
                                "aceite": true,
                                "produto": "Impermeabilizantes"
                            },
                            {
                                "inicioMes": "2026-05-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 64706,
                                "codigo": "1697436",
                                "razaoSocial": "JEFERSON ILTON DE MEDEIROS DANTAS",
                                "gap": 184,
                                "aceite": true,
                                "produto": "Colantes"
                            },
                            {
                                "inicioMes": "2026-05-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 107309,
                                "codigo": "1424376",
                                "razaoSocial": "GEOVANE BARROS DE OLIVEIRA",
                                "gap": 184,
                                "aceite": true,
                                "produto": "Colantes"
                            },
                            {
                                "inicioMes": "2026-05-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 107309,
                                "codigo": "1424376",
                                "razaoSocial": "GEOVANE BARROS DE OLIVEIRA",
                                "gap": 172.5,
                                "aceite": true,
                                "produto": "Rejuntes"
                            },
                            {
                                "inicioMes": "2026-05-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 107309,
                                "codigo": "1424376",
                                "razaoSocial": "GEOVANE BARROS DE OLIVEIRA",
                                "gap": 345,
                                "aceite": true,
                                "produto": "Impermeabilizantes"
                            },
                            {
                                "inicioMes": "2026-05-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 107309,
                                "codigo": "1424376",
                                "razaoSocial": "GEOVANE BARROS DE OLIVEIRA",
                                "gap": 160,
                                "aceite": true,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-04-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 107309,
                                "codigo": "1424376",
                                "razaoSocial": "GEOVANE BARROS DE OLIVEIRA",
                                "gap": 160,
                                "aceite": true,
                                "produto": "Colantes"
                            },
                            {
                                "inicioMes": "2026-04-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 107309,
                                "codigo": "1424376",
                                "razaoSocial": "GEOVANE BARROS DE OLIVEIRA",
                                "gap": 150,
                                "aceite": true,
                                "produto": "Rejuntes"
                            },
                            {
                                "inicioMes": "2026-04-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 107309,
                                "codigo": "1424376",
                                "razaoSocial": "GEOVANE BARROS DE OLIVEIRA",
                                "gap": 240,
                                "aceite": true,
                                "produto": "Impermeabilizantes"
                            },
                            {
                                "inicioMes": "2026-04-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 107309,
                                "codigo": "1424376",
                                "razaoSocial": "GEOVANE BARROS DE OLIVEIRA",
                                "gap": 170,
                                "aceite": true,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-08-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 107309,
                                "codigo": "1424376",
                                "razaoSocial": "GEOVANE BARROS DE OLIVEIRA",
                                "gap": 187,
                                "aceite": false,
                                "produto": "Rejuntes"
                            },
                            {
                                "inicioMes": "2026-08-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 107309,
                                "codigo": "1424376",
                                "razaoSocial": "GEOVANE BARROS DE OLIVEIRA",
                                "gap": 126.49999999999999,
                                "aceite": false,
                                "produto": "Colantes"
                            },
                            {
                                "inicioMes": "2026-08-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 107309,
                                "codigo": "1424376",
                                "razaoSocial": "GEOVANE BARROS DE OLIVEIRA",
                                "gap": 126.5,
                                "aceite": false,
                                "produto": "Impermeabilizantes"
                            },
                            {
                                "inicioMes": "2026-08-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 107309,
                                "codigo": "1424376",
                                "razaoSocial": "GEOVANE BARROS DE OLIVEIRA",
                                "gap": 286,
                                "aceite": false,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-05-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 107313,
                                "codigo": "1706517",
                                "razaoSocial": "DEPOSITO LIMA LTDA",
                                "gap": 172.5,
                                "aceite": true,
                                "produto": "Rejuntes"
                            },
                            {
                                "inicioMes": "2026-05-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 107313,
                                "codigo": "1706517",
                                "razaoSocial": "DEPOSITO LIMA LTDA",
                                "gap": 345,
                                "aceite": true,
                                "produto": "Impermeabilizantes"
                            },
                            {
                                "inicioMes": "2026-05-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 107313,
                                "codigo": "1706517",
                                "razaoSocial": "DEPOSITO LIMA LTDA",
                                "gap": 184,
                                "aceite": true,
                                "produto": "Colantes"
                            },
                            {
                                "inicioMes": "2026-05-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 107313,
                                "codigo": "1706517",
                                "razaoSocial": "DEPOSITO LIMA LTDA",
                                "gap": 460,
                                "aceite": true,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-06-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 107313,
                                "codigo": "1706517",
                                "razaoSocial": "DEPOSITO LIMA LTDA",
                                "gap": 126.49999999999999,
                                "aceite": true,
                                "produto": "Colantes"
                            },
                            {
                                "inicioMes": "2026-06-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 107313,
                                "codigo": "1706517",
                                "razaoSocial": "DEPOSITO LIMA LTDA",
                                "gap": 374,
                                "aceite": true,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-06-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 107313,
                                "codigo": "1706517",
                                "razaoSocial": "DEPOSITO LIMA LTDA",
                                "gap": 206.99999999999997,
                                "aceite": true,
                                "produto": "Rejuntes"
                            },
                            {
                                "inicioMes": "2026-06-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 107313,
                                "codigo": "1706517",
                                "razaoSocial": "DEPOSITO LIMA LTDA",
                                "gap": 345,
                                "aceite": true,
                                "produto": "Impermeabilizantes"
                            },
                            {
                                "inicioMes": "2026-08-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 107313,
                                "codigo": "1706517",
                                "razaoSocial": "DEPOSITO LIMA LTDA",
                                "gap": 126.5,
                                "aceite": false,
                                "produto": "Impermeabilizantes"
                            },
                            {
                                "inicioMes": "2026-08-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 107313,
                                "codigo": "1706517",
                                "razaoSocial": "DEPOSITO LIMA LTDA",
                                "gap": 462,
                                "aceite": false,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-07-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 107313,
                                "codigo": "1706517",
                                "razaoSocial": "DEPOSITO LIMA LTDA",
                                "gap": 126.49999999999999,
                                "aceite": false,
                                "produto": "Colantes"
                            },
                            {
                                "inicioMes": "2026-07-01T00:00:00",
                                "realizado": 604.032,
                                "clienteId": 107316,
                                "codigo": "1733883",
                                "razaoSocial": "EDIFICA MATERIAIS PARA CONSTRUCAO",
                                "gap": -54.912000000000035,
                                "aceite": true,
                                "produto": "Colantes"
                            },
                            {
                                "inicioMes": "2026-07-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 107316,
                                "codigo": "1733883",
                                "razaoSocial": "EDIFICA MATERIAIS PARA CONSTRUCAO",
                                "gap": 576,
                                "aceite": true,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-08-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 107316,
                                "codigo": "1733883",
                                "razaoSocial": "EDIFICA MATERIAIS PARA CONSTRUCAO",
                                "gap": 159.5,
                                "aceite": false,
                                "produto": "Impermeabilizantes"
                            },
                            {
                                "inicioMes": "2026-08-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 107316,
                                "codigo": "1733883",
                                "razaoSocial": "EDIFICA MATERIAIS PARA CONSTRUCAO",
                                "gap": 187,
                                "aceite": false,
                                "produto": "Rejuntes"
                            },
                            {
                                "inicioMes": "2026-08-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 107316,
                                "codigo": "1733883",
                                "razaoSocial": "EDIFICA MATERIAIS PARA CONSTRUCAO",
                                "gap": 379.5,
                                "aceite": false,
                                "produto": "Colantes"
                            },
                            {
                                "inicioMes": "2026-08-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 107316,
                                "codigo": "1733883",
                                "razaoSocial": "EDIFICA MATERIAIS PARA CONSTRUCAO",
                                "gap": 374,
                                "aceite": false,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-04-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 107317,
                                "codigo": "1778028",
                                "razaoSocial": "MARCOPISOS LTDA",
                                "gap": 150,
                                "aceite": true,
                                "produto": "Rejuntes"
                            },
                            {
                                "inicioMes": "2026-04-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 107317,
                                "codigo": "1778028",
                                "razaoSocial": "MARCOPISOS LTDA",
                                "gap": 140,
                                "aceite": true,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-04-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 107317,
                                "codigo": "1778028",
                                "razaoSocial": "MARCOPISOS LTDA",
                                "gap": 600,
                                "aceite": true,
                                "produto": "Impermeabilizantes"
                            },
                            {
                                "inicioMes": "2026-04-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 107317,
                                "codigo": "1778028",
                                "razaoSocial": "MARCOPISOS LTDA",
                                "gap": 200,
                                "aceite": true,
                                "produto": "Colantes"
                            },
                            {
                                "inicioMes": "2026-04-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 134210,
                                "codigo": "1130442",
                                "razaoSocial": "J  AUGUSTO PINHEIRO PAPELARIA",
                                "gap": 120.39999999999999,
                                "aceite": false,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-06-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 176068,
                                "codigo": "1724963",
                                "razaoSocial": "MENEZES CIMENTOS LTDA",
                                "gap": 180,
                                "aceite": true,
                                "produto": "Rejuntes"
                            },
                            {
                                "inicioMes": "2026-06-01T00:00:00",
                                "realizado": 12100,
                                "clienteId": 176068,
                                "codigo": "1724963",
                                "razaoSocial": "MENEZES CIMENTOS LTDA",
                                "gap": -1100,
                                "aceite": true,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-06-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 176068,
                                "codigo": "1724963",
                                "razaoSocial": "MENEZES CIMENTOS LTDA",
                                "gap": 300,
                                "aceite": true,
                                "produto": "Impermeabilizantes"
                            },
                            {
                                "inicioMes": "2026-06-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 176068,
                                "codigo": "1724963",
                                "razaoSocial": "MENEZES CIMENTOS LTDA",
                                "gap": 250,
                                "aceite": true,
                                "produto": "Colantes"
                            },
                            {
                                "inicioMes": "2026-07-01T00:00:00",
                                "realizado": 12496,
                                "clienteId": 176068,
                                "codigo": "1724963",
                                "razaoSocial": "MENEZES CIMENTOS LTDA",
                                "gap": -1136,
                                "aceite": true,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-07-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 176068,
                                "codigo": "1724963",
                                "razaoSocial": "MENEZES CIMENTOS LTDA",
                                "gap": 228,
                                "aceite": true,
                                "produto": "Rejuntes"
                            },
                            {
                                "inicioMes": "2026-07-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 176068,
                                "codigo": "1724963",
                                "razaoSocial": "MENEZES CIMENTOS LTDA",
                                "gap": 156,
                                "aceite": true,
                                "produto": "Colantes"
                            },
                            {
                                "inicioMes": "2026-07-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 176068,
                                "codigo": "1724963",
                                "razaoSocial": "MENEZES CIMENTOS LTDA",
                                "gap": 456,
                                "aceite": true,
                                "produto": "Impermeabilizantes"
                            },
                            {
                                "inicioMes": "2026-04-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 176068,
                                "codigo": "1724963",
                                "razaoSocial": "MENEZES CIMENTOS LTDA",
                                "gap": 150,
                                "aceite": true,
                                "produto": "Rejuntes"
                            },
                            {
                                "inicioMes": "2026-04-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 176068,
                                "codigo": "1724963",
                                "razaoSocial": "MENEZES CIMENTOS LTDA",
                                "gap": 200,
                                "aceite": true,
                                "produto": "Colantes"
                            },
                            {
                                "inicioMes": "2026-04-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 176068,
                                "codigo": "1724963",
                                "razaoSocial": "MENEZES CIMENTOS LTDA",
                                "gap": 240,
                                "aceite": true,
                                "produto": "Impermeabilizantes"
                            },
                            {
                                "inicioMes": "2026-04-01T00:00:00",
                                "realizado": 8976,
                                "clienteId": 176068,
                                "codigo": "1724963",
                                "razaoSocial": "MENEZES CIMENTOS LTDA",
                                "gap": -816,
                                "aceite": true,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-08-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 176069,
                                "codigo": "1759677",
                                "razaoSocial": "ELLAS MATERIAIS DE CONSTRUCOES LTDA",
                                "gap": 726,
                                "aceite": false,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-08-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 176069,
                                "codigo": "1759677",
                                "razaoSocial": "ELLAS MATERIAIS DE CONSTRUCOES LTDA",
                                "gap": 126.5,
                                "aceite": false,
                                "produto": "Impermeabilizantes"
                            },
                            {
                                "inicioMes": "2026-08-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 176069,
                                "codigo": "1759677",
                                "razaoSocial": "ELLAS MATERIAIS DE CONSTRUCOES LTDA",
                                "gap": 126.49999999999999,
                                "aceite": false,
                                "produto": "Colantes"
                            },
                            {
                                "inicioMes": "2026-08-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 176069,
                                "codigo": "1759677",
                                "razaoSocial": "ELLAS MATERIAIS DE CONSTRUCOES LTDA",
                                "gap": 187,
                                "aceite": false,
                                "produto": "Rejuntes"
                            },
                            {
                                "inicioMes": "2026-06-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 176069,
                                "codigo": "1759677",
                                "razaoSocial": "ELLAS MATERIAIS DE CONSTRUCOES LTDA",
                                "gap": 206.99999999999997,
                                "aceite": false,
                                "produto": "Rejuntes"
                            },
                            {
                                "inicioMes": "2026-06-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 176069,
                                "codigo": "1759677",
                                "razaoSocial": "ELLAS MATERIAIS DE CONSTRUCOES LTDA",
                                "gap": 316.25,
                                "aceite": false,
                                "produto": "Colantes"
                            },
                            {
                                "inicioMes": "2026-06-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 176069,
                                "codigo": "1759677",
                                "razaoSocial": "ELLAS MATERIAIS DE CONSTRUCOES LTDA",
                                "gap": 345,
                                "aceite": false,
                                "produto": "Impermeabilizantes"
                            },
                            {
                                "inicioMes": "2026-06-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 176069,
                                "codigo": "1759677",
                                "razaoSocial": "ELLAS MATERIAIS DE CONSTRUCOES LTDA",
                                "gap": 462,
                                "aceite": false,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-07-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 64505,
                                "codigo": "1068160",
                                "razaoSocial": "LETICIA CAVALCANTE HOLANDA",
                                "gap": 100,
                                "aceite": true,
                                "produto": "Colantes"
                            },
                            {
                                "inicioMes": "2026-08-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 64505,
                                "codigo": "1068160",
                                "razaoSocial": "LETICIA CAVALCANTE HOLANDA",
                                "gap": 126.5,
                                "aceite": false,
                                "produto": "Impermeabilizantes"
                            },
                            {
                                "inicioMes": "2026-08-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 64505,
                                "codigo": "1068160",
                                "razaoSocial": "LETICIA CAVALCANTE HOLANDA",
                                "gap": 187,
                                "aceite": false,
                                "produto": "Rejuntes"
                            },
                            {
                                "inicioMes": "2026-08-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 64505,
                                "codigo": "1068160",
                                "razaoSocial": "LETICIA CAVALCANTE HOLANDA",
                                "gap": 126.49999999999999,
                                "aceite": false,
                                "produto": "Colantes"
                            },
                            {
                                "inicioMes": "2026-08-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 64505,
                                "codigo": "1068160",
                                "razaoSocial": "LETICIA CAVALCANTE HOLANDA",
                                "gap": 440,
                                "aceite": false,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-06-01T00:00:00",
                                "realizado": 374,
                                "clienteId": 64505,
                                "codigo": "1068160",
                                "razaoSocial": "LETICIA CAVALCANTE HOLANDA",
                                "gap": 0,
                                "aceite": true,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-06-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 64505,
                                "codigo": "1068160",
                                "razaoSocial": "LETICIA CAVALCANTE HOLANDA",
                                "gap": 206.99999999999997,
                                "aceite": true,
                                "produto": "Rejuntes"
                            },
                            {
                                "inicioMes": "2026-06-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 64505,
                                "codigo": "1068160",
                                "razaoSocial": "LETICIA CAVALCANTE HOLANDA",
                                "gap": 345,
                                "aceite": true,
                                "produto": "Impermeabilizantes"
                            },
                            {
                                "inicioMes": "2026-06-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 64505,
                                "codigo": "1068160",
                                "razaoSocial": "LETICIA CAVALCANTE HOLANDA",
                                "gap": 151.8,
                                "aceite": true,
                                "produto": "Colantes"
                            },
                            {
                                "inicioMes": "2026-05-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 64505,
                                "codigo": "1068160",
                                "razaoSocial": "LETICIA CAVALCANTE HOLANDA",
                                "gap": 172.5,
                                "aceite": true,
                                "produto": "Rejuntes"
                            },
                            {
                                "inicioMes": "2026-05-01T00:00:00",
                                "realizado": 672,
                                "clienteId": 64505,
                                "codigo": "1068160",
                                "razaoSocial": "LETICIA CAVALCANTE HOLANDA",
                                "gap": 0,
                                "aceite": true,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-05-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 64505,
                                "codigo": "1068160",
                                "razaoSocial": "LETICIA CAVALCANTE HOLANDA",
                                "gap": 345,
                                "aceite": true,
                                "produto": "Impermeabilizantes"
                            },
                            {
                                "inicioMes": "2026-05-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 64505,
                                "codigo": "1068160",
                                "razaoSocial": "LETICIA CAVALCANTE HOLANDA",
                                "gap": 184,
                                "aceite": true,
                                "produto": "Colantes"
                            },
                            {
                                "inicioMes": "2026-04-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 180174,
                                "codigo": "1242458",
                                "razaoSocial": "DIVA MAGNA BERNARDINO FERREIRA",
                                "gap": 150,
                                "aceite": true,
                                "produto": "Rejuntes"
                            },
                            {
                                "inicioMes": "2026-04-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 180174,
                                "codigo": "1242458",
                                "razaoSocial": "DIVA MAGNA BERNARDINO FERREIRA",
                                "gap": 240,
                                "aceite": true,
                                "produto": "Impermeabilizantes"
                            },
                            {
                                "inicioMes": "2026-04-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 180174,
                                "codigo": "1242458",
                                "razaoSocial": "DIVA MAGNA BERNARDINO FERREIRA",
                                "gap": 3100,
                                "aceite": true,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-04-01T00:00:00",
                                "realizado": 162,
                                "clienteId": 180174,
                                "codigo": "1242458",
                                "razaoSocial": "DIVA MAGNA BERNARDINO FERREIRA",
                                "gap": -2,
                                "aceite": true,
                                "produto": "Colantes"
                            },
                            {
                                "inicioMes": "2026-05-01T00:00:00",
                                "realizado": 2640,
                                "clienteId": 180174,
                                "codigo": "1242458",
                                "razaoSocial": "DIVA MAGNA BERNARDINO FERREIRA",
                                "gap": -240,
                                "aceite": true,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-05-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 180174,
                                "codigo": "1242458",
                                "razaoSocial": "DIVA MAGNA BERNARDINO FERREIRA",
                                "gap": 345,
                                "aceite": true,
                                "produto": "Impermeabilizantes"
                            },
                            {
                                "inicioMes": "2026-05-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 180174,
                                "codigo": "1242458",
                                "razaoSocial": "DIVA MAGNA BERNARDINO FERREIRA",
                                "gap": 128,
                                "aceite": true,
                                "produto": "Colantes"
                            },
                            {
                                "inicioMes": "2026-05-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 180174,
                                "codigo": "1242458",
                                "razaoSocial": "DIVA MAGNA BERNARDINO FERREIRA",
                                "gap": 172.5,
                                "aceite": true,
                                "produto": "Rejuntes"
                            },
                            {
                                "inicioMes": "2026-07-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 180174,
                                "codigo": "1242458",
                                "razaoSocial": "DIVA MAGNA BERNARDINO FERREIRA",
                                "gap": 456,
                                "aceite": true,
                                "produto": "Impermeabilizantes"
                            },
                            {
                                "inicioMes": "2026-07-01T00:00:00",
                                "realizado": 108.75,
                                "clienteId": 180174,
                                "codigo": "1242458",
                                "razaoSocial": "DIVA MAGNA BERNARDINO FERREIRA",
                                "gap": -8.75,
                                "aceite": true,
                                "produto": "Colantes"
                            },
                            {
                                "inicioMes": "2026-07-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 180174,
                                "codigo": "1242458",
                                "razaoSocial": "DIVA MAGNA BERNARDINO FERREIRA",
                                "gap": 228,
                                "aceite": true,
                                "produto": "Rejuntes"
                            },
                            {
                                "inicioMes": "2026-07-01T00:00:00",
                                "realizado": 6840,
                                "clienteId": 180174,
                                "codigo": "1242458",
                                "razaoSocial": "DIVA MAGNA BERNARDINO FERREIRA",
                                "gap": -240,
                                "aceite": true,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-08-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 180174,
                                "codigo": "1242458",
                                "razaoSocial": "DIVA MAGNA BERNARDINO FERREIRA",
                                "gap": 100,
                                "aceite": true,
                                "produto": "Colantes"
                            },
                            {
                                "inicioMes": "2026-08-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 180174,
                                "codigo": "1242458",
                                "razaoSocial": "DIVA MAGNA BERNARDINO FERREIRA",
                                "gap": 228,
                                "aceite": true,
                                "produto": "Rejuntes"
                            },
                            {
                                "inicioMes": "2026-08-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 180174,
                                "codigo": "1242458",
                                "razaoSocial": "DIVA MAGNA BERNARDINO FERREIRA",
                                "gap": 4480,
                                "aceite": true,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-05-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 196923,
                                "codigo": "1440065",
                                "razaoSocial": "F A F DA SILVA LTDA",
                                "gap": 240,
                                "aceite": true,
                                "produto": "Impermeabilizantes"
                            },
                            {
                                "inicioMes": "2026-05-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 196923,
                                "codigo": "1440065",
                                "razaoSocial": "F A F DA SILVA LTDA",
                                "gap": 120,
                                "aceite": true,
                                "produto": "Rejuntes"
                            },
                            {
                                "inicioMes": "2026-05-01T00:00:00",
                                "realizado": 668.8,
                                "clienteId": 196923,
                                "codigo": "1440065",
                                "razaoSocial": "F A F DA SILVA LTDA",
                                "gap": -60.799999999999955,
                                "aceite": true,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-05-01T00:00:00",
                                "realizado": 144,
                                "clienteId": 196923,
                                "codigo": "1440065",
                                "razaoSocial": "F A F DA SILVA LTDA",
                                "gap": 16,
                                "aceite": true,
                                "produto": "Colantes"
                            },
                            {
                                "inicioMes": "2026-04-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 196923,
                                "codigo": "1440065",
                                "razaoSocial": "F A F DA SILVA LTDA",
                                "gap": 150,
                                "aceite": true,
                                "produto": "Rejuntes"
                            },
                            {
                                "inicioMes": "2026-04-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 196923,
                                "codigo": "1440065",
                                "razaoSocial": "F A F DA SILVA LTDA",
                                "gap": 240,
                                "aceite": true,
                                "produto": "Impermeabilizantes"
                            },
                            {
                                "inicioMes": "2026-04-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 196923,
                                "codigo": "1440065",
                                "razaoSocial": "F A F DA SILVA LTDA",
                                "gap": 240,
                                "aceite": true,
                                "produto": "Colantes"
                            },
                            {
                                "inicioMes": "2026-04-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 196923,
                                "codigo": "1440065",
                                "razaoSocial": "F A F DA SILVA LTDA",
                                "gap": 620,
                                "aceite": true,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-08-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 196923,
                                "codigo": "1440065",
                                "razaoSocial": "F A F DA SILVA LTDA",
                                "gap": 187,
                                "aceite": false,
                                "produto": "Rejuntes"
                            },
                            {
                                "inicioMes": "2026-08-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 196923,
                                "codigo": "1440065",
                                "razaoSocial": "F A F DA SILVA LTDA",
                                "gap": 126.5,
                                "aceite": false,
                                "produto": "Impermeabilizantes"
                            },
                            {
                                "inicioMes": "2026-08-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 196923,
                                "codigo": "1440065",
                                "razaoSocial": "F A F DA SILVA LTDA",
                                "gap": 189.75,
                                "aceite": false,
                                "produto": "Colantes"
                            },
                            {
                                "inicioMes": "2026-08-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 196923,
                                "codigo": "1440065",
                                "razaoSocial": "F A F DA SILVA LTDA",
                                "gap": 1122,
                                "aceite": false,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-07-01T00:00:00",
                                "realizado": 110,
                                "clienteId": 196923,
                                "codigo": "1440065",
                                "razaoSocial": "F A F DA SILVA LTDA",
                                "gap": -10,
                                "aceite": true,
                                "produto": "Colantes"
                            },
                            {
                                "inicioMes": "2026-07-01T00:00:00",
                                "realizado": 1760,
                                "clienteId": 196923,
                                "codigo": "1440065",
                                "razaoSocial": "F A F DA SILVA LTDA",
                                "gap": -120,
                                "aceite": true,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-07-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 196923,
                                "codigo": "1440065",
                                "razaoSocial": "F A F DA SILVA LTDA",
                                "gap": 300,
                                "aceite": true,
                                "produto": "Impermeabilizantes"
                            },
                            {
                                "inicioMes": "2026-07-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 196923,
                                "codigo": "1440065",
                                "razaoSocial": "F A F DA SILVA LTDA",
                                "gap": 150,
                                "aceite": true,
                                "produto": "Rejuntes"
                            },
                            {
                                "inicioMes": "2026-04-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 196941,
                                "codigo": "1068197",
                                "razaoSocial": "DEPOSITO MODELO LTDA",
                                "gap": 123.19999999999999,
                                "aceite": false,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-06-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 196950,
                                "codigo": "1065610",
                                "razaoSocial": "DEPOSITO ORIENTE DE MATERIAL DE",
                                "gap": 206.99999999999997,
                                "aceite": true,
                                "produto": "Rejuntes"
                            },
                            {
                                "inicioMes": "2026-06-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 196950,
                                "codigo": "1065610",
                                "razaoSocial": "DEPOSITO ORIENTE DE MATERIAL DE",
                                "gap": 345,
                                "aceite": true,
                                "produto": "Impermeabilizantes"
                            },
                            {
                                "inicioMes": "2026-06-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 196950,
                                "codigo": "1065610",
                                "razaoSocial": "DEPOSITO ORIENTE DE MATERIAL DE",
                                "gap": 462,
                                "aceite": true,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-06-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 196950,
                                "codigo": "1065610",
                                "razaoSocial": "DEPOSITO ORIENTE DE MATERIAL DE",
                                "gap": 151.8,
                                "aceite": true,
                                "produto": "Colantes"
                            },
                            {
                                "inicioMes": "2026-08-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 196950,
                                "codigo": "1065610",
                                "razaoSocial": "DEPOSITO ORIENTE DE MATERIAL DE",
                                "gap": 126.5,
                                "aceite": false,
                                "produto": "Impermeabilizantes"
                            },
                            {
                                "inicioMes": "2026-08-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 196950,
                                "codigo": "1065610",
                                "razaoSocial": "DEPOSITO ORIENTE DE MATERIAL DE",
                                "gap": 330,
                                "aceite": false,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-05-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 196950,
                                "codigo": "1065610",
                                "razaoSocial": "DEPOSITO ORIENTE DE MATERIAL DE",
                                "gap": 120,
                                "aceite": true,
                                "produto": "Rejuntes"
                            },
                            {
                                "inicioMes": "2026-05-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 196950,
                                "codigo": "1065610",
                                "razaoSocial": "DEPOSITO ORIENTE DE MATERIAL DE",
                                "gap": 240,
                                "aceite": true,
                                "produto": "Impermeabilizantes"
                            },
                            {
                                "inicioMes": "2026-05-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 196950,
                                "codigo": "1065610",
                                "razaoSocial": "DEPOSITO ORIENTE DE MATERIAL DE",
                                "gap": 128,
                                "aceite": true,
                                "produto": "Colantes"
                            },
                            {
                                "inicioMes": "2026-05-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 196950,
                                "codigo": "1065610",
                                "razaoSocial": "DEPOSITO ORIENTE DE MATERIAL DE",
                                "gap": 368,
                                "aceite": true,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-07-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 196950,
                                "codigo": "1065610",
                                "razaoSocial": "DEPOSITO ORIENTE DE MATERIAL DE",
                                "gap": 100,
                                "aceite": true,
                                "produto": "Colantes"
                            },
                            {
                                "inicioMes": "2026-05-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 198758,
                                "codigo": "1470574",
                                "razaoSocial": "LOJA DE MATERIAIS DE CONSTRUCAO",
                                "gap": 440,
                                "aceite": true,
                                "produto": "Colantes"
                            },
                            {
                                "inicioMes": "2026-05-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 198758,
                                "codigo": "1470574",
                                "razaoSocial": "LOJA DE MATERIAIS DE CONSTRUCAO",
                                "gap": 345,
                                "aceite": true,
                                "produto": "Impermeabilizantes"
                            },
                            {
                                "inicioMes": "2026-05-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 198758,
                                "codigo": "1470574",
                                "razaoSocial": "LOJA DE MATERIAIS DE CONSTRUCAO",
                                "gap": 1600,
                                "aceite": true,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-05-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 198758,
                                "codigo": "1470574",
                                "razaoSocial": "LOJA DE MATERIAIS DE CONSTRUCAO",
                                "gap": 172.5,
                                "aceite": true,
                                "produto": "Rejuntes"
                            },
                            {
                                "inicioMes": "2026-08-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 198758,
                                "codigo": "1470574",
                                "razaoSocial": "LOJA DE MATERIAIS DE CONSTRUCAO",
                                "gap": 316.25,
                                "aceite": false,
                                "produto": "Colantes"
                            },
                            {
                                "inicioMes": "2026-08-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 198758,
                                "codigo": "1470574",
                                "razaoSocial": "LOJA DE MATERIAIS DE CONSTRUCAO",
                                "gap": 187,
                                "aceite": false,
                                "produto": "Rejuntes"
                            },
                            {
                                "inicioMes": "2026-08-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 198758,
                                "codigo": "1470574",
                                "razaoSocial": "LOJA DE MATERIAIS DE CONSTRUCAO",
                                "gap": 1606,
                                "aceite": false,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-08-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 198758,
                                "codigo": "1470574",
                                "razaoSocial": "LOJA DE MATERIAIS DE CONSTRUCAO",
                                "gap": 126.5,
                                "aceite": false,
                                "produto": "Impermeabilizantes"
                            },
                            {
                                "inicioMes": "2026-07-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 198758,
                                "codigo": "1470574",
                                "razaoSocial": "LOJA DE MATERIAIS DE CONSTRUCAO",
                                "gap": 3744,
                                "aceite": true,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-07-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 198758,
                                "codigo": "1470574",
                                "razaoSocial": "LOJA DE MATERIAIS DE CONSTRUCAO",
                                "gap": 456,
                                "aceite": true,
                                "produto": "Impermeabilizantes"
                            },
                            {
                                "inicioMes": "2026-07-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 198758,
                                "codigo": "1470574",
                                "razaoSocial": "LOJA DE MATERIAIS DE CONSTRUCAO",
                                "gap": 187,
                                "aceite": true,
                                "produto": "Rejuntes"
                            },
                            {
                                "inicioMes": "2026-07-01T00:00:00",
                                "realizado": 926.64,
                                "clienteId": 198758,
                                "codigo": "1470574",
                                "razaoSocial": "LOJA DE MATERIAIS DE CONSTRUCAO",
                                "gap": -84.24000000000001,
                                "aceite": true,
                                "produto": "Colantes"
                            },
                            {
                                "inicioMes": "2026-04-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 198758,
                                "codigo": "1470574",
                                "razaoSocial": "LOJA DE MATERIAIS DE CONSTRUCAO",
                                "gap": 440,
                                "aceite": true,
                                "produto": "Colantes"
                            },
                            {
                                "inicioMes": "2026-04-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 198758,
                                "codigo": "1470574",
                                "razaoSocial": "LOJA DE MATERIAIS DE CONSTRUCAO",
                                "gap": 240,
                                "aceite": true,
                                "produto": "Impermeabilizantes"
                            },
                            {
                                "inicioMes": "2026-04-01T00:00:00",
                                "realizado": 150,
                                "clienteId": 198758,
                                "codigo": "1470574",
                                "razaoSocial": "LOJA DE MATERIAIS DE CONSTRUCAO",
                                "gap": 0,
                                "aceite": true,
                                "produto": "Rejuntes"
                            },
                            {
                                "inicioMes": "2026-04-01T00:00:00",
                                "realizado": 1160,
                                "clienteId": 198758,
                                "codigo": "1470574",
                                "razaoSocial": "LOJA DE MATERIAIS DE CONSTRUCAO",
                                "gap": -60,
                                "aceite": true,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-07-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 1127256,
                                "codigo": "1902724",
                                "razaoSocial": "FRANCISCA ERLANIA DA SILVA",
                                "gap": 198,
                                "aceite": false,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-07-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 1127256,
                                "codigo": "1902724",
                                "razaoSocial": "FRANCISCA ERLANIA DA SILVA",
                                "gap": 374,
                                "aceite": false,
                                "produto": "Impermeabilizantes"
                            },
                            {
                                "inicioMes": "2026-05-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 1130739,
                                "codigo": "1905118",
                                "razaoSocial": "CEARA CIMENTOS E MATERIAIS PARA",
                                "gap": 240,
                                "aceite": true,
                                "produto": "Impermeabilizantes"
                            },
                            {
                                "inicioMes": "2026-05-01T00:00:00",
                                "realizado": 4000,
                                "clienteId": 1130739,
                                "codigo": "1905118",
                                "razaoSocial": "CEARA CIMENTOS E MATERIAIS PARA",
                                "gap": -320,
                                "aceite": true,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-05-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 1130739,
                                "codigo": "1905118",
                                "razaoSocial": "CEARA CIMENTOS E MATERIAIS PARA",
                                "gap": 152,
                                "aceite": true,
                                "produto": "Rejuntes"
                            },
                            {
                                "inicioMes": "2026-05-01T00:00:00",
                                "realizado": 140.8,
                                "clienteId": 1130739,
                                "codigo": "1905118",
                                "razaoSocial": "CEARA CIMENTOS E MATERIAIS PARA",
                                "gap": -12.800000000000011,
                                "aceite": true,
                                "produto": "Colantes"
                            },
                            {
                                "inicioMes": "2026-06-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 1130739,
                                "codigo": "1905118",
                                "razaoSocial": "CEARA CIMENTOS E MATERIAIS PARA",
                                "gap": 180,
                                "aceite": true,
                                "produto": "Rejuntes"
                            },
                            {
                                "inicioMes": "2026-06-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 1130739,
                                "codigo": "1905118",
                                "razaoSocial": "CEARA CIMENTOS E MATERIAIS PARA",
                                "gap": 300,
                                "aceite": true,
                                "produto": "Impermeabilizantes"
                            },
                            {
                                "inicioMes": "2026-06-01T00:00:00",
                                "realizado": 4760,
                                "clienteId": 1130739,
                                "codigo": "1905118",
                                "razaoSocial": "CEARA CIMENTOS E MATERIAIS PARA",
                                "gap": 240,
                                "aceite": true,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-06-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 1130739,
                                "codigo": "1905118",
                                "razaoSocial": "CEARA CIMENTOS E MATERIAIS PARA",
                                "gap": 650,
                                "aceite": true,
                                "produto": "Colantes"
                            },
                            {
                                "inicioMes": "2026-08-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 1130739,
                                "codigo": "1905118",
                                "razaoSocial": "CEARA CIMENTOS E MATERIAIS PARA",
                                "gap": 150,
                                "aceite": true,
                                "produto": "Rejuntes"
                            },
                            {
                                "inicioMes": "2026-08-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 1130739,
                                "codigo": "1905118",
                                "razaoSocial": "CEARA CIMENTOS E MATERIAIS PARA",
                                "gap": 250,
                                "aceite": true,
                                "produto": "Colantes"
                            },
                            {
                                "inicioMes": "2026-08-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 1130739,
                                "codigo": "1905118",
                                "razaoSocial": "CEARA CIMENTOS E MATERIAIS PARA",
                                "gap": 3500,
                                "aceite": true,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-08-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 1130739,
                                "codigo": "1905118",
                                "razaoSocial": "CEARA CIMENTOS E MATERIAIS PARA",
                                "gap": 100,
                                "aceite": true,
                                "produto": "Impermeabilizantes"
                            },
                            {
                                "inicioMes": "2026-07-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 196871,
                                "codigo": "1350726",
                                "razaoSocial": "A M E MATERIAIS DE CONSTRUCAO LTDA",
                                "gap": 166.98,
                                "aceite": false,
                                "produto": "Colantes"
                            },
                            {
                                "inicioMes": "2026-04-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 196872,
                                "codigo": "1070791",
                                "razaoSocial": "FRANCISCA OTILIA DOS SANTOS SAMPAIO",
                                "gap": 212.79999999999998,
                                "aceite": false,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-04-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 196887,
                                "codigo": "1292000",
                                "razaoSocial": "SILVIO JOSE DE CASTRO SOUZA",
                                "gap": 313.59999999999997,
                                "grupoCentralizador": "CONSTRUCASTRO",
                                "aceite": false,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-04-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 180176,
                                "codigo": "1070059",
                                "razaoSocial": "DEIZIANE CHAVES BEZERRA",
                                "gap": 156.79999999999998,
                                "grupoCentralizador": "CONSTRUCASTRO",
                                "aceite": false,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-06-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 176488,
                                "codigo": "1729941",
                                "razaoSocial": "ALM COMERCIO CONSTRUCOES E",
                                "gap": 206.99999999999997,
                                "grupoCentralizador": "IMPERIO DO CIMENTO",
                                "aceite": true,
                                "produto": "Rejuntes"
                            },
                            {
                                "inicioMes": "2026-06-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 176488,
                                "codigo": "1729941",
                                "razaoSocial": "ALM COMERCIO CONSTRUCOES E",
                                "gap": 316.25,
                                "grupoCentralizador": "IMPERIO DO CIMENTO",
                                "aceite": true,
                                "produto": "Colantes"
                            },
                            {
                                "inicioMes": "2026-06-01T00:00:00",
                                "realizado": 5544,
                                "clienteId": 176488,
                                "codigo": "1729941",
                                "razaoSocial": "ALM COMERCIO CONSTRUCOES E",
                                "gap": 528,
                                "grupoCentralizador": "IMPERIO DO CIMENTO",
                                "aceite": true,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-06-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 176488,
                                "codigo": "1729941",
                                "razaoSocial": "ALM COMERCIO CONSTRUCOES E",
                                "gap": 345,
                                "grupoCentralizador": "IMPERIO DO CIMENTO",
                                "aceite": true,
                                "produto": "Impermeabilizantes"
                            },
                            {
                                "inicioMes": "2026-05-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 176488,
                                "codigo": "1729941",
                                "razaoSocial": "ALM COMERCIO CONSTRUCOES E",
                                "gap": 128,
                                "grupoCentralizador": "IMPERIO DO CIMENTO",
                                "aceite": true,
                                "produto": "Colantes"
                            },
                            {
                                "inicioMes": "2026-05-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 176488,
                                "codigo": "1729941",
                                "razaoSocial": "ALM COMERCIO CONSTRUCOES E",
                                "gap": 120,
                                "grupoCentralizador": "IMPERIO DO CIMENTO",
                                "aceite": true,
                                "produto": "Rejuntes"
                            },
                            {
                                "inicioMes": "2026-05-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 176488,
                                "codigo": "1729941",
                                "razaoSocial": "ALM COMERCIO CONSTRUCOES E",
                                "gap": 2240,
                                "grupoCentralizador": "IMPERIO DO CIMENTO",
                                "aceite": true,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-05-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 176488,
                                "codigo": "1729941",
                                "razaoSocial": "ALM COMERCIO CONSTRUCOES E",
                                "gap": 240,
                                "grupoCentralizador": "IMPERIO DO CIMENTO",
                                "aceite": true,
                                "produto": "Impermeabilizantes"
                            },
                            {
                                "inicioMes": "2026-08-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 176488,
                                "codigo": "1729941",
                                "razaoSocial": "ALM COMERCIO CONSTRUCOES E",
                                "gap": 187,
                                "grupoCentralizador": "IMPERIO DO CIMENTO",
                                "aceite": false,
                                "produto": "Rejuntes"
                            },
                            {
                                "inicioMes": "2026-08-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 176488,
                                "codigo": "1729941",
                                "razaoSocial": "ALM COMERCIO CONSTRUCOES E",
                                "gap": 126.49999999999999,
                                "grupoCentralizador": "IMPERIO DO CIMENTO",
                                "aceite": false,
                                "produto": "Colantes"
                            },
                            {
                                "inicioMes": "2026-08-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 176488,
                                "codigo": "1729941",
                                "razaoSocial": "ALM COMERCIO CONSTRUCOES E",
                                "gap": 126.5,
                                "grupoCentralizador": "IMPERIO DO CIMENTO",
                                "aceite": false,
                                "produto": "Impermeabilizantes"
                            },
                            {
                                "inicioMes": "2026-07-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 27413,
                                "codigo": "1598847",
                                "razaoSocial": "DISTRIBUIDORA IMPERIO DO CIMENTO",
                                "gap": 150,
                                "grupoCentralizador": "IMPERIO DO CIMENTO",
                                "aceite": true,
                                "produto": "Rejuntes"
                            },
                            {
                                "inicioMes": "2026-07-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 27413,
                                "codigo": "1598847",
                                "razaoSocial": "DISTRIBUIDORA IMPERIO DO CIMENTO",
                                "gap": 300,
                                "grupoCentralizador": "IMPERIO DO CIMENTO",
                                "aceite": true,
                                "produto": "Impermeabilizantes"
                            },
                            {
                                "inicioMes": "2026-07-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 27413,
                                "codigo": "1598847",
                                "razaoSocial": "DISTRIBUIDORA IMPERIO DO CIMENTO",
                                "gap": 4400,
                                "grupoCentralizador": "IMPERIO DO CIMENTO",
                                "aceite": true,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-07-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 27413,
                                "codigo": "1598847",
                                "razaoSocial": "DISTRIBUIDORA IMPERIO DO CIMENTO",
                                "gap": 100,
                                "grupoCentralizador": "IMPERIO DO CIMENTO",
                                "aceite": true,
                                "produto": "Colantes"
                            },
                            {
                                "inicioMes": "2026-04-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 27413,
                                "codigo": "1598847",
                                "razaoSocial": "DISTRIBUIDORA IMPERIO DO CIMENTO",
                                "gap": 200,
                                "grupoCentralizador": "IMPERIO DO CIMENTO",
                                "aceite": true,
                                "produto": "Colantes"
                            },
                            {
                                "inicioMes": "2026-04-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 27413,
                                "codigo": "1598847",
                                "razaoSocial": "DISTRIBUIDORA IMPERIO DO CIMENTO",
                                "gap": 240,
                                "grupoCentralizador": "IMPERIO DO CIMENTO",
                                "aceite": true,
                                "produto": "Impermeabilizantes"
                            },
                            {
                                "inicioMes": "2026-04-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 27413,
                                "codigo": "1598847",
                                "razaoSocial": "DISTRIBUIDORA IMPERIO DO CIMENTO",
                                "gap": 150,
                                "grupoCentralizador": "IMPERIO DO CIMENTO",
                                "aceite": true,
                                "produto": "Rejuntes"
                            },
                            {
                                "inicioMes": "2026-04-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 27413,
                                "codigo": "1598847",
                                "razaoSocial": "DISTRIBUIDORA IMPERIO DO CIMENTO",
                                "gap": 3100,
                                "grupoCentralizador": "IMPERIO DO CIMENTO",
                                "aceite": true,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-06-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 57845,
                                "codigo": "1508834",
                                "razaoSocial": "FORTE COMERCIO DE MATERIAL DE",
                                "gap": 180,
                                "grupoCentralizador": "FORTE COMERCIO",
                                "aceite": true,
                                "produto": "Rejuntes"
                            },
                            {
                                "inicioMes": "2026-06-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 57845,
                                "codigo": "1508834",
                                "razaoSocial": "FORTE COMERCIO DE MATERIAL DE",
                                "gap": 250,
                                "grupoCentralizador": "FORTE COMERCIO",
                                "aceite": true,
                                "produto": "Colantes"
                            },
                            {
                                "inicioMes": "2026-06-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 57845,
                                "codigo": "1508834",
                                "razaoSocial": "FORTE COMERCIO DE MATERIAL DE",
                                "gap": 300,
                                "grupoCentralizador": "FORTE COMERCIO",
                                "aceite": true,
                                "produto": "Impermeabilizantes"
                            },
                            {
                                "inicioMes": "2026-06-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 57845,
                                "codigo": "1508834",
                                "razaoSocial": "FORTE COMERCIO DE MATERIAL DE",
                                "gap": 5000,
                                "grupoCentralizador": "FORTE COMERCIO",
                                "aceite": true,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-04-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 57845,
                                "codigo": "1508834",
                                "razaoSocial": "FORTE COMERCIO DE MATERIAL DE",
                                "gap": 150,
                                "grupoCentralizador": "FORTE COMERCIO",
                                "aceite": true,
                                "produto": "Rejuntes"
                            },
                            {
                                "inicioMes": "2026-04-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 57845,
                                "codigo": "1508834",
                                "razaoSocial": "FORTE COMERCIO DE MATERIAL DE",
                                "gap": 240,
                                "grupoCentralizador": "FORTE COMERCIO",
                                "aceite": true,
                                "produto": "Colantes"
                            },
                            {
                                "inicioMes": "2026-04-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 57845,
                                "codigo": "1508834",
                                "razaoSocial": "FORTE COMERCIO DE MATERIAL DE",
                                "gap": 240,
                                "grupoCentralizador": "FORTE COMERCIO",
                                "aceite": true,
                                "produto": "Impermeabilizantes"
                            },
                            {
                                "inicioMes": "2026-04-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 57845,
                                "codigo": "1508834",
                                "razaoSocial": "FORTE COMERCIO DE MATERIAL DE",
                                "gap": 2500,
                                "grupoCentralizador": "FORTE COMERCIO",
                                "aceite": true,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-05-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 57845,
                                "codigo": "1508834",
                                "razaoSocial": "FORTE COMERCIO DE MATERIAL DE",
                                "gap": 160,
                                "grupoCentralizador": "FORTE COMERCIO",
                                "aceite": true,
                                "produto": "Colantes"
                            },
                            {
                                "inicioMes": "2026-05-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 57845,
                                "codigo": "1508834",
                                "razaoSocial": "FORTE COMERCIO DE MATERIAL DE",
                                "gap": 300,
                                "grupoCentralizador": "FORTE COMERCIO",
                                "aceite": true,
                                "produto": "Impermeabilizantes"
                            },
                            {
                                "inicioMes": "2026-05-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 57845,
                                "codigo": "1508834",
                                "razaoSocial": "FORTE COMERCIO DE MATERIAL DE",
                                "gap": 150,
                                "grupoCentralizador": "FORTE COMERCIO",
                                "aceite": true,
                                "produto": "Rejuntes"
                            },
                            {
                                "inicioMes": "2026-05-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 57845,
                                "codigo": "1508834",
                                "razaoSocial": "FORTE COMERCIO DE MATERIAL DE",
                                "gap": 2500,
                                "grupoCentralizador": "FORTE COMERCIO",
                                "aceite": true,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-08-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 57845,
                                "codigo": "1508834",
                                "razaoSocial": "FORTE COMERCIO DE MATERIAL DE",
                                "gap": 100,
                                "grupoCentralizador": "FORTE COMERCIO",
                                "aceite": true,
                                "produto": "Impermeabilizantes"
                            },
                            {
                                "inicioMes": "2026-08-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 57845,
                                "codigo": "1508834",
                                "razaoSocial": "FORTE COMERCIO DE MATERIAL DE",
                                "gap": 3500,
                                "grupoCentralizador": "FORTE COMERCIO",
                                "aceite": true,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-07-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 57845,
                                "codigo": "1508834",
                                "razaoSocial": "FORTE COMERCIO DE MATERIAL DE",
                                "gap": 5000,
                                "grupoCentralizador": "FORTE COMERCIO",
                                "aceite": true,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-07-01T00:00:00",
                                "realizado": 1120,
                                "clienteId": 64507,
                                "codigo": "1710051",
                                "razaoSocial": "COMERCIAL AVENIDA MATERIAIS DE",
                                "gap": -40,
                                "grupoCentralizador": "COMERCIAL AVENIDA",
                                "aceite": true,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-07-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 64507,
                                "codigo": "1710051",
                                "razaoSocial": "COMERCIAL AVENIDA MATERIAIS DE",
                                "gap": 150,
                                "grupoCentralizador": "COMERCIAL AVENIDA",
                                "aceite": true,
                                "produto": "Rejuntes"
                            },
                            {
                                "inicioMes": "2026-07-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 64507,
                                "codigo": "1710051",
                                "razaoSocial": "COMERCIAL AVENIDA MATERIAIS DE",
                                "gap": 156,
                                "grupoCentralizador": "COMERCIAL AVENIDA",
                                "aceite": true,
                                "produto": "Colantes"
                            },
                            {
                                "inicioMes": "2026-08-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 64507,
                                "codigo": "1710051",
                                "razaoSocial": "COMERCIAL AVENIDA MATERIAIS DE",
                                "gap": 960,
                                "grupoCentralizador": "COMERCIAL AVENIDA",
                                "aceite": true,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-08-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 64507,
                                "codigo": "1710051",
                                "razaoSocial": "COMERCIAL AVENIDA MATERIAIS DE",
                                "gap": 100,
                                "grupoCentralizador": "COMERCIAL AVENIDA",
                                "aceite": true,
                                "produto": "Colantes"
                            },
                            {
                                "inicioMes": "2026-08-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 64507,
                                "codigo": "1710051",
                                "razaoSocial": "COMERCIAL AVENIDA MATERIAIS DE",
                                "gap": 150,
                                "grupoCentralizador": "COMERCIAL AVENIDA",
                                "aceite": true,
                                "produto": "Rejuntes"
                            },
                            {
                                "inicioMes": "2026-08-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 64507,
                                "codigo": "1710051",
                                "razaoSocial": "COMERCIAL AVENIDA MATERIAIS DE",
                                "gap": 100,
                                "grupoCentralizador": "COMERCIAL AVENIDA",
                                "aceite": true,
                                "produto": "Impermeabilizantes"
                            },
                            {
                                "inicioMes": "2026-05-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 64507,
                                "codigo": "1710051",
                                "razaoSocial": "COMERCIAL AVENIDA MATERIAIS DE",
                                "gap": 184,
                                "grupoCentralizador": "COMERCIAL AVENIDA",
                                "aceite": true,
                                "produto": "Colantes"
                            },
                            {
                                "inicioMes": "2026-05-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 64507,
                                "codigo": "1710051",
                                "razaoSocial": "COMERCIAL AVENIDA MATERIAIS DE",
                                "gap": 345,
                                "grupoCentralizador": "COMERCIAL AVENIDA",
                                "aceite": true,
                                "produto": "Impermeabilizantes"
                            },
                            {
                                "inicioMes": "2026-05-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 64507,
                                "codigo": "1710051",
                                "razaoSocial": "COMERCIAL AVENIDA MATERIAIS DE",
                                "gap": 1360,
                                "grupoCentralizador": "COMERCIAL AVENIDA",
                                "aceite": true,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-05-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 64507,
                                "codigo": "1710051",
                                "razaoSocial": "COMERCIAL AVENIDA MATERIAIS DE",
                                "gap": 172.5,
                                "grupoCentralizador": "COMERCIAL AVENIDA",
                                "aceite": true,
                                "produto": "Rejuntes"
                            },
                            {
                                "inicioMes": "2026-04-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 64507,
                                "codigo": "1710051",
                                "razaoSocial": "COMERCIAL AVENIDA MATERIAIS DE",
                                "gap": 160,
                                "grupoCentralizador": "COMERCIAL AVENIDA",
                                "aceite": true,
                                "produto": "Colantes"
                            },
                            {
                                "inicioMes": "2026-04-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 64507,
                                "codigo": "1710051",
                                "razaoSocial": "COMERCIAL AVENIDA MATERIAIS DE",
                                "gap": 240,
                                "grupoCentralizador": "COMERCIAL AVENIDA",
                                "aceite": true,
                                "produto": "Impermeabilizantes"
                            },
                            {
                                "inicioMes": "2026-04-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 64507,
                                "codigo": "1710051",
                                "razaoSocial": "COMERCIAL AVENIDA MATERIAIS DE",
                                "gap": 150,
                                "grupoCentralizador": "COMERCIAL AVENIDA",
                                "aceite": true,
                                "produto": "Rejuntes"
                            },
                            {
                                "inicioMes": "2026-04-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 64507,
                                "codigo": "1710051",
                                "razaoSocial": "COMERCIAL AVENIDA MATERIAIS DE",
                                "gap": 620,
                                "grupoCentralizador": "COMERCIAL AVENIDA",
                                "aceite": true,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-04-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 327595,
                                "codigo": "1067668",
                                "razaoSocial": "LEONCIO MATERIAIS DE CONSTRUCAO E C",
                                "gap": 150,
                                "grupoCentralizador": "GLAISON ALMEIDA",
                                "aceite": true,
                                "produto": "Rejuntes"
                            },
                            {
                                "inicioMes": "2026-04-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 327595,
                                "codigo": "1067668",
                                "razaoSocial": "LEONCIO MATERIAIS DE CONSTRUCAO E C",
                                "gap": 240,
                                "grupoCentralizador": "GLAISON ALMEIDA",
                                "aceite": true,
                                "produto": "Impermeabilizantes"
                            },
                            {
                                "inicioMes": "2026-04-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 327595,
                                "codigo": "1067668",
                                "razaoSocial": "LEONCIO MATERIAIS DE CONSTRUCAO E C",
                                "gap": 160,
                                "grupoCentralizador": "GLAISON ALMEIDA",
                                "aceite": true,
                                "produto": "Colantes"
                            },
                            {
                                "inicioMes": "2026-04-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 327595,
                                "codigo": "1067668",
                                "razaoSocial": "LEONCIO MATERIAIS DE CONSTRUCAO E C",
                                "gap": 2500,
                                "grupoCentralizador": "GLAISON ALMEIDA",
                                "aceite": true,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-05-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 327595,
                                "codigo": "1067668",
                                "razaoSocial": "LEONCIO MATERIAIS DE CONSTRUCAO E C",
                                "gap": 150,
                                "grupoCentralizador": "GLAISON ALMEIDA",
                                "aceite": true,
                                "produto": "Rejuntes"
                            },
                            {
                                "inicioMes": "2026-05-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 327595,
                                "codigo": "1067668",
                                "razaoSocial": "LEONCIO MATERIAIS DE CONSTRUCAO E C",
                                "gap": 160,
                                "grupoCentralizador": "GLAISON ALMEIDA",
                                "aceite": true,
                                "produto": "Colantes"
                            },
                            {
                                "inicioMes": "2026-05-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 327595,
                                "codigo": "1067668",
                                "razaoSocial": "LEONCIO MATERIAIS DE CONSTRUCAO E C",
                                "gap": 2500,
                                "grupoCentralizador": "GLAISON ALMEIDA",
                                "aceite": true,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-05-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 327595,
                                "codigo": "1067668",
                                "razaoSocial": "LEONCIO MATERIAIS DE CONSTRUCAO E C",
                                "gap": 300,
                                "grupoCentralizador": "GLAISON ALMEIDA",
                                "aceite": true,
                                "produto": "Impermeabilizantes"
                            },
                            {
                                "inicioMes": "2026-07-01T00:00:00",
                                "realizado": 5010,
                                "clienteId": 327595,
                                "codigo": "1067668",
                                "razaoSocial": "LEONCIO MATERIAIS DE CONSTRUCAO E C",
                                "gap": -10,
                                "grupoCentralizador": "GLAISON ALMEIDA",
                                "aceite": true,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-07-01T00:00:00",
                                "realizado": 105,
                                "clienteId": 327595,
                                "codigo": "1067668",
                                "razaoSocial": "LEONCIO MATERIAIS DE CONSTRUCAO E C",
                                "gap": -5,
                                "grupoCentralizador": "GLAISON ALMEIDA",
                                "aceite": true,
                                "produto": "Colantes"
                            },
                            {
                                "inicioMes": "2026-07-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 327595,
                                "codigo": "1067668",
                                "razaoSocial": "LEONCIO MATERIAIS DE CONSTRUCAO E C",
                                "gap": 150,
                                "grupoCentralizador": "GLAISON ALMEIDA",
                                "aceite": true,
                                "produto": "Rejuntes"
                            },
                            {
                                "inicioMes": "2026-08-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 327595,
                                "codigo": "1067668",
                                "razaoSocial": "LEONCIO MATERIAIS DE CONSTRUCAO E C",
                                "gap": 100,
                                "grupoCentralizador": "GLAISON ALMEIDA",
                                "aceite": false,
                                "produto": "Impermeabilizantes"
                            },
                            {
                                "inicioMes": "2026-08-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 327595,
                                "codigo": "1067668",
                                "razaoSocial": "LEONCIO MATERIAIS DE CONSTRUCAO E C",
                                "gap": 100,
                                "grupoCentralizador": "GLAISON ALMEIDA",
                                "aceite": false,
                                "produto": "Colantes"
                            },
                            {
                                "inicioMes": "2026-08-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 327595,
                                "codigo": "1067668",
                                "razaoSocial": "LEONCIO MATERIAIS DE CONSTRUCAO E C",
                                "gap": 3500,
                                "grupoCentralizador": "GLAISON ALMEIDA",
                                "aceite": false,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-08-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 327595,
                                "codigo": "1067668",
                                "razaoSocial": "LEONCIO MATERIAIS DE CONSTRUCAO E C",
                                "gap": 150,
                                "grupoCentralizador": "GLAISON ALMEIDA",
                                "aceite": false,
                                "produto": "Rejuntes"
                            },
                            {
                                "inicioMes": "2026-06-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 327595,
                                "codigo": "1067668",
                                "razaoSocial": "LEONCIO MATERIAIS DE CONSTRUCAO E C",
                                "gap": 180,
                                "grupoCentralizador": "GLAISON ALMEIDA",
                                "aceite": true,
                                "produto": "Rejuntes"
                            },
                            {
                                "inicioMes": "2026-06-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 327595,
                                "codigo": "1067668",
                                "razaoSocial": "LEONCIO MATERIAIS DE CONSTRUCAO E C",
                                "gap": 300,
                                "grupoCentralizador": "GLAISON ALMEIDA",
                                "aceite": true,
                                "produto": "Impermeabilizantes"
                            },
                            {
                                "inicioMes": "2026-06-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 327595,
                                "codigo": "1067668",
                                "razaoSocial": "LEONCIO MATERIAIS DE CONSTRUCAO E C",
                                "gap": 5000,
                                "grupoCentralizador": "GLAISON ALMEIDA",
                                "aceite": true,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-06-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 327595,
                                "codigo": "1067668",
                                "razaoSocial": "LEONCIO MATERIAIS DE CONSTRUCAO E C",
                                "gap": 250,
                                "grupoCentralizador": "GLAISON ALMEIDA",
                                "aceite": true,
                                "produto": "Colantes"
                            },
                            {
                                "inicioMes": "2026-04-01T00:00:00",
                                "realizado": 165,
                                "clienteId": 176581,
                                "codigo": "1672180",
                                "razaoSocial": "MARACANAU CONSTRUCOES E SERVICOS",
                                "gap": -15,
                                "grupoCentralizador": "MARACANAU CONSTRUCOES",
                                "aceite": true,
                                "produto": "Rejuntes"
                            },
                            {
                                "inicioMes": "2026-04-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 176581,
                                "codigo": "1672180",
                                "razaoSocial": "MARACANAU CONSTRUCOES E SERVICOS",
                                "gap": 160,
                                "grupoCentralizador": "MARACANAU CONSTRUCOES",
                                "aceite": true,
                                "produto": "Colantes"
                            },
                            {
                                "inicioMes": "2026-04-01T00:00:00",
                                "realizado": 4352,
                                "clienteId": 176581,
                                "codigo": "1672180",
                                "razaoSocial": "MARACANAU CONSTRUCOES E SERVICOS",
                                "gap": 48,
                                "grupoCentralizador": "MARACANAU CONSTRUCOES",
                                "aceite": true,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-04-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 176581,
                                "codigo": "1672180",
                                "razaoSocial": "MARACANAU CONSTRUCOES E SERVICOS",
                                "gap": 240,
                                "grupoCentralizador": "MARACANAU CONSTRUCOES",
                                "aceite": true,
                                "produto": "Impermeabilizantes"
                            }
                        ]
                    },
                    {
                        "id": -8,
                        "linhaTempoVolume": [
                            {
                                "inicioMes": "2026-04-01T00:00:00",
                                "realizado": 10,
                                "clienteId": 64706,
                                "codigo": "1697436",
                                "razaoSocial": "JEFERSON ILTON DE MEDEIROS DANTAS",
                                "gap": 14,
                                "aceite": true,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-04-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 64706,
                                "codigo": "1697436",
                                "razaoSocial": "JEFERSON ILTON DE MEDEIROS DANTAS",
                                "gap": 0.3,
                                "aceite": true,
                                "produto": "Rejuntes"
                            },
                            {
                                "inicioMes": "2026-04-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 64706,
                                "codigo": "1697436",
                                "razaoSocial": "JEFERSON ILTON DE MEDEIROS DANTAS",
                                "gap": 0.3,
                                "aceite": true,
                                "produto": "Impermeabilizantes"
                            },
                            {
                                "inicioMes": "2026-04-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 64706,
                                "codigo": "1697436",
                                "razaoSocial": "JEFERSON ILTON DE MEDEIROS DANTAS",
                                "gap": 4,
                                "aceite": true,
                                "produto": "Colantes"
                            },
                            {
                                "inicioMes": "2026-08-01T00:00:00",
                                "realizado": 6,
                                "clienteId": 64706,
                                "codigo": "1697436",
                                "razaoSocial": "JEFERSON ILTON DE MEDEIROS DANTAS",
                                "gap": 22,
                                "aceite": false,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-08-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 64706,
                                "codigo": "1697436",
                                "razaoSocial": "JEFERSON ILTON DE MEDEIROS DANTAS",
                                "gap": 4.6,
                                "aceite": false,
                                "produto": "Colantes"
                            },
                            {
                                "inicioMes": "2026-08-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 64706,
                                "codigo": "1697436",
                                "razaoSocial": "JEFERSON ILTON DE MEDEIROS DANTAS",
                                "gap": 0.23,
                                "aceite": false,
                                "produto": "Impermeabilizantes"
                            },
                            {
                                "inicioMes": "2026-08-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 64706,
                                "codigo": "1697436",
                                "razaoSocial": "JEFERSON ILTON DE MEDEIROS DANTAS",
                                "gap": 0.34,
                                "aceite": false,
                                "produto": "Rejuntes"
                            },
                            {
                                "inicioMes": "2026-05-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 64706,
                                "codigo": "1697436",
                                "razaoSocial": "JEFERSON ILTON DE MEDEIROS DANTAS",
                                "gap": 0.345,
                                "aceite": true,
                                "produto": "Rejuntes"
                            },
                            {
                                "inicioMes": "2026-05-01T00:00:00",
                                "realizado": 16,
                                "clienteId": 64706,
                                "codigo": "1697436",
                                "razaoSocial": "JEFERSON ILTON DE MEDEIROS DANTAS",
                                "gap": 8,
                                "aceite": true,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-05-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 64706,
                                "codigo": "1697436",
                                "razaoSocial": "JEFERSON ILTON DE MEDEIROS DANTAS",
                                "gap": 0.345,
                                "aceite": true,
                                "produto": "Impermeabilizantes"
                            },
                            {
                                "inicioMes": "2026-05-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 64706,
                                "codigo": "1697436",
                                "razaoSocial": "JEFERSON ILTON DE MEDEIROS DANTAS",
                                "gap": 4.6,
                                "aceite": true,
                                "produto": "Colantes"
                            },
                            {
                                "inicioMes": "2026-05-01T00:00:00",
                                "realizado": 0.3,
                                "clienteId": 107309,
                                "codigo": "1424376",
                                "razaoSocial": "GEOVANE BARROS DE OLIVEIRA",
                                "gap": 4.3,
                                "aceite": true,
                                "produto": "Colantes"
                            },
                            {
                                "inicioMes": "2026-05-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 107309,
                                "codigo": "1424376",
                                "razaoSocial": "GEOVANE BARROS DE OLIVEIRA",
                                "gap": 0.345,
                                "aceite": true,
                                "produto": "Rejuntes"
                            },
                            {
                                "inicioMes": "2026-05-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 107309,
                                "codigo": "1424376",
                                "razaoSocial": "GEOVANE BARROS DE OLIVEIRA",
                                "gap": 0.345,
                                "aceite": true,
                                "produto": "Impermeabilizantes"
                            },
                            {
                                "inicioMes": "2026-05-01T00:00:00",
                                "realizado": 10,
                                "clienteId": 107309,
                                "codigo": "1424376",
                                "razaoSocial": "GEOVANE BARROS DE OLIVEIRA",
                                "gap": 6,
                                "aceite": true,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-04-01T00:00:00",
                                "realizado": 0.6,
                                "clienteId": 107309,
                                "codigo": "1424376",
                                "razaoSocial": "GEOVANE BARROS DE OLIVEIRA",
                                "gap": 3.4,
                                "aceite": true,
                                "produto": "Colantes"
                            },
                            {
                                "inicioMes": "2026-04-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 107309,
                                "codigo": "1424376",
                                "razaoSocial": "GEOVANE BARROS DE OLIVEIRA",
                                "gap": 0.3,
                                "aceite": true,
                                "produto": "Rejuntes"
                            },
                            {
                                "inicioMes": "2026-04-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 107309,
                                "codigo": "1424376",
                                "razaoSocial": "GEOVANE BARROS DE OLIVEIRA",
                                "gap": 0.3,
                                "aceite": true,
                                "produto": "Impermeabilizantes"
                            },
                            {
                                "inicioMes": "2026-04-01T00:00:00",
                                "realizado": 12,
                                "clienteId": 107309,
                                "codigo": "1424376",
                                "razaoSocial": "GEOVANE BARROS DE OLIVEIRA",
                                "gap": 5,
                                "aceite": true,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-08-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 107309,
                                "codigo": "1424376",
                                "razaoSocial": "GEOVANE BARROS DE OLIVEIRA",
                                "gap": 0.34,
                                "aceite": false,
                                "produto": "Rejuntes"
                            },
                            {
                                "inicioMes": "2026-08-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 107309,
                                "codigo": "1424376",
                                "razaoSocial": "GEOVANE BARROS DE OLIVEIRA",
                                "gap": 4.6,
                                "aceite": false,
                                "produto": "Colantes"
                            },
                            {
                                "inicioMes": "2026-08-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 107309,
                                "codigo": "1424376",
                                "razaoSocial": "GEOVANE BARROS DE OLIVEIRA",
                                "gap": 0.23,
                                "aceite": false,
                                "produto": "Impermeabilizantes"
                            },
                            {
                                "inicioMes": "2026-08-01T00:00:00",
                                "realizado": 2,
                                "clienteId": 107309,
                                "codigo": "1424376",
                                "razaoSocial": "GEOVANE BARROS DE OLIVEIRA",
                                "gap": 24,
                                "aceite": false,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-05-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 107313,
                                "codigo": "1706517",
                                "razaoSocial": "DEPOSITO LIMA LTDA",
                                "gap": 0.345,
                                "aceite": true,
                                "produto": "Rejuntes"
                            },
                            {
                                "inicioMes": "2026-05-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 107313,
                                "codigo": "1706517",
                                "razaoSocial": "DEPOSITO LIMA LTDA",
                                "gap": 0.345,
                                "aceite": true,
                                "produto": "Impermeabilizantes"
                            },
                            {
                                "inicioMes": "2026-05-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 107313,
                                "codigo": "1706517",
                                "razaoSocial": "DEPOSITO LIMA LTDA",
                                "gap": 4.6,
                                "aceite": true,
                                "produto": "Colantes"
                            },
                            {
                                "inicioMes": "2026-05-01T00:00:00",
                                "realizado": 30,
                                "clienteId": 107313,
                                "codigo": "1706517",
                                "razaoSocial": "DEPOSITO LIMA LTDA",
                                "gap": 16,
                                "aceite": true,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-06-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 107313,
                                "codigo": "1706517",
                                "razaoSocial": "DEPOSITO LIMA LTDA",
                                "gap": 2.3,
                                "aceite": true,
                                "produto": "Colantes"
                            },
                            {
                                "inicioMes": "2026-06-01T00:00:00",
                                "realizado": 20,
                                "clienteId": 107313,
                                "codigo": "1706517",
                                "razaoSocial": "DEPOSITO LIMA LTDA",
                                "gap": 14,
                                "aceite": true,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-06-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 107313,
                                "codigo": "1706517",
                                "razaoSocial": "DEPOSITO LIMA LTDA",
                                "gap": 0.345,
                                "aceite": true,
                                "produto": "Rejuntes"
                            },
                            {
                                "inicioMes": "2026-06-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 107313,
                                "codigo": "1706517",
                                "razaoSocial": "DEPOSITO LIMA LTDA",
                                "gap": 0.345,
                                "aceite": true,
                                "produto": "Impermeabilizantes"
                            },
                            {
                                "inicioMes": "2026-08-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 107313,
                                "codigo": "1706517",
                                "razaoSocial": "DEPOSITO LIMA LTDA",
                                "gap": 0.23,
                                "aceite": false,
                                "produto": "Impermeabilizantes"
                            },
                            {
                                "inicioMes": "2026-08-01T00:00:00",
                                "realizado": 10,
                                "clienteId": 107313,
                                "codigo": "1706517",
                                "razaoSocial": "DEPOSITO LIMA LTDA",
                                "gap": 32,
                                "aceite": false,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-07-01T00:00:00",
                                "realizado": 0.3,
                                "clienteId": 107313,
                                "codigo": "1706517",
                                "razaoSocial": "DEPOSITO LIMA LTDA",
                                "gap": 1.9999999999999998,
                                "aceite": false,
                                "produto": "Colantes"
                            },
                            {
                                "inicioMes": "2026-07-01T00:00:00",
                                "realizado": 17.55,
                                "clienteId": 107316,
                                "codigo": "1733883",
                                "razaoSocial": "EDIFICA MATERIAIS PARA CONSTRUCAO",
                                "gap": -7.15,
                                "aceite": true,
                                "produto": "Colantes"
                            },
                            {
                                "inicioMes": "2026-07-01T00:00:00",
                                "realizado": 14.25,
                                "clienteId": 107316,
                                "codigo": "1733883",
                                "razaoSocial": "EDIFICA MATERIAIS PARA CONSTRUCAO",
                                "gap": 25.75,
                                "aceite": true,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-08-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 107316,
                                "codigo": "1733883",
                                "razaoSocial": "EDIFICA MATERIAIS PARA CONSTRUCAO",
                                "gap": 0.29,
                                "aceite": false,
                                "produto": "Impermeabilizantes"
                            },
                            {
                                "inicioMes": "2026-08-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 107316,
                                "codigo": "1733883",
                                "razaoSocial": "EDIFICA MATERIAIS PARA CONSTRUCAO",
                                "gap": 0.34,
                                "aceite": false,
                                "produto": "Rejuntes"
                            },
                            {
                                "inicioMes": "2026-08-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 107316,
                                "codigo": "1733883",
                                "razaoSocial": "EDIFICA MATERIAIS PARA CONSTRUCAO",
                                "gap": 13.8,
                                "aceite": false,
                                "produto": "Colantes"
                            },
                            {
                                "inicioMes": "2026-08-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 107316,
                                "codigo": "1733883",
                                "razaoSocial": "EDIFICA MATERIAIS PARA CONSTRUCAO",
                                "gap": 34,
                                "aceite": false,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-04-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 107317,
                                "codigo": "1778028",
                                "razaoSocial": "MARCOPISOS LTDA",
                                "gap": 0.3,
                                "aceite": true,
                                "produto": "Rejuntes"
                            },
                            {
                                "inicioMes": "2026-04-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 107317,
                                "codigo": "1778028",
                                "razaoSocial": "MARCOPISOS LTDA",
                                "gap": 14,
                                "aceite": true,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-04-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 107317,
                                "codigo": "1778028",
                                "razaoSocial": "MARCOPISOS LTDA",
                                "gap": 0.6,
                                "aceite": true,
                                "produto": "Impermeabilizantes"
                            },
                            {
                                "inicioMes": "2026-04-01T00:00:00",
                                "realizado": 1.5,
                                "clienteId": 107317,
                                "codigo": "1778028",
                                "razaoSocial": "MARCOPISOS LTDA",
                                "gap": 3.5,
                                "aceite": true,
                                "produto": "Colantes"
                            },
                            {
                                "inicioMes": "2026-04-01T00:00:00",
                                "realizado": 0.75,
                                "clienteId": 134210,
                                "codigo": "1130442",
                                "razaoSocial": "J  AUGUSTO PINHEIRO PAPELARIA",
                                "gap": 10,
                                "aceite": false,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-06-01T00:00:00",
                                "realizado": 0.02,
                                "clienteId": 176068,
                                "codigo": "1724963",
                                "razaoSocial": "MENEZES CIMENTOS LTDA",
                                "gap": 0.27999999999999997,
                                "aceite": true,
                                "produto": "Rejuntes"
                            },
                            {
                                "inicioMes": "2026-06-01T00:00:00",
                                "realizado": 626,
                                "clienteId": 176068,
                                "codigo": "1724963",
                                "razaoSocial": "MENEZES CIMENTOS LTDA",
                                "gap": -76,
                                "aceite": true,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-06-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 176068,
                                "codigo": "1724963",
                                "razaoSocial": "MENEZES CIMENTOS LTDA",
                                "gap": 0.3,
                                "aceite": true,
                                "produto": "Impermeabilizantes"
                            },
                            {
                                "inicioMes": "2026-06-01T00:00:00",
                                "realizado": 0.3,
                                "clienteId": 176068,
                                "codigo": "1724963",
                                "razaoSocial": "MENEZES CIMENTOS LTDA",
                                "gap": 4.7,
                                "aceite": true,
                                "produto": "Colantes"
                            },
                            {
                                "inicioMes": "2026-07-01T00:00:00",
                                "realizado": 714,
                                "clienteId": 176068,
                                "codigo": "1724963",
                                "razaoSocial": "MENEZES CIMENTOS LTDA",
                                "gap": -146,
                                "aceite": true,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-07-01T00:00:00",
                                "realizado": 0.02,
                                "clienteId": 176068,
                                "codigo": "1724963",
                                "razaoSocial": "MENEZES CIMENTOS LTDA",
                                "gap": 0.36,
                                "aceite": true,
                                "produto": "Rejuntes"
                            },
                            {
                                "inicioMes": "2026-07-01T00:00:00",
                                "realizado": 0.3,
                                "clienteId": 176068,
                                "codigo": "1724963",
                                "razaoSocial": "MENEZES CIMENTOS LTDA",
                                "gap": 4.9,
                                "aceite": true,
                                "produto": "Colantes"
                            },
                            {
                                "inicioMes": "2026-07-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 176068,
                                "codigo": "1724963",
                                "razaoSocial": "MENEZES CIMENTOS LTDA",
                                "gap": 0.38,
                                "aceite": true,
                                "produto": "Impermeabilizantes"
                            },
                            {
                                "inicioMes": "2026-04-01T00:00:00",
                                "realizado": 0.2,
                                "clienteId": 176068,
                                "codigo": "1724963",
                                "razaoSocial": "MENEZES CIMENTOS LTDA",
                                "gap": 0.09999999999999998,
                                "aceite": true,
                                "produto": "Rejuntes"
                            },
                            {
                                "inicioMes": "2026-04-01T00:00:00",
                                "realizado": 0.99,
                                "clienteId": 176068,
                                "codigo": "1724963",
                                "razaoSocial": "MENEZES CIMENTOS LTDA",
                                "gap": 4.01,
                                "aceite": true,
                                "produto": "Colantes"
                            },
                            {
                                "inicioMes": "2026-04-01T00:00:00",
                                "realizado": 0.032,
                                "clienteId": 176068,
                                "codigo": "1724963",
                                "razaoSocial": "MENEZES CIMENTOS LTDA",
                                "gap": 0.268,
                                "aceite": true,
                                "produto": "Impermeabilizantes"
                            },
                            {
                                "inicioMes": "2026-04-01T00:00:00",
                                "realizado": 586,
                                "clienteId": 176068,
                                "codigo": "1724963",
                                "razaoSocial": "MENEZES CIMENTOS LTDA",
                                "gap": -76,
                                "aceite": true,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-08-01T00:00:00",
                                "realizado": 10,
                                "clienteId": 176069,
                                "codigo": "1759677",
                                "razaoSocial": "ELLAS MATERIAIS DE CONSTRUCOES LTDA",
                                "gap": 56,
                                "aceite": false,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-08-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 176069,
                                "codigo": "1759677",
                                "razaoSocial": "ELLAS MATERIAIS DE CONSTRUCOES LTDA",
                                "gap": 0.23,
                                "aceite": false,
                                "produto": "Impermeabilizantes"
                            },
                            {
                                "inicioMes": "2026-08-01T00:00:00",
                                "realizado": 2.4,
                                "clienteId": 176069,
                                "codigo": "1759677",
                                "razaoSocial": "ELLAS MATERIAIS DE CONSTRUCOES LTDA",
                                "gap": 2.1999999999999997,
                                "aceite": false,
                                "produto": "Colantes"
                            },
                            {
                                "inicioMes": "2026-08-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 176069,
                                "codigo": "1759677",
                                "razaoSocial": "ELLAS MATERIAIS DE CONSTRUCOES LTDA",
                                "gap": 0.34,
                                "aceite": false,
                                "produto": "Rejuntes"
                            },
                            {
                                "inicioMes": "2026-06-01T00:00:00",
                                "realizado": 0.1,
                                "clienteId": 176069,
                                "codigo": "1759677",
                                "razaoSocial": "ELLAS MATERIAIS DE CONSTRUCOES LTDA",
                                "gap": 0.24499999999999997,
                                "aceite": false,
                                "produto": "Rejuntes"
                            },
                            {
                                "inicioMes": "2026-06-01T00:00:00",
                                "realizado": 2.4,
                                "clienteId": 176069,
                                "codigo": "1759677",
                                "razaoSocial": "ELLAS MATERIAIS DE CONSTRUCOES LTDA",
                                "gap": 3.35,
                                "aceite": false,
                                "produto": "Colantes"
                            },
                            {
                                "inicioMes": "2026-06-01T00:00:00",
                                "realizado": 0.108,
                                "clienteId": 176069,
                                "codigo": "1759677",
                                "razaoSocial": "ELLAS MATERIAIS DE CONSTRUCOES LTDA",
                                "gap": 0.237,
                                "aceite": false,
                                "produto": "Impermeabilizantes"
                            },
                            {
                                "inicioMes": "2026-06-01T00:00:00",
                                "realizado": 10.25,
                                "clienteId": 176069,
                                "codigo": "1759677",
                                "razaoSocial": "ELLAS MATERIAIS DE CONSTRUCOES LTDA",
                                "gap": 31.75,
                                "aceite": false,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-07-01T00:00:00",
                                "realizado": 0.9,
                                "clienteId": 64505,
                                "codigo": "1068160",
                                "razaoSocial": "LETICIA CAVALCANTE HOLANDA",
                                "gap": 1.1,
                                "aceite": true,
                                "produto": "Colantes"
                            },
                            {
                                "inicioMes": "2026-08-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 64505,
                                "codigo": "1068160",
                                "razaoSocial": "LETICIA CAVALCANTE HOLANDA",
                                "gap": 0.23,
                                "aceite": false,
                                "produto": "Impermeabilizantes"
                            },
                            {
                                "inicioMes": "2026-08-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 64505,
                                "codigo": "1068160",
                                "razaoSocial": "LETICIA CAVALCANTE HOLANDA",
                                "gap": 0.34,
                                "aceite": false,
                                "produto": "Rejuntes"
                            },
                            {
                                "inicioMes": "2026-08-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 64505,
                                "codigo": "1068160",
                                "razaoSocial": "LETICIA CAVALCANTE HOLANDA",
                                "gap": 4.6,
                                "aceite": false,
                                "produto": "Colantes"
                            },
                            {
                                "inicioMes": "2026-08-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 64505,
                                "codigo": "1068160",
                                "razaoSocial": "LETICIA CAVALCANTE HOLANDA",
                                "gap": 40,
                                "aceite": false,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-06-01T00:00:00",
                                "realizado": 34,
                                "clienteId": 64505,
                                "codigo": "1068160",
                                "razaoSocial": "LETICIA CAVALCANTE HOLANDA",
                                "gap": 0,
                                "aceite": true,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-06-01T00:00:00",
                                "realizado": 0.02,
                                "clienteId": 64505,
                                "codigo": "1068160",
                                "razaoSocial": "LETICIA CAVALCANTE HOLANDA",
                                "gap": 0.32499999999999996,
                                "aceite": true,
                                "produto": "Rejuntes"
                            },
                            {
                                "inicioMes": "2026-06-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 64505,
                                "codigo": "1068160",
                                "razaoSocial": "LETICIA CAVALCANTE HOLANDA",
                                "gap": 0.345,
                                "aceite": true,
                                "produto": "Impermeabilizantes"
                            },
                            {
                                "inicioMes": "2026-06-01T00:00:00",
                                "realizado": 0.3,
                                "clienteId": 64505,
                                "codigo": "1068160",
                                "razaoSocial": "LETICIA CAVALCANTE HOLANDA",
                                "gap": 3.1500000000000004,
                                "aceite": true,
                                "produto": "Colantes"
                            },
                            {
                                "inicioMes": "2026-05-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 64505,
                                "codigo": "1068160",
                                "razaoSocial": "LETICIA CAVALCANTE HOLANDA",
                                "gap": 0.345,
                                "aceite": true,
                                "produto": "Rejuntes"
                            },
                            {
                                "inicioMes": "2026-05-01T00:00:00",
                                "realizado": 28,
                                "clienteId": 64505,
                                "codigo": "1068160",
                                "razaoSocial": "LETICIA CAVALCANTE HOLANDA",
                                "gap": 0,
                                "aceite": true,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-05-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 64505,
                                "codigo": "1068160",
                                "razaoSocial": "LETICIA CAVALCANTE HOLANDA",
                                "gap": 0.345,
                                "aceite": true,
                                "produto": "Impermeabilizantes"
                            },
                            {
                                "inicioMes": "2026-05-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 64505,
                                "codigo": "1068160",
                                "razaoSocial": "LETICIA CAVALCANTE HOLANDA",
                                "gap": 4.6,
                                "aceite": true,
                                "produto": "Colantes"
                            },
                            {
                                "inicioMes": "2026-04-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 180174,
                                "codigo": "1242458",
                                "razaoSocial": "DIVA MAGNA BERNARDINO FERREIRA",
                                "gap": 0.3,
                                "aceite": true,
                                "produto": "Rejuntes"
                            },
                            {
                                "inicioMes": "2026-04-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 180174,
                                "codigo": "1242458",
                                "razaoSocial": "DIVA MAGNA BERNARDINO FERREIRA",
                                "gap": 0.3,
                                "aceite": true,
                                "produto": "Impermeabilizantes"
                            },
                            {
                                "inicioMes": "2026-04-01T00:00:00",
                                "realizado": 207.75,
                                "clienteId": 180174,
                                "codigo": "1242458",
                                "razaoSocial": "DIVA MAGNA BERNARDINO FERREIRA",
                                "gap": 102.25,
                                "aceite": true,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-04-01T00:00:00",
                                "realizado": 4.05,
                                "clienteId": 180174,
                                "codigo": "1242458",
                                "razaoSocial": "DIVA MAGNA BERNARDINO FERREIRA",
                                "gap": -0.04999999999999982,
                                "aceite": true,
                                "produto": "Colantes"
                            },
                            {
                                "inicioMes": "2026-05-01T00:00:00",
                                "realizado": 348.5,
                                "clienteId": 180174,
                                "codigo": "1242458",
                                "razaoSocial": "DIVA MAGNA BERNARDINO FERREIRA",
                                "gap": -48.5,
                                "aceite": true,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-05-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 180174,
                                "codigo": "1242458",
                                "razaoSocial": "DIVA MAGNA BERNARDINO FERREIRA",
                                "gap": 0.345,
                                "aceite": true,
                                "produto": "Impermeabilizantes"
                            },
                            {
                                "inicioMes": "2026-05-01T00:00:00",
                                "realizado": 2.4,
                                "clienteId": 180174,
                                "codigo": "1242458",
                                "razaoSocial": "DIVA MAGNA BERNARDINO FERREIRA",
                                "gap": 1.6,
                                "aceite": true,
                                "produto": "Colantes"
                            },
                            {
                                "inicioMes": "2026-05-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 180174,
                                "codigo": "1242458",
                                "razaoSocial": "DIVA MAGNA BERNARDINO FERREIRA",
                                "gap": 0.345,
                                "aceite": true,
                                "produto": "Rejuntes"
                            },
                            {
                                "inicioMes": "2026-07-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 180174,
                                "codigo": "1242458",
                                "razaoSocial": "DIVA MAGNA BERNARDINO FERREIRA",
                                "gap": 0.38,
                                "aceite": true,
                                "produto": "Impermeabilizantes"
                            },
                            {
                                "inicioMes": "2026-07-01T00:00:00",
                                "realizado": 4.35,
                                "clienteId": 180174,
                                "codigo": "1242458",
                                "razaoSocial": "DIVA MAGNA BERNARDINO FERREIRA",
                                "gap": -0.34999999999999964,
                                "aceite": true,
                                "produto": "Colantes"
                            },
                            {
                                "inicioMes": "2026-07-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 180174,
                                "codigo": "1242458",
                                "razaoSocial": "DIVA MAGNA BERNARDINO FERREIRA",
                                "gap": 0.38,
                                "aceite": true,
                                "produto": "Rejuntes"
                            },
                            {
                                "inicioMes": "2026-07-01T00:00:00",
                                "realizado": 342,
                                "clienteId": 180174,
                                "codigo": "1242458",
                                "razaoSocial": "DIVA MAGNA BERNARDINO FERREIRA",
                                "gap": -12,
                                "aceite": true,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-08-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 180174,
                                "codigo": "1242458",
                                "razaoSocial": "DIVA MAGNA BERNARDINO FERREIRA",
                                "gap": 4,
                                "aceite": true,
                                "produto": "Colantes"
                            },
                            {
                                "inicioMes": "2026-08-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 180174,
                                "codigo": "1242458",
                                "razaoSocial": "DIVA MAGNA BERNARDINO FERREIRA",
                                "gap": 0.38,
                                "aceite": true,
                                "produto": "Rejuntes"
                            },
                            {
                                "inicioMes": "2026-08-01T00:00:00",
                                "realizado": 74.25,
                                "clienteId": 180174,
                                "codigo": "1242458",
                                "razaoSocial": "DIVA MAGNA BERNARDINO FERREIRA",
                                "gap": 245.75,
                                "aceite": true,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-05-01T00:00:00",
                                "realizado": 0.209,
                                "clienteId": 196923,
                                "codigo": "1440065",
                                "razaoSocial": "F A F DA SILVA LTDA",
                                "gap": 0.091,
                                "aceite": true,
                                "produto": "Impermeabilizantes"
                            },
                            {
                                "inicioMes": "2026-05-01T00:00:00",
                                "realizado": 0.24,
                                "clienteId": 196923,
                                "codigo": "1440065",
                                "razaoSocial": "F A F DA SILVA LTDA",
                                "gap": 0.06,
                                "aceite": true,
                                "produto": "Rejuntes"
                            },
                            {
                                "inicioMes": "2026-05-01T00:00:00",
                                "realizado": 88.25,
                                "clienteId": 196923,
                                "codigo": "1440065",
                                "razaoSocial": "F A F DA SILVA LTDA",
                                "gap": -12.25,
                                "aceite": true,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-05-01T00:00:00",
                                "realizado": 4.5,
                                "clienteId": 196923,
                                "codigo": "1440065",
                                "razaoSocial": "F A F DA SILVA LTDA",
                                "gap": 0.5,
                                "aceite": true,
                                "produto": "Colantes"
                            },
                            {
                                "inicioMes": "2026-04-01T00:00:00",
                                "realizado": 0.02,
                                "clienteId": 196923,
                                "codigo": "1440065",
                                "razaoSocial": "F A F DA SILVA LTDA",
                                "gap": 0.27999999999999997,
                                "aceite": true,
                                "produto": "Rejuntes"
                            },
                            {
                                "inicioMes": "2026-04-01T00:00:00",
                                "realizado": 0.108,
                                "clienteId": 196923,
                                "codigo": "1440065",
                                "razaoSocial": "F A F DA SILVA LTDA",
                                "gap": 0.192,
                                "aceite": true,
                                "produto": "Impermeabilizantes"
                            },
                            {
                                "inicioMes": "2026-04-01T00:00:00",
                                "realizado": 3.75,
                                "clienteId": 196923,
                                "codigo": "1440065",
                                "razaoSocial": "F A F DA SILVA LTDA",
                                "gap": 2.25,
                                "aceite": true,
                                "produto": "Colantes"
                            },
                            {
                                "inicioMes": "2026-04-01T00:00:00",
                                "realizado": 48.25,
                                "clienteId": 196923,
                                "codigo": "1440065",
                                "razaoSocial": "F A F DA SILVA LTDA",
                                "gap": 13.75,
                                "aceite": true,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-08-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 196923,
                                "codigo": "1440065",
                                "razaoSocial": "F A F DA SILVA LTDA",
                                "gap": 0.34,
                                "aceite": false,
                                "produto": "Rejuntes"
                            },
                            {
                                "inicioMes": "2026-08-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 196923,
                                "codigo": "1440065",
                                "razaoSocial": "F A F DA SILVA LTDA",
                                "gap": 0.23,
                                "aceite": false,
                                "produto": "Impermeabilizantes"
                            },
                            {
                                "inicioMes": "2026-08-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 196923,
                                "codigo": "1440065",
                                "razaoSocial": "F A F DA SILVA LTDA",
                                "gap": 6.9,
                                "aceite": false,
                                "produto": "Colantes"
                            },
                            {
                                "inicioMes": "2026-08-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 196923,
                                "codigo": "1440065",
                                "razaoSocial": "F A F DA SILVA LTDA",
                                "gap": 102,
                                "aceite": false,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-07-01T00:00:00",
                                "realizado": 6.3,
                                "clienteId": 196923,
                                "codigo": "1440065",
                                "razaoSocial": "F A F DA SILVA LTDA",
                                "gap": -2.3,
                                "aceite": true,
                                "produto": "Colantes"
                            },
                            {
                                "inicioMes": "2026-07-01T00:00:00",
                                "realizado": 88,
                                "clienteId": 196923,
                                "codigo": "1440065",
                                "razaoSocial": "F A F DA SILVA LTDA",
                                "gap": -6,
                                "aceite": true,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-07-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 196923,
                                "codigo": "1440065",
                                "razaoSocial": "F A F DA SILVA LTDA",
                                "gap": 0.3,
                                "aceite": true,
                                "produto": "Impermeabilizantes"
                            },
                            {
                                "inicioMes": "2026-07-01T00:00:00",
                                "realizado": 0.22,
                                "clienteId": 196923,
                                "codigo": "1440065",
                                "razaoSocial": "F A F DA SILVA LTDA",
                                "gap": 0.07999999999999999,
                                "aceite": true,
                                "produto": "Rejuntes"
                            },
                            {
                                "inicioMes": "2026-04-01T00:00:00",
                                "realizado": 5,
                                "clienteId": 196941,
                                "codigo": "1068197",
                                "razaoSocial": "DEPOSITO MODELO LTDA",
                                "gap": 6,
                                "aceite": false,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-06-01T00:00:00",
                                "realizado": 0.02,
                                "clienteId": 196950,
                                "codigo": "1065610",
                                "razaoSocial": "DEPOSITO ORIENTE DE MATERIAL DE",
                                "gap": 0.32499999999999996,
                                "aceite": true,
                                "produto": "Rejuntes"
                            },
                            {
                                "inicioMes": "2026-06-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 196950,
                                "codigo": "1065610",
                                "razaoSocial": "DEPOSITO ORIENTE DE MATERIAL DE",
                                "gap": 0.345,
                                "aceite": true,
                                "produto": "Impermeabilizantes"
                            },
                            {
                                "inicioMes": "2026-06-01T00:00:00",
                                "realizado": 20.5,
                                "clienteId": 196950,
                                "codigo": "1065610",
                                "razaoSocial": "DEPOSITO ORIENTE DE MATERIAL DE",
                                "gap": 21.5,
                                "aceite": true,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-06-01T00:00:00",
                                "realizado": 1.05,
                                "clienteId": 196950,
                                "codigo": "1065610",
                                "razaoSocial": "DEPOSITO ORIENTE DE MATERIAL DE",
                                "gap": 2.4000000000000004,
                                "aceite": true,
                                "produto": "Colantes"
                            },
                            {
                                "inicioMes": "2026-08-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 196950,
                                "codigo": "1065610",
                                "razaoSocial": "DEPOSITO ORIENTE DE MATERIAL DE",
                                "gap": 0.23,
                                "aceite": false,
                                "produto": "Impermeabilizantes"
                            },
                            {
                                "inicioMes": "2026-08-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 196950,
                                "codigo": "1065610",
                                "razaoSocial": "DEPOSITO ORIENTE DE MATERIAL DE",
                                "gap": 30,
                                "aceite": false,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-05-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 196950,
                                "codigo": "1065610",
                                "razaoSocial": "DEPOSITO ORIENTE DE MATERIAL DE",
                                "gap": 0.3,
                                "aceite": true,
                                "produto": "Rejuntes"
                            },
                            {
                                "inicioMes": "2026-05-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 196950,
                                "codigo": "1065610",
                                "razaoSocial": "DEPOSITO ORIENTE DE MATERIAL DE",
                                "gap": 0.3,
                                "aceite": true,
                                "produto": "Impermeabilizantes"
                            },
                            {
                                "inicioMes": "2026-05-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 196950,
                                "codigo": "1065610",
                                "razaoSocial": "DEPOSITO ORIENTE DE MATERIAL DE",
                                "gap": 4,
                                "aceite": true,
                                "produto": "Colantes"
                            },
                            {
                                "inicioMes": "2026-05-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 196950,
                                "codigo": "1065610",
                                "razaoSocial": "DEPOSITO ORIENTE DE MATERIAL DE",
                                "gap": 46,
                                "aceite": true,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-07-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 196950,
                                "codigo": "1065610",
                                "razaoSocial": "DEPOSITO ORIENTE DE MATERIAL DE",
                                "gap": 2,
                                "aceite": true,
                                "produto": "Colantes"
                            },
                            {
                                "inicioMes": "2026-05-01T00:00:00",
                                "realizado": 7.8,
                                "clienteId": 198758,
                                "codigo": "1470574",
                                "razaoSocial": "LOJA DE MATERIAIS DE CONSTRUCAO",
                                "gap": 3.2,
                                "aceite": true,
                                "produto": "Colantes"
                            },
                            {
                                "inicioMes": "2026-05-01T00:00:00",
                                "realizado": 0.108,
                                "clienteId": 198758,
                                "codigo": "1470574",
                                "razaoSocial": "LOJA DE MATERIAIS DE CONSTRUCAO",
                                "gap": 0.237,
                                "aceite": true,
                                "produto": "Impermeabilizantes"
                            },
                            {
                                "inicioMes": "2026-05-01T00:00:00",
                                "realizado": 90,
                                "clienteId": 198758,
                                "codigo": "1470574",
                                "razaoSocial": "LOJA DE MATERIAIS DE CONSTRUCAO",
                                "gap": 70,
                                "aceite": true,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-05-01T00:00:00",
                                "realizado": 0.08,
                                "clienteId": 198758,
                                "codigo": "1470574",
                                "razaoSocial": "LOJA DE MATERIAIS DE CONSTRUCAO",
                                "gap": 0.26499999999999996,
                                "aceite": true,
                                "produto": "Rejuntes"
                            },
                            {
                                "inicioMes": "2026-08-01T00:00:00",
                                "realizado": 5.85,
                                "clienteId": 198758,
                                "codigo": "1470574",
                                "razaoSocial": "LOJA DE MATERIAIS DE CONSTRUCAO",
                                "gap": 5.65,
                                "aceite": false,
                                "produto": "Colantes"
                            },
                            {
                                "inicioMes": "2026-08-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 198758,
                                "codigo": "1470574",
                                "razaoSocial": "LOJA DE MATERIAIS DE CONSTRUCAO",
                                "gap": 0.34,
                                "aceite": false,
                                "produto": "Rejuntes"
                            },
                            {
                                "inicioMes": "2026-08-01T00:00:00",
                                "realizado": 22,
                                "clienteId": 198758,
                                "codigo": "1470574",
                                "razaoSocial": "LOJA DE MATERIAIS DE CONSTRUCAO",
                                "gap": 124,
                                "aceite": false,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-08-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 198758,
                                "codigo": "1470574",
                                "razaoSocial": "LOJA DE MATERIAIS DE CONSTRUCAO",
                                "gap": 0.23,
                                "aceite": false,
                                "produto": "Impermeabilizantes"
                            },
                            {
                                "inicioMes": "2026-07-01T00:00:00",
                                "realizado": 132,
                                "clienteId": 198758,
                                "codigo": "1470574",
                                "razaoSocial": "LOJA DE MATERIAIS DE CONSTRUCAO",
                                "gap": 24,
                                "aceite": true,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-07-01T00:00:00",
                                "realizado": 0.144,
                                "clienteId": 198758,
                                "codigo": "1470574",
                                "razaoSocial": "LOJA DE MATERIAIS DE CONSTRUCAO",
                                "gap": 0.23600000000000002,
                                "aceite": true,
                                "produto": "Impermeabilizantes"
                            },
                            {
                                "inicioMes": "2026-07-01T00:00:00",
                                "realizado": 0.16,
                                "clienteId": 198758,
                                "codigo": "1470574",
                                "razaoSocial": "LOJA DE MATERIAIS DE CONSTRUCAO",
                                "gap": 0.18000000000000002,
                                "aceite": true,
                                "produto": "Rejuntes"
                            },
                            {
                                "inicioMes": "2026-07-01T00:00:00",
                                "realizado": 21.45,
                                "clienteId": 198758,
                                "codigo": "1470574",
                                "razaoSocial": "LOJA DE MATERIAIS DE CONSTRUCAO",
                                "gap": -5.85,
                                "aceite": true,
                                "produto": "Colantes"
                            },
                            {
                                "inicioMes": "2026-04-01T00:00:00",
                                "realizado": 9.75,
                                "clienteId": 198758,
                                "codigo": "1470574",
                                "razaoSocial": "LOJA DE MATERIAIS DE CONSTRUCAO",
                                "gap": 1.25,
                                "aceite": true,
                                "produto": "Colantes"
                            },
                            {
                                "inicioMes": "2026-04-01T00:00:00",
                                "realizado": 0.108,
                                "clienteId": 198758,
                                "codigo": "1470574",
                                "razaoSocial": "LOJA DE MATERIAIS DE CONSTRUCAO",
                                "gap": 0.192,
                                "aceite": true,
                                "produto": "Impermeabilizantes"
                            },
                            {
                                "inicioMes": "2026-04-01T00:00:00",
                                "realizado": 0.3,
                                "clienteId": 198758,
                                "codigo": "1470574",
                                "razaoSocial": "LOJA DE MATERIAIS DE CONSTRUCAO",
                                "gap": 0,
                                "aceite": true,
                                "produto": "Rejuntes"
                            },
                            {
                                "inicioMes": "2026-04-01T00:00:00",
                                "realizado": 116,
                                "clienteId": 198758,
                                "codigo": "1470574",
                                "razaoSocial": "LOJA DE MATERIAIS DE CONSTRUCAO",
                                "gap": -6,
                                "aceite": true,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-07-01T00:00:00",
                                "realizado": 8.5,
                                "clienteId": 1127256,
                                "codigo": "1902724",
                                "razaoSocial": "FRANCISCA ERLANIA DA SILVA",
                                "gap": 9.5,
                                "aceite": false,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-07-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 1127256,
                                "codigo": "1902724",
                                "razaoSocial": "FRANCISCA ERLANIA DA SILVA",
                                "gap": 0.34,
                                "aceite": false,
                                "produto": "Impermeabilizantes"
                            },
                            {
                                "inicioMes": "2026-05-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 1130739,
                                "codigo": "1905118",
                                "razaoSocial": "CEARA CIMENTOS E MATERIAIS PARA",
                                "gap": 0.3,
                                "aceite": true,
                                "produto": "Impermeabilizantes"
                            },
                            {
                                "inicioMes": "2026-05-01T00:00:00",
                                "realizado": 250,
                                "clienteId": 1130739,
                                "codigo": "1905118",
                                "razaoSocial": "CEARA CIMENTOS E MATERIAIS PARA",
                                "gap": -20,
                                "aceite": true,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-05-01T00:00:00",
                                "realizado": 0.2,
                                "clienteId": 1130739,
                                "codigo": "1905118",
                                "razaoSocial": "CEARA CIMENTOS E MATERIAIS PARA",
                                "gap": 0.18,
                                "aceite": true,
                                "produto": "Rejuntes"
                            },
                            {
                                "inicioMes": "2026-05-01T00:00:00",
                                "realizado": 10,
                                "clienteId": 1130739,
                                "codigo": "1905118",
                                "razaoSocial": "CEARA CIMENTOS E MATERIAIS PARA",
                                "gap": -6,
                                "aceite": true,
                                "produto": "Colantes"
                            },
                            {
                                "inicioMes": "2026-06-01T00:00:00",
                                "realizado": 0.1,
                                "clienteId": 1130739,
                                "codigo": "1905118",
                                "razaoSocial": "CEARA CIMENTOS E MATERIAIS PARA",
                                "gap": 0.19999999999999998,
                                "aceite": true,
                                "produto": "Rejuntes"
                            },
                            {
                                "inicioMes": "2026-06-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 1130739,
                                "codigo": "1905118",
                                "razaoSocial": "CEARA CIMENTOS E MATERIAIS PARA",
                                "gap": 0.3,
                                "aceite": true,
                                "produto": "Impermeabilizantes"
                            },
                            {
                                "inicioMes": "2026-06-01T00:00:00",
                                "realizado": 238,
                                "clienteId": 1130739,
                                "codigo": "1905118",
                                "razaoSocial": "CEARA CIMENTOS E MATERIAIS PARA",
                                "gap": 12,
                                "aceite": true,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-06-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 1130739,
                                "codigo": "1905118",
                                "razaoSocial": "CEARA CIMENTOS E MATERIAIS PARA",
                                "gap": 13,
                                "aceite": true,
                                "produto": "Colantes"
                            },
                            {
                                "inicioMes": "2026-08-01T00:00:00",
                                "realizado": 0.02,
                                "clienteId": 1130739,
                                "codigo": "1905118",
                                "razaoSocial": "CEARA CIMENTOS E MATERIAIS PARA",
                                "gap": 0.27999999999999997,
                                "aceite": true,
                                "produto": "Rejuntes"
                            },
                            {
                                "inicioMes": "2026-08-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 1130739,
                                "codigo": "1905118",
                                "razaoSocial": "CEARA CIMENTOS E MATERIAIS PARA",
                                "gap": 10,
                                "aceite": true,
                                "produto": "Colantes"
                            },
                            {
                                "inicioMes": "2026-08-01T00:00:00",
                                "realizado": 70,
                                "clienteId": 1130739,
                                "codigo": "1905118",
                                "razaoSocial": "CEARA CIMENTOS E MATERIAIS PARA",
                                "gap": 180,
                                "aceite": true,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-08-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 1130739,
                                "codigo": "1905118",
                                "razaoSocial": "CEARA CIMENTOS E MATERIAIS PARA",
                                "gap": 0.2,
                                "aceite": true,
                                "produto": "Impermeabilizantes"
                            },
                            {
                                "inicioMes": "2026-07-01T00:00:00",
                                "realizado": 0.9,
                                "clienteId": 196871,
                                "codigo": "1350726",
                                "razaoSocial": "A M E MATERIAIS DE CONSTRUCAO LTDA",
                                "gap": 2.5500000000000003,
                                "aceite": false,
                                "produto": "Colantes"
                            },
                            {
                                "inicioMes": "2026-04-01T00:00:00",
                                "realizado": 5,
                                "clienteId": 196872,
                                "codigo": "1070791",
                                "razaoSocial": "FRANCISCA OTILIA DOS SANTOS SAMPAIO",
                                "gap": 14,
                                "aceite": false,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-04-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 196887,
                                "codigo": "1292000",
                                "razaoSocial": "SILVIO JOSE DE CASTRO SOUZA",
                                "gap": 28,
                                "grupoCentralizador": "CONSTRUCASTRO",
                                "aceite": false,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-04-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 180176,
                                "codigo": "1070059",
                                "razaoSocial": "DEIZIANE CHAVES BEZERRA",
                                "gap": 14,
                                "grupoCentralizador": "CONSTRUCASTRO",
                                "aceite": false,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-06-01T00:00:00",
                                "realizado": 0.08,
                                "clienteId": 176488,
                                "codigo": "1729941",
                                "razaoSocial": "ALM COMERCIO CONSTRUCOES E",
                                "gap": 0.26499999999999996,
                                "grupoCentralizador": "IMPERIO DO CIMENTO",
                                "aceite": true,
                                "produto": "Rejuntes"
                            },
                            {
                                "inicioMes": "2026-06-01T00:00:00",
                                "realizado": 1.62,
                                "clienteId": 176488,
                                "codigo": "1729941",
                                "razaoSocial": "ALM COMERCIO CONSTRUCOES E",
                                "gap": 4.13,
                                "grupoCentralizador": "IMPERIO DO CIMENTO",
                                "aceite": true,
                                "produto": "Colantes"
                            },
                            {
                                "inicioMes": "2026-06-01T00:00:00",
                                "realizado": 252,
                                "clienteId": 176488,
                                "codigo": "1729941",
                                "razaoSocial": "ALM COMERCIO CONSTRUCOES E",
                                "gap": 24,
                                "grupoCentralizador": "IMPERIO DO CIMENTO",
                                "aceite": true,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-06-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 176488,
                                "codigo": "1729941",
                                "razaoSocial": "ALM COMERCIO CONSTRUCOES E",
                                "gap": 0.345,
                                "grupoCentralizador": "IMPERIO DO CIMENTO",
                                "aceite": true,
                                "produto": "Impermeabilizantes"
                            },
                            {
                                "inicioMes": "2026-05-01T00:00:00",
                                "realizado": 3.12,
                                "clienteId": 176488,
                                "codigo": "1729941",
                                "razaoSocial": "ALM COMERCIO CONSTRUCOES E",
                                "gap": 0.8799999999999999,
                                "grupoCentralizador": "IMPERIO DO CIMENTO",
                                "aceite": true,
                                "produto": "Colantes"
                            },
                            {
                                "inicioMes": "2026-05-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 176488,
                                "codigo": "1729941",
                                "razaoSocial": "ALM COMERCIO CONSTRUCOES E",
                                "gap": 0.3,
                                "grupoCentralizador": "IMPERIO DO CIMENTO",
                                "aceite": true,
                                "produto": "Rejuntes"
                            },
                            {
                                "inicioMes": "2026-05-01T00:00:00",
                                "realizado": 248,
                                "clienteId": 176488,
                                "codigo": "1729941",
                                "razaoSocial": "ALM COMERCIO CONSTRUCOES E",
                                "gap": 32,
                                "grupoCentralizador": "IMPERIO DO CIMENTO",
                                "aceite": true,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-05-01T00:00:00",
                                "realizado": 0.108,
                                "clienteId": 176488,
                                "codigo": "1729941",
                                "razaoSocial": "ALM COMERCIO CONSTRUCOES E",
                                "gap": 0.192,
                                "grupoCentralizador": "IMPERIO DO CIMENTO",
                                "aceite": true,
                                "produto": "Impermeabilizantes"
                            },
                            {
                                "inicioMes": "2026-08-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 176488,
                                "codigo": "1729941",
                                "razaoSocial": "ALM COMERCIO CONSTRUCOES E",
                                "gap": 0.34,
                                "grupoCentralizador": "IMPERIO DO CIMENTO",
                                "aceite": false,
                                "produto": "Rejuntes"
                            },
                            {
                                "inicioMes": "2026-08-01T00:00:00",
                                "realizado": 1.08,
                                "clienteId": 176488,
                                "codigo": "1729941",
                                "razaoSocial": "ALM COMERCIO CONSTRUCOES E",
                                "gap": 3.5199999999999996,
                                "grupoCentralizador": "IMPERIO DO CIMENTO",
                                "aceite": false,
                                "produto": "Colantes"
                            },
                            {
                                "inicioMes": "2026-08-01T00:00:00",
                                "realizado": 0.054,
                                "clienteId": 176488,
                                "codigo": "1729941",
                                "razaoSocial": "ALM COMERCIO CONSTRUCOES E",
                                "gap": 0.17600000000000002,
                                "grupoCentralizador": "IMPERIO DO CIMENTO",
                                "aceite": false,
                                "produto": "Impermeabilizantes"
                            },
                            {
                                "inicioMes": "2026-07-01T00:00:00",
                                "realizado": 0.02,
                                "clienteId": 27413,
                                "codigo": "1598847",
                                "razaoSocial": "DISTRIBUIDORA IMPERIO DO CIMENTO",
                                "gap": 0.27999999999999997,
                                "grupoCentralizador": "IMPERIO DO CIMENTO",
                                "aceite": true,
                                "produto": "Rejuntes"
                            },
                            {
                                "inicioMes": "2026-07-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 27413,
                                "codigo": "1598847",
                                "razaoSocial": "DISTRIBUIDORA IMPERIO DO CIMENTO",
                                "gap": 0.3,
                                "grupoCentralizador": "IMPERIO DO CIMENTO",
                                "aceite": true,
                                "produto": "Impermeabilizantes"
                            },
                            {
                                "inicioMes": "2026-07-01T00:00:00",
                                "realizado": 14,
                                "clienteId": 27413,
                                "codigo": "1598847",
                                "razaoSocial": "DISTRIBUIDORA IMPERIO DO CIMENTO",
                                "gap": 206,
                                "grupoCentralizador": "IMPERIO DO CIMENTO",
                                "aceite": true,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-07-01T00:00:00",
                                "realizado": 0.225,
                                "clienteId": 27413,
                                "codigo": "1598847",
                                "razaoSocial": "DISTRIBUIDORA IMPERIO DO CIMENTO",
                                "gap": 3.775,
                                "grupoCentralizador": "IMPERIO DO CIMENTO",
                                "aceite": true,
                                "produto": "Colantes"
                            },
                            {
                                "inicioMes": "2026-04-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 27413,
                                "codigo": "1598847",
                                "razaoSocial": "DISTRIBUIDORA IMPERIO DO CIMENTO",
                                "gap": 5,
                                "grupoCentralizador": "IMPERIO DO CIMENTO",
                                "aceite": true,
                                "produto": "Colantes"
                            },
                            {
                                "inicioMes": "2026-04-01T00:00:00",
                                "realizado": 0.036,
                                "clienteId": 27413,
                                "codigo": "1598847",
                                "razaoSocial": "DISTRIBUIDORA IMPERIO DO CIMENTO",
                                "gap": 0.264,
                                "grupoCentralizador": "IMPERIO DO CIMENTO",
                                "aceite": true,
                                "produto": "Impermeabilizantes"
                            },
                            {
                                "inicioMes": "2026-04-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 27413,
                                "codigo": "1598847",
                                "razaoSocial": "DISTRIBUIDORA IMPERIO DO CIMENTO",
                                "gap": 0.3,
                                "grupoCentralizador": "IMPERIO DO CIMENTO",
                                "aceite": true,
                                "produto": "Rejuntes"
                            },
                            {
                                "inicioMes": "2026-04-01T00:00:00",
                                "realizado": 14,
                                "clienteId": 27413,
                                "codigo": "1598847",
                                "razaoSocial": "DISTRIBUIDORA IMPERIO DO CIMENTO",
                                "gap": 296,
                                "grupoCentralizador": "IMPERIO DO CIMENTO",
                                "aceite": true,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-06-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 57845,
                                "codigo": "1508834",
                                "razaoSocial": "FORTE COMERCIO DE MATERIAL DE",
                                "gap": 0.3,
                                "grupoCentralizador": "FORTE COMERCIO",
                                "aceite": true,
                                "produto": "Rejuntes"
                            },
                            {
                                "inicioMes": "2026-06-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 57845,
                                "codigo": "1508834",
                                "razaoSocial": "FORTE COMERCIO DE MATERIAL DE",
                                "gap": 5,
                                "grupoCentralizador": "FORTE COMERCIO",
                                "aceite": true,
                                "produto": "Colantes"
                            },
                            {
                                "inicioMes": "2026-06-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 57845,
                                "codigo": "1508834",
                                "razaoSocial": "FORTE COMERCIO DE MATERIAL DE",
                                "gap": 0.3,
                                "grupoCentralizador": "FORTE COMERCIO",
                                "aceite": true,
                                "produto": "Impermeabilizantes"
                            },
                            {
                                "inicioMes": "2026-06-01T00:00:00",
                                "realizado": 94,
                                "clienteId": 57845,
                                "codigo": "1508834",
                                "razaoSocial": "FORTE COMERCIO DE MATERIAL DE",
                                "gap": 156,
                                "grupoCentralizador": "FORTE COMERCIO",
                                "aceite": true,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-04-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 57845,
                                "codigo": "1508834",
                                "razaoSocial": "FORTE COMERCIO DE MATERIAL DE",
                                "gap": 0.3,
                                "grupoCentralizador": "FORTE COMERCIO",
                                "aceite": true,
                                "produto": "Rejuntes"
                            },
                            {
                                "inicioMes": "2026-04-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 57845,
                                "codigo": "1508834",
                                "razaoSocial": "FORTE COMERCIO DE MATERIAL DE",
                                "gap": 6,
                                "grupoCentralizador": "FORTE COMERCIO",
                                "aceite": true,
                                "produto": "Colantes"
                            },
                            {
                                "inicioMes": "2026-04-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 57845,
                                "codigo": "1508834",
                                "razaoSocial": "FORTE COMERCIO DE MATERIAL DE",
                                "gap": 0.3,
                                "grupoCentralizador": "FORTE COMERCIO",
                                "aceite": true,
                                "produto": "Impermeabilizantes"
                            },
                            {
                                "inicioMes": "2026-04-01T00:00:00",
                                "realizado": 196,
                                "clienteId": 57845,
                                "codigo": "1508834",
                                "razaoSocial": "FORTE COMERCIO DE MATERIAL DE",
                                "gap": 54,
                                "grupoCentralizador": "FORTE COMERCIO",
                                "aceite": true,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-05-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 57845,
                                "codigo": "1508834",
                                "razaoSocial": "FORTE COMERCIO DE MATERIAL DE",
                                "gap": 4,
                                "grupoCentralizador": "FORTE COMERCIO",
                                "aceite": true,
                                "produto": "Colantes"
                            },
                            {
                                "inicioMes": "2026-05-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 57845,
                                "codigo": "1508834",
                                "razaoSocial": "FORTE COMERCIO DE MATERIAL DE",
                                "gap": 0.3,
                                "grupoCentralizador": "FORTE COMERCIO",
                                "aceite": true,
                                "produto": "Impermeabilizantes"
                            },
                            {
                                "inicioMes": "2026-05-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 57845,
                                "codigo": "1508834",
                                "razaoSocial": "FORTE COMERCIO DE MATERIAL DE",
                                "gap": 0.3,
                                "grupoCentralizador": "FORTE COMERCIO",
                                "aceite": true,
                                "produto": "Rejuntes"
                            },
                            {
                                "inicioMes": "2026-05-01T00:00:00",
                                "realizado": 84,
                                "clienteId": 57845,
                                "codigo": "1508834",
                                "razaoSocial": "FORTE COMERCIO DE MATERIAL DE",
                                "gap": 166,
                                "grupoCentralizador": "FORTE COMERCIO",
                                "aceite": true,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-08-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 57845,
                                "codigo": "1508834",
                                "razaoSocial": "FORTE COMERCIO DE MATERIAL DE",
                                "gap": 0.2,
                                "grupoCentralizador": "FORTE COMERCIO",
                                "aceite": true,
                                "produto": "Impermeabilizantes"
                            },
                            {
                                "inicioMes": "2026-08-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 57845,
                                "codigo": "1508834",
                                "razaoSocial": "FORTE COMERCIO DE MATERIAL DE",
                                "gap": 250,
                                "grupoCentralizador": "FORTE COMERCIO",
                                "aceite": true,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-07-01T00:00:00",
                                "realizado": 104,
                                "clienteId": 57845,
                                "codigo": "1508834",
                                "razaoSocial": "FORTE COMERCIO DE MATERIAL DE",
                                "gap": 146,
                                "grupoCentralizador": "FORTE COMERCIO",
                                "aceite": true,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-07-01T00:00:00",
                                "realizado": 56,
                                "clienteId": 64507,
                                "codigo": "1710051",
                                "razaoSocial": "COMERCIAL AVENIDA MATERIAIS DE",
                                "gap": -2,
                                "grupoCentralizador": "COMERCIAL AVENIDA",
                                "aceite": true,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-07-01T00:00:00",
                                "realizado": 0.02,
                                "clienteId": 64507,
                                "codigo": "1710051",
                                "razaoSocial": "COMERCIAL AVENIDA MATERIAIS DE",
                                "gap": 0.27999999999999997,
                                "grupoCentralizador": "COMERCIAL AVENIDA",
                                "aceite": true,
                                "produto": "Rejuntes"
                            },
                            {
                                "inicioMes": "2026-07-01T00:00:00",
                                "realizado": 0.3,
                                "clienteId": 64507,
                                "codigo": "1710051",
                                "razaoSocial": "COMERCIAL AVENIDA MATERIAIS DE",
                                "gap": 4.9,
                                "grupoCentralizador": "COMERCIAL AVENIDA",
                                "aceite": true,
                                "produto": "Colantes"
                            },
                            {
                                "inicioMes": "2026-08-01T00:00:00",
                                "realizado": 14,
                                "clienteId": 64507,
                                "codigo": "1710051",
                                "razaoSocial": "COMERCIAL AVENIDA MATERIAIS DE",
                                "gap": 34,
                                "grupoCentralizador": "COMERCIAL AVENIDA",
                                "aceite": true,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-08-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 64507,
                                "codigo": "1710051",
                                "razaoSocial": "COMERCIAL AVENIDA MATERIAIS DE",
                                "gap": 4,
                                "grupoCentralizador": "COMERCIAL AVENIDA",
                                "aceite": true,
                                "produto": "Colantes"
                            },
                            {
                                "inicioMes": "2026-08-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 64507,
                                "codigo": "1710051",
                                "razaoSocial": "COMERCIAL AVENIDA MATERIAIS DE",
                                "gap": 0.3,
                                "grupoCentralizador": "COMERCIAL AVENIDA",
                                "aceite": true,
                                "produto": "Rejuntes"
                            },
                            {
                                "inicioMes": "2026-08-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 64507,
                                "codigo": "1710051",
                                "razaoSocial": "COMERCIAL AVENIDA MATERIAIS DE",
                                "gap": 0.2,
                                "grupoCentralizador": "COMERCIAL AVENIDA",
                                "aceite": true,
                                "produto": "Impermeabilizantes"
                            },
                            {
                                "inicioMes": "2026-05-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 64507,
                                "codigo": "1710051",
                                "razaoSocial": "COMERCIAL AVENIDA MATERIAIS DE",
                                "gap": 4.6,
                                "grupoCentralizador": "COMERCIAL AVENIDA",
                                "aceite": true,
                                "produto": "Colantes"
                            },
                            {
                                "inicioMes": "2026-05-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 64507,
                                "codigo": "1710051",
                                "razaoSocial": "COMERCIAL AVENIDA MATERIAIS DE",
                                "gap": 0.345,
                                "grupoCentralizador": "COMERCIAL AVENIDA",
                                "aceite": true,
                                "produto": "Impermeabilizantes"
                            },
                            {
                                "inicioMes": "2026-05-01T00:00:00",
                                "realizado": 28,
                                "clienteId": 64507,
                                "codigo": "1710051",
                                "razaoSocial": "COMERCIAL AVENIDA MATERIAIS DE",
                                "gap": 40,
                                "grupoCentralizador": "COMERCIAL AVENIDA",
                                "aceite": true,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-05-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 64507,
                                "codigo": "1710051",
                                "razaoSocial": "COMERCIAL AVENIDA MATERIAIS DE",
                                "gap": 0.345,
                                "grupoCentralizador": "COMERCIAL AVENIDA",
                                "aceite": true,
                                "produto": "Rejuntes"
                            },
                            {
                                "inicioMes": "2026-04-01T00:00:00",
                                "realizado": 0.45,
                                "clienteId": 64507,
                                "codigo": "1710051",
                                "razaoSocial": "COMERCIAL AVENIDA MATERIAIS DE",
                                "gap": 3.55,
                                "grupoCentralizador": "COMERCIAL AVENIDA",
                                "aceite": true,
                                "produto": "Colantes"
                            },
                            {
                                "inicioMes": "2026-04-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 64507,
                                "codigo": "1710051",
                                "razaoSocial": "COMERCIAL AVENIDA MATERIAIS DE",
                                "gap": 0.3,
                                "grupoCentralizador": "COMERCIAL AVENIDA",
                                "aceite": true,
                                "produto": "Impermeabilizantes"
                            },
                            {
                                "inicioMes": "2026-04-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 64507,
                                "codigo": "1710051",
                                "razaoSocial": "COMERCIAL AVENIDA MATERIAIS DE",
                                "gap": 0.3,
                                "grupoCentralizador": "COMERCIAL AVENIDA",
                                "aceite": true,
                                "produto": "Rejuntes"
                            },
                            {
                                "inicioMes": "2026-04-01T00:00:00",
                                "realizado": 42,
                                "clienteId": 64507,
                                "codigo": "1710051",
                                "razaoSocial": "COMERCIAL AVENIDA MATERIAIS DE",
                                "gap": 20,
                                "grupoCentralizador": "COMERCIAL AVENIDA",
                                "aceite": true,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-04-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 327595,
                                "codigo": "1067668",
                                "razaoSocial": "LEONCIO MATERIAIS DE CONSTRUCAO E C",
                                "gap": 0.3,
                                "grupoCentralizador": "GLAISON ALMEIDA",
                                "aceite": true,
                                "produto": "Rejuntes"
                            },
                            {
                                "inicioMes": "2026-04-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 327595,
                                "codigo": "1067668",
                                "razaoSocial": "LEONCIO MATERIAIS DE CONSTRUCAO E C",
                                "gap": 0.3,
                                "grupoCentralizador": "GLAISON ALMEIDA",
                                "aceite": true,
                                "produto": "Impermeabilizantes"
                            },
                            {
                                "inicioMes": "2026-04-01T00:00:00",
                                "realizado": 1.65,
                                "clienteId": 327595,
                                "codigo": "1067668",
                                "razaoSocial": "LEONCIO MATERIAIS DE CONSTRUCAO E C",
                                "gap": 2.35,
                                "grupoCentralizador": "GLAISON ALMEIDA",
                                "aceite": true,
                                "produto": "Colantes"
                            },
                            {
                                "inicioMes": "2026-04-01T00:00:00",
                                "realizado": 96.25,
                                "clienteId": 327595,
                                "codigo": "1067668",
                                "razaoSocial": "LEONCIO MATERIAIS DE CONSTRUCAO E C",
                                "gap": 153.75,
                                "grupoCentralizador": "GLAISON ALMEIDA",
                                "aceite": true,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-05-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 327595,
                                "codigo": "1067668",
                                "razaoSocial": "LEONCIO MATERIAIS DE CONSTRUCAO E C",
                                "gap": 0.3,
                                "grupoCentralizador": "GLAISON ALMEIDA",
                                "aceite": true,
                                "produto": "Rejuntes"
                            },
                            {
                                "inicioMes": "2026-05-01T00:00:00",
                                "realizado": 1.2,
                                "clienteId": 327595,
                                "codigo": "1067668",
                                "razaoSocial": "LEONCIO MATERIAIS DE CONSTRUCAO E C",
                                "gap": 2.8,
                                "grupoCentralizador": "GLAISON ALMEIDA",
                                "aceite": true,
                                "produto": "Colantes"
                            },
                            {
                                "inicioMes": "2026-05-01T00:00:00",
                                "realizado": 82,
                                "clienteId": 327595,
                                "codigo": "1067668",
                                "razaoSocial": "LEONCIO MATERIAIS DE CONSTRUCAO E C",
                                "gap": 168,
                                "grupoCentralizador": "GLAISON ALMEIDA",
                                "aceite": true,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-05-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 327595,
                                "codigo": "1067668",
                                "razaoSocial": "LEONCIO MATERIAIS DE CONSTRUCAO E C",
                                "gap": 0.3,
                                "grupoCentralizador": "GLAISON ALMEIDA",
                                "aceite": true,
                                "produto": "Impermeabilizantes"
                            },
                            {
                                "inicioMes": "2026-07-01T00:00:00",
                                "realizado": 250.5,
                                "clienteId": 327595,
                                "codigo": "1067668",
                                "razaoSocial": "LEONCIO MATERIAIS DE CONSTRUCAO E C",
                                "gap": -0.5,
                                "grupoCentralizador": "GLAISON ALMEIDA",
                                "aceite": true,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-07-01T00:00:00",
                                "realizado": 4.2,
                                "clienteId": 327595,
                                "codigo": "1067668",
                                "razaoSocial": "LEONCIO MATERIAIS DE CONSTRUCAO E C",
                                "gap": -0.20000000000000018,
                                "grupoCentralizador": "GLAISON ALMEIDA",
                                "aceite": true,
                                "produto": "Colantes"
                            },
                            {
                                "inicioMes": "2026-07-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 327595,
                                "codigo": "1067668",
                                "razaoSocial": "LEONCIO MATERIAIS DE CONSTRUCAO E C",
                                "gap": 0.3,
                                "grupoCentralizador": "GLAISON ALMEIDA",
                                "aceite": true,
                                "produto": "Rejuntes"
                            },
                            {
                                "inicioMes": "2026-08-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 327595,
                                "codigo": "1067668",
                                "razaoSocial": "LEONCIO MATERIAIS DE CONSTRUCAO E C",
                                "gap": 0.2,
                                "grupoCentralizador": "GLAISON ALMEIDA",
                                "aceite": false,
                                "produto": "Impermeabilizantes"
                            },
                            {
                                "inicioMes": "2026-08-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 327595,
                                "codigo": "1067668",
                                "razaoSocial": "LEONCIO MATERIAIS DE CONSTRUCAO E C",
                                "gap": 4,
                                "grupoCentralizador": "GLAISON ALMEIDA",
                                "aceite": false,
                                "produto": "Colantes"
                            },
                            {
                                "inicioMes": "2026-08-01T00:00:00",
                                "realizado": 14,
                                "clienteId": 327595,
                                "codigo": "1067668",
                                "razaoSocial": "LEONCIO MATERIAIS DE CONSTRUCAO E C",
                                "gap": 236,
                                "grupoCentralizador": "GLAISON ALMEIDA",
                                "aceite": false,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-08-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 327595,
                                "codigo": "1067668",
                                "razaoSocial": "LEONCIO MATERIAIS DE CONSTRUCAO E C",
                                "gap": 0.3,
                                "grupoCentralizador": "GLAISON ALMEIDA",
                                "aceite": false,
                                "produto": "Rejuntes"
                            },
                            {
                                "inicioMes": "2026-06-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 327595,
                                "codigo": "1067668",
                                "razaoSocial": "LEONCIO MATERIAIS DE CONSTRUCAO E C",
                                "gap": 0.3,
                                "grupoCentralizador": "GLAISON ALMEIDA",
                                "aceite": true,
                                "produto": "Rejuntes"
                            },
                            {
                                "inicioMes": "2026-06-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 327595,
                                "codigo": "1067668",
                                "razaoSocial": "LEONCIO MATERIAIS DE CONSTRUCAO E C",
                                "gap": 0.3,
                                "grupoCentralizador": "GLAISON ALMEIDA",
                                "aceite": true,
                                "produto": "Impermeabilizantes"
                            },
                            {
                                "inicioMes": "2026-06-01T00:00:00",
                                "realizado": 162.5,
                                "clienteId": 327595,
                                "codigo": "1067668",
                                "razaoSocial": "LEONCIO MATERIAIS DE CONSTRUCAO E C",
                                "gap": 87.5,
                                "grupoCentralizador": "GLAISON ALMEIDA",
                                "aceite": true,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-06-01T00:00:00",
                                "realizado": 3.9,
                                "clienteId": 327595,
                                "codigo": "1067668",
                                "razaoSocial": "LEONCIO MATERIAIS DE CONSTRUCAO E C",
                                "gap": 1.1,
                                "grupoCentralizador": "GLAISON ALMEIDA",
                                "aceite": true,
                                "produto": "Colantes"
                            },
                            {
                                "inicioMes": "2026-04-01T00:00:00",
                                "realizado": 0.34,
                                "clienteId": 176581,
                                "codigo": "1672180",
                                "razaoSocial": "MARACANAU CONSTRUCOES E SERVICOS",
                                "gap": -0.040000000000000036,
                                "grupoCentralizador": "MARACANAU CONSTRUCOES",
                                "aceite": true,
                                "produto": "Rejuntes"
                            },
                            {
                                "inicioMes": "2026-04-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 176581,
                                "codigo": "1672180",
                                "razaoSocial": "MARACANAU CONSTRUCOES E SERVICOS",
                                "gap": 4,
                                "grupoCentralizador": "MARACANAU CONSTRUCOES",
                                "aceite": true,
                                "produto": "Colantes"
                            },
                            {
                                "inicioMes": "2026-04-01T00:00:00",
                                "realizado": 272,
                                "clienteId": 176581,
                                "codigo": "1672180",
                                "razaoSocial": "MARACANAU CONSTRUCOES E SERVICOS",
                                "gap": 3,
                                "grupoCentralizador": "MARACANAU CONSTRUCOES",
                                "aceite": true,
                                "produto": "Cimentos"
                            },
                            {
                                "inicioMes": "2026-04-01T00:00:00",
                                "realizado": 0,
                                "clienteId": 176581,
                                "codigo": "1672180",
                                "razaoSocial": "MARACANAU CONSTRUCOES E SERVICOS",
                                "gap": 0.3,
                                "grupoCentralizador": "MARACANAU CONSTRUCOES",
                                "aceite": true,
                                "produto": "Impermeabilizantes"
                            }
                        ]
                    },
                    {
                        "id": -9,
                        "filtros": {
                            "gruposCentralizadores": [
                                null,
                                "CONSTRUCASTRO",
                                "IMPERIO DO CIMENTO",
                                "FORTE COMERCIO",
                                "COMERCIAL AVENIDA",
                                "GLAISON ALMEIDA",
                                "MARACANAU CONSTRUCOES"
                            ],
                            "gruposProduto": [
                                "Cimentos",
                                "Rejuntes",
                                "Impermeabilizantes",
                                "Colantes"
                            ]
                        }
                    },
                    {
                        "id": -10,
                        "createdAt": "2026-08-07T09:20:06.3336303"
                    }
                ]
            }
        ]
    ],
    "existentes": []
}
]]